const translations = {
  en: {
    'common.add': 'Add',
    'common.addNew': 'Add new',
    'common.edit': 'Edit',
    'common.update': 'Update',
    'common.view': 'View',
    'common.hide': 'Hide',
    'common.viewOrders': 'View orders',
    'common.viewInvoices': 'View invoices',
    'common.delete': 'Delete',
    'common.remove': 'Remove',
    'common.cancel': 'Cancel',
    'common.optional': 'optional',
    'common.close': 'Close',
    'common.details': 'Details',
    'common.openDetailsPage': 'Open full page',
    'common.createdAt': 'Created at',
    'common.updatedAt': 'Updated at',
    'common.actions': 'Actions',
    'common.refresh': 'Refresh',
    'common.confirmDeleteTitle': 'Delete Item',
    'common.confirmDeleteMessage': 'Are you sure you want to delete this item?',
    'common.back': 'Back',
    'common.deleteConfirm': 'Delete',
    'common.added': 'Added',
    'common.zeroPlaceholder': '0',
    'common.notes': 'Notes',
    'common.phone': 'Phone Number',
    'common.whatsapp': 'WhatsApp Number',
    'common.address': 'Address',
    'common.email': 'Email',
    'common.subject': 'Subject',
    'common.required': 'This field is required',
    'common.confirm': 'Confirm',
    'common.validationError': 'Validation error',
    'api.errors.validation_error': 'Validation error',
    'api.errors.invalid_credentials': 'Invalid credentials',
    'api.errors.unauthenticated': 'Unauthenticated',
    'api.errors.permission_denied': 'You do not have permission to perform this action',
    'api.errors.invalid_current_password': 'Current password is incorrect',
    'api.errors.login_identifier_required': 'Please provide an email address or a username.',
    'api.errors.email_invalid': 'Please provide a valid email address.',
    'api.errors.email_taken': 'This email is already registered.',
    'api.errors.username_taken': 'This username is already taken.',
    'api.errors.already_taken': 'This value is already taken.',
    'api.errors.backoffice_access_denied': 'This account cannot access the backoffice portal.',
    'api.errors.vendor_portal_only': 'This account must sign in through the vendor portal.',
    'api.errors.not_found': 'Not found',
    'api.errors.request_failed': 'Something went wrong',
    'forms.whatsappSameAsPhone': 'WhatsApp same as phone',
    'forms.phone.placeholder': 'Enter phone number',
    'forms.whatsapp.placeholder': 'Enter WhatsApp number',
    'forms.copyFromVendor.label': 'Use lab contact details',
    'forms.copyFromVendor.phone': 'Lab phone',
    'forms.copyFromVendor.whatsapp': 'Lab WhatsApp',
    'forms.copyFromVendor.address': 'Lab address',
    'forms.copyFromClient.label': 'Use client contact details',
    'forms.copyFromClient.phone': 'Client phone',
    'forms.copyFromClient.whatsapp': 'Client WhatsApp',
    'forms.copyFromClient.address': 'Client address',
    'common.clear': 'Clear',
    'common.resetFilters': 'Reset Filters',
    'common.filters': 'Filters',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.attachments': 'Attachments',
    'common.general': 'General',
    'validation.name.required': 'Name is required',
    'validation.name.min': 'Name must be at least 2 characters',
    'validation.name.max': 'Name cannot exceed 255 characters',
    'validation.email.required': 'Email is required',
    'validation.email.invalid': 'Please enter a valid email address',
    'validation.email.max': 'Email cannot exceed 255 characters',
    'validation.username.required': 'Username is required',
    'validation.username.min': 'Username must be at least 3 characters',
    'validation.username.max': 'Username cannot exceed 50 characters',
    'validation.username.invalid': 'Username may only contain letters, numbers, dots, underscores, and hyphens',
    'validation.login.identifierRequired': 'Enter an email or a username',
    'validation.phone.required': 'Phone is required',
    'validation.phone.invalid': 'Please enter a valid phone number',
    'validation.phone.max': 'Phone cannot exceed 50 characters',
    'validation.whatsapp.required': 'WhatsApp is required',
    'validation.whatsapp.invalid': 'Please enter a valid WhatsApp number',
    'validation.whatsapp.max': 'WhatsApp cannot exceed 50 characters',
    'common.loading': 'Loading...',
    'common.saved': 'Saved successfully',
    'common.active': 'Active',
    'common.status': 'Status',
    'common.inactive': 'Inactive',
    'common.export': 'Export',
    'common.export.csv': 'Export CSV',
    'common.export.excel': 'Export Excel',
    'common.export.pdf': 'Export PDF',
    'common.export.selectedCount': '{{count}} selected',
    'common.export.error': 'Export failed',
    'common.export.dateRange.label': 'Date range',
    'common.export.dateRange.hint': 'Leave empty to export all dates.',
    'common.export.dateRange.thisMonth': 'This month',
    'common.export.dateRange.lastMonth': 'Last month',
    'common.export.dateRange.last30Days': 'Last 30 days',
    'common.export.dateRange.thisYear': 'This year',
    'common.export.entity.orders': 'Orders',
    'common.export.entity.invoices': 'Invoices',
    'common.export.entity.clients': 'Clients',
    'common.export.entity.users': 'Users',
    'common.export.entity.expenses': 'Expenses',

    // Sidebar
    'sidebar.dashboard': 'Analytics',
    'sidebar.reports': 'Reports',
    'sidebar.month_summary': 'Collection Report',
    'sidebar.collection_report': 'Collection Report',
    'sidebar.revenue_report': 'Revenue Report',
    'sidebar.chart_of_accounts': 'Chart of Accounts',
    'sidebar.journal_entries': 'Journal Entries',
    'accounting.noAccess': 'You do not have access to accounting.',
    'accounting.debit': 'Debit',
    'accounting.credit': 'Credit',
    'accounting.balance': 'Balance',
    'accounting.error.load': 'Could not load accounting data.',
    'accounting.error.save': 'Could not save the change.',
    'accounting.type.all': 'All',
    'accounting.type.asset': 'Assets',
    'accounting.type.liability': 'Liabilities',
    'accounting.type.equity': 'Equity',
    'accounting.type.revenue': 'Revenue',
    'accounting.type.expense': 'Expenses',
    'accounting.source.order': 'Orders',
    'accounting.source.transaction': 'Payments & wallets',
    'accounting.source.expense': 'Expenses',
    'accounting.source.asset': 'Assets',
    'accounting.source.manual': 'Manual entries',
    'accounting.tabs.accounts': 'Accounts',
    'accounting.tabs.maps': 'Posting rules',
    'accounting.tabs.health': 'Reconciliation',
    'accounting.tabs.events': 'Events',
    'accounting.postingEvents.hint': 'Every operation in the system that creates a journal entry, and the accounts each side of the entry posts to. Mapped accounts follow the "Posting rules" tab; accounts picked on the operation itself are shown in italics.',
    'accounting.postingEvents.editMaps': 'Edit posting rules',
    'accounting.postingEvents.search': 'Search events or accounts',
    'accounting.postingEvents.usedOnly': 'Only events with entries',
    'accounting.postingEvents.event': 'Event',
    'accounting.postingEvents.lines': 'Posts to',
    'accounting.postingEvents.activity': 'Activity',
    'accounting.postingEvents.side.debit': 'Debit',
    'accounting.postingEvents.side.credit': 'Credit',
    'accounting.postingEvents.side.either': 'Dr / Cr',
    'accounting.postingEvents.entries': '{count} entries',
    'accounting.postingEvents.lastEntry': 'Last: {date}',
    'accounting.postingEvents.noEntries': 'No entries yet',
    'accounting.postingEvents.notMapped': 'Not mapped',
    'accounting.postingEvents.showMore': 'Show {count} more',
    'accounting.postingEvents.showLess': 'Show less',
    'accounting.setup.enabled': 'Ledger on',
    'accounting.setup.disabled': 'Ledger off',
    'accounting.setup.enable': 'Enable accounting',
    'accounting.setup.disable': 'Disable',
    'accounting.setup.disableConfirm': 'Stop posting new operations to the ledger? Existing entries are kept.',
    'accounting.setup.resync': 'Resync ledger',
    'accounting.setup.disabledTitle': 'Accounting is not enabled',
    'accounting.setup.disabledBody': 'Enabling posts every existing order, payment, wallet movement, expense and asset to the ledger (this runs in the background), then keeps the ledger updated automatically.',
    'accounting.setup.running': 'Posting existing records to the ledger…',
    'accounting.setup.starting': 'Starting…',
    'accounting.setup.failed': 'The last ledger sync did not finish',
    'accounting.setup.stale': 'The background sync stopped responding. Run a resync.',
    'accounting.setup.healthIssues': 'The ledger does not fully match operations',
    'accounting.setup.healthIssuesBody': 'Open the Reconciliation tab to see which clients differ.',
    'accounting.accounts.subtitle': 'Accounts, balances and the rules that post lab operations to the ledger',
    'accounting.accounts.countLabel': 'accounts',
    'accounting.accounts.add': 'Add account',
    'accounting.accounts.edit': 'Edit account',
    'accounting.accounts.code': 'Code',
    'accounting.accounts.name': 'Account',
    'accounting.accounts.type': 'Type',
    'accounting.accounts.parent': 'Parent account',
    'accounting.accounts.description': 'Description',
    'accounting.accounts.active': 'Active',
    'accounting.accounts.inactive': 'Inactive',
    'accounting.accounts.system': 'System',
    'accounting.accounts.systemHint': 'Used by automatic posting: the code and name can change, the type cannot and it stays active.',
    'accounting.accounts.deleteConfirm': 'Delete this account?',
    'accounting.accounts.search': 'Search code or name',
    'accounting.accounts.asOf': 'Balances as of (today)',
    'accounting.accounts.trialBalance': 'Trial balance',
    'accounting.maps.hint': 'Choose which account each operation posts to. Changes apply to new postings; run "Resync ledger" to re-post history with the new accounts.',
    'accounting.maps.rule': 'Operation',
    'accounting.maps.account': 'Posts to account',
    'accounting.maps.default': 'Default',
    'accounting.maps.isDefault': 'Default',
    'accounting.maps.custom': 'Custom',
    'accounting.maps.reset': 'Reset',
    'accounting.maps.save': 'Save mappings',
    'accounting.maps.group.core': 'Orders and clients',
    'accounting.maps.group.payment_methods': 'Payment methods (money received into)',
    'accounting.maps.group.expenses': 'Expenses',
    'accounting.maps.group.assets': 'Assets',
    'accounting.health.run': 'Run checks',
    'accounting.health.ok': 'Balanced',
    'accounting.health.issues': 'Differences',
    'accounting.health.totalDebit': 'Total debit',
    'accounting.health.totalCredit': 'Total credit',
    'accounting.health.trialBalance': 'Trial balance',
    'accounting.health.unbalanced': 'Unbalanced entries',
    'accounting.health.receivable': 'Client receivables vs orders and payments',
    'accounting.health.receivableHint': 'Per client: receivable in the ledger vs billable orders minus payments plus refunds.',
    'accounting.health.wallets': 'Wallet liability vs wallet balances',
    'accounting.health.walletsHint': 'Per client: wallet liability in the ledger vs the wallet balance.',
    'accounting.health.statement': 'Client receivables vs client statement',
    'accounting.health.statementHint': 'The statement hides on-hold and disputed orders and never shows below zero, so differences here are expected.',
    'accounting.health.informational': 'Informational',
    'accounting.health.client': 'Client',
    'accounting.health.noClient': 'No client',
    'accounting.health.ledger': 'Ledger',
    'accounting.health.operations': 'Operations',
    'accounting.health.wallet_balance': 'Wallet balance',
    'accounting.health.statement_col': 'Statement',
    'accounting.health.difference': 'Difference',
    'accounting.health.noDifferences': 'No differences',
    'accounting.journal.subtitle': 'Every posting to the ledger, from operations and manual entries',
    'accounting.journal.countLabel': 'entries',
    'accounting.journal.newEntry': 'New journal entry',
    'accounting.journal.entry': 'Journal entry',
    'accounting.journal.number': 'Entry #',
    'accounting.journal.date': 'Date',
    'accounting.journal.event': 'Operation',
    'accounting.journal.source': 'Source',
    'accounting.journal.reference': 'Reference',
    'accounting.journal.memo': 'Memo',
    'accounting.journal.amount': 'Amount',
    'accounting.journal.statusLabel': 'Status',
    'accounting.journal.status.draft': 'Draft',
    'accounting.journal.status.posted': 'Posted',
    'accounting.journal.status.reversed': 'Reversed',
    'accounting.journal.status.reversal': 'Reversal',
    'accounting.journal.account': 'Account',
    'accounting.journal.details': 'Details',
    'accounting.journal.invoice': 'Invoice',
    'accounting.journal.total': 'Total',
    'accounting.journal.filteredTotal': 'Total of filtered entries',
    'accounting.journal.post': 'Post',
    'accounting.journal.saveDraft': 'Save as draft',
    'accounting.journal.void': 'Void',
    'accounting.journal.voidConfirm': 'Void this entry? A reversing entry will be posted.',
    'accounting.journal.deleteConfirm': 'Delete this draft?',
    'accounting.journal.revision': 'Revision {n}',
    'accounting.journal.reverses': 'Reverses',
    'accounting.journal.reversedBy': 'Reversed by',
    'accounting.journal.createdBy': 'Created by',
    'accounting.journal.system': 'System',
    'accounting.journal.automaticTitle': 'Posted automatically',
    'accounting.journal.automaticHint': 'This entry was generated from {source}. It cannot be deleted or voided here: delete or edit the source and the entry is reversed automatically.',
    'accounting.journal.openSource': 'Open source',
    'accounting.journal.postedAt': 'Posted at',
    'accounting.journal.search': 'Entry #, reference or memo',
    'accounting.journal.hideReversed': 'Hide reversed entries and their reversals',
    'accounting.journal.addLine': 'Add line',
    'accounting.journal.lineDescription': 'Line description',
    'accounting.journal.accountRequired': 'Select an account',
    'accounting.journal.difference': 'Difference',
    'accounting.journal.tax': 'Tax',
    'accounting.journal.taxLine': 'Tax',
    'accounting.journal.taxBase': 'Tax base: {{amount}}',
    'accounting.journal.taxedWith': 'Taxed: {{tax}}',
    'accounting.journal.taxTotal': 'Tax total',
    'accounting.journal.taxHint': 'Tax lines are added automatically to the matching tax account when the entry is saved.',
    'accounting.journal.withTax': 'Only entries with tax',
    'accounting.journal.disabledHint': 'New operations are not posted until accounting is enabled from the Chart of Accounts page.',
    'sidebar.cash_bank': 'Cash & Bank',
    'sidebar.suppliers': 'Suppliers',
    'sidebar.supplier_bills': 'Supplier Bills',
    'sidebar.aging_reports': 'Aging Reports',
    'accounting.source.cash_account': 'Opening balances',
    'accounting.source.cash_transfer': 'Transfers',
    'accounting.source.bill': 'Supplier bills',
    'accounting.source.bill_payment': 'Supplier payments',
    'accounting.maps.group.suppliers': 'Suppliers',
    'accounting.maps.group.cash': 'Cash & bank',
    'accounting.health.payables': 'Supplier payables vs bills and payments',
    'accounting.health.payablesHint': 'Per supplier: payable in the ledger vs unpaid bills minus unallocated payments.',
    'accounting.health.supplier': 'Supplier',
    'accounting.health.bills_col': 'Bills − payments',
    'accounting.deposit.placeholder': 'Default account',
    'accounting.deposit.defaultPlaceholder': 'Default: {name}',
    'accounting.cash.subtitle': 'Cash drawers, bank accounts and transfer channels with balances from the ledger',
    'accounting.cash.countLabel': 'accounts',
    'accounting.cash.add': 'Add account',
    'accounting.cash.edit': 'Edit account',
    'accounting.cash.name': 'Account',
    'accounting.cash.namePlaceholder': 'e.g. Front desk cash, CIB current account',
    'accounting.cash.nameRequired': 'Enter a name',
    'accounting.cash.type': 'Type',
    'accounting.cash.types.cash': 'Cash',
    'accounting.cash.types.bank': 'Bank',
    'accounting.cash.types.transfer': 'Transfer channel',
    'accounting.cash.typesPlural.cash': 'Cash',
    'accounting.cash.typesPlural.bank': 'Banks',
    'accounting.cash.typesPlural.transfer': 'Transfer channels',
    'accounting.cash.bankDetails': 'Bank details',
    'accounting.cash.bankDetailsHint': 'Link one of the bank accounts from Payment Settings (optional).',
    'accounting.cash.openingBalance': 'Opening balance',
    'accounting.cash.openingDate': 'Opening balance date',
    'accounting.cash.openingDateHint': 'Leave empty to use the date the account was created.',
    'accounting.cash.receives': 'Receives client payments by',
    'accounting.cash.receivesHint': 'Payments with these methods are deposited here unless another account is chosen on the payment.',
    'accounting.cash.methods.cash_on_delivery': 'Cash on delivery',
    'accounting.cash.methods.money_transfer': 'Money transfer',
    'accounting.cash.methods.credit_card': 'Credit card',
    'accounting.cash.expenseDefault': 'Pays expenses by default',
    'accounting.cash.expenseDefaultHint': 'Manual expenses without a "Paid from" account are paid from here.',
    'accounting.cash.paysExpenses': 'Pays expenses',
    'accounting.cash.active': 'Active',
    'accounting.cash.defaults': 'Used by default for',
    'accounting.cash.moneyIn': 'Money in',
    'accounting.cash.moneyOut': 'Money out',
    'accounting.cash.movements': 'Movements',
    'accounting.cash.opening': 'Opening balance',
    'accounting.cash.closing': 'Closing balance',
    'accounting.cash.totalBalance': 'Total balance',
    'accounting.cash.showInactive': 'Show inactive',
    'accounting.cash.deleteConfirm': 'Delete this account?',
    'accounting.cash.disabledHint': 'Balances and movements come from the ledger. Enable accounting from the Chart of Accounts page to see them.',
    'accounting.cash.tabs.accounts': 'Accounts',
    'accounting.cash.tabs.transfers': 'Transfers',
    'accounting.cash.transfer': 'Transfer money',
    'accounting.cash.from': 'From',
    'accounting.cash.to': 'To',
    'accounting.cash.sameAccount': 'Choose a different account',
    'accounting.cash.amount': 'Amount',
    'accounting.cash.date': 'Date',
    'accounting.cash.reference': 'Reference',
    'accounting.cash.operation': 'Operation',
    'accounting.cash.counterparty': 'Counterparty',
    'accounting.cash.deleteTransferConfirm': 'Delete this transfer? Its ledger entry will be reversed.',
    'accounting.suppliers.subtitle': 'Who you buy from, what you owe them and their statements',
    'accounting.suppliers.countLabel': 'suppliers',
    'accounting.suppliers.add': 'Add supplier',
    'accounting.suppliers.edit': 'Edit supplier',
    'accounting.suppliers.name': 'Supplier',
    'accounting.suppliers.nameRequired': 'Enter the supplier name',
    'accounting.suppliers.terms': 'Payment terms',
    'accounting.suppliers.termsHint': 'Days until a bill is due (sets the due date on new bills).',
    'accounting.suppliers.termsValue': '{n} days',
    'accounting.suppliers.days': 'days',
    'accounting.suppliers.taxNumber': 'Tax number',
    'accounting.suppliers.search': 'Name, phone, email or tax number',
    'accounting.suppliers.onlyWithBalance': 'Only suppliers with a balance',
    'accounting.suppliers.openBills': 'Open bills',
    'accounting.suppliers.totalBilled': 'Total billed',
    'accounting.suppliers.outstanding': 'Outstanding',
    'accounting.suppliers.overdue': 'Overdue',
    'accounting.suppliers.credit': 'Unapplied credit',
    'accounting.suppliers.statement': 'Statement',
    'accounting.suppliers.deleteConfirm': 'Delete this supplier?',
    'accounting.suppliers.document': 'Document',
    'accounting.suppliers.docType.bill': 'Bill',
    'accounting.suppliers.docType.payment': 'Payment',
    'accounting.suppliers.billed': 'Billed',
    'accounting.suppliers.paid': 'Paid',
    'accounting.bills.subtitle': 'Bills from suppliers and the payments that settle them',
    'accounting.bills.tabs.bills': 'Bills',
    'accounting.bills.tabs.payments': 'Payments',
    'accounting.bills.add': 'New bill',
    'accounting.bills.edit': 'Edit bill',
    'accounting.bills.bill': 'Bill',
    'accounting.bills.number': 'Bill #',
    'accounting.bills.supplier': 'Supplier',
    'accounting.bills.supplierRequired': 'Select a supplier',
    'accounting.bills.supplierReference': 'Supplier invoice #',
    'accounting.bills.supplierReferencePlaceholder': 'Number printed on their invoice',
    'accounting.bills.billDate': 'Bill date',
    'accounting.bills.dueDate': 'Due date',
    'accounting.bills.dueFromTerms': 'Leave empty to use the supplier terms: {date}',
    'accounting.bills.category': 'Expense type or account',
    'accounting.bills.expenseAccount': 'Expense account',
    'accounting.bills.categoryRequired': 'Choose what this line is for',
    'accounting.bills.expenseTypes': 'Expense types',
    'accounting.bills.ledgerAccounts': 'Ledger accounts',
    'accounting.bills.lineDescription': 'Description',
    'accounting.bills.quantity': 'Qty',
    'accounting.bills.unitPrice': 'Unit price',
    'accounting.bills.total': 'Total',
    'accounting.bills.paid': 'Paid',
    'accounting.bills.paidOnBill': 'Paid on this bill',
    'accounting.bills.ofPayment': 'of a {amount} payment',
    'accounting.bills.remaining': 'Remaining',
    'accounting.bills.search': 'Bill #, supplier invoice # or notes',
    'accounting.bills.status.label': 'Status',
    'accounting.bills.status.open': 'Open',
    'accounting.bills.status.partially_paid': 'Partially paid',
    'accounting.bills.status.paid': 'Paid',
    'accounting.bills.status.void': 'Void',
    'accounting.bills.status.draft': 'Draft',
    'accounting.bills.accountingDate': 'Accounting date',
    'accounting.bills.accountingDateHint': 'Optional: post to the ledger on this date instead of the bill date.',
    'accounting.bills.approve': 'Approve',
    'accounting.bills.approveConfirm': 'Approve this bill? It will be posted to the ledger and receive any stock items.',
    'accounting.bills.approvedBy': 'Approved by',
    'accounting.bills.audit': 'History',
    'accounting.bills.attachments.label': 'Attachments',
    'accounting.bills.attachments.hint': 'The supplier invoice, receipts or photos. Up to 20 MB per file.',
    'accounting.bills.attachments.choose': 'Attach files or images',
    'accounting.bills.attachments.tooLarge': 'This file is larger than 20 MB.',
    'accounting.bills.attachments.deleteConfirm': 'Delete this attachment?',
    'accounting.bills.attachments.deleteFailed': 'Could not delete the attachment.',
    'accounting.bills.attachments.uploadFailed': 'The bill was saved, but the files could not be uploaded.',
    'accounting.bills.discount': 'Discount',
    'accounting.bills.draftHint': 'This bill is a draft: it is not owed, has not been posted to the ledger and has not received any stock yet.',
    'accounting.bills.draftsWaiting': '{n} draft bill(s) waiting for approval.',
    'accounting.bills.showDrafts': 'Show drafts',
    'accounting.bills.entry.accountingOff': 'Accounting is not enabled, so nothing is posted.',
    'accounting.bills.entry.onApproval': 'Posted when the bill is approved.',
    'accounting.bills.lineType.label': 'Line type',
    'accounting.bills.lineType.expense': 'Expense',
    'accounting.bills.lineType.inventory': 'Stock item',
    'accounting.bills.lineType.production': 'Production',
    'accounting.bills.lineType.asset': 'Fixed asset',
    'accounting.bills.noStockItems': 'No stock items yet. Add them under Inventory.',
    'accounting.bills.noStockItemsCreate': 'No stock items yet. Create one below.',
    'accounting.bills.newStockItem': 'New stock item',
    'accounting.bills.manageStockItems': 'Manage stock items',
    'accounting.bills.printTitle': 'Supplier bill',
    'accounting.bills.printedAt': 'Printed {date}',
    'accounting.bills.currency': 'Currency',
    'accounting.bills.saveApprove': 'Save & approve',
    'accounting.bills.saveDraft': 'Save as draft',
    'accounting.bills.stockItem': 'Stock item',
    'accounting.bills.stockItemRequired': 'Choose the stock item',
    'accounting.bills.debitAccount': 'Debit account',
    'accounting.bills.stockAccountHint': "Stock is debited to the item's inventory account (Inventory / materials unless the item has its own). Change it on the item under Inventory.",
    'accounting.bills.stockMovements': 'Stock received',
    'accounting.bills.tabs.summary': 'Purchases vs costs',
    'accounting.bills.summary.hint': 'Purchases are what approved bills bought in the period. Costs are what the ledger recognized: stock becomes a cost when it is used (under work in progress, when the order it was issued to is billed). Supplier bills are never linked to orders.',
    'accounting.bills.summary.purchases': 'Purchases by type',
    'accounting.bills.summary.recognized': 'Recognized in the ledger',
    'accounting.bills.summary.bills': 'Bills',
    'accounting.bills.summary.net': 'Net',
    'accounting.bills.summary.revenue': 'Revenue',
    'accounting.bills.summary.directCosts': 'Direct costs',
    'accounting.bills.summary.grossProfit': 'Gross profit',
    'accounting.bills.summary.grossMargin': 'Gross margin',
    'accounting.bills.taxNotRecoverable': 'not recoverable',
    'accounting.bills.taxNotRecoverableHint': 'This tax cannot be reclaimed, so it is added to the cost of the line.',
    'accounting.postedEntries.empty': 'No journal entries.',
    'accounting.postedEntries.reversal': 'Reversal',
    'accounting.postedEntries.reversed': 'Reversed',
    'accounting.costing.productionFlow': 'Production costs',
    'accounting.costing.productionFlows.direct': 'Expense directly',
    'accounting.costing.productionFlows.wip': 'Work in progress',
    'accounting.costing.productionFlowHints.direct': 'Materials issued to an order are expensed when they are issued.',
    'accounting.costing.productionFlowHints.wip': 'Materials issued to an order are held in work in progress and moved to cost of sales when the order reaches its billable status. Changing this re-posts past entries.',
    'accounting.costing.orderCost.title': 'Production cost',
    'accounting.costing.orderCost.open': 'Production cost details',
    'accounting.costing.orderCost.released': 'Charged to cost of sales on',
    'accounting.costing.orderCost.notReleased': 'Still in work in progress (order not billed yet)',
    'accounting.costing.orderCost.wip': 'In work in progress',
    'accounting.costing.orderCost.recognized': 'Recognized costs',
    'accounting.costing.orderCost.grossProfit': 'Gross profit',
    'accounting.costing.orderCost.sources': 'Costs of this order',
    'accounting.costing.orderCost.source': 'Source',
    'accounting.costing.orderCost.sourceTypes.stock_movement': 'Stock issued',
    'accounting.costing.orderCost.productionCost': 'Production cost',
    'accounting.costing.orderCost.noSources': 'No costs recorded for this order.',
    'accounting.costing.orderCost.ledger': 'Posted to the ledger',
    'accounting.costing.orderCost.noLedger': 'Nothing posted for this order yet.',
    'accounting.costing.orderCost.section': 'Section',
    'accounting.costing.orderCost.sections.revenue': 'Revenue',
    'accounting.costing.orderCost.sections.work_in_progress': 'Work in progress',
    'accounting.costing.orderCost.sections.cost': 'Cost',
    'accounting.costing.orderCost.sections.formula_cost': 'Formula COGS (estimate)',
    'accounting.inventory.subtitle': 'Stock items, movements and valuation',
    'accounting.inventory.receiptsFromBills': 'Stock is received by approving a supplier bill with stock item lines. Issues, adjustments and supplier returns are recorded here.',
    'accounting.inventory.tabs.items': 'Items',
    'accounting.inventory.tabs.movements': 'Movements',
    'accounting.inventory.tabs.valuation': 'Valuation',
    'accounting.inventory.addItem': 'Add stock item',
    'accounting.inventory.editItem': 'Edit stock item',
    'accounting.inventory.item': 'Item',
    'accounting.inventory.items': 'Items',
    'accounting.inventory.itemName': 'Name',
    'accounting.inventory.sku': 'SKU',
    'accounting.inventory.unit': 'Unit',
    'accounting.inventory.unitPlaceholder': 'pcs, g, ml…',
    'accounting.inventory.account': 'Inventory account',
    'accounting.inventory.accountHint': 'Leave empty to use the default inventory account.',
    'accounting.inventory.accountLocked': 'The account cannot change once the item has stock movements.',
    'accounting.inventory.defaultAccount': 'Default',
    'accounting.inventory.reorderLevel': 'Reorder level',
    'accounting.inventory.active': 'Active',
    'accounting.inventory.inactive': 'Inactive',
    'accounting.inventory.belowReorder': 'Below reorder level',
    'accounting.inventory.showInactive': 'Show inactive',
    'accounting.inventory.searchItems': 'Search by name or SKU',
    'accounting.inventory.searchMovements': 'Search movements',
    'accounting.inventory.onHandQty': 'On hand',
    'accounting.inventory.averageCost': 'Average cost',
    'accounting.inventory.value': 'Value',
    'accounting.inventory.stockValue': 'Stock value',
    'accounting.inventory.noItems': 'No stock items.',
    'accounting.inventory.noMovements': 'No stock movements.',
    'accounting.inventory.deleteConfirm': 'Delete this item? Items with history are deactivated instead.',
    'accounting.inventory.recordMovement': 'Record movement',
    'accounting.inventory.movement': 'Stock movement',
    'accounting.inventory.number': 'Number',
    'accounting.inventory.type': 'Type',
    'accounting.inventory.movementType.receipt': 'Receipt',
    'accounting.inventory.movementType.issue': 'Issue',
    'accounting.inventory.movementType.adjustment': 'Adjustment',
    'accounting.inventory.movementType.supplier_return': 'Supplier return',
    'accounting.inventory.typeHint.issue': 'Takes stock out at average cost, into the order (work in progress or materials expense).',
    'accounting.inventory.typeHint.adjustment': 'Corrects stock after a count, damage or loss. Posted against the inventory adjustment account.',
    'accounting.inventory.typeHint.supplier_return': 'Sends stock back to the supplier and reduces what you owe them.',
    'accounting.inventory.counter': 'Counter entry',
    'accounting.inventory.voided': 'Voided',
    'accounting.inventory.quantity': 'Quantity',
    'accounting.inventory.unitCost': 'Unit cost',
    'accounting.inventory.unitCostHint': 'Leave empty to use the current average cost.',
    'accounting.inventory.direction': 'Direction',
    'accounting.inventory.increase': 'Add stock',
    'accounting.inventory.decrease': 'Remove stock',
    'accounting.inventory.reason': 'Reason',
    'accounting.inventory.reasons.count': 'Stock count',
    'accounting.inventory.reasons.damage': 'Damaged',
    'accounting.inventory.reasons.expiry': 'Expired',
    'accounting.inventory.reasons.loss': 'Lost',
    'accounting.inventory.reasons.found': 'Found',
    'accounting.inventory.reasons.opening': 'Opening stock',
    'accounting.inventory.reasons.other': 'Other',
    'accounting.inventory.order': 'Order',
    'accounting.inventory.orderHint': 'Optional: the order the material was used for (charged to materials expense).',
    'accounting.inventory.orderWipHint': 'Optional: held in the order\'s work in progress until it is billed.',
    'accounting.inventory.originalBill': 'Original bill',
    'accounting.inventory.creditAmount': 'Supplier credit',
    'accounting.inventory.creditAmountHint': 'What the supplier credits you. Leave empty for the stock value; any difference goes to purchase price variance.',
    'accounting.inventory.returnCurrencyHint': 'Only suppliers that bill in your currency.',
    'accounting.inventory.onHand': 'On hand: {qty} · average cost {cost}',
    'accounting.inventory.estimatedValue': 'Estimated value: {value}',
    'accounting.inventory.estimatedAll': 'Takes all remaining stock (about {value}).',
    'accounting.inventory.reference': 'Reference',
    'accounting.inventory.void': 'Void',
    'accounting.inventory.voidConfirm': 'Void this movement? A counter movement dated today is recorded and its journal entry reversed.',
    'accounting.inventory.receiptHint': 'Receipts follow their supplier bill: edit or void the bill to change them.',
    'accounting.inventory.receiptNoEntry': 'Receipts are posted by their supplier bill.',
    'accounting.inventory.asOf': 'As of',
    'accounting.inventory.itemsValue': 'Stock items value',
    'accounting.inventory.ledgerBalance': 'Ledger balance',
    'accounting.inventory.valueOnly': 'Not tracked by item',
    'accounting.inventory.valueOnlyHint': 'Inventory posted without stock items (formula material costs, stock counts, manual entries).',
    'accounting.inventory.byItem': 'By item',
    'accounting.inventory.byAccount': 'By inventory account',
    'accounting.tax.input_recoverable': 'Recoverable on purchases',
    'accounting.tax.input_recoverable_hint': 'When off, this tax on supplier bills is added to the cost instead of the recoverable input tax account.',
    'accounting.tax.not_recoverable': 'Not recoverable',
    'accounting.bills.status.unpaid': 'Unpaid (open + partial)',
    'accounting.bills.status.overdue': 'Overdue',
    'accounting.bills.overdueDays': '{n} days overdue',
    'accounting.bills.void': 'Void',
    'accounting.bills.voidConfirm': 'Void this bill? Its ledger entry will be reversed.',
    'accounting.bills.deleteConfirm': 'Delete this bill?',
    'accounting.bills.payments': 'Payments',
    'accounting.bills.noPayments': 'No payments yet',
    'accounting.bills.noSuppliers': 'Add a supplier first from the Suppliers page.',
    'accounting.payments.add': 'Pay supplier',
    'accounting.payments.edit': 'Edit payment',
    'accounting.payments.number': 'Payment #',
    'accounting.payments.paidFrom': 'Paid from',
    'accounting.payments.reference': 'Reference',
    'accounting.payments.referencePlaceholder': 'Cheque or transfer number',
    'accounting.payments.allocation': 'Apply to bills',
    'accounting.payments.autoAllocate': 'Oldest bills first',
    'accounting.payments.allocate': 'Apply',
    'accounting.payments.allocated': 'Applied to bills',
    'accounting.payments.unallocated': 'Unapplied',
    'accounting.payments.unallocatedHint': 'The unapplied amount stays as credit with the supplier and can be applied to later bills.',
    'accounting.payments.overAllocated': 'The amounts applied to bills are more than the payment.',
    'accounting.payments.noOpenBills': 'This supplier has no unpaid bills',
    'accounting.payments.pickSupplier': 'Select a supplier to see their unpaid bills',
    'accounting.payments.deleteConfirm': 'Delete this payment? The bills it paid become unpaid again.',
    'accounting.payments.totalPaid': 'Total paid',
    'accounting.aging.subtitle': 'How long amounts have been due, for clients and suppliers',
    'accounting.aging.receivables': 'Receivables (clients)',
    'accounting.aging.payables': 'Payables (suppliers)',
    'accounting.aging.receivablesHint': 'Unpaid orders as of {date}. Billable orders are aged from the day they reached the billable status; Total matches the client balance. Orders that have not reached the billable status yet are shown under "Not yet due" and are not counted in Total.',
    'accounting.aging.payablesHint': 'Unpaid supplier bills as of {date}, aged from their due date.',
    'accounting.aging.buckets.current': 'Not yet due',
    'accounting.aging.buckets.1_30': '1–30 days',
    'accounting.aging.buckets.31_60': '31–60 days',
    'accounting.aging.buckets.61_90': '61–90 days',
    'accounting.aging.buckets.over_90': 'Over 90 days',
    'accounting.aging.total': 'Total',
    'accounting.aging.client': 'Client',
    'accounting.aging.supplier': 'Supplier',
    'accounting.aging.oldestDue': 'Oldest due',
    'accounting.aging.order': 'Order',
    'accounting.aging.invoice': 'Invoice',
    'accounting.aging.notInvoiced': 'Not invoiced',
    'accounting.aging.dueDate': 'Due date',
    'accounting.aging.age': 'Age',
    'accounting.aging.daysOverdue': '{n} days overdue',
    'accounting.aging.dueToday': 'Due today',
    'accounting.aging.outstanding': 'Outstanding',
    'accounting.aging.net': 'Net owed',
    'accounting.aging.refresh': 'Refresh',
    'sidebar.financial_reports': 'Financial Reports',
    'sidebar.bank_reconciliation': 'Bank Reconciliation',
    'sidebar.period_close': 'Period Close',
    'sidebar.technician_settlements': 'Technician Settlements',
    'sidebar.salaries': 'Salaries',
    'sidebar.lab_costing': 'Lab Costing',
    'sidebar.inventory': 'Inventory',
    'sidebar.tax': 'Tax',
    'sidebar.financial_insights': 'Financial Insights',
    'sidebar.finance_group_sales': 'Sales',
    'sidebar.finance_group_expenses': 'Expenses & Suppliers',
    'sidebar.finance_group_cash_bank': 'Cash & Bank',
    'sidebar.finance_group_accounting': 'Accounting',
    'sidebar.finance_group_reports': 'Reports & Insights',
    'accounting.maps.group.tax': 'Tax',
    'accounting.maps.group.currency': 'Foreign currency',
    'accounting.source.fx_revaluation': 'FX revaluation',
    'accounting.export.button': 'Export',
    'accounting.export.csv': 'CSV',
    'accounting.export.excel': 'Excel',
    'accounting.reports.tabs.subsidiary_ledger': 'Sub-ledger',
    'accounting.reports.gl.partyFilter': '{type}: {name}',
    'accounting.reports.sub.pickAccount': 'Choose a control account',
    'accounting.reports.sub.pickAccountHint': 'Pick a control account (receivables, payables, technicians…) or a parent account to see the balance of every party or sub-account under it.',
    'accounting.reports.sub.byParty': 'By party',
    'accounting.reports.sub.byAccount': 'By sub-account',
    'accounting.reports.sub.search': 'Search names',
    'accounting.reports.sub.party': 'Party',
    'accounting.reports.sub.opening': 'Opening',
    'accounting.reports.sub.closing': 'Closing',
    'accounting.reports.sub.foreign': 'Foreign balance',
    'accounting.reports.sub.lastActivity': 'Last activity',
    'accounting.reports.sub.total': 'Total ({count})',
    'accounting.reports.sub.unassigned': 'Not linked to a party',
    'accounting.reports.sub.unassignedHint': '{amount} of this account is not linked to any party. Open the row to review those entries.',
    'accounting.reports.sub.partyTypes.client': 'Client',
    'accounting.reports.sub.partyTypes.supplier': 'Supplier',
    'accounting.reports.sub.partyTypes.user': 'Technician',
    'accounting.reports.sub.partyTypes.none': 'No party',
    'accounting.cash.amountIn': 'Amount ({currency})',
    'accounting.cash.receivedIn': 'Amount received ({currency})',
    'accounting.cash.receivedBase': 'Amount received (base currency)',
    'accounting.cash.receivedHint': 'The accounts use different currencies. Enter what arrived; leave empty to convert at the day\'s rate.',
    'accounting.bills.exchangeRate': 'Rate: 1 {currency} = ? {base}',
    'accounting.bills.exchangeRateHint': 'Leave empty to use the saved rate for the date.',
    'accounting.bills.foreignHint': 'Amounts on this bill are in {currency}.',
    'accounting.bills.noTax': 'No tax',
    'accounting.bills.itemsPurchased': 'Items purchased',
    'accounting.bills.item': 'Item',
    'accounting.bills.itemPlaceholder': 'Item, e.g. Zirconia discs',
    'accounting.bills.postTo': 'Post to',
    'accounting.bills.tax': 'Tax',
    'accounting.bills.subtotal': 'Subtotal',
    'accounting.bills.totalBill': 'Total bill',
    'accounting.bills.outstanding': 'Outstanding',
    'accounting.bills.paidNow.title': 'Already paid on this bill',
    'accounting.bills.paidNow.label': 'Paid now',
    'accounting.bills.paidNow.payInFull': 'Paid in full',
    'accounting.bills.paidNow.paidFromRequired': 'Choose the account the money was paid from',
    'accounting.bills.paidNow.aboveTotal': 'Cannot be more than the bill total',
    'accounting.bills.paidNow.hint': 'Leave empty if nothing is paid yet. It is recorded as a supplier payment on the bill date; pay the rest later with "Pay supplier".',
    'accounting.bills.entry.title': 'How it is recorded in the accounts',
    'accounting.bills.entry.onBill': 'When the bill is saved',
    'accounting.bills.entry.onPayment': 'When the payment is recorded',
    'accounting.bills.entry.payable': 'Accounts payable',
    'accounting.bills.entry.inputTax': 'Input tax recoverable',
    'accounting.bills.entry.cash': 'Cash / bank',
    'accounting.bills.entry.empty': 'Enter item amounts to see the entry',
    'accounting.bills.entry.foreign': 'Amounts are in {currency}; the ledger records them in {base} at the bill exchange rate.',
    'accounting.statement.tab': 'Bank statements',
    'accounting.statement.import': 'Import statement',
    'accounting.statement.import_lines': 'Import {count} lines',
    'accounting.statement.imported': 'Statement imported.',
    'accounting.statement.account': 'Bank or cash account',
    'accounting.statement.drop': 'Click or drop the bank statement file here',
    'accounting.statement.drop_hint': 'CSV export from your bank or an OFX/QFX file, up to 5 MB. Lines already imported are skipped.',
    'accounting.statement.mapping': 'Columns',
    'accounting.statement.columns.date': 'Date',
    'accounting.statement.columns.description': 'Description',
    'accounting.statement.columns.reference': 'Reference',
    'accounting.statement.columns.amount': 'Amount (+/−)',
    'accounting.statement.columns.money_in': 'Money in',
    'accounting.statement.columns.money_out': 'Money out',
    'accounting.statement.columns.balance': 'Balance',
    'accounting.statement.date_format': 'Date format',
    'accounting.statement.decimal': 'Number format',
    'accounting.statement.delimiter': 'Separator',
    'accounting.statement.auto': 'Auto',
    'accounting.statement.skip_rows': 'Skip rows at top',
    'accounting.statement.negate': 'Flip signs (the bank shows withdrawals as positive)',
    'accounting.statement.preview_count': 'Showing {shown} of {total} lines',
    'accounting.statement.date': 'Date',
    'accounting.statement.description': 'Description',
    'accounting.statement.reference': 'Reference',
    'accounting.statement.amount': 'Amount',
    'accounting.statement.balance': 'Balance',
    'accounting.statement.status': 'Status',
    'accounting.statement.statuses.unmatched': 'Unmatched',
    'accounting.statement.statuses.matched': 'Matched',
    'accounting.statement.statuses.ignored': 'Ignored',
    'accounting.statement.match': 'Match',
    'accounting.statement.unmatch': 'Unmatch',
    'accounting.statement.ignore': 'Ignore',
    'accounting.statement.restore': 'Restore',
    'accounting.statement.create_entry': 'Create entry',
    'accounting.statement.post_entry': 'Post entry',
    'accounting.statement.entry_hint_in': '{amount} came into the account on {date}. Choose where it came from.',
    'accounting.statement.entry_hint_out': '{amount} left the account on {date}. Choose what it paid for.',
    'accounting.statement.counter_account': 'Other account',
    'accounting.statement.memo': 'Memo',
    'accounting.statement.auto_match': 'Auto-match',
    'accounting.statement.auto_match_hint': 'Matches unmatched lines to ledger movements with the same amount within a few days.',
    'accounting.statement.search': 'Description or reference',
    'accounting.statement.empty': 'No statement lines. Import a statement to start matching.',
    'accounting.statement.imports': 'Imported files',
    'accounting.statement.file': 'File',
    'accounting.statement.period': 'Period',
    'accounting.statement.lines': 'Lines',
    'accounting.statement.lines_summary': '{lines} lines · {matched} matched · {duplicates} skipped',
    'accounting.statement.closing_balance': 'Closing balance',
    'accounting.statement.imported_by': 'Imported',
    'accounting.statement.delete_import_confirm': 'Delete this import and all its lines? Matches are removed; journal entries stay.',
    'accounting.statement.find_match': 'Find a ledger match',
    'accounting.statement.fit': 'Fit',
    'accounting.statement.exact_amount': 'Exact amount',
    'accounting.statement.days_apart': '{days} days apart',
    'accounting.statement.no_suggestions': 'No ledger movements with a similar amount around this date',
    'accounting.statement.apply': 'Tick from statement',
    'accounting.statement.apply_hint': 'Marks as cleared every ledger line matched to an imported statement line up to the statement date, and fills the statement balance when the file has one.',
    'accounting.tax.title': 'Tax',
    'accounting.tax.subtitle': 'Tax rules, rates, client tax details, tax reports and electronic invoicing',
    'accounting.tax.tabs.profile': 'Settings',
    'accounting.tax.tabs.rates': 'Rates',
    'accounting.tax.tabs.rules': 'Rules',
    'accounting.tax.tabs.clients': 'Client tax details',
    'accounting.tax.tabs.report': 'Tax report',
    'accounting.tax.profile': 'Tax profile',
    'accounting.tax.jurisdiction': 'Country / tax system',
    'accounting.tax.jurisdiction_hint': 'Based on the lab currency ({currency}).',
    'accounting.tax.enabled': 'Use the tax engine',
    'accounting.tax.enabled_hint': 'When off, orders keep using the simple VAT setting.',
    'accounting.tax.simple_vat': 'Simple VAT %',
    'accounting.tax.simple_vat_hint': 'Applied to new orders while the tax engine is off. Existing orders keep their VAT.',
    'accounting.tax.registered': 'Tax registered',
    'accounting.tax.registration_number': 'Tax registration number',
    'accounting.tax.invoice_address': 'Address on tax invoices',
    'accounting.tax.invoice_address_hint': 'Printed under the lab name on tax invoices (E-Invoice). Leave empty to use the lab profile address.',
    'accounting.tax.profile_saved': 'Tax settings saved.',
    'accounting.tax.tax_types': 'Tax types',
    'accounting.tax.no_tax_types': 'Choose a country to load its tax types.',
    'accounting.tax.install_templates': 'Install standard rates',
    'accounting.tax.install_templates_hint': 'Adds the official rates for the selected country. Existing rates are kept.',
    'accounting.tax.templates_installed': 'Standard rates installed.',
    'accounting.tax.recalculate': 'Recalculate tax',
    'accounting.tax.recalculate_hint': 'Re-applies the current rules to unpaid orders from this date. Paid orders and closed periods are not changed.',
    'accounting.tax.recalculate_confirm': 'Recalculate tax on unpaid orders from this date?',
    'accounting.tax.recalculated': '{count} orders recalculated.',
    'accounting.tax.add_rate': 'Add rate',
    'accounting.tax.edit_rate': 'Edit rate',
    'accounting.tax.rate_name': 'Name',
    'accounting.tax.tax_type': 'Tax type',
    'accounting.tax.treatment': 'Treatment',
    'accounting.tax.treatments.standard': 'Standard',
    'accounting.tax.treatments.reduced': 'Reduced',
    'accounting.tax.treatments.zero_rated': 'Zero-rated',
    'accounting.tax.treatments.exempt': 'Exempt',
    'accounting.tax.treatments.out_of_scope': 'Out of scope',
    'accounting.tax.treatments.reverse_charge': 'Reverse charge',
    'accounting.tax.treatments.additional': 'Additional tax',
    'accounting.tax.treatments.withholding': 'Withholding',
    'accounting.tax.rate': 'Rate',
    'accounting.tax.fixed_amount': 'Fixed amount',
    'accounting.tax.subtype': 'Official subtype code',
    'accounting.tax.subtype_hint': 'Code required by the tax authority, e.g. V009 for Egypt.',
    'accounting.tax.effective_period': 'Effective',
    'accounting.tax.effective_from': 'Effective from',
    'accounting.tax.effective_until': 'Effective until',
    'accounting.tax.usage': 'Used',
    'accounting.tax.default': 'Default',
    'accounting.tax.default_hint': 'Applied when no rule matches.',
    'accounting.tax.active': 'Active',
    'accounting.tax.inactive': 'Inactive',
    'accounting.tax.rate_saved': 'Tax rate saved.',
    'accounting.tax.rate_deleted': 'Tax rate removed.',
    'accounting.tax.rate_delete_confirm': 'Delete this rate?',
    'accounting.tax.rate_deactivate_confirm': 'This rate is already used, so it will be deactivated instead of deleted. Continue?',
    'accounting.tax.rules_hint': 'Rules pick the tax rate for each order line. The matching rule with the highest priority wins; if none match, the default rate applies.',
    'accounting.tax.add_rule': 'Add rule',
    'accounting.tax.edit_rule': 'Edit rule',
    'accounting.tax.priority': 'Priority',
    'accounting.tax.priority_hint': 'Higher wins',
    'accounting.tax.applies_to': 'Applies to',
    'accounting.tax.applies.all': 'Everything',
    'accounting.tax.applies.formula_type': 'A product type',
    'accounting.tax.applies.additional_cost': 'Additional costs',
    'accounting.tax.applies.delivery': 'Delivery',
    'accounting.tax.formula_type': 'Product type',
    'accounting.tax.conditions': 'Client conditions',
    'accounting.tax.any_client': 'Any client',
    'accounting.tax.any': 'Any',
    'accounting.tax.client_type': 'Client type',
    'accounting.tax.client_types.business': 'Business',
    'accounting.tax.client_types.individual': 'Individual',
    'accounting.tax.client_types.government': 'Government',
    'accounting.tax.client_country': 'Client country',
    'accounting.tax.country_hint': 'Two-letter country code, e.g. EG',
    'accounting.tax.notes': 'Notes',
    'accounting.tax.rule_saved': 'Tax rule saved.',
    'accounting.tax.rule_deleted': 'Tax rule deleted.',
    'accounting.tax.rule_delete_confirm': 'Delete this rule?',
    'accounting.tax.client': 'Client',
    'accounting.tax.tax_id': 'Tax registration number',
    'accounting.tax.tax_id_hint': 'For individuals in Egypt, enter the national ID (required on invoices above 50,000 EGP).',
    'accounting.tax.country': 'Country',
    'accounting.tax.exemption': 'Exemption reference',
    'accounting.tax.address': 'Tax address',
    'accounting.tax.address_fields.governate': 'Governorate',
    'accounting.tax.address_fields.regionCity': 'City / area',
    'accounting.tax.address_fields.street': 'Street',
    'accounting.tax.address_fields.buildingNumber': 'Building number',
    'accounting.tax.not_set': 'Not set',
    'accounting.tax.search_clients': 'Search clients',
    'accounting.tax.missing_only': 'Only clients missing tax details',
    'accounting.tax.edit_client': 'Tax details · {name}',
    'accounting.tax.client_saved': 'Client tax details saved.',
    'accounting.tax.summary': 'Summary',
    'accounting.tax.output_tax': 'Output tax (sales)',
    'accounting.tax.input_tax': 'Input tax (purchases)',
    'accounting.tax.net_payable': 'Net payable',
    'accounting.tax.output_detail': 'Sales by tax rate',
    'accounting.tax.input_detail': 'Purchases by tax rate',
    'accounting.tax.taxable_base': 'Taxable amount',
    'accounting.tax.tax_amount': 'Tax',
    'accounting.tax.documents': 'Documents',
    'accounting.tax.ledger_movement': 'Tax accounts in the ledger',
    'accounting.tax.ledger_hint': 'Movement on the tax accounts in the same period, to reconcile against the report.',
    'accounting.tax.account': 'Account',
    'accounting.tax.debit': 'Debit',
    'accounting.tax.credit': 'Credit',
    'accounting.tax.net': 'Net',
    'accounting.tax.report_legacy_hint': 'The tax engine is off, so sales tax comes from the simple VAT setting on each order.',
    'accounting.tax.engine': 'Tax engine',
    'accounting.tax.engine_on': 'On',
    'accounting.tax.engine_off': 'Off (simple VAT)',
    'accounting.einvoice.tab': 'E-invoicing',
    'accounting.einvoice.menu': 'E-invoice',
    'accounting.einvoice.settings': 'Connection settings',
    'accounting.einvoice.settings_saved': 'E-invoicing settings saved.',
    'accounting.einvoice.provider': 'Provider',
    'accounting.einvoice.environment': 'Environment',
    'accounting.einvoice.environments.sandbox': 'Test (sandbox)',
    'accounting.einvoice.environments.production': 'Live (production)',
    'accounting.einvoice.enabled': 'Enabled',
    'accounting.einvoice.auto_submit': 'Submit new invoices automatically',
    'accounting.einvoice.auto_submit_hint': 'Invoices missing required data are recorded as rejected so you can fix and retry them.',
    'accounting.einvoice.integration.not_configured': 'Not configured',
    'accounting.einvoice.integration.configured': 'Configured',
    'accounting.einvoice.integration.connected': 'Connected',
    'accounting.einvoice.integration.failed': 'Connection failed',
    'accounting.einvoice.last_tested': 'Tested {at}',
    'accounting.einvoice.missing_trn': 'Add the lab tax registration number in the Settings tab before submitting e-invoices.',
    'accounting.einvoice.config.activity_code': 'Activity code',
    'accounting.einvoice.config.activity_code_hint': 'Taxpayer activity code registered with the ETA, e.g. 8690.',
    'accounting.einvoice.config.branch_id': 'Branch ID',
    'accounting.einvoice.config.branch_id_hint': 'Use 0 for the main branch.',
    'accounting.einvoice.config.issuer_address': 'Lab branch address',
    'accounting.einvoice.config.item_type': 'Item coding',
    'accounting.einvoice.config.default_item_code': 'Default item code',
    'accounting.einvoice.config.default_item_code_hint': 'Registered EGS/GS1 code used for orders without a specific code.',
    'accounting.einvoice.config.item_codes': 'Item codes per product type',
    'accounting.einvoice.config.item_codes_hint': '(optional, overrides the default code)',
    'accounting.einvoice.config.unit_type': 'Unit type',
    'accounting.einvoice.config.unit_type_hint': 'ETA unit code, usually EA.',
    'accounting.einvoice.config.document_version': 'Document version',
    'accounting.einvoice.config.document_version_hint': '0.9 is unsigned and only allowed in the test environment; 1.0 needs a signing service.',
    'accounting.einvoice.config.signer_url': 'Signing service URL',
    'accounting.einvoice.config.signer_url_hint': 'Service that signs documents with your e-seal or token (required for version 1.0).',
    'accounting.einvoice.fields.client_id': 'Client ID',
    'accounting.einvoice.fields.client_secret': 'Client secret',
    'accounting.einvoice.fields.signer_token': 'Signer token',
    'accounting.einvoice.credentials': 'Credentials',
    'accounting.einvoice.credentials_hint': 'Stored encrypted and never shown again. Leave a field empty to keep the saved value.',
    'accounting.einvoice.stored': 'Saved',
    'accounting.einvoice.clear': 'Remove',
    'accounting.einvoice.test_connection': 'Test connection',
    'accounting.einvoice.connection_ok': 'Connected successfully.',
    'accounting.einvoice.documents': 'Submitted documents',
    'accounting.einvoice.invoice_id': 'Invoice ID',
    'accounting.einvoice.check_invoice': 'Check invoice',
    'accounting.einvoice.status': 'Status',
    'accounting.einvoice.statuses.pending': 'Queued',
    'accounting.einvoice.statuses.submitted': 'Submitted',
    'accounting.einvoice.statuses.accepted': 'Valid',
    'accounting.einvoice.statuses.rejected': 'Rejected',
    'accounting.einvoice.statuses.retry_pending': 'Will retry',
    'accounting.einvoice.statuses.cancelled': 'Cancelled',
    'accounting.einvoice.search': 'Invoice #, UUID or client',
    'accounting.einvoice.invoice': 'Invoice',
    'accounting.einvoice.amount': 'Amount',
    'accounting.einvoice.uuid': 'Authority UUID',
    'accounting.einvoice.submitted_at': 'Submitted',
    'accounting.einvoice.attempts': 'Attempts',
    'accounting.einvoice.error': 'Error',
    'accounting.einvoice.open_portal': 'Open on the tax authority portal',
    'accounting.einvoice.refresh': 'Check status',
    'accounting.einvoice.retry': 'Resubmit',
    'accounting.einvoice.updated': 'Updated.',
    'accounting.einvoice.cancel': 'Cancel e-invoice',
    'accounting.einvoice.cancel_title': 'Cancel e-invoice {reference}',
    'accounting.einvoice.cancel_hint': 'The tax authority requires a reason. Cancellation is only possible within the authority\'s allowed window.',
    'accounting.einvoice.cancel_reason': 'Reason',
    'accounting.einvoice.cancelled': 'E-invoice cancelled.',
    'accounting.einvoice.invoice_title': 'E-invoice · {reference}',
    'accounting.einvoice.not_ready': 'This invoice cannot be submitted yet',
    'accounting.einvoice.ready': 'All required data is present',
    'accounting.einvoice.submit': 'Submit to tax authority',
    'accounting.einvoice.queued': 'Submission queued.',
    'accounting.einvoice.payload': 'Document preview (JSON)',
    'accounting.einvoice.no_documents': 'Not submitted yet',
    'accounting.einvoice.total': 'Invoice total: {amount}',
    'accounting.insights.title': 'Financial insights',
    'accounting.insights.subtitle': 'Alerts on margins, overdue receivables and cash runway',
    'accounting.insights.analysis_period': 'Margins & aging period',
    'accounting.insights.thresholds': 'Alert thresholds',
    'accounting.insights.thresholds_saved': 'Alert thresholds saved.',
    'accounting.insights.threshold_margin': 'Warn when an order margin is below (%)',
    'accounting.insights.threshold_overdue': 'Receivables overdue after (days)',
    'accounting.insights.threshold_runway': 'Warn when cash covers less than (months)',
    'accounting.insights.disabled': 'Accounting is not enabled, so ledger-based figures may be empty.',
    'accounting.insights.alerts': 'Alerts',
    'accounting.insights.no_alerts': 'Nothing needs attention right now.',
    'accounting.insights.kpi.revenue': 'Revenue (month to date)',
    'accounting.insights.kpi.gross_profit': 'Gross profit',
    'accounting.insights.kpi.net_profit': 'Net profit',
    'accounting.insights.kpi.expenses': 'Costs & expenses',
    'accounting.insights.vs_last_month': 'Last month: {amount}',
    'accounting.insights.mtd_note': '{from} → {to}, compared with {compare_from} → {compare_to}',
    'accounting.insights.gross_margin': 'Gross margin {pct}',
    'accounting.insights.trend': 'Last 12 months',
    'accounting.insights.revenue': 'Revenue',
    'accounting.insights.expenses': 'Expenses',
    'accounting.insights.net_cash': 'Net cash flow',
    'accounting.insights.runway': 'Cash runway',
    'accounting.insights.runway_months': 'Months of cash left',
    'accounting.insights.cash_positive': 'Cash-positive',
    'accounting.insights.cash_balance': 'Cash & bank',
    'accounting.insights.avg_inflow': 'Average monthly in',
    'accounting.insights.avg_outflow': 'Average monthly out',
    'accounting.insights.monthly_burn': 'Monthly burn',
    'accounting.insights.measured': 'Based on {from} → {to}',
    'accounting.insights.low_margin_orders': 'Orders below {threshold}% margin',
    'accounting.insights.low_margin_clients': 'Clients below {threshold}% margin',
    'accounting.insights.overall_margin': 'Overall margin {pct}',
    'accounting.insights.showing_of': 'Showing {shown} of {total}',
    'accounting.insights.order': 'Order',
    'accounting.insights.client': 'Client',
    'accounting.insights.orders': 'Orders',
    'accounting.insights.margin': 'Margin',
    'accounting.insights.margin_pct': 'Margin %',
    'accounting.insights.overdue_receivables': 'Receivables overdue more than {days} days',
    'accounting.insights.total_receivable': 'Total receivable',
    'accounting.insights.overdue_amount': 'Overdue',
    'accounting.insights.overdue_share': 'Overdue share',
    'accounting.insights.oldest_days': 'Oldest (days)',
    'accounting.insights.payables': 'Supplier bills due (next {days} days)',
    'accounting.insights.total_payable': 'Total payable',
    'accounting.insights.due_soon_amount': 'Due soon',
    'accounting.insights.bill': 'Bill',
    'accounting.insights.due_date': 'Due date',
    'accounting.insights.amount': 'Amount',
    'accounting.insights.status': 'Status',
    'accounting.insights.days_overdue': '{days} days overdue',
    'accounting.insights.due_soon': 'Due soon',
    'accounting.source.technician_settlement': 'Technician settlements',
    'accounting.source.technician_payment': 'Technician payments',
    'accounting.maps.group.costing': 'Lab costing',
    'accounting.health.technicians': 'Technician payable vs settlements',
    'accounting.health.techniciansHint': 'Per technician: payable in the ledger vs approved settlements minus their payments.',
    'accounting.health.technician': 'Technician',
    'accounting.health.settlements_col': 'Settlements − payments',
    'accounting.settlements.subtitle': 'Pay technicians per period from the orders assigned to them, then record what you paid.',
    'accounting.settlements.tabs.settlements': 'Settlements',
    'accounting.settlements.tabs.payments': 'Payments',
    'accounting.settlements.add': 'New settlement',
    'accounting.settlements.edit': 'Edit settlement',
    'accounting.settlements.settlement': 'Settlement',
    'accounting.settlements.number': 'Settlement #',
    'accounting.settlements.technician': 'Technician',
    'accounting.settlements.technicianRequired': 'Choose a technician',
    'accounting.settlements.period': 'Period',
    'accounting.settlements.date': 'Settlement date',
    'accounting.settlements.loadOrders': 'Load orders',
    'accounting.settlements.pickTechnicianPeriod': 'Choose a technician and a period first.',
    'accounting.settlements.noOrders': 'No orders loaded. Pick a technician and period, then click "Load orders".',
    'accounting.settlements.order': 'Order',
    'accounting.settlements.units': 'Units',
    'accounting.settlements.share': 'Share',
    'accounting.settlements.editSplit': 'Edit the split between technicians',
    'accounting.settlements.splitTitle': 'Split between technicians',
    'accounting.settlements.rateTotal': 'Order piece rate',
    'accounting.settlements.splitEqually': 'Split equally',
    'accounting.settlements.splitMustTotal': 'The shares must total 100%.',
    'accounting.settlements.splitLocked': 'This technician\'s settlement of the order is approved, so their share is fixed. Void it to change it.',
    'accounting.settlements.splitHint': 'The split applies to every technician\'s settlement of this order. Draft settlements are updated to the new share.',
    'accounting.settlements.paidAsExpenses': '{count} expense(s) totalling {amount} were already paid to this technician in the period as manual expenses. Make sure you are not paying them twice.',
    'accounting.settlements.adjustments': 'Adjustments',
    'accounting.settlements.adjustment': 'Adjustment',
    'accounting.settlements.addAdjustment': 'Add bonus or deduction',
    'accounting.settlements.adjustmentDescription': 'Describe the adjustment',
    'accounting.settlements.adjustmentPlaceholder': 'e.g. Weekend bonus, advance deduction',
    'accounting.settlements.adjustmentAmount': 'Amount (− for deductions)',
    'accounting.settlements.ordersTotal': 'Orders',
    'accounting.settlements.total': 'Total',
    'accounting.settlements.postingHint': 'Drafts post nothing. Approving debits technician labor and credits Technician payable.',
    'accounting.settlements.saveDraft': 'Save draft',
    'accounting.settlements.saveApprove': 'Save & approve',
    'accounting.settlements.approve': 'Approve',
    'accounting.settlements.approvedBy': 'Approved by',
    'accounting.settlements.void': 'Void',
    'accounting.settlements.voidConfirm': 'Void this settlement? Its posting is reversed and its orders become available again.',
    'accounting.settlements.deleteConfirm': 'Delete this settlement?',
    'accounting.settlements.pay': 'Pay technician',
    'accounting.settlements.noUnpaid': 'No approved settlements left to pay',
    'accounting.settlements.line': 'Line',
    'accounting.settlements.search': 'Search number, technician or notes',
    'accounting.settlements.approvedTotal': 'Approved',
    'accounting.settlements.owed': 'Still owed',
    'accounting.settlements.drafts': 'Drafts',
    'accounting.settlements.owedTo': 'Still owed to technicians',
    'accounting.settlements.noTechnicians': 'No technicians yet. Add users with the technician type to settle their work.',
    'accounting.settlements.status.label': 'Status',
    'accounting.settlements.status.draft': 'Draft',
    'accounting.settlements.status.approved': 'Approved',
    'accounting.settlements.status.partially_paid': 'Partially paid',
    'accounting.settlements.status.paid': 'Paid',
    'accounting.settlements.status.void': 'Void',
    'accounting.settlements.status.unpaid': 'Unpaid',
    'accounting.settlements.printTitle': 'Technician settlement',
    'accounting.settlements.patient': 'Patient',
    'accounting.settlements.technicianSignature': 'Technician signature',
    'accounting.source.salary_run': 'Salary runs',
    'accounting.source.salary_payment': 'Salary payments',
    'accounting.maps.group.payroll': 'Salaries',
    'accounting.health.salaries': 'Salaries payable vs salary runs',
    'accounting.health.salariesHint': 'Per employee: salaries payable in the ledger vs approved salary runs minus their payments.',
    'accounting.health.employee': 'Employee',
    'accounting.health.salary_runs_col': 'Salary runs − payments',
    'accounting.health.materials': 'Material inventory',
    'accounting.health.materialsOk': 'No warnings',
    'accounting.health.materialsWarning': 'Needs attention',
    'accounting.health.materialsHint': 'Material costing method: {method}. These warnings do not affect the overall result.',
    'accounting.health.inventoryBalance': 'Material inventory (1500)',
    'accounting.health.inventoryNegative': 'More materials were issued from stock than the supplier bills and stock counts added. Enter the missing supplier bills or run a stock count.',
    'accounting.salaries.subtitle': 'Monthly salaries of your staff (admins, technicians, couriers, accountants): run payroll each month, then record what you paid.',
    'accounting.salaries.tabs.runs': 'Salary runs',
    'accounting.salaries.tabs.employees': 'Employees',
    'accounting.salaries.tabs.recurring': 'Recurring',
    'accounting.salaries.addRun': 'New salary run',
    'accounting.salaries.editRun': 'Edit salary run',
    'accounting.salaries.run': 'Salary run',
    'accounting.salaries.number': 'Run #',
    'accounting.salaries.month': 'Month',
    'accounting.salaries.runDate': 'Posting date',
    'accounting.salaries.runDateHint': 'The salary expense is booked on this date.',
    'accounting.salaries.pickMonth': 'Choose a month first.',
    'accounting.salaries.loadEmployees': 'Load employees',
    'accounting.salaries.addEmployee': 'Add employee',
    'accounting.salaries.nothingToLoad': 'No employees left to load: everyone with a salary is already in a run for this month.',
    'accounting.salaries.prorated': 'Prorated: {days} of {total} days',
    'accounting.salaries.noLines': 'Add at least one employee.',
    'accounting.salaries.noLinesLoaded': 'No employees yet. Pick a month, then click "Load employees" or add employees one by one.',
    'accounting.salaries.employee': 'Employee',
    'accounting.salaries.type': 'Type',
    'accounting.salaries.base': 'Salary',
    'accounting.salaries.allowances': 'Allowances',
    'accounting.salaries.deductions': 'Deductions',
    'accounting.salaries.net': 'Net',
    'accounting.salaries.employeesCount': 'Employees',
    'accounting.salaries.printTitle': 'Payroll sheet',
    'accounting.salaries.signature': 'Signature',
    'accounting.salaries.preparedBy': 'Prepared by',
    'accounting.salaries.approvedBy': 'Approved by',
    'accounting.salaries.postingHint': 'Drafts post nothing. Approving books each net salary as an expense and credits Salaries payable; paying moves it from Salaries payable to the cash account.',
    'accounting.salaries.pay': 'Pay salaries',
    'accounting.salaries.payAll': 'Pay all',
    'accounting.salaries.pickRun': 'Choose an approved salary run to see who is left to pay.',
    'accounting.salaries.selectEmployees': 'Select at least one employee to pay.',
    'accounting.salaries.noUnpaid': 'No approved salary runs left to pay',
    'accounting.salaries.voidConfirm': 'Void this salary run? Its posting is reversed and its employees can be paid for the month again.',
    'accounting.salaries.deleteConfirm': 'Delete this salary run?',
    'accounting.salaries.deletePaymentConfirm': 'Delete this payment? The salary becomes unpaid again.',
    'accounting.salaries.automatic': 'Automatic',
    'accounting.salaries.search': 'Search run number or notes',
    'accounting.salaries.searchEmployees': 'Search name, email or phone',
    'accounting.salaries.employeeName': 'Employee name',
    'accounting.salaries.noAccount': 'No user account',
    'accounting.salaries.noAccountHint': 'Use this for employees who do not use the system. They get no user account, cannot sign in and do not appear on the Users page.',
    'accounting.salaries.deleteEmployeeConfirm': 'Delete this employee and their salary?',
    'accounting.salaries.monthlySalary': 'Monthly salary',
    'accounting.salaries.notSet': 'Not set',
    'accounting.salaries.employment': 'Employment',
    'accounting.salaries.startDate': 'Start date',
    'accounting.salaries.endDate': 'End date',
    'accounting.salaries.datesHint': 'Optional. A partial first or last month is prorated by days.',
    'accounting.salaries.includeInRuns': 'In salary runs',
    'accounting.salaries.editSalary': 'Edit salary',
    'accounting.salaries.monthlyPayroll': 'Monthly payroll',
    'accounting.salaries.withoutSalary': '{count} employee(s) have no salary yet.',
    'accounting.salaries.owedTo': 'Salaries still owed',
    'accounting.salaries.autoRun': 'Automatic monthly run',
    'accounting.salaries.autoRunMode.off': 'Off (create runs manually)',
    'accounting.salaries.autoRunMode.draft': 'Create a draft run',
    'accounting.salaries.autoRunMode.approve': 'Create and approve the run',
    'accounting.salaries.autoRunHint.off': 'Salary runs are only created when you click "New salary run".',
    'accounting.salaries.autoRunHint.draft': "On the pay day, the month's run is created as a draft from everyone's salary, for you to review and approve.",
    'accounting.salaries.autoRunHint.approve': "On the pay day, the month's run is created from everyone's salary and approved, so the salaries are booked automatically. Payments are still recorded by you.",
    'accounting.salaries.payDay': 'Pay day',
    'accounting.salaries.payDayHint': 'Day of the month (1–31). In shorter months the last day is used.',
    'accounting.salaries.lastAutoMonth': 'Last automatic run: {month}',
    'accounting.costing.subtitle': 'Margin per order from the ledger, remake cost, material inventory and overhead allocation.',
    'accounting.costing.tabs.margins': 'Order margins',
    'accounting.costing.tabs.remakes': 'Remakes',
    'accounting.costing.tabs.inventory': 'Inventory & settings',
    'accounting.costing.groupBy.order': 'By order',
    'accounting.costing.groupBy.client': 'By client',
    'accounting.costing.groupBy.technician': 'By technician',
    'accounting.costing.groupBy.formula_type': 'By formula type',
    'accounting.costing.groups.client': 'Client',
    'accounting.costing.groups.technician': 'Technician',
    'accounting.costing.groups.formula_type': 'Formula type',
    'accounting.costing.unassigned': 'Unassigned',
    'accounting.costing.ordersUnits': '{orders} orders · {units} units',
    'accounting.costing.search': 'Search order, patient or client',
    'accounting.costing.remakesOnly': 'Remakes only',
    'accounting.costing.orders': 'Orders',
    'accounting.costing.revenue': 'Revenue',
    'accounting.costing.cost.materials': 'Materials',
    'accounting.costing.cost.technician': 'Technician',
    'accounting.costing.cost.additional': 'Additional',
    'accounting.costing.cost.delivery': 'Delivery',
    'accounting.costing.cost.other': 'Other',
    'accounting.costing.directCost': 'Direct cost',
    'accounting.costing.overhead': 'Overhead',
    'accounting.costing.margin': 'Margin',
    'accounting.costing.marginPct': 'Margin %',
    'accounting.costing.remake': 'Remake',
    'accounting.costing.noRevenue': 'No revenue yet',
    'accounting.costing.noRevenueHint': 'No revenue is posted for this order yet (not billable yet or zero total).',
    'accounting.costing.unposted': '{count} order(s) in this period have no posted revenue yet, so their margin shows only costs.',
    'accounting.costing.notEnabled': 'Accounting is not enabled, so there are no postings to analyse.',
    'accounting.costing.purchaseExpenseHint': 'Materials are expensed when bought, so order margins show no material cost per order.',
    'accounting.costing.overheadInfo.percent_of_revenue': 'Overhead pool {pool} (operating expenses {operating} + depreciation {depreciation}) allocated at {rate} of revenue.',
    'accounting.costing.overheadInfo.per_unit': 'Overhead pool {pool} (operating expenses {operating} + depreciation {depreciation}) allocated at {rate} per unit.',
    'accounting.costing.remakes': 'Remakes / orders',
    'accounting.costing.remakeRate': 'Remake rate',
    'accounting.costing.netCost': 'Net cost',
    'accounting.costing.labNetCost': 'Lab-caused cost',
    'accounting.costing.charged': 'Charged',
    'accounting.costing.byReason': 'By reason',
    'accounting.costing.byResponsibility': 'By responsibility',
    'accounting.costing.byTechnician': 'By technician',
    'accounting.costing.count': 'Count',
    'accounting.costing.noRemakes': 'No remakes tagged in this period.',
    'accounting.costing.tagRemake': 'Tag remake',
    'accounting.costing.editRemake': 'Edit remake tag',
    'accounting.costing.tag': 'Tag',
    'accounting.costing.untagConfirm': 'Remove the remake tag from this order?',
    'accounting.costing.remakeOrder': 'Remake order',
    'accounting.costing.remakeOrderHint': 'The order that redoes the work. Its costs count as remake cost.',
    'accounting.costing.originalOrder': 'Original order',
    'accounting.costing.searchOrder': 'Search by order number, patient or client',
    'accounting.costing.reason': 'Reason',
    'accounting.costing.responsibility': 'Responsibility',
    'accounting.costing.reasons.fit': 'Fit',
    'accounting.costing.reasons.shade': 'Shade',
    'accounting.costing.reasons.fracture': 'Fracture',
    'accounting.costing.reasons.design': 'Design',
    'accounting.costing.reasons.impression': 'Impression',
    'accounting.costing.reasons.damaged_in_delivery': 'Damaged in delivery',
    'accounting.costing.reasons.clinic_request': 'Clinic request',
    'accounting.costing.reasons.other': 'Other',
    'accounting.costing.responsibilities.lab': 'Lab',
    'accounting.costing.responsibilities.clinic': 'Clinic',
    'accounting.costing.responsibilities.shared': 'Shared',
    'accounting.costing.responsibilities.unknown': 'Unknown',
    'accounting.costing.suggestions': 'Possible remakes not tagged yet',
    'accounting.costing.suggestionsHint': 'Orders that went through a remake, rework or failed quality-control status.',
    'accounting.costing.patientClient': 'Patient · client',
    'accounting.costing.status': 'Status seen',
    'accounting.costing.settings': 'Costing settings',
    'accounting.costing.materialMethod': 'Material costing method',
    'accounting.costing.materialMethods.accrual': 'Accrual (default)',
    'accounting.costing.materialMethods.inventory': 'Inventory',
    'accounting.costing.materialMethods.purchase_expense': 'Expense on purchase',
    'accounting.costing.materialMethodHints.accrual': 'Material purchases are expensed when billed. Order formula costs post separately to Material COGS (formula).',
    'accounting.costing.materialMethodHints.inventory': 'Material purchases go to inventory and leave it when issued from stock. Use stock counts to correct the book value. Order formula costs post separately to Material COGS (formula) and never touch inventory.',
    'accounting.costing.materialMethodHints.purchase_expense': 'Material purchases are expensed when billed. Order formula costs post separately to Material COGS (formula).',
    'accounting.costing.changeMethodTitle': 'Change the material costing method?',
    'accounting.costing.changeMethodBody': 'All expenses and supplier bills are re-posted under the new method in the background. Closed periods are not changed; corrections land on the first open day.',
    'accounting.costing.overheadMethod': 'Overhead allocation',
    'accounting.costing.overheadMethodHint': 'Spreads operating expenses (and asset depreciation) over orders in margin reports. Nothing is posted.',
    'accounting.costing.overheadMethods.none': 'Do not allocate',
    'accounting.costing.overheadMethods.percent_of_revenue': '% of revenue',
    'accounting.costing.overheadMethods.per_unit': 'Per unit',
    'accounting.costing.assetLife': 'Asset useful life (years)',
    'accounting.costing.assetLifeHint': 'Adds straight-line depreciation of your assets to the overhead pool. Leave empty to skip.',
    'accounting.costing.inventory': 'Material inventory',
    'accounting.costing.inventoryNotUsed': 'The inventory method is not selected, so only stock counts and purchases mapped to this account move it.',
    'accounting.costing.opening': 'Opening',
    'accounting.costing.closing': 'Closing',
    'accounting.costing.formulaMaterial': 'Formula material cost',
    'accounting.costing.formulaMaterialHint': 'Material cost booked by orders in the period, whatever the costing method.',
    'accounting.costing.movement': 'Movement',
    'accounting.costing.in': 'In',
    'accounting.costing.out': 'Out',
    'accounting.costing.noMovements': 'No movements in this period.',
    'accounting.costing.stockCount': 'Stock count',
    'accounting.costing.stockCountHint': 'Enter the value of materials on hand. The difference from the book value is posted against materials expense.',
    'accounting.costing.countedValue': 'Counted value',
    'accounting.costing.postCount': 'Post adjustment',
    'accounting.costing.noCounts': 'No stock counts yet.',
    'accounting.costing.adjustment': 'Adjustment',
    'accounting.costing.reversed': 'Voided',
    'accounting.journal.movedFromClosed': 'Moved from {date}',
    'accounting.journal.movedFromClosedHint': 'The operation is dated in a closed period, so it was posted on the first open day.',
    'accounting.accounts.cashFlowCategory': 'Cash flow section',
    'accounting.accounts.cashFlowCategoryHint': 'Where changes in this account appear on the cash flow statement.',
    'accounting.accounts.cashFlowAuto': 'Automatic',
    'accounting.reports.subtitle': 'Statements built from the posted journal: the books of record.',
    'accounting.reports.tabs.trial_balance': 'Trial balance',
    'accounting.reports.tabs.general_ledger': 'General ledger',
    'accounting.reports.tabs.profit_and_loss': 'Profit & loss',
    'accounting.reports.tabs.balance_sheet': 'Balance sheet',
    'accounting.reports.tabs.cash_flow': 'Cash flow',
    'accounting.reports.presets.thisMonth': 'This month',
    'accounting.reports.presets.lastMonth': 'Last month',
    'accounting.reports.presets.thisQuarter': 'This quarter',
    'accounting.reports.presets.yearToDate': 'Year to date',
    'accounting.reports.presets.lastYear': 'Last year',
    'accounting.reports.compare.none': 'No comparison',
    'accounting.reports.compare.previous_period': 'Compare with previous period',
    'accounting.reports.compare.previous_year': 'Compare with same period last year',
    'accounting.reports.compare.bs_previous_period': 'Compare with start of period',
    'accounting.reports.compare.bs_previous_year': 'Compare with same date last year',
    'accounting.reports.includeZero': 'Show zero balances',
    'accounting.reports.asOfLabel': 'As of',
    'accounting.reports.asOf': 'As of {date}',
    'accounting.reports.periodRange': '{from} to {to}',
    'accounting.reports.beginning': 'the beginning',
    'accounting.reports.today': 'today',
    'accounting.reports.lockedThrough': 'Books closed through {date}',
    'accounting.reports.refresh': 'Refresh',
    'accounting.reports.print': 'Print',
    'accounting.reports.disabledHint': 'Turn on accounting in the chart of accounts to build the ledger these reports read from.',
    'accounting.reports.noActivity': 'No posted activity for this selection.',
    'accounting.reports.line': 'Line',
    'accounting.reports.account': 'Account',
    'accounting.reports.type': 'Type',
    'accounting.reports.amount': 'Amount',
    'accounting.reports.change': 'Change',
    'accounting.reports.debit': 'Debit',
    'accounting.reports.credit': 'Credit',
    'accounting.reports.balance': 'Balance',
    'accounting.reports.total': 'Total',
    'accounting.reports.tb.opening': 'Opening',
    'accounting.reports.tb.movement': 'Movement',
    'accounting.reports.tb.closing': 'Closing',
    'accounting.reports.tb.unbalanced': 'Debits and credits do not match. Run the ledger health check in the chart of accounts.',
    'accounting.reports.gl.pickAccount': 'Choose an account',
    'accounting.reports.gl.pickAccountHint': 'Choose an account to see its posted lines and running balance.',
    'accounting.reports.gl.includeChildren': 'Include sub-accounts',
    'accounting.reports.gl.description': 'Operation',
    'accounting.reports.gl.counter': 'Other side',
    'accounting.reports.gl.opening': 'Opening balance',
    'accounting.reports.gl.debits': 'Debits',
    'accounting.reports.gl.credits': 'Credits',
    'accounting.reports.gl.closing': 'Closing balance',
    'accounting.reports.gl.normalSide.debit': 'Balances are shown as debit minus credit.',
    'accounting.reports.gl.normalSide.credit': 'Balances are shown as credit minus debit.',
    'accounting.reports.pl.revenue': 'Revenue',
    'accounting.reports.pl.direct_costs': 'Direct costs',
    'accounting.reports.pl.operating_expenses': 'Operating expenses',
    'accounting.reports.pl.total_revenue': 'Total revenue',
    'accounting.reports.pl.total_direct_costs': 'Total direct costs',
    'accounting.reports.pl.total_operating_expenses': 'Total operating expenses',
    'accounting.reports.pl.gross_profit': 'Gross profit',
    'accounting.reports.pl.net_profit': 'Net profit',
    'accounting.reports.bs.current_assets': 'Current assets',
    'accounting.reports.bs.non_current_assets': 'Non-current assets',
    'accounting.reports.bs.liabilities': 'Liabilities',
    'accounting.reports.bs.equity': 'Equity',
    'accounting.reports.bs.total_current_assets': 'Total current assets',
    'accounting.reports.bs.total_non_current_assets': 'Total non-current assets',
    'accounting.reports.bs.total_assets': 'Total assets',
    'accounting.reports.bs.total_liabilities': 'Total liabilities',
    'accounting.reports.bs.total_equity': 'Total equity',
    'accounting.reports.bs.total_liabilities_and_equity': 'Total liabilities & equity',
    'accounting.reports.bs.retained_earnings': 'Retained earnings',
    'accounting.reports.bs.current_year_earnings': 'Current year earnings',
    'accounting.reports.bs.unbalanced': 'Assets do not equal liabilities plus equity. Run the ledger health check in the chart of accounts.',
    'accounting.reports.bs.fiscalYearHint': 'Current year earnings are counted from {date}; earlier profit is shown as retained earnings.',
    'accounting.reports.cf.operating': 'Operating activities',
    'accounting.reports.cf.investing': 'Investing activities',
    'accounting.reports.cf.financing': 'Financing activities',
    'accounting.reports.cf.netIncome': 'Net profit',
    'accounting.reports.cf.movement.increase': 'increase',
    'accounting.reports.cf.movement.decrease': 'decrease',
    'accounting.reports.cf.total_operating': 'Net cash from operating activities',
    'accounting.reports.cf.total_investing': 'Net cash from investing activities',
    'accounting.reports.cf.total_financing': 'Net cash from financing activities',
    'accounting.reports.cf.netChange': 'Net change in cash',
    'accounting.reports.cf.openingCash': 'Cash at beginning of period',
    'accounting.reports.cf.closingCash': 'Cash at end of period',
    'accounting.reports.cf.methodHint': 'Indirect method: net profit adjusted by the change in every non-cash balance sheet account.',
    'accounting.reports.cf.notReconciled': 'Opening cash plus the net change does not equal closing cash. Run the ledger health check.',
    'accounting.reports.cf.cashAccounts': 'Cash and bank accounts',
    'accounting.reports.cf.opening': 'Opening',
    'accounting.reports.cf.closing': 'Closing',
    'accounting.reports.opsDashboardNotice': 'This is an operational dashboard. For the books of record, see the profit & loss statement in Financial Reports.',
    'accounting.reports.openProfitAndLoss': 'Open profit & loss',
    'accounting.periods.subtitle': 'Lock finished periods so the reported numbers cannot change.',
    'accounting.periods.lockedThrough': 'Books closed through',
    'accounting.periods.notClosed': 'Not closed yet',
    'accounting.periods.firstOpenDate': 'First open date',
    'accounting.periods.anyDate': 'Any date',
    'accounting.periods.fiscalYearStart': 'Fiscal year starts in',
    'accounting.periods.fiscalYearHint': 'Used to split retained earnings from current year earnings.',
    'accounting.periods.closeTitle': 'Close the books',
    'accounting.periods.closeHint': 'Closing locks every day up to the chosen date. Manual entries into it are refused, and operations dated in it (orders, payments, expenses…) post on the first open day instead.',
    'accounting.periods.closeThrough': 'Close through',
    'accounting.periods.pickDate': 'Choose the last day to close.',
    'accounting.periods.range': 'Period',
    'accounting.periods.entries': 'Entries',
    'accounting.periods.netIncome': 'Net profit',
    'accounting.periods.totalPosted': 'Total posted',
    'accounting.periods.cannotClose': 'This period cannot be closed yet',
    'accounting.periods.unreconciledTitle': 'Some cash or bank lines in this period are not reconciled',
    'accounting.periods.unreconciledLine': '{name}: {count} uncleared lines',
    'accounting.periods.goReconcile': 'Go to bank reconciliation',
    'accounting.periods.notes': 'Notes',
    'accounting.periods.close': 'Close through {date}',
    'accounting.periods.closeConfirm': 'Close the books through {date}? Entries up to that date will be locked.',
    'accounting.periods.history': 'Closed periods',
    'accounting.periods.empty': 'No period has been closed yet.',
    'accounting.periods.statusLabel': 'Status',
    'accounting.periods.status.closed': 'Closed',
    'accounting.periods.status.reopened': 'Reopened',
    'accounting.periods.closedBy': 'Closed by',
    'accounting.periods.reopened': 'Reopened',
    'accounting.periods.reopen': 'Reopen',
    'accounting.periods.reopenTitle': 'Reopen period',
    'accounting.periods.reopenWarning': 'Reopening {from} to {to} lets entries change again. Reports already shared may no longer match.',
    'accounting.periods.reason': 'Reason',
    'accounting.reconciliation.subtitle': 'Match your bank and cash statements against the ledger.',
    'accounting.reconciliation.start': 'Start reconciliation',
    'accounting.reconciliation.startOk': 'Start',
    'accounting.reconciliation.reconcile': 'Reconcile',
    'accounting.reconciliation.continue': 'Continue',
    'accounting.reconciliation.open': 'Open',
    'accounting.reconciliation.workspace': 'Reconciliation',
    'accounting.reconciliation.account': 'Account',
    'accounting.reconciliation.pickAccount': 'Choose a cash or bank account',
    'accounting.reconciliation.allAccounts': 'All accounts',
    'accounting.reconciliation.allStatuses': 'All statuses',
    'accounting.reconciliation.lastStatement': 'Last reconciled statement: {date}. The new statement must be later.',
    'accounting.reconciliation.firstStatement': 'First reconciliation for this account: the opening balance is zero.',
    'accounting.reconciliation.statementDate': 'Statement date',
    'accounting.reconciliation.statementOf': 'Statement of {date}',
    'accounting.reconciliation.statementBalance': 'Statement balance',
    'accounting.reconciliation.statementBalanceHint': 'The closing balance printed on the statement.',
    'accounting.reconciliation.reference': 'Statement reference',
    'accounting.reconciliation.notes': 'Notes',
    'accounting.reconciliation.editStatement': 'Edit statement',
    'accounting.reconciliation.ledgerBalance': 'Ledger balance',
    'accounting.reconciliation.reconciledThrough': 'Reconciled through {date} ({amount})',
    'accounting.reconciliation.neverReconciled': 'Never reconciled',
    'accounting.reconciliation.unclearedCount': '{count} uncleared lines',
    'accounting.reconciliation.noAccounts': 'Add a cash or bank account in Cash & Bank first.',
    'accounting.reconciliation.history': 'Statements',
    'accounting.reconciliation.empty': 'No reconciliations yet.',
    'accounting.reconciliation.statusLabel': 'Status',
    'accounting.reconciliation.status.draft': 'In progress',
    'accounting.reconciliation.status.completed': 'Completed',
    'accounting.reconciliation.completedAt': 'Completed',
    'accounting.reconciliation.completedBy': 'completed by {name} on {date}',
    'accounting.reconciliation.opening': 'Opening balance',
    'accounting.reconciliation.clearedIn': 'Cleared in',
    'accounting.reconciliation.clearedOut': 'Cleared out',
    'accounting.reconciliation.clearedBalance': 'Cleared balance',
    'accounting.reconciliation.difference': 'Difference',
    'accounting.reconciliation.clearedCount': '{count} lines cleared',
    'accounting.reconciliation.bookBalanceHint': 'Ledger balance on {date}: {amount}',
    'accounting.reconciliation.howTo': 'Tick every line that appears on the statement. When the difference reaches zero you can complete the reconciliation.',
    'accounting.reconciliation.view.all': 'All',
    'accounting.reconciliation.view.uncleared': 'Uncleared',
    'accounting.reconciliation.view.cleared': 'Cleared',
    'accounting.reconciliation.search': 'Search lines',
    'accounting.reconciliation.noLines': 'No ledger lines up to the statement date.',
    'accounting.reconciliation.moneyIn': 'Money in',
    'accounting.reconciliation.moneyOut': 'Money out',
    'accounting.reconciliation.complete': 'Complete',
    'accounting.reconciliation.completeConfirm': 'Complete this reconciliation? Its cleared lines will be locked.',
    'accounting.reconciliation.reopen': 'Reopen',
    'accounting.reconciliation.reopenConfirm': 'Reopen this reconciliation so its lines can be changed?',
    'accounting.reconciliation.deleteConfirm': 'Delete this reconciliation? Its ticked lines become uncleared again.',
    'expenses.form.paidFrom.label': 'Paid from',
    'expenses.form.paidFrom.hint': 'Cash or bank account the money left. Leave empty to use the default.',
    'invoice.markPaid.depositTo': 'Deposit to',
    'clients.wallet.depositTo': 'Deposit to',
    'sidebar.finance': 'Finance',
    'sidebar.settings': 'Settings',
    'sidebar.client_settings': 'Settings',
    'sidebar.client_transactions': 'Transactions',
    'sidebar.client_statement': 'Account Statement',
    'sidebar.client_wallet': 'Wallet',
    'sidebar.setting': 'Lab Settings',
    'sidebar.setting_lab_info': 'Lab',
    'sidebar.setting_subscription': 'Subscription',
    'sidebar.setting_payment': 'Payment Settings',
    'sidebar.setting_delivery': 'Delivery Settings',
    'sidebar.setting_vacations': 'Vacations',
    'sidebar.setting_discounts': 'Discount Settings',
    'discountSettings.subtitle': 'Control how discounts appear on orders, invoices, and PDFs',
    'sidebar.orders': 'Orders',
    'sidebar.orders_calendar': 'Calendar',
    'sidebar.invoices': 'Invoices',

    'collectionReport.title': 'Collection Report',
    'collectionReport.subtitle': 'Cash basis: income from billable orders paid in this period (by payment date), after order discounts. Unpaid due orders are left out. Cash surplus = paid orders subtotal − general expenses. Formula Types costs show margin of collected work only and are not deducted from cash surplus. Do not add this report’s surplus to the Revenue Report net.',
    'collectionReport.countLabel': 'formula types',
    'collectionReport.section.formulaTypesProfit': 'Formula Types Profit',
    'collectionReport.period.month': 'Month',
    'collectionReport.period.range': 'Date range',
    'collectionReport.includeCosts': 'Include costs:',
    'collectionReport.includeCosts.material': 'Material',
    'collectionReport.includeCosts.technician': 'Technician',
    'collectionReport.includeCosts.additional': 'Additional',
    'collectionReport.column.name': 'Formula type',
    'collectionReport.column.units': 'Units',
    'collectionReport.column.sellingPrice': 'Selling price / unit',
    'collectionReport.column.totalIncome': 'Total income',
    'collectionReport.column.materialCost': 'Material cost / unit',
    'collectionReport.column.totalMaterial': 'Total material cost',
    'collectionReport.column.technicianCost': 'Technician cost / unit',
    'collectionReport.column.totalTechnician': 'Total technician cost',
    'collectionReport.column.additionalCost': 'Additional cost / unit',
    'collectionReport.column.totalAdditional': 'Total additional costs',
    'collectionReport.column.netProfit': 'Net profit',
    'collectionReport.totals': 'Total',
    'collectionReport.empty': 'No units in this period',
    'collectionReport.sellingPriceVaries': 'Average, because units were sold at different prices. Expand the row to see each price.',
    'collectionReport.priceSource.default': 'Default price',
    'collectionReport.priceSource.client': 'Client price',
    'collectionReport.priceSource.custom': 'Custom price (set on order)',
    'collectionReport.priceSource.clientsCount': '{{count}} clients',
    'collectionReport.priceSource.noClient': 'No client',
    'collectionReport.noAccess': 'You do not have access to the collection report',
    'collectionReport.loadError': 'Could not load the collection report',
    'collectionReport.section.paidOrders': 'Paid Orders',
    'collectionReport.paidOrders.hint': 'Totals for billable orders paid in this period (by payment date): formulas, order discounts, additional costs, subtotal, VAT, delivery, and grand total. Formula Types Profit uses formulas after discounts; its costs are margin of collected work only.',
    'collectionReport.paidOrders.type': 'Type',
    'collectionReport.paidOrders.amount': 'Amount',
    'collectionReport.paidOrders.formulas': 'Formulas',
    'collectionReport.paidOrders.discount': 'Discount',
    'collectionReport.paidOrders.additionalCosts': 'Additional costs',
    'collectionReport.paidOrders.subtotal': 'Subtotal',
    'collectionReport.paidOrders.vat': 'Total VAT',
    'collectionReport.paidOrders.delivery': 'Delivery costs',
    'collectionReport.paidOrders.total': 'Total',
    'collectionReport.paidOrders.ordersCount': '{{count}} paid order(s)',
    'collectionReport.paidOrders.empty': 'No paid orders in this period',
    'collectionReport.discountDetails.title': 'Discount Details',
    'collectionReport.discountDetails.ordersCount': '{{count}} discounted order(s)',
    'collectionReport.discountDetails.hint': 'Orders with an order-level discount that make up the Discount line above. Unit price reductions (client or custom prices) are already included in Formulas.',
    'collectionReport.discountDetails.order': 'Order',
    'collectionReport.discountDetails.client': 'Client',
    'collectionReport.discountDetails.formulaTypes': 'Formula types',
    'collectionReport.discountDetails.formulas': 'Formulas',
    'collectionReport.discountDetails.discount': 'Discount',
    'collectionReport.discountDetails.discountPercentage': 'Discount %',
    'collectionReport.discountDetails.afterDiscount': 'After discount',
    'collectionReport.markupDetails.title': 'Markup Details',
    'collectionReport.markupDetails.ordersCount': '{{count}} order(s) with markup',
    'collectionReport.markupDetails.hint': 'Orders with units charged above their catalog price (client price list or per-unit price). The markup is already included in Formulas.',
    'collectionReport.markupDetails.order': 'Order',
    'collectionReport.markupDetails.client': 'Client',
    'collectionReport.markupDetails.formulaTypes': 'Formula types',
    'collectionReport.markupDetails.catalog': 'Catalog price',
    'collectionReport.markupDetails.markup': 'Markup',
    'collectionReport.markupDetails.markupPercentage': 'Markup %',
    'collectionReport.markupDetails.charged': 'Charged',
    'collectionReport.settings.button': 'Report settings',
    'collectionReport.settings.title': 'Report settings',
    'collectionReport.settings.display': 'Show in the Revenue and Collection reports',
    'collectionReport.settings.showDiscounts': 'Discounts',
    'collectionReport.settings.showDiscountsHint': 'When off, the Discount line is merged into Formulas.',
    'collectionReport.settings.showDiscountDetails': 'Discount details',
    'collectionReport.settings.showMarkupDetails': 'Markup details',
    'collectionReport.settings.showVat': 'VAT',
    'collectionReport.settings.showVatHint': 'When off, the VAT line is hidden and the total excludes VAT.',
    'collectionReport.settings.showCogs': 'Cost of goods sold (formula type costs)',
    'collectionReport.settings.showCogsHint': 'Material, technician and additional costs per unit, in the formula types profit and net profit.',
    'collectionReport.settings.noCostsEnabled': 'No formula type costs are enabled for your lab yet.',
    'collectionReport.settings.saved': 'Report settings saved',
    'collectionReport.settings.loadError': 'Could not load the report settings',
    'collectionReport.settings.readOnly': 'You need the Edit settings permission to change these settings.',
    'collectionReport.section.generalExpenses': 'General Expenses',
    'collectionReport.generalExpenses.hint': 'Cash operating expenses entered manually in this period. Expenses created automatically from orders are not included (those belong with production costs on the Revenue Report).',
    'collectionReport.notBillableOrders': '{{count}} order(s) in this period are not counted yet because they have not reached the status set in the Order Status Workflow.',
    'collectionReport.unpaidOrders': '{{count}} unpaid due order(s) in this period are left out of collection (due balances are not counted until paid).',
    'collectionReport.generalExpenses.expenseType': 'Expense type',
    'collectionReport.generalExpenses.expenses': 'Expenses',
    'collectionReport.generalExpenses.uncategorized': 'Uncategorized',
    'collectionReport.generalExpenses.empty': 'No general expenses in this period',
    'collectionReport.section.netProfitSummary': 'Cash Surplus Summary',
    'collectionReport.netProfitSummary.hint': 'Cash basis: total income is the Paid Orders subtotal (after discounts, including additional costs). Cash surplus = total income − general expenses. Formula Types production costs are not deducted here (see Formula Types Profit for collected-work margin). VAT and delivery stay in Paid Orders only.',
    'collectionReport.netProfitSummary.type': 'Type',
    'collectionReport.netProfitSummary.amount': 'Amount',
    'collectionReport.netProfitSummary.totalIncome': 'Total income',
    'collectionReport.netProfitSummary.totalTechnicianCost': 'Total technicians cost',
    'collectionReport.netProfitSummary.totalMaterialCost': 'Total materials cost',
    'collectionReport.netProfitSummary.generalExpenses': 'General expenses',
    'collectionReport.netProfitSummary.others': 'Others',
    'collectionReport.netProfitSummary.netProfit': 'Cash surplus',
    'collectionReport.section.formulaTypesTracker': 'Formula Types Tracker',
    'collectionReport.section.latestFormulaTypes': 'Latest Used Formula Types',
    'collectionReport.section.receivables': 'Outstanding Receivables',
    'collectionReport.receivables.hint': 'Unpaid billable orders that became due in this period. Outstanding is the total unpaid balance; Overdue and Not Due classify it by invoice payment deadline.',
    'collectionReport.receivables.outstanding': 'Outstanding',
    'collectionReport.receivables.overdue': 'Overdue',
    'collectionReport.receivables.current': 'Not Due',
    'collectionReport.receivables.empty': 'No outstanding receivables in this period',
    'collectionReport.section.byClient': 'By Client',
    'collectionReport.byClient.hint': 'Paid orders in this period grouped by client (by payment date).',
    'collectionReport.byClient.client': 'Client',
    'collectionReport.byClient.orders': 'Orders',
    'collectionReport.byClient.amount': 'Amount',
    'collectionReport.byClient.uncategorized': 'No client',
    'collectionReport.byClient.empty': 'No collections by client in this period',
    'collectionReport.section.byPaymentMethod': 'By Payment Method',
    'collectionReport.byPaymentMethod.hint': 'Invoice payments received in this period, grouped by payment method.',
    'collectionReport.byPaymentMethod.method': 'Payment method',
    'collectionReport.byPaymentMethod.transactions': 'Payments',
    'collectionReport.byPaymentMethod.amount': 'Amount',
    'collectionReport.byPaymentMethod.uncategorized': 'Unspecified',
    'collectionReport.byPaymentMethod.empty': 'No payments by method in this period',
    'collectionReport.section.byInvoice': 'By Invoice',
    'collectionReport.byInvoice.hint': 'Invoice payments received in this period, grouped by invoice.',
    'collectionReport.byInvoice.invoice': 'Invoice',
    'collectionReport.byInvoice.client': 'Client',
    'collectionReport.byInvoice.transactions': 'Payments',
    'collectionReport.byInvoice.amount': 'Amount',
    'collectionReport.byInvoice.empty': 'No invoice payments in this period',
    'collectionReport.section.refunds': 'Refunds',
    'collectionReport.refunds.hint': 'Invoice refunds credited to client wallets in this period.',
    'collectionReport.refunds.invoice': 'Invoice',
    'collectionReport.refunds.client': 'Client',
    'collectionReport.refunds.amount': 'Amount',
    'collectionReport.refunds.empty': 'No refunds in this period',
    'collectionReport.section.unallocated': 'Unallocated Payments',
    'collectionReport.unallocated.hint': 'Wallet recharges in this period (advances not yet applied to invoices).',
    'collectionReport.unallocated.client': 'Client',
    'collectionReport.unallocated.method': 'Payment method',
    'collectionReport.unallocated.amount': 'Amount',
    'collectionReport.unallocated.empty': 'No unallocated payments in this period',

    'revenueReport.title': 'Revenue Report',
    'revenueReport.subtitle': 'Accrual basis: income from orders that became due in this period (when they reached the Order Status Workflow due status), after order discounts. Paid and unpaid orders are both included. Net profit = Revenue Orders subtotal − production costs (material, technician, additional). General cash expenses are on the Collection Report. Do not add this report’s net to the Collection Report surplus.',
    'revenueReport.countLabel': 'formula types',
    'revenueReport.section.formulaTypesProfit': 'Formula Types Profit',
    'revenueReport.period.month': 'Month',
    'revenueReport.period.range': 'Date range',
    'revenueReport.includeCosts': 'Include costs:',
    'revenueReport.includeCosts.material': 'Material',
    'revenueReport.includeCosts.technician': 'Technician',
    'revenueReport.includeCosts.additional': 'Additional',
    'revenueReport.column.name': 'Formula type',
    'revenueReport.column.units': 'Units',
    'revenueReport.column.sellingPrice': 'Selling price / unit',
    'revenueReport.column.totalIncome': 'Total income',
    'revenueReport.column.materialCost': 'Material cost / unit',
    'revenueReport.column.totalMaterial': 'Total material cost',
    'revenueReport.column.technicianCost': 'Technician cost / unit',
    'revenueReport.column.totalTechnician': 'Total technician cost',
    'revenueReport.column.additionalCost': 'Additional cost / unit',
    'revenueReport.column.totalAdditional': 'Total additional costs',
    'revenueReport.column.netProfit': 'Net profit',
    'revenueReport.totals': 'Total',
    'revenueReport.empty': 'No units in this period',
    'revenueReport.sellingPriceVaries': 'Average, because units were sold at different prices. Expand the row to see each price.',
    'revenueReport.priceSource.default': 'Default price',
    'revenueReport.priceSource.client': 'Client price',
    'revenueReport.priceSource.custom': 'Custom price (set on order)',
    'revenueReport.priceSource.clientsCount': '{{count}} clients',
    'revenueReport.priceSource.noClient': 'No client',
    'revenueReport.noAccess': 'You do not have access to the revenue report',
    'revenueReport.loadError': 'Could not load the revenue report',
    'revenueReport.section.dueOrders': 'Revenue Orders',
    'revenueReport.dueOrders.hint': 'Totals for orders counted as revenue in this period, paid and unpaid (orders that became due by due/billable date): formulas, order discounts, additional costs, subtotal, VAT, delivery, and grand total. Formula Types Profit uses formulas after discounts.',
    'revenueReport.dueOrders.type': 'Type',
    'revenueReport.dueOrders.amount': 'Amount',
    'revenueReport.dueOrders.formulas': 'Formulas',
    'revenueReport.dueOrders.discount': 'Discount',
    'revenueReport.dueOrders.additionalCosts': 'Additional costs',
    'revenueReport.dueOrders.subtotal': 'Subtotal',
    'revenueReport.dueOrders.vat': 'Total VAT',
    'revenueReport.dueOrders.delivery': 'Delivery costs',
    'revenueReport.dueOrders.total': 'Total',
    'revenueReport.dueOrders.ordersCount': '{{count}} order(s)',
    'revenueReport.dueOrders.empty': 'No revenue orders in this period',
    'revenueReport.discountDetails.title': 'Discount Details',
    'revenueReport.discountDetails.ordersCount': '{{count}} discounted order(s)',
    'revenueReport.discountDetails.hint': 'Orders with an order-level discount that make up the Discount line above. Unit price reductions (client or custom prices) are already included in Formulas.',
    'revenueReport.discountDetails.order': 'Order',
    'revenueReport.discountDetails.client': 'Client',
    'revenueReport.discountDetails.formulaTypes': 'Formula types',
    'revenueReport.discountDetails.formulas': 'Formulas',
    'revenueReport.discountDetails.discount': 'Discount',
    'revenueReport.discountDetails.discountPercentage': 'Discount %',
    'revenueReport.discountDetails.afterDiscount': 'After discount',
    'revenueReport.markupDetails.title': 'Markup Details',
    'revenueReport.markupDetails.ordersCount': '{{count}} order(s) with markup',
    'revenueReport.markupDetails.hint': 'Orders with units charged above their catalog price (client price list or per-unit price). The markup is already included in Formulas.',
    'revenueReport.markupDetails.order': 'Order',
    'revenueReport.markupDetails.client': 'Client',
    'revenueReport.markupDetails.formulaTypes': 'Formula types',
    'revenueReport.markupDetails.catalog': 'Catalog price',
    'revenueReport.markupDetails.markup': 'Markup',
    'revenueReport.markupDetails.markupPercentage': 'Markup %',
    'revenueReport.markupDetails.charged': 'Charged',
    'revenueReport.settings.button': 'Report settings',
    'revenueReport.settings.title': 'Report settings',
    'revenueReport.settings.display': 'Show in the Revenue and Collection reports',
    'revenueReport.settings.showDiscounts': 'Discounts',
    'revenueReport.settings.showDiscountsHint': 'When off, the Discount line is merged into Formulas.',
    'revenueReport.settings.showDiscountDetails': 'Discount details',
    'revenueReport.settings.showMarkupDetails': 'Markup details',
    'revenueReport.settings.showVat': 'VAT',
    'revenueReport.settings.showVatHint': 'When off, the VAT line is hidden and the total excludes VAT.',
    'revenueReport.settings.showCogs': 'Cost of goods sold (formula type costs)',
    'revenueReport.settings.showCogsHint': 'Material, technician and additional costs per unit, in the formula types profit and net profit.',
    'revenueReport.settings.noCostsEnabled': 'No formula type costs are enabled for your lab yet.',
    'revenueReport.settings.saved': 'Report settings saved',
    'revenueReport.settings.loadError': 'Could not load the report settings',
    'revenueReport.settings.readOnly': 'You need the Edit settings permission to change these settings.',
    'revenueReport.section.generalExpenses': 'General Expenses',
    'revenueReport.generalExpenses.hint': 'Cash operating expenses belong on the Collection Report and are not deducted from accrual net profit.',
    'revenueReport.notBillableOrders': '{{count}} order(s) in this period are not counted yet because they have not reached the status set in the Order Status Workflow.',
    'revenueReport.unpaidDueOrders': '{{count}} unpaid order(s) in this period are included in revenue but not yet collected.',
    'revenueReport.generalExpenses.expenseType': 'Expense type',
    'revenueReport.generalExpenses.expenses': 'Expenses',
    'revenueReport.generalExpenses.uncategorized': 'Uncategorized',
    'revenueReport.generalExpenses.empty': 'No general expenses in this period',
    'revenueReport.section.netProfitSummary': 'Net Profit Summary',
    'revenueReport.netProfitSummary.hint': 'Accrual basis: total income is the Revenue Orders subtotal (after discounts, including additional costs). Net profit = total income − technicians cost − materials cost − others (additional operational costs). These order formula costs are deducted only when "Count order formula costs as expenses" is on in Finance → Expenses; otherwise they are shown as estimates only. Costs unchecked in the filters are not deducted. General cash expenses are on the Collection Report. VAT and delivery stay in Revenue Orders only.',
    'revenueReport.netProfitSummary.formulaCostsNotCounted': 'Order formula costs are shown as estimates only: they are not deducted from net profit or posted to the journal. To count them, turn on "Count order formula costs as expenses" in Finance → Expenses.',
    'revenueReport.netProfitSummary.formulaCostHint': 'Estimate from order formula costs. Not deducted from net profit or posted to the journal.',
    'revenueReport.netProfitSummary.type': 'Type',
    'revenueReport.netProfitSummary.amount': 'Amount',
    'revenueReport.netProfitSummary.totalIncome': 'Total income',
    'revenueReport.netProfitSummary.totalTechnicianCost': 'Total technicians cost',
    'revenueReport.netProfitSummary.totalMaterialCost': 'Total materials cost',
    'revenueReport.netProfitSummary.generalExpenses': 'General expenses',
    'revenueReport.netProfitSummary.others': 'Others',
    'revenueReport.netProfitSummary.netProfit': 'Net profit',
    'revenueReport.section.formulaTypesTracker': 'Formula Types Tracker',
    'revenueReport.section.latestFormulaTypes': 'Latest Used Formula Types',
    'revenueReport.section.receivables': 'Outstanding Receivables',
    'revenueReport.receivables.hint': 'Unpaid billable orders that became due in this period. Outstanding is the total unpaid balance; Overdue and Not Due classify it by invoice payment deadline. Uninvoiced unpaid orders count as Not Due.',
    'revenueReport.receivables.outstanding': 'Outstanding',
    'revenueReport.receivables.overdue': 'Overdue',
    'revenueReport.receivables.current': 'Not Due',
    'revenueReport.receivables.empty': 'No outstanding receivables in this period',
    'revenueReport.section.byClient': 'By Client',
    'revenueReport.byClient.hint': 'Revenue orders in this period grouped by client (accrual revenue).',
    'revenueReport.byClient.client': 'Client',
    'revenueReport.byClient.orders': 'Orders',
    'revenueReport.byClient.amount': 'Amount',
    'revenueReport.byClient.uncategorized': 'No client',
    'revenueReport.byClient.empty': 'No revenue by client in this period',

    'monthSummary.title': 'Collection Report',
    'monthSummary.subtitle': 'Cash basis: income from billable orders paid in this period (by payment date), after order discounts. Unpaid due orders are left out. Cash surplus = paid orders subtotal − general expenses. Formula Types costs show margin of collected work only and are not deducted from cash surplus. Do not add this report’s surplus to the Revenue Report net.',
    'monthSummary.countLabel': 'formula types',
    'monthSummary.section.formulaTypesProfit': 'Formula Types Profit',
    'monthSummary.period.month': 'Month',
    'monthSummary.period.range': 'Date range',
    'monthSummary.includeCosts': 'Include costs:',
    'monthSummary.includeCosts.material': 'Material',
    'monthSummary.includeCosts.technician': 'Technician',
    'monthSummary.includeCosts.additional': 'Additional',
    'monthSummary.column.name': 'Formula type',
    'monthSummary.column.units': 'Units',
    'monthSummary.column.sellingPrice': 'Selling price / unit',
    'monthSummary.column.totalIncome': 'Total income',
    'monthSummary.column.materialCost': 'Material cost / unit',
    'monthSummary.column.totalMaterial': 'Total material cost',
    'monthSummary.column.technicianCost': 'Technician cost / unit',
    'monthSummary.column.totalTechnician': 'Total technician cost',
    'monthSummary.column.additionalCost': 'Additional cost / unit',
    'monthSummary.column.totalAdditional': 'Total additional costs',
    'monthSummary.column.netProfit': 'Net profit',
    'monthSummary.totals': 'Total',
    'monthSummary.empty': 'No units in this period',
    'monthSummary.sellingPriceVaries': 'Average, because units were sold at different prices. Expand the row to see each price.',
    'monthSummary.priceSource.default': 'Default price',
    'monthSummary.priceSource.client': 'Client price',
    'monthSummary.priceSource.custom': 'Custom price (set on order)',
    'monthSummary.priceSource.clientsCount': '{{count}} clients',
    'monthSummary.priceSource.noClient': 'No client',
    'monthSummary.noAccess': 'You do not have access to the collection report',
    'monthSummary.loadError': 'Could not load the collection report',
    'monthSummary.section.paidOrders': 'Paid Orders',
    'monthSummary.paidOrders.hint': 'Totals for billable orders paid in this period (by payment date): formulas, order discounts, additional costs, subtotal, VAT, delivery, and grand total. Formula Types Profit uses formulas after discounts; its costs are margin of collected work only.',
    'monthSummary.paidOrders.type': 'Type',
    'monthSummary.paidOrders.amount': 'Amount',
    'monthSummary.paidOrders.formulas': 'Formulas',
    'monthSummary.paidOrders.discount': 'Discount',
    'monthSummary.paidOrders.additionalCosts': 'Additional costs',
    'monthSummary.paidOrders.subtotal': 'Subtotal',
    'monthSummary.paidOrders.vat': 'Total VAT',
    'monthSummary.paidOrders.delivery': 'Delivery costs',
    'monthSummary.paidOrders.total': 'Total',
    'monthSummary.paidOrders.ordersCount': '{{count}} paid order(s)',
    'monthSummary.paidOrders.empty': 'No paid orders in this period',
    'monthSummary.section.generalExpenses': 'General Expenses',
    'monthSummary.generalExpenses.hint': 'Cash operating expenses entered manually in this period. Expenses created automatically from orders are not included (those belong with production costs on the Revenue Report).',
    'monthSummary.notBillableOrders': '{{count}} order(s) in this period are not counted yet because they have not reached the status set in the Order Status Workflow.',
    'monthSummary.unpaidOrders': '{{count}} unpaid due order(s) in this period are left out of collection (due balances are not counted until paid).',
    'monthSummary.generalExpenses.expenseType': 'Expense type',
    'monthSummary.generalExpenses.expenses': 'Expenses',
    'monthSummary.generalExpenses.uncategorized': 'Uncategorized',
    'monthSummary.generalExpenses.empty': 'No general expenses in this period',
    'monthSummary.section.netProfitSummary': 'Cash Surplus Summary',
    'monthSummary.netProfitSummary.hint': 'Cash basis: total income is the Paid Orders subtotal (after discounts, including additional costs). Cash surplus = total income − general expenses. Formula Types production costs are not deducted here (see Formula Types Profit for collected-work margin). VAT and delivery stay in Paid Orders only.',
    'monthSummary.netProfitSummary.type': 'Type',
    'monthSummary.netProfitSummary.amount': 'Amount',
    'monthSummary.netProfitSummary.totalIncome': 'Total income',
    'monthSummary.netProfitSummary.totalTechnicianCost': 'Total technicians cost',
    'monthSummary.netProfitSummary.totalMaterialCost': 'Total materials cost',
    'monthSummary.netProfitSummary.generalExpenses': 'General expenses',
    'monthSummary.netProfitSummary.others': 'Others',
    'monthSummary.netProfitSummary.netProfit': 'Cash surplus',
    'monthSummary.section.formulaTypesTracker': 'Formula Types Tracker',
    'monthSummary.section.latestFormulaTypes': 'Latest Used Formula Types',
    // Invoices
    'invoices.header.title': 'Invoices',
    'invoices.header.subtitle': 'Manage laboratory invoices, payment collection statuses and financial records',
    'invoices.stats.total': 'Total Invoices',
    'invoices.stats.amount': 'Total Amount',
    'invoices.stats.paid': 'Total Paid',
    'invoices.stats.unpaid': 'Total Unpaid',
    'invoices.filter.title': 'Filter Invoices',
    'invoices.filter.active': 'Active',
    'invoices.filter.clear': 'Reset Filters',
    'invoices.table.refresh': 'Refresh',
    'invoices.table.ordersCount': 'Orders',
    'invoices.table.number': 'Invoice ID',
    'invoice.table.orderRef': 'Order Ref',
    'invoice.table.invoiceRef': 'Invoice Ref',
    'invoice.field.shipmentDate': 'Shipment Date',
    'invoice.field.vat': 'VAT',
    'invoice.field.deliveryCost': 'Delivery Cost',
    'invoice.field.orderId': 'Order Id',
    'invoice.field.amount': 'Amount',
    'invoices.table.status': 'Status',
    'invoices.table.issueDate': 'Issue Date',
    'invoices.table.client': 'Client',
    'invoices.table.dentist': 'Dentist',
    'invoices.table.dueDate': 'Due Date',
    'invoices.table.total': 'Total',
    'invoices.table.remaining': 'Rem',
    'invoices.table.actions': 'Actions',
    'invoices.table.draft': 'Archived',
    'invoices.table.draftLabel': 'Archived',
    'invoices.confirm.delete': 'Are you sure you want to delete this invoice?',
    'invoices.alert.noAccess': 'You do not have access to view invoices.',
    'invoices.button.showDrafts': 'Show Archived',
    'invoices.button.hideDrafts': 'Hide Archived',
    'invoices.filter.all': 'Show All',
    'invoices.filter.drafts': 'Show Archived',
    'invoices.filter.nonDrafts': 'Hide Archived',
    'invoices.filter.issueDateFrom': 'Issue date from',
    'invoices.filter.issueDateTo': 'Issue date to',
    'invoices.filter.dueDateFrom': 'Due date from',
    'invoices.filter.dueDateTo': 'Due date to',
    'invoices.search.placeholder': 'Search invoice #, ref, client, dentist or notes',

  
    'sidebar.formula_types': 'Formulas and Services',
    'sidebar.colors': 'Colors',
    'sidebar.platform_settings': 'Platform Settings',
    'sidebar.notifications_settings': 'Notification Settings',
    'sidebar.support_chat': 'Support Chat',
    'sidebar.assets': 'Fixed Assets',
    'sidebar.branchs': 'Branches',
    'sidebar.delivery_centers': 'Delivery Centers',
    'sidebar.expenses': 'Expenses',
    'sidebar.expense_types': 'Expense Types',
    'sidebar.dentists': 'Dentists',
    'sidebar.users': 'Users',
    'sidebar.roles': 'Roles & Permissions',
    'sidebar.transactions': 'Transactions',
    'sidebar.activities': 'Activities',
    'sidebar.units': 'Units',
    'sidebar.unit_types': 'Unit Types',

    // Activities
    'activities.table.entity_affected': 'Entity affected',
    'activities.table.user': 'User name',
    'activities.table.operation': 'Operation',
    'activities.table.ip': 'Device IP',
    'activities.table.date': 'Date',
    'activities.table.properties': 'Properties',
    'activities.filters.name': 'Name',
    'activities.filters.entity': 'Entity',
    'activities.filters.operation': 'Operation',
    'activities.operations.create': 'CREATE',
    'activities.operations.created': 'CREATE',
    'activities.operations.update': 'UPDATE',
    'activities.operations.updated': 'UPDATE',
    'activities.operations.delete': 'DELETE',
    'activities.operations.deleted': 'DELETE',
    'activities.operations.paid_invoice': 'PAID_INVOICE',
    'activities.operations.undo_mark_paid': 'UNDO_MARK_PAID',
    'activities.operations.refund_invoice': 'REFUND_INVOICE',
    'activities.operations.partial_payment': 'PARTIAL_PAYMENT',
    'activities.operations.mark_order_paid': 'MARK_ORDER_PAID',
    'activities.operations.mark_order_unpaid': 'MARK_ORDER_UNPAID',
    'activities.operations.restore_order_status_after_invoice_unpaid': 'RESTORE_ORDER_STATUS_AFTER_INVOICE_UNPAID',
    'activities.operations.restore_order_status_after_invoice_detach': 'RESTORE_ORDER_STATUS_AFTER_INVOICE_DETACH',
    'activities.operations.mark_order_partially_paid': 'MARK_ORDER_PARTIALLY_PAID',
    'activities.operations.cancel': 'CANCEL',
    'activities.operations.send_email': 'SEND_EMAIL',
    'activities.operations.send_whatsapp': 'SEND_WHATSAPP',
    'activities.operations.download_invoice_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_invoice_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_invoice_spreadsheet': 'DOWNLOAD_INVOICE_SPREADSHEET',
    'activities.operations.upload_attachment': 'UPLOAD_ATTACHMENT',
    'activities.operations.delete_attachment': 'DELETE_ATTACHMENT',
    'activities.operations.export_account_statement': 'EXPORT_ACCOUNT_STATEMENT',
    // Legacy activity event aliases
    'activities.operations.download_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    'activities.operations.login': 'LOGIN',
    'activities.operations.logout': 'LOGOUT',
    'activities.operations.password_reset': 'PASSWORD RESET',
    'activities.operations.password_reset_request': 'PASSWORD RESET REQUEST',
    'activities.operations.impersonate': 'IMPERSONATE',
    'activities.operations.wallet_recharge': 'WALLET_RECHARGE',
    'activities.operations.update_wallet_log_date': 'UPDATE_WALLET_LOG_DATE',
    'activities.operations.wallet_recharge_revert': 'WALLET_RECHARGE_REVERT',
    'activities.properties.field': 'Field',
    'activities.properties.old': 'Old',
    'activities.properties.new': 'New',
    'activities.properties.no_changes': 'No old/new comparison data for this activity.',
    'activities.modal.properties_title': 'Changed properties',
    'activities.fields.id': 'ID',
    'activities.fields.name': 'Name',
    'activities.fields.email': 'Email',
    'activities.fields.phone': 'Phone',
    'activities.fields.notes': 'Notes',
    'activities.fields.address': 'Address',
    'activities.fields.whatsapp': 'WhatsApp',
    'activities.fields.client': 'Client',
    'activities.fields.client_id': 'Client',
    'activities.fields.client_name': 'Client',
    'activities.fields.client_address': 'Client Address',
    'activities.fields.dentist': 'Dentist',
    'activities.fields.dentist_id': 'Dentist',
    'activities.fields.dentist_name': 'Dentist',
    'activities.fields.dentist_email': 'Dentist Email',
    'activities.fields.dentist_phone': 'Dentist Phone',
    'activities.fields.technician': 'Technician',
    'activities.fields.technician_id': 'Technician',
    'activities.fields.technician_name': 'Technician Name',
    'activities.fields.technician_email': 'Technician Email',
    'activities.fields.courier': 'Courier',
    'activities.fields.courier_id': 'Courier',
    'activities.fields.orders': 'Orders',
    'activities.fields.units': 'Units',
    'activities.fields.units_count': 'Units Count',
    'activities.fields.attachments': 'Attachments',
    'activities.fields.requested_at': 'Requested At',
    'activities.fields.delivered_at': 'Delivered At',
    'activities.fields.code': 'Code',
    'activities.fields.color': 'Color',
   
    'activities.fields.delivery_type': 'Delivery Type',
    'activities.fields.delivery_type_name': 'Delivery Type',
    'activities.fields.user_type': 'User Type',
    'activities.fields.payment_method': 'Payment Method',
    'activities.fields.payment_method_id': 'Payment Method',
    'activities.fields.payment_status': 'Payment Status',
    'activities.fields.payment_status_id': 'Payment Status',
    'activities.fields.order_status': 'Order Status',
    'activities.fields.delivery_center': 'Delivery Center',
    'activities.fields.delivery_center_id': 'Delivery Center',
    'activities.fields.cost_center_id': 'Cost center',
    'activities.fields.delivery_center_name': 'Delivery Center Name',
    'activities.fields.delivery_center_address': 'Delivery Center Address',
    'activities.fields.delivery_center_created_at': 'Delivery Center Created At',
    'activities.fields.delivery_center_updated_at': 'Delivery Center Updated At',
    'activities.fields.delivery_cost': 'Delivery Cost',
    'activities.fields.discount_amount': 'Discount Amount',
    'activities.fields.vat_percentage': 'VAT Percentage',
    'activities.fields.unit_price_override': 'Unit Price Override',
    'activities.fields.unit_price_source': 'Unit Price Source',
    'activities.fields.reference': 'Reference',
    'activities.fields.is_draft': 'Draft',
    'activities.fields.due_date': 'Due Date',
    'activities.fields.issue_date': 'Issue Date',
    'activities.fields.paid_at': 'Paid At',
    'activities.fields.paid_amount': 'Paid Amount',
    'activities.fields.total_amount': 'Total Amount',
    'activities.fields.subtotal_amount': 'Subtotal Amount',
    'activities.fields.remaining_amount': 'Remaining Amount',
    'activities.fields.created_at': 'Created At',
    'activities.fields.balance': 'Balance',
    'activities.fields.updated_at': 'Updated At',

    // Auth
    'auth.login.title': 'Welcome back',
    'auth.login.vendorTitle': 'Vendor Portal',
    'auth.login.vendorSubtitle': 'Sign in to manage your lab',
    'auth.login.brandLede': 'Orders, invoices, and delivery — one place for your dental lab.',
    'auth.login.formSubtitle': 'Sign in with your email or username and password',
    'auth.login.secureNotice': 'Protected access for authorized lab staff only.',
    'auth.login.newAccount.title': 'Your account is ready',
    'auth.login.newAccount.message': 'We filled in your email and a temporary password. Sign in now, then go to Profile → Change Password and replace it with a strong password (at least 8 characters, mixing letters, numbers and symbols).',
    'auth.login.email.label': 'Email',
    'auth.login.email.required': 'Please enter the email address',
    'auth.login.email.invalid': 'Please enter a valid email address',
    'auth.login.email.placeholder': 'Enter the email address',
    'auth.login.identifier.label': 'Email or username',
    'auth.login.identifier.required': 'Please enter your email or username',
    'auth.login.identifier.placeholder': 'Enter email or username',
    'auth.login.password.label': 'Password',
    'auth.login.password.required': 'Please enter the password',
    'auth.login.password.placeholder': 'Enter the password',
    'auth.login.submit': 'Sign in',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.forgotPassword.title': 'Reset password',
    'auth.forgotPassword.description': 'Enter your email address and we will send you a link to reset your password.',
    'auth.forgotPassword.brandHeadline': 'Regain access in a few steps',
    'auth.forgotPassword.brandLede': 'Use your email for a reset link, or look up your lab admin if you sign in with a username only.',
    'auth.forgotPassword.submit': 'Send reset link',
    'auth.forgotPassword.success': 'If an account exists for that email, a password reset link has been sent.',
    'auth.forgotPassword.failed': 'Unable to send reset link. Please try again.',
    'auth.forgotPassword.backToLogin': 'Back to login',
    'auth.forgotPassword.noEmailDivider': 'No email?',
    'auth.forgotPassword.noEmailDescription': 'If you sign in with a username and have no email, enter your username to get your lab admin contact details. They can reset your password to the temporary password.',
    'auth.forgotPassword.contactAdmin': 'Get admin contact',
    'auth.forgotPassword.usernameRequired': 'Please enter your username',
    'auth.forgotPassword.contactFailed': 'Unable to look up admin contact. Please try again.',
    'auth.forgotPassword.hasEmail': 'This account has an email. Use the form above to receive a reset link.',
    'auth.forgotPassword.contactFound': 'Contact your lab administrator and ask them to reset your password.',
    'auth.forgotPassword.contactAdminGeneric': 'Contact your lab administrator and ask them to reset your password to the temporary password.',
    'auth.resetPassword.title': 'Set new password',
    'auth.resetPassword.description': 'Choose a new password for your account.',
    'auth.resetPassword.brandHeadline': 'Choose a strong new password',
    'auth.resetPassword.brandLede': 'After resetting, you can sign in again with your updated credentials.',
    'auth.resetPassword.password.label': 'New password',
    'auth.resetPassword.password.required': 'Please enter a new password',
    'auth.resetPassword.password.minLength': 'Password must be at least 8 characters',
    'auth.resetPassword.password.placeholder': 'Enter your new password',
    'auth.resetPassword.password.confirm': 'Confirm password',
    'auth.resetPassword.password.confirmRequired': 'Please confirm your password',
    'auth.resetPassword.password.confirmPlaceholder': 'Confirm your new password',
    'auth.resetPassword.password.mismatch': 'Passwords do not match',
    'auth.resetPassword.submit': 'Reset password',
    'auth.resetPassword.success': 'Your password has been reset. You can now log in.',
    'auth.resetPassword.failed': 'Unable to reset password. Please try again.',
    'auth.resetPassword.error': 'Invalid link',
    'auth.resetPassword.invalidLink': 'Invalid or expired reset link. Please request a new one.',

    // Assets
    'assets.table.name': 'Name',
    'assets.table.cost': 'Cost',
    'assets.table.notes': 'Notes',
    'assets.table.actions': 'Actions',
    'assets.button.add': 'Add Asset',
    'assets.editTitle': 'Edit Asset',
    'assets.modal.title': 'Assets',
    'assets.confirm.deleteTitle': 'Delete Asset',
    'assets.confirm.deleteMessage': 'Are you sure you want to delete this asset?',
    'assets.form.name.label': 'Asset Name',
    'assets.form.name.placeholder': 'Asset name',
    'assets.form.name.required': 'Please enter the asset name',
    'assets.form.cost.label': 'Cost',
    'assets.form.cost.placeholder': 'Enter cost',
    'assets.form.cost.required': 'Please enter the cost',
    'assets.form.cost.min': 'Cost must be at least 1',
    'assets.form.notes.label': 'Notes',
    'assets.form.notes.placeholder': 'Notes',
    'assets.table.attachments': 'Attachments',
    'assets.form.attachments.label': 'Images & files',
    'assets.form.attachments.hint': 'Attach photos, invoices, warranties or manuals (max 20 MB per file).',
    'assets.form.attachments.choose': 'Choose files',
    'assets.form.attachments.existing': 'Current attachments',
    'assets.form.attachments.deleteConfirm': 'Remove this attachment?',
    'assets.form.attachments.deleted': 'Attachment deleted',
    'assets.form.attachments.deleteFailed': 'Unable to delete attachment',
    'assets.form.attachments.tooLarge': 'File is larger than 20 MB',
    'assets.search.namePlaceholder': 'Search by name',
    'assets.search.notesPlaceholder': 'Search by notes',
    'assets.alert.noAccess': 'You do not have access to view assets.',

    // Branchs
    'branchs.table.name': 'Branch Name',
    'branchs.table.address': 'Address',
    'branchs.table.phone': 'Phone Number',
    'branchs.table.whatsapp': 'WhatsApp Number',
    'branchs.table.email': 'Email',
    'branchs.table.notes': 'Notes',
    'branchs.table.actions': 'Actions',
    'branchs.button.add': 'Add Branch',
    'branchs.editTitle': 'Edit Branch',
    'branchs.modal.title': 'Branches',
    'branchs.confirm.deleteTitle': 'Delete Branch',
    'branchs.confirm.deleteMessage': 'Are you sure you want to delete this branch?',
    'branchs.form.name.label': 'Branch Name',
    'branchs.form.name.placeholder': 'Enter branch name',
    'branchs.form.name.required': 'Please enter the branch name',
    'branchs.form.name.max': 'Name must be at most 255 characters',
    'branchs.form.address.label': 'Address',
    'branchs.form.address.placeholder': 'Enter address',
    'branchs.form.address.required': 'Please enter the address',
    'branchs.form.address.max': 'Address must be at most 500 characters',
    'branchs.form.phone.label': 'Phone Number',
    'branchs.form.phone.placeholder': 'Enter phone number',
    'branchs.form.phone.required': 'Please enter the phone number',
    'branchs.form.phone.max': 'Phone number must be at most 50 characters',
    'branchs.form.whatsapp.label': 'WhatsApp Number',
    'branchs.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'branchs.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'branchs.form.email.label': 'Email',
    'branchs.form.email.placeholder': 'Enter email',
    'branchs.form.email.invalid': 'Please enter a valid email address',
    'branchs.form.notes.label': 'Notes',
    'branchs.form.notes.placeholder': 'Enter notes',
    'branchs.form.notes.max': 'Notes must be at most 1000 characters',
    'branchs.alert.noAccess': 'You do not have access to view branches.',

    // Delivery Centers
    'deliveryCenters.table.name': 'Center Name',
    'deliveryCenters.table.address': 'Address',
    'deliveryCenters.table.phone': 'Phone Number',
    'deliveryCenters.table.whatsapp': 'WhatsApp Number',
    'deliveryCenters.table.email': 'Email',
    'deliveryCenters.table.client': 'Assigned Client',
    'deliveryCenters.table.noClient': 'No client assigned',
    'deliveryCenters.table.actions': 'Actions',
    'deliveryCenters.button.add': 'Add Delivery Center',
    'deliveryCenters.modal.title': 'Delivery Centers',
    'deliveryCenters.confirm.deleteTitle': 'Delete Delivery Center',
    'deliveryCenters.confirm.deleteMessage': 'Are you sure you want to delete this delivery center?',
    'deliveryCenters.form.address.max': 'Address must be at most 500 characters',
    'deliveryCenters.form.phone.max': 'Phone number must be at most 50 characters',
    'deliveryCenters.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'deliveryCenters.form.notes.max': 'Notes must be at most 1000 characters',
    'deliveryCenters.form.client.label': 'Client',
    'deliveryCenters.form.client.placeholder': 'Select a client',
    'deliveryCenters.form.client.required': 'Please select a client',
    'deliveryCenters.alert.noAccess': 'You do not have access to view delivery centers.',
    'deliveryCenters.filter.title': 'Filter Delivery Centers',
    'deliveryCenters.filter.active': 'Active',
    'deliveryCenters.filter.clear': 'Reset Filters',
    'deliveryCenters.filter.searchPlaceholder': 'Search by name, address, phone, WhatsApp or email',
    'responses.delivery_center.updated': 'Delivery center updated successfully',

    // Clients
    'clients.header.title': 'Clients',
    'clients.header.subtitle': 'Manage clinics, hospitals, and labs with contacts, dentists, and delivery centers',
    'clients.filter.title': 'Filter Clients',
    'clients.filter.active': 'Active',
    'clients.filter.clear': 'Reset Filters',
    'clients.filter.type.placeholder': 'Client type',
    'clients.wallet.historyEmpty': 'No wallet transactions yet',
    'clients.alert.noAccess': 'You do not have access to view clients.',
    'clients.table.name': 'Client Name',
    'clients.table.type': 'Client Type',
    'clients.table.phone': 'Phone Number',
    'clients.table.whatsapp': 'WhatsApp Number',
    'clients.table.email': 'Email',
    'clients.table.dentists': 'Assigned Dentists',
    'clients.table.noDentists': 'No dentists assigned',
    'clients.table.noLabContacts': 'No lab contacts assigned',
    'clients.table.showMore': 'Show more',
    'clients.table.showLess': 'Show less',
    'clients.table.deliveryCenters': 'Delivery Centers',
    'clients.table.noDeliveryCenters': 'No delivery centers assigned',
    'clients.table.actions': 'Actions',
    'clients.formulaTypePrices.button': 'Formula type prices',
    'clients.formulaTypePrices.title': 'Formula type prices for',
    'clients.formulaTypePrices.help': 'Set a custom unit price per formula type for this client. Leave empty to use the default selling price.',
    'clients.formulaTypePrices.formulaType': 'Formula type',
    'clients.formulaTypePrices.defaultPrice': 'Default price',
    'clients.formulaTypePrices.customPrice': 'Custom unit price',
    'clients.formulaTypePrices.noChanges': 'No changes to save',
    'clients.button.add': 'Add Client',
    'clients.editTitle': 'Edit Client',
    'clients.title': 'Client',
    'clients.modal.title': 'Clients',
    'clients.confirm.deleteTitle': 'Delete Client',
    'clients.confirm.deleteMessage': 'Are you sure you want to delete this client?',
    'clients.form.name.label': 'Client Name',
    'clients.form.name.placeholder': 'Enter client name',
    'clients.form.name.required': 'Please enter the client name',
    'clients.form.name.max': 'Name must be at most 255 characters',
    'clients.form.type.label': 'Client Type',
    'clients.form.type.placeholder': 'Select a client type',
    'clients.form.type.required': 'Please select a client type',
    'clients.form.type.options.clinic': 'Clinic',
    'clients.form.type.options.hospital': 'Hospital',
    'clients.form.type.options.lab': 'Lab',
    'clients.form.search.placeholder': 'Search by name, email, or phone',
    'clients.form.phone.label': 'Phone Number',
    'clients.form.phone.placeholder': 'Enter phone number',
    'clients.form.phone.max': 'Phone number must be at most 50 characters',
    'clients.form.whatsapp.label': 'WhatsApp Number',
    'clients.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'clients.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'clients.form.email.label': 'Email',
    'clients.form.email.placeholder': 'Enter email',
    'clients.form.email.invalid': 'Please enter a valid email address',
    'clients.form.dentists.label': 'Dentists',
    'clients.form.dentists.placeholder': 'Select dentists',
    'clients.form.dentists.empty': 'No available dentists',
    'clients.form.dentists.labelLab': 'Lab contacts',
    'clients.form.dentists.placeholderLab': 'Select lab contacts',
    'clients.form.dentists.emptyLab': 'No available lab contacts',
    'clients.form.deliveryCenters.label': 'Delivery Centers',
    'clients.form.deliveryCenters.placeholder': 'Select or add delivery centers',
    'clients.form.deliveryCenters.empty': 'No available delivery centers',
    'clients.form.submit.edit': 'Update',
    'clients.form.submit.createThenContacts': 'Create client & add contacts',
    'clients.form.submit.createWithContacts': 'Create client with contacts',
    'clients.form.contactMode.label': 'Contacts for this client',
    'clients.form.contactMode.required': 'Please choose how to add contacts',
    'clients.form.contactMode.mirror': 'Create a dentist with the same details',
    'clients.form.contactMode.mirrorLab': 'Create a lab contact with the same details',
    'clients.form.contactMode.mirrorHelp': 'Best when the clinic/hospital has one doctor — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.mirrorHelpLab': 'Best when the lab has one contact — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.list': 'Add multiple dentists',
    'clients.form.contactMode.listLab': 'Add multiple lab contacts',
    'clients.form.contactMode.listHelp': 'Expand this form to add one or more dentists now, then create everything together.',
    'clients.form.contactMode.listHelpLab': 'Expand this form to add one or more lab contacts now, then create everything together.',
    'clients.form.contactMode.dentistTypeMissing': 'Dentist user type is not available. Refresh and try again.',
    'clients.form.mirror.sectionTitle': 'Dentist login',
    'clients.form.mirror.sectionTitleLab': 'Lab contact login',
    'clients.form.mirror.hint': 'Name, phone, WhatsApp, and email are taken from the client. Email and username are optional.',
    'clients.form.mirror.createFailed': 'Client was created, but the dentist could not be created. Add them from the client page.',
    'clients.form.mirror.createFailedLab': 'Client was created, but the lab contact could not be created. Add them from the client page.',
    'clients.form.list.sectionTitle': 'Dentists',
    'clients.form.list.sectionTitleLab': 'Lab contacts',
    'clients.form.list.clientCreated': 'Client "{{name}}" was created',
    'clients.form.list.stepTitle': 'Add dentists — {{name}}',
    'clients.form.list.stepTitleLab': 'Add lab contacts — {{name}}',
    'clients.form.list.stepHelp': 'Add one or more dentists for this client. You can skip and add them later.',
    'clients.form.list.stepHelpLab': 'Add one or more lab contacts for this client. You can skip and add them later.',
    'clients.form.list.addAnother': 'Add another dentist',
    'clients.form.list.addAnotherLab': 'Add another lab contact',
    'clients.form.list.saveContacts': 'Save dentists',
    'clients.form.list.saveContactsLab': 'Save lab contacts',
    'clients.form.list.createFailed': 'Client was created, but some dentists could not be created. Add them from the client page.',
    'clients.form.list.createFailedLab': 'Client was created, but some lab contacts could not be created. Add them from the client page.',
    'clients.form.list.done': 'Done',
    'clients.type.clinic': 'Clinic',
    'clients.type.hospital': 'Hospital',
    'clients.type.lab': 'Lab',
    'clients.wallet.title': 'Client Wallet',
    'clients.tabs.overview': 'Overview',
    'clients.tabs.wallet': 'Wallet',
    'clients.tabs.deliveryCenters': 'Delivery Centers',
    'clients.tabs.dentists': 'Dentists',
    'clients.tabs.labContacts': 'Lab contacts',
    'clients.tabs.customPrices': 'Custom prices',
    'clients.tabs.accountStatement': 'Account statement',
    'clients.tabs.orders': 'Orders',
    'clients.tabs.invoices': 'Invoices',
    'clients.accountStatement.serial': 'Serial',
    'clients.accountStatement.amount': 'Amount',
    'clients.accountStatement.status': 'Payment Status',
    'clients.accountStatement.orderStatus': 'Order Status',
    'clients.accountStatement.paymentStatus': 'Payment Status',
    'clients.accountStatement.paid': 'Paid',
    'clients.accountStatement.due': 'Due',
    'clients.accountStatement.total': 'Total',
    'clients.accountStatement.empty': 'No orders for this client yet',
    'clients.accountStatement.patient': 'Patient',
    'clients.accountStatement.positions': 'Positions',
    'clients.accountStatement.units': 'Units',
    'clients.accountStatement.formula': 'Formula',
    'clients.accountStatement.arch': 'arch',
    'clients.accountStatement.paymentMethod': 'Payment method',
    'clients.accountStatement.date': 'Date',
    'clients.accountStatement.color': 'Color',
    'clients.accountStatement.periodDue': 'Due amount for selected period',
    'clients.accountStatement.previousDue': 'Previous due amount',
    'clients.accountStatement.clientTotalDue': 'Total client due amount',
    'clients.totalOrdersAmount': 'Total Orders Amount',
    'clients.totalOrdersPaidAmount': 'Total Orders Paid Amount',
    'clients.totalDueOrdersAmount': 'Total Outstanding',
    'clients.totalOrdersCount': 'Total Orders',
    'clients.paidOrdersCount': 'Paid Orders',
    'clients.unpaidOrdersCount': 'Unpaid Orders',
    'clients.notYetDueOrders': 'Not Yet Due Orders',
    'clients.notYetDueOrdersCount': '{{count}} orders',
    'clients.walletBalance': 'Wallet Balance',
    'clients.wallet.balance': 'Balance',
    'clients.wallet.recharge': 'Recharge',
    'clients.wallet.amount': 'Amount',
    'clients.wallet.amountPlaceholder': 'Enter amount',
    'clients.wallet.notes': 'Notes',
    'clients.wallet.notesPlaceholder': 'Optional notes for this recharge',
    'clients.wallet.rechargeSuccess': 'Wallet recharged successfully',
    'clients.wallet.rechargeError': 'Failed to recharge wallet',
    'clients.wallet.amountRequired': 'Amount is required',
    'clients.wallet.amountMin': 'Amount must be at least 0.01',
    'clients.wallet.paymentMethod': 'Payment Method',
    'clients.wallet.paymentMethodPlaceholder': 'Select payment method',
    'clients.wallet.attachments': 'Attachments',
    'clients.wallet.uploadImage': 'Upload image',
    'clients.wallet.history': 'Wallet History',
    'clients.wallet.historyDate': 'Date',
    'clients.wallet.transactionType': 'Type',
    'clients.wallet.changeDate': 'Change date',
    'clients.wallet.changeDateTitle': 'Change wallet log date',
    'clients.wallet.newDate': 'New date',
    'clients.wallet.dateRequired': 'Date is required',
    'clients.wallet.changeDateSuccess': 'Wallet log date updated',
    'clients.wallet.changeDateError': 'Failed to update wallet log date',
    'clients.wallet.actions': 'Actions',
    'clients.wallet.revert': 'Revert',
    'clients.wallet.reverted': 'Reverted',
    'clients.wallet.revertTitle': 'Revert wallet recharge',
    'clients.wallet.revertConfirm': 'This will deduct {{amount}} from the wallet and mark the recharge as reverted. This cannot be undone.',
    'clients.wallet.revertNotesPlaceholder': 'Reason for reverting (optional)',
    'clients.wallet.revertSuccess': 'Wallet recharge reverted',
    'clients.wallet.revertError': 'Failed to revert wallet recharge',
    'sidebar.clients': 'Clients and Doctors',
    'sidebar.wallets': 'Wallets',
    'wallets.title': 'Wallets',
    'wallets.column.walletId': 'Wallet ID',
    'wallets.column.clientName': 'Client name',
    'wallets.column.balance': 'Balance',
    'wallets.viewTitle': 'Wallet #{{id}}',
    'wallets.backToList': 'Back to Transactions',
    'wallets.openClient': 'Client profile',
    'wallets.walletIdLabel': 'Wallet ID',
    'wallets.alert.noAccess': 'You do not have access to wallets.',

    // Colors
    'colors.table.name': 'Color',
    'colors.table.actions': 'Actions',
    'colors.button.add': 'Add Color',
    'colors.modal.title': 'Colors',
    'colors.confirm.deleteTitle': 'Delete Color',
    'colors.confirm.deleteMessage': 'Are you sure you want to delete this color?',
    'colors.form.code.placeholder': 'Enter code',
    'colors.form.preview.label': 'Tooth Color Preview',
    'colors.alert.noAccess': 'You do not have access to view colors.',

    // Dentists
    'dentists.label.singular': 'Dentist',
    'dentists.label.singular.lab': 'Lab contact',
    'dentists.label.plural': 'Dentists',
    'dentists.label.plural.lab': 'Lab contacts',
    'dentists.table.name': 'Dentist Name',
    'dentists.table.username': 'Username',
    'dentists.table.email': 'Email',
    'dentists.table.address': 'Address',
    'dentists.table.phone': 'Phone Number',
    'dentists.table.whatsapp': 'WhatsApp Number',
    'dentists.table.client': 'Client',
    'dentists.table.accountRole': 'Account',
    'dentists.table.accountRoleMain': 'Main',
    'dentists.table.accountRoleSub': 'Sub',
    'dentists.table.noClient': 'No client',
    'dentists.table.actions': 'Actions',
    'dentists.filter.title': 'Filter Dentists',
    'dentists.filter.titleLab': 'Filter Lab Contacts',
    'dentists.filter.active': 'Active',
    'dentists.button.add': 'Add Dentist',
    'dentists.button.addLabContact': 'Add Lab Contact',
    'dentists.modal.title': 'Dentists',
    'dentists.modal.titleLabContact': 'Lab Contacts',
    'dentists.confirm.deleteTitle': 'Delete Dentist',
    'dentists.confirm.deleteMessage': 'Are you sure you want to delete this dentist?',
    'dentists.confirm.removeTitle': 'Remove Dentist',
    'dentists.confirm.removeMessage': 'This dentist will be detached from this client and deactivated.',
    'dentists.confirm.deleteTitleLabContact': 'Delete Lab Contact',
    'dentists.confirm.deleteMessageLabContact': 'Are you sure you want to delete this lab contact?',
    'dentists.confirm.removeTitleLabContact': 'Remove Lab Contact',
    'dentists.confirm.removeMessageLabContact': 'This lab contact will be detached from this client and deactivated.',
    'dentists.form.accountRole.label': 'Account type',
    'dentists.form.accountRole.main': 'Main account',
    'dentists.form.accountRole.sub': 'Sub account',
    'dentists.form.accountRole.hint': 'Main accounts can access all client resources. Sub accounts only access their own orders and profile.',
    'dentists.form.accountRole.labLocked': 'Lab contacts are always main accounts.',
    'dentists.form.client.label': 'Client',
    'dentists.form.client.placeholder': 'Select or add a client',
    'dentists.alert.noAccess': 'You do not have access to view dentists.',
    'dentists.alert.noDentistType': 'Dentist user type is missing. Please configure user types first.',
    'dentists.changeHistory': 'Change history',
    'dentists.versions.title': 'Dentist change history',
    'dentists.versions.empty': 'No change history yet',
    'dentists.versions.timelineTitle': 'Timeline',
    'dentists.versions.by': 'Updated by',
    'dentists.versions.fieldsChanged': 'Fields changed',
    'dentists.versions.compareTitle': 'Compare with current',
    'dentists.versions.selectVersion': 'Select a version',
    'dentists.versions.noFields': 'No changed fields captured',
    'dentists.versions.before': 'Before',
    'dentists.versions.after': 'After (Current)',

    // Expenses
    'expenses.table.serial': 'Serial',
    'expenses.table.expenseType': 'Expense Type',
    'expenses.table.cost': 'Cost',
    'expenses.table.date': 'Date',
    'expenses.table.notes': 'Notes',
    'expenses.table.order': 'Order',
    'expenses.table.paidTo': 'Paid to',
    'expenses.table.actions': 'Actions',
    'expenses.button.add': 'Add Expense',
    'expenses.editTitle': 'Edit Expense',
    'expenses.modal.title': 'Expense Record',
    'expenses.confirm.deleteTitle': 'Delete Expense',
    'expenses.confirm.deleteMessage': 'Are you sure you want to delete this expense?',
    'expenses.form.type.label': 'Expense Item',
    'expenses.form.expense_type_id': 'Expense Type',
    'expenses.form.type.placeholder': 'Select expense item',
    'expenses.form.type.required': 'Please select an expense item',
    'expenses.form.cost.label': 'Cost',
    'expenses.form.cost.placeholder': '0',
    'expenses.form.cost.required': 'Please enter the cost',
    'expenses.form.expensedAt.label': 'Expense Date',
    'expenses.form.expensedAt.placeholder': 'Select date',
    'expenses.form.expensedAt.required': 'Please select the expense date',
    'expenses.form.notes.label': 'Notes',
    'expenses.form.notes.placeholder': 'Enter notes',
    'expenses.form.paidTo.label': 'Paid for',
    'expenses.form.paidTo.placeholder': 'Select a staff member',
    'expenses.form.paidTo.none': 'Not specified',
    'expenses.form.attachments.label': 'Attachments',
    'expenses.form.attachments.hint': 'Attach receipts, invoices or photos (max 20 MB per file).',
    'expenses.form.attachments.choose': 'Choose files',
    'expenses.form.attachments.existing': 'Current attachments',
    'expenses.form.attachments.deleteConfirm': 'Remove this attachment?',
    'expenses.form.attachments.deleted': 'Attachment deleted',
    'expenses.form.attachments.deleteFailed': 'Unable to delete attachment',
    'expenses.form.attachments.tooLarge': 'File is larger than 20 MB',
    'expenses.search.notesPlaceholder': 'Search notes',
    'expenses.notCalculated': 'Not calculated',
    'expenses.notCalculatedHint': 'This cost is disabled for your account, so it is recorded but left out of totals and reports.',
    'expenses.reportingOnly': 'Reporting only',
    'expenses.reportingOnlyHint': 'Formula cost of an order, kept for profit reports only. It is not added to expense totals or the ledger.',
    'expenses.settings.formulaCostsInExpenses': 'Count order formula costs as expenses',
    'expenses.settings.formulaCostsInExpensesOffHint': 'Off: order formula costs are used in reports only, so your real expenses are not counted twice.',
    'expenses.settings.formulaCostsInExpensesOnHint': 'On: order formula costs are added to expense totals, the dashboard and the ledger.',
    'expenses.filter.type.placeholder': 'Filter by type',
    'expenses.filter.paidTo.placeholder': 'Filter by paid for',
    'expenses.filter.systemTypes.label': 'Include default items',
    'expenses.filter.systemTypes.hint': 'Uncheck an item to hide its expenses from the table and the total.',
    'expenses.summary.totalAmount': 'Total amount',
    'expenses.view.paidFor': 'Paid for',
    'expenses.alert.noAccess': 'You do not have access to view expenses.',

    // Expense Types
    'expenseTypes.table.name': 'Item Name',
    'expenseTypes.table.description': 'Description',
    'expenseTypes.table.actions': 'Actions',
    'expenseTypes.button.add': 'Add Expense Item',
    'expenseTypes.editTitle': 'Edit Expense Item',
    'expenseTypes.modal.title': 'Expense Items',
    'expenseTypes.confirm.deleteTitle': 'Delete Expense Item',
    'expenseTypes.confirm.deleteMessage': 'Are you sure you want to delete this expense item?',
    'expenseTypes.form.name.label': 'Item Name',
    'expenseTypes.form.name.placeholder': 'Enter item name',
    'expenseTypes.form.name.required': 'Please enter the item name',
    'expenseTypes.form.description.label': 'Item Description',
    'expenseTypes.form.description.placeholder': 'Enter item description',
    'expenseTypes.search.namePlaceholder': 'Search by name',
    'expenseTypes.search.descriptionPlaceholder': 'Search by description',
    'expenseTypes.alert.noAccess': 'You do not have access to view expense types.',
    'expenseTypes.system.tag': 'Default',
    'expenseTypes.system.locked': 'This is a default expense item and cannot be edited or deleted.',
    'expenseTypes.system.materials.name': 'Dental Materials',
    'expenseTypes.system.materials.description': 'Purchase of dental laboratory materials',
    'expenseTypes.system.technicians.name': 'Dental Technicians',
    'expenseTypes.system.technicians.description': 'Technician payments and wages',
    'expenseTypes.system.additional_operation_cost.name': 'Additional Operation Cost',
    'expenseTypes.system.additional_operation_cost.description': 'Extra operational costs such as lab-to-lab work',

    // Orders
    'orders.header.title': 'Orders',
    'orders.header.subtitle': 'Track laboratory orders, production workflow and delivery schedules',
    'orders.stats.totalOrders': 'Total Orders',
    'orders.stats.notYetDue': 'Not Yet Due',
    'orders.stats.totalDue': 'Total Revenue',
    'orders.stats.outstanding': 'Total Outstanding',
    'orders.stats.paymentOverdue': 'Overdue',
    'orders.stats.totalPaid': 'Total Collections',
    'orders.stats.totalPaidHint': 'By payment date (paid_at), same as Collection',
    'invoice.markPaid.paidAt': 'Payment date',
    'orders.search.placeholder': 'Search patient, order # or reference',
    'orders.filter.title': 'Filter Orders',
    'orders.filter.clear': 'Reset Filters',
    'orders.filter.active': 'Active',
    'orders.filter.dentist': 'Dentist',
    'orders.filter.technicians': 'Technicians',
    'orders.filter.courier': 'Courier',
    'orders.filter.allStatuses': 'All',
    'orders.filter.formulaType': 'Formula type',
    'orders.filter.requestedAtFrom': 'Requested date from',
    'orders.filter.requestedAtTo': 'Requested date to',
    'orders.filter.deliveredAtFrom': 'Delivered date from',
    'orders.filter.deliveredAtTo': 'Delivered date to',
    'orders.filter.paidAtFrom': 'Paid date from',
    'orders.filter.paidAtTo': 'Paid date to',
    'orders.table.refresh': 'Refresh',
    'orders.table.notInvoiced': 'Not Invoiced',
    'orders.table.invoiced': 'Invoiced',
    'orders.table.positions': 'Positions',
    'orders.table.formulaTypes': 'Formula Types',
    'orders.table.patientName': 'Patient Name',
    'orders.table.dentistName': 'Dentist',
    'orders.table.color': 'Color',
    'orders.table.formulaType': 'Formula Type',
    'orders.table.client': 'Client',
    'orders.table.invoice': 'Invoice',
    'orders.table.total': 'Total Amount',
    'orders.table.id': 'Order ID',
    'orders.table.paid': 'Paid Amount',
    'orders.table.remaining': 'Remaining Amount',
    'orders.table.paymentStatus': 'Payment Status',
    'orders.table.status': 'Order Status',
    'orders.summary.title': 'Order Summary',
    'orders.summary.itemsLabel': 'Items',
    'orders.summary.deliveryCenter': 'Delivery Center',
    'orders.summary.noDeliveryCenter': 'No delivery center',
    'orders.summary.color': 'Color',
    'orders.summary.noColor': '—',
    'orders.summary.subtotal': 'Subtotal',
    'orders.summary.discount': 'Discount',
   
    'orders.summary.discountClientFormulaType': 'Client formula type discount',
    'orders.summary.discountUnitOverride': 'Per-unit override discount',
    'orders.summary.discountOrderAmount': 'Order discount',
    'orders.summary.totalDiscount': 'Total discount',
    'orders.summary.markup': 'Markup',
    'orders.summary.markupClientFormulaType': 'Client formula type markup',
    'orders.summary.markupUnitOverride': 'Per-unit override markup',
    'orders.summary.totalMarkup': 'Total markup',
    'orders.actions.workCard': 'Work Card',
    'orders.actions.workCardCreated': 'Work card created',
    'orders.actions.createWorkCard': 'Work Card',
    'orders.actions.downloadWorkCard': 'Download Work Card',
    'orders.calendar.title': 'Calendar',
    'orders.calendar.subtitle': 'Track order and invoice dates across week, month, and year views',
    'orders.calendar.viewList': 'View Orders List',
    'orders.calendar.more': 'more',
    'orders.calendar.week': 'Week',
    'orders.calendar.month': 'Month',
    'orders.calendar.year': 'Year',
    'orders.calendar.ordersCount': 'orders',
    'orders.calendar.itemsCount': 'items',
    'orders.calendar.today': 'Today',
    'orders.calendar.noOrders': 'No orders',
    'orders.calendar.noItems': 'No items',
    'orders.calendar.patient': 'Patient',
    'orders.calendar.client': 'Client',
    'orders.calendar.ref': 'Serial',
    'orders.calendar.entity.order': 'Order',
    'orders.calendar.entity.invoice': 'Invoice',
    'orders.calendar.filter.title': 'Show on calendar',
    'orders.calendar.filter.byClientDentist': 'Clients & dentists',
    'orders.calendar.filter.client.placeholder': 'Select client',
    'orders.calendar.filter.dentist.placeholder': 'Select dentist',
    'orders.calendar.filter.orders': 'Orders',
    'orders.calendar.filter.invoices': 'Invoices',
    'orders.calendar.filter.orderDeliveryDate': 'Delivery date',
    'orders.calendar.filter.orderRequestedAt': 'Requested at',
    'orders.calendar.filter.invoiceIssueDate': 'Issue date',
    'orders.calendar.filter.invoiceDueDate': 'Due date',
    'orders.calendar.weekend': 'Weekend',
    'orders.calendar.vacation': 'Vacation',
    'orders.calendar.legend.closed': 'Closed days',

    // Vacations / weekend settings
    'vacations.weekend.title': 'Weekend days',
    'vacations.weekend.hint': 'Select which weekdays are weekends. They will be highlighted on the orders calendar.',
    'vacations.weekend.save': 'Save weekend days',
    'vacations.list.title': 'Vacations',
    'vacations.list.hint': 'Add date ranges when the lab is closed. These days will appear on the calendar.',
    'vacations.add': 'Add vacation',
    'vacations.edit': 'Edit vacation',
    'vacations.table.name': 'Name',
    'vacations.table.startsOn': 'Starts on',
    'vacations.table.endsOn': 'Ends on',
    'vacations.table.notes': 'Notes',
    'vacations.table.actions': 'Actions',
    'vacations.form.name': 'Name',
    'vacations.form.nameRequired': 'Name is required',
    'vacations.form.namePlaceholder': 'e.g. Eid holiday',
    'vacations.form.range': 'Date range',
    'vacations.form.rangeRequired': 'Date range is required',
    'vacations.form.notes': 'Notes',
    'vacations.confirm.deleteTitle': 'Delete vacation?',
    'vacations.confirm.deleteMessage': 'This cannot be undone.',
    'vacations.weekday.sunday': 'Sunday',
    'vacations.weekday.monday': 'Monday',
    'vacations.weekday.tuesday': 'Tuesday',
    'vacations.weekday.wednesday': 'Wednesday',
    'vacations.weekday.thursday': 'Thursday',
    'vacations.weekday.friday': 'Friday',
    'vacations.weekday.saturday': 'Saturday',

    // UI labels for work card modal
    'ui.order.work_card': 'Work Card',
    'ui.order.order_id': 'Order ID',
    'ui.order.client': 'Client',
    'ui.order.dentist': 'Dentist',
    'ui.order.patient': 'Patient',
   
    'ui.order.formulaType': 'Formula type',
    'ui.order.color': 'Color',
    'ui.order.units': 'Units',
    'ui.order.units_positions': 'Units (positions)',
    'ui.order.units_count': 'Units count',
    'ui.order.items': 'Items',
    'ui.order.unit': 'Unit',
    'ui.order.no_qr_available': 'No QR available',
    'ui.order.order_barcode': 'Order Barcode',
    'ui.order.view_public_note': 'This is a public view of the order. No authentication required.',
    'ui.order.unit_types': 'Chosen Units (by position)',
    'ui.order.unit_positions': 'Unit positions',
    'ui.order.color_hex': 'Hex',
    // Arabic translation
    'ui.order.unit_positions_ar': 'Unit positions',
    'ui.order.unit_level': 'Level',
    'ui.order.unit_direction': 'Direction',
    'ui.order.unit_order': 'Order',
    'ui.order.unit_name': 'Type',
    'ui.order.tooth_picker': 'Tooth Picker',
    'ui.order.tooth_previewer': 'Tooth Previewer',
    'ui.order.tooth_picker_hint': 'Selected units are highlighted below',
    'ui.order.note': 'Note',
    'ui.order.view_title': 'Order View',
    'ui.order.switch_to_en': 'Switch to English',
    'ui.order.switch_to_ar': 'Switch to Arabic',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',
    'ui.order.tracking_barcode': 'Lab Tracking & Barcode',
    'ui.order.scan_instructions': 'Scan barcode with a scanner or QR code with a camera to view or track this order.',
    'ui.order.dental_chart': 'Dental Chart (Odontogram)',
    'ui.order.clinical_specifications': 'Clinical Specifications & Restorations',
    'ui.order.clinical_notes': 'Clinical Notes & Special Instructions',
    'ui.order.no_notes': 'No special clinical instructions or notes recorded for this order.',
    'ui.order.attachments_title': 'Clinical Attachments & 3D Scans',
    'ui.order.no_attachments': 'No clinical files or scans attached to this order.',
    'ui.order.logistics_title': 'Delivery & Logistics',
    'ui.order.linked_invoice': 'Linked Invoice',
    'ui.order.view_invoice_action': 'View Public Invoice',
    'ui.order.selected_teeth_legend': 'Restored Teeth',
    'ui.order.natural_teeth_legend': 'Natural / Untreated',
    'ui.order.qc_signoff': 'Quality Control & Lab Sign-Off',
    'ui.order.qc_passed': 'QC Inspection Passed',
    'ui.order.technician_signature': 'Technician Signature',
    'ui.order.qc_date': 'Date',
    'ui.order.teeth_selected_count': '{{count}} teeth specified',
    'ui.order.expected_delivery': 'Expected Delivery',
    'ui.order.shade_color': 'Shade / Color',
    'ui.order.product_type': 'Product',
    'ui.order.quadrant_1': 'Q1 (Upper Right)',
    'ui.order.quadrant_2': 'Q2 (Upper Left)',
    'ui.order.quadrant_3': 'Q3 (Lower Left)',
    'ui.order.quadrant_4': 'Q4 (Lower Right)',
    'ui.order.scan_modal_title': 'Order Barcode & QR Code',
    'ui.order.fullscreen_scan': 'Scan / Enlarge',
    'ui.order.download_attachment': 'Download',
    'ui.order.preview_attachment': 'Preview',
    'ui.order.clinic': 'Clinic',
    'ui.order.order_date': 'Order Date',
    'ui.order.public_order_disclaimer': 'This official dental lab order specification is provided for clinical and laboratory verification. No login required.',
    'ui.order.loading_details': 'Loading order details...',

    // Generic language toggler
    'ui.switch_to_en': 'Switch to English',
    'ui.switch_to_ar': 'Switch to Arabic',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.copy_link': 'Copy link',
    'ui.copy_link_copied': 'Link copied',
    'ui.theme.lightMode': 'Light Mode',
    'ui.theme.darkMode': 'Dark Mode',
    'ui.menu.open': 'Open menu',
    'ui.menu.navigation': 'Navigation',
    'ui.menu.collapse': 'Hide sidebar',
    'ui.menu.expand': 'Show sidebar',
    'ui.prices.show': 'Show prices',
    'ui.prices.hide': 'Hide prices',
    'ui.date.startDate': 'Start Date',
    'ui.date.endDate': 'End Date',

    'cookies.title': 'We use cookies',
    'cookies.message':
      'We use cookies to keep you signed in, remember your language, and improve Dentrist. By continuing, you accept our use of cookies.',
    'cookies.accept': 'Accept cookies',

    'onboarding.menu.start': 'System tour',
    'onboarding.welcome.title': 'Welcome to Dentrist',
    'onboarding.welcome.description':
      'This system tour walks you through the workspace chrome and every page in your sidebar. You can replay it anytime from your profile menu.',
    'onboarding.navigation.title': 'Main navigation',
    'onboarding.navigation.description':
      'Use the sidebar to open every page available in your system. Next, we will visit each one.',
    'onboarding.controls.title': 'Language & theme',
    'onboarding.controls.description':
      'Switch between Arabic and English, and choose light or dark mode for your workspace.',
    'onboarding.account.title': 'Account & alerts',
    'onboarding.account.description':
      'Check notifications, show or hide prices, open your profile, or restart this tour from the user menu.',
    'onboarding.workspace.title': 'Your workspace',
    'onboarding.workspace.description':
      'This is where dashboards, lists, and forms appear. Start from Home to see your lab activity at a glance.',
    'onboarding.pages.title': 'System pages',
    'onboarding.pages.description':
      'We will now open each page included in your system so you can see where everything lives.',
    'onboarding.page.description':
      'This is the {{page}} page. Open it anytime from the sidebar to continue your work here.',
    'onboarding.finish.title': 'You are ready',
    'onboarding.finish.description':
      'That covers every page in your system. Restart this tour anytime from your profile menu.',

    'userTypes.dentist': 'Dentist',
    'userTypes.lab_contact': 'Lab contact',
    'userTypes.technician': 'Technician',
    'userTypes.courier': 'Courier',
    'userTypes.admin': 'Admin',
    'userTypes.support': 'Support',
    'userTypes.accountant': 'Accountant',
    'userTypes.designer': 'Designer',
    'userTypes.scanner': 'Scanner',
    'userTypes.custom': 'Custom role',
    'orders.comments.role.designer': 'Designer',
    'orders.comments.role.scanner': 'Scanner',
    'orders.comments.role.accountant': 'Accountant',
    'customRoles.button.manage': 'Roles',
    'customRoles.button.add': 'Add role',
    'customRoles.header.title': 'Roles',
    'customRoles.header.subtitle': 'Default roles come with the system and cannot be changed. Create custom roles with exactly the permissions they need, then assign them to users.',
    'customRoles.tag.default': 'Default',
    'customRoles.readOnly': 'Not editable',
    'customRoles.alert.disabled': 'Custom roles are not enabled for your lab. Contact support to enable them. Existing roles stay assigned to their users.',
    'customRoles.empty': 'No custom roles yet',
    'customRoles.table.name': 'Role',
    'customRoles.table.permissions': 'Permissions',
    'customRoles.table.users': 'Users',
    'customRoles.modal.createTitle': 'Add custom role',
    'customRoles.modal.editTitle': 'Edit custom role',
    'customRoles.form.name.label': 'Role name',
    'customRoles.form.name.placeholder': 'e.g. Senior technician',
    'customRoles.form.name.required': 'Enter the role name',
    'customRoles.form.name.length': 'Role name must be 2 to 60 characters',
    'customRoles.form.nameAr.label': 'Arabic name',
    'customRoles.form.nameAr.placeholder': 'e.g. فني أول',
    'customRoles.form.nameAr.hint': 'Shown when the app is in Arabic. Leave empty to use the role name.',
    'customRoles.form.permissions.label': 'Permissions',
    'customRoles.form.permissions.search': 'Search permissions',
    'customRoles.form.permissions.selectAll': 'Select all',
    'customRoles.form.permissions.selectedCount': '{count} selected',
    'customRoles.form.permissions.required': 'Select at least one permission',
    'customRoles.form.permissions.propagateHint': 'Users with this role get added permissions and lose removed ones, and will need to sign in again.',
    'customRoles.delete.title': 'Delete this role?',
    'customRoles.delete.description': 'This cannot be undone.',
    'customRoles.delete.blocked': 'Move its users to another role before deleting it.',
    'customRoles.toast.created': 'Role created',
    'customRoles.toast.updated': 'Role updated',
    'customRoles.toast.deleted': 'Role deleted',
    'customRoles.error.load': 'Failed to load roles',
    'customRoles.error.save': 'Failed to save the role',
    'customRoles.error.delete': 'Failed to delete the role',

    'deliveryTypes.standard_delivery': 'Standard Delivery',
    'deliveryTypes.free_delivery': 'Free Delivery',
    'ui.order.units_list': 'Units',
    'ui.order.qr': 'QR',

    'orders.summary.vat': 'VAT ({{percent}}%)',

    // General UI
    'common.print': 'Print',
    'common.openNew': 'Open in New Page',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.save': 'Save',
    'common.updated': 'Updated',
    'orders.summary.delivery': 'Delivery Cost',
    'orders.summary.total': 'Total',
    'orders.summary.noFormulaType': 'No formula type selected',
    'orders.summary.formulaType': 'Formula type',
    'orders.summary.unitUnknown': 'Unit',
    'orders.summary.noUnits': 'No units selected',
    'orders.summary.unitLabel': 'Unit',
    'orders.summary.price': 'Price',
    'orders.summary.formulaLineTitle': 'Formula {{n}}',
    'orders.summary.pricePerUnit': 'Price per unit',
    'orders.summary.unitsCount': 'Units count',
    'orders.summary.formulaLineTotal': 'Formula price',
    'orders.summary.vatLabel': 'VAT',
    'orders.summary.deliveryLabel': 'Delivery Cost',
    'orders.summary.deliveryLabelWithType': 'Delivery Cost ({type})',
    'orders.summary.free': 'Free',
    'orders.table.delivery': 'Delivery',
    'orders.table.createdAt': 'Created On',
    'orders.table.requestedAt': 'Requested At',
    'orders.table.deliveredAt': 'Delivered At',
    'orders.table.paidAt': 'Paid At',
    'orders.table.units': 'Units Count',
    'orders.table.actions': 'Actions',
    'orders.table.technician': 'Technician',
    'orders.table.courier': 'Courier',
    'orders.status.delivered': 'Delivered',
    'orders.status.pendingDelivery': 'Not delivered',
    'orders.status.paid': 'Paid',
    'orders.status.unpaid': 'Unpaid',
    'orders.status.unknown': 'Unknown',
    'orders.form.patientName.label': 'Patient Name',
    'orders.form.patientName.placeholder': 'Enter patient name',
    'orders.form.patientName.required': 'Please enter the patient name',
    'orders.form.dentist.label': 'Dentist',
    'orders.form.dentist.placeholder': 'Select or add a dentist',
    'orders.form.dentist.required': 'Please select a dentist',
    'orders.form.dentist.clientRequired': 'Select a client first to choose a dentist.',
    'orders.form.dentist.labelLabContact': 'Lab contact',
    'orders.form.dentist.placeholderLabContact': 'Select or add a lab contact',
    'orders.form.dentist.requiredLabContact': 'Please select a lab contact',
    'orders.form.dentist.clientRequiredLabContact': 'Select a client first to choose a lab contact.',
    'orders.form.client.label': 'Client',
    'orders.form.client.placeholder': 'Select or add a client',
    'orders.form.client.required': 'Please select a client',
    'orders.form.clientStep.selectTab': 'Select Client',
    'orders.form.clientStep.newTab': 'New Client',
    'orders.form.clientStep.selectPlaceholder': '-- Select Client --',
    'orders.form.clientStep.hint': 'Select an existing client or add a new one to start filling the order.',
    'orders.form.clientStep.autoCreateHint': 'The client will be added automatically when you create the order.',
    'orders.form.color.label': 'Color',
    'orders.form.color.defaultLabel': 'Default color (for new units)',
    'orders.form.color.defaultHelp': 'Applied when you add a new unit',
    'orders.form.color.placeholder': 'Select or add a color',
    'orders.form.color.required': 'Please select a color',
    'orders.form.color.selectButton': 'Select color',
    'orders.form.color.modalTitle': 'Select color',
    'orders.form.color.searchPlaceholder': 'Search by name, code or VITA shade',
    'orders.form.color.clear': 'Remove color',
    'orders.form.unitColors.label': 'Color per unit',
    'orders.form.unitFormulaTypes.label': 'Formula type per unit',
    'orders.form.formulaType.defaultLabel': 'Default Formula Type (for new units)',
    'orders.form.formulaType.defaultHelp': 'Applied when you add a new unit',
    'orders.form.unitPriceOverride.placeholder': 'Price override',
    'orders.form.discountAmount.label': 'Order discount (amount)',
    'orders.form.discountAmount.help': 'Deduct this amount from the order subtotal.',
    'orders.form.discountAmount.placeholder': '0',
    'orders.form.formulaType.label': 'Formula Type',
    'orders.form.formulaType.placeholder': 'Select Formula Type',
    'orders.form.formulaType.required': 'Please select a Formula Type',
    'orders.form.requestedAt.label': 'Requested At',
    'orders.form.requestedAt.placeholder': 'Select date',
    'orders.form.issueDate.label': 'Issue Date',
    'orders.form.issueDate.placeholder': 'Select date',
    'orders.form.deliveryDate.label': 'Delivery Date',
    'orders.form.deliveryDate.placeholder': 'Select date',
    'orders.form.additionalCostItems.title': 'Additional cost items',
    'orders.form.additionalCostItems.labelPlaceholder': 'Item description',
    'orders.form.additionalCostItems.amountPlaceholder': 'Cost',
    'orders.form.additionalCostItems.add': 'Add cost item',
    'orders.form.additionalCostItems.remove': 'Remove',
    'orders.form.additionalCostItems.labelRequired': 'Item Description is required.',
    'orders.form.additionalCostItems.amountRequired': 'Cost is required.',
    'orders.form.additionalCostItems.rowLabelRequired': 'Additional cost item {{n}}: Item Description is required.',
    'orders.form.additionalCostItems.rowAmountRequired': 'Additional cost item {{n}}: Cost is required.',
    'orders.summary.additionalCostsTitle': 'Additional costs',
    'orders.summary.additionalCostItemFallback': 'Extra item',
    'orders.summary.additionalCosts': 'Additional costs total',
    'orders.form.notes.label': 'Notes',
    'orders.form.notes.placeholder': 'Notes',
    'orders.form.technician.label': 'Technicians',
    'orders.form.technician.placeholder': 'Select technicians',
    'orders.form.technician.required': 'Please select at least one technician',
    'orders.form.selectUnits.label': 'Select Units',
    'orders.form.selectUnits.required': 'Please select at least one unit',
    'orders.form.orderFormulas.title': 'Order formulas',
    'orders.form.orderFormulas.help': 'An order can include several formulas. On each line, first choose the formula type, then choose the units (teeth for unit scope, or upper and/or lower arch for arch scope). Only unit types that match the formula type are shown.',
    'orders.form.orderFormulas.lineTitle': 'Formula {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'Formula #',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.colorLabel': 'Color (this formula)',
    'orders.form.orderFormulas.stepUnits': 'Step 2: Units',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'Select formula type first',
    'orders.form.orderFormulas.addLine': 'Add another formula',
    'orders.form.orderFormulas.removeLine': 'Remove this formula',
    'orders.form.orderFormulas.formulaType': 'Formula type',
    'orders.form.orderFormulas.selectUnits': 'Teeth / units',
    'orders.form.orderFormulas.archChoice': 'Arch',
    'orders.form.orderFormulas.archUpper': 'Upper arch',
    'orders.form.orderFormulas.archLower': 'Lower arch',
    'orders.form.orderFormulas.zeroPriceHint': 'This formula type has no selling price (0). Add a price for it so the order is priced correctly.',
    'orders.form.orderFormulas.zeroPriceHintAction': 'Set price',
    'orders.form.orderFormulas.required': 'Add at least one formula line with a type and selected units.',
    'orders.form.orderFormulas.incompleteLine': 'Each formula line with a selected type must include at least one unit (tooth or arch).',
    'orders.form.orderFormulas.duplicateFormulaType': 'You can only add one line per formula type on an order.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'Each selected unit must have a formula type before saving.',
    'orders.form.orderFormulas.summaryUnits': 'Units in this order',
    'orders.form.persistedFormulas.title': 'Formulas on this order',
    'orders.form.persistedFormulas.help': 'Each row is a saved formula (type, unit, and color). Adjust per-unit formula types and pricing in the summary when editing.',
    'orders.form.persistedFormulas.unit': 'Unit (FDI)',
    'orders.form.persistedFormulas.color': 'Color',
    'orders.form.persistedFormulas.detach': 'Remove from order',
    'orders.form.persistedFormulas.detachConfirm': 'Remove this formula line from the order? Linked teeth will lose this formula until you add a new line or set types in the summary.',
    'orders.form.persistedFormulas.detachSuccess': 'Formula line removed from the order.',
    'orders.form.persistedFormulas.detachError': 'Could not remove the formula line. Try again.',
    'orders.form.toothPreview.title': 'Teeth preview',
    'orders.form.toothPreview.help': 'Same chart as when creating an order. When editing, tap teeth to change the selection, then save.',
    'toothPicker.selectUpper': 'Select upper arch',
    'toothPicker.selectLower': 'Select lower arch',
    'toothPicker.clear': 'Clear',
    'orders.form.deliveryCenter.label': 'Delivery Center',
    'orders.form.costCenter.label': 'Cost center',
    'orders.form.deliveryCenter.placeholder': 'Select or add a delivery center',
    'orders.form.deliveryCenter.required': 'Please select a delivery center',
    'orders.form.deliveryCenter.clientRequired': 'Select a client first to choose a delivery center.',
    'orders.form.deliveryType.label': 'Delivery Type',
    'orders.form.deliveryType.placeholder': 'Select delivery type',
    'orders.form.attachment.label': 'Attachments',
    'orders.form.attachments.label': 'Attachments',
    'orders.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'orders.form.attachments.choose': 'Choose files',
    'orders.form.attachments.existing': 'Existing attachments:',
    'orders.form.attachments.deleteConfirm': 'Remove attachment?',
    'orders.form.attachments.empty': 'No attachments',
    'orders.form.attachments.download': 'Download',
    'orders.form.attachments.commentPlaceholder': 'Comment',
    'orders.form.attachments.col.id': 'ID',
    'orders.form.attachments.col.name': 'Name',
    'orders.form.attachments.col.url': 'URL',
    'orders.form.attachments.col.file': 'File',
    'orders.form.attachments.col.comment': 'Comment',
    'orders.form.attachments.col.preview': 'Preview',
    'orders.attachments.viewer3d.view': 'View 3D',
    'orders.attachments.viewer3d.loading': 'Loading 3D model…',
    'orders.attachments.viewer3d.loadFailed': 'Failed to load the 3D file.',
    'orders.attachments.viewer3d.parseFailed': 'This file could not be read as a 3D model.',
    'orders.attachments.viewer3d.noModelsInZip': 'No STL, PLY or OBJ files were found in this archive.',
    'orders.attachments.viewer3d.wireframe': 'Wireframe',
    'orders.attachments.viewer3d.resetView': 'Reset view',
    'orders.attachments.viewer3d.parts': 'Models',
    'orders.attachments.viewer3d.controlsHint': 'Left-drag: rotate · Right-drag: pan · Scroll: zoom',
    'orders.form.attachments.col.download': 'Download',
    'orders.form.attachments.col.delete': 'Delete',
    'orders.form.attachments.col.edit': 'Edit',
    'orders.form.attachments.edit': 'Edit',
    'orders.form.attachments.editTitle': 'Edit attachment',
    'orders.form.attachments.viewTitle': 'Attachment details',
    'orders.form.attachments.namePlaceholder': 'Attachment name',
    'orders.form.attachments.replaceFile': 'Replace file',
    'orders.form.attachments.replaceFileHint': 'Leave empty to keep the current file.',
    'orders.form.attachments.chooseReplacement': 'Choose replacement file',
    'orders.files.title': 'File Management',
    'orders.files.expand': 'Expand',
    'orders.files.collapse': 'Collapse',
    'orders.files.dropzone': 'Click or drop files here to upload',
    'orders.files.hint': '* You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'orders.files.queueTitle': 'Upload queue',
    'orders.files.queueLength': 'Queue length: {{count}}',
    'orders.files.searchPlaceholder': 'Search filename or comment',
    'orders.files.col.name': 'File name',
    'orders.files.col.uploadDate': 'Upload date',
    'orders.files.col.size': 'Size',
    'orders.files.col.progress': 'Progress',
    'orders.files.col.actions': 'Actions',
    'orders.files.downloadAll': 'Download all',
    'orders.files.total': '{{count}} Total',
    'orders.files.empty': 'No files uploaded yet',
    'orders.files.noComment': 'No comment',
    'orders.files.status.queued': 'Waiting',
    'orders.files.status.failed': 'Failed',
    'orders.files.retry': 'Retry',
    'orders.files.cancel': 'Cancel upload',
    'orders.files.remove': 'Remove from queue',
    'orders.files.preview': 'Preview',
    'orders.files.download': 'Download',
    'orders.files.edit': 'Edit',
    'orders.files.delete': 'Delete',
    'orders.files.deleteConfirm': 'Delete this file?',
    'orders.files.invalidType': '{{name}}: this file type is not allowed',
    'orders.files.tooLarge': '{{name}}: file is larger than 20 MB',
    'orders.files.downloadFailed': 'Could not download the file(s)',
    'orders.form.submit.create': 'Submit Order',
    'orders.form.submit.save': 'Save Changes',
    'orders.create.header.title': 'New Order',
    'orders.create.header.subtitle': 'Pick the client and dentist, add the order formulas, then confirm the delivery schedule.',
    'orders.create.header.backToOrders': 'Back to orders',
    'orders.create.header.nextCode': 'Order code',
    'orders.create.header.nextCodeHint': 'Final code is assigned when the order is saved.',
    'orders.create.success.title': 'Order created successfully',
    'orders.create.success.description': 'The order has been saved. You can open it now or start a new order below.',
    'orders.create.success.patient': 'Patient',
    'orders.create.success.viewOrder': 'View order',
    'orders.create.success.dismiss': 'Dismiss',
    'orders.table.code': 'Order Code',
    'orders.form.section.parties': 'Client & Dentist',
    'orders.form.section.schedule': 'Patient & Schedule',
    'orders.form.section.notesAttachments': 'Notes & Attachments',
    'orders.create.section.primaryTitle': 'Order Details',
    'orders.create.section.secondaryTitle': 'Financial Details',
    'orders.create.section.secondaryPlaceholder': 'This section will be available soon.',
    'orders.update.section.primaryTitle': 'Order Details',
    'orders.update.section.secondaryTitle': 'Order Actions',
    'orders.update.section.secondaryPlaceholder': 'Additional order information will appear here soon.',
    'orders.changeHistory': 'Change history',
    'orders.comments.title': 'Conversation',
    'orders.comments.internal.tab': 'Internal (team)',
    'orders.comments.internal.hint': 'Visible to your lab team only. Clients cannot see these messages.',
    'orders.comments.external.tab': 'Client conversation',
    'orders.comments.external.hint': 'Visible to the client’s dentists / lab contacts, lab admins, assigned technicians and anyone mentioned.',
    'orders.comments.external.hintClient': 'Your conversation with the lab about this order.',
    'orders.comments.empty': 'No messages yet. Start the conversation.',
    'orders.comments.placeholder': 'Write a message… Type @ to mention someone (Ctrl+Enter to send)',
    'orders.comments.mentions.empty': 'No matching users',
    'orders.comments.send': 'Send',
    'orders.comments.edited': 'edited',
    'orders.comments.edit': 'Edit',
    'orders.comments.delete': 'Delete',
    'orders.comments.save': 'Save',
    'orders.comments.deleteConfirm': 'Delete this message?',
    'orders.comments.sendError': 'Failed to send message',
    'orders.comments.updateError': 'Failed to update message',
    'orders.comments.deleteError': 'Failed to delete message',
    'orders.comments.loadError': 'Failed to load messages',
    'orders.comments.you': 'You',
    'orders.comments.files.attach': 'Attach files (they are also added to the order files)',
    'orders.comments.files.dropHere': 'Drop files to attach them to your message',
    'orders.comments.files.tooMany': 'You can attach up to {{count}} files per message',
    'orders.comments.files.openInNewTab': 'Open in new tab',
    'orders.comments.files.remove': 'Remove',
    'orders.comments.files.sending': 'Sending…',
    'orders.comments.files.processing': 'Finishing…',
    'orders.comments.files.cancelUpload': 'Cancel upload',
    'orders.comments.files.discard': 'Discard message',
    'orders.comments.files.uploadCanceled': 'Upload canceled. Your message was not sent.',
    'orders.files.fromChat': 'From chat',
    'orders.files.fromChatHint': 'Uploading from a chat message',
    'orders.comments.role.client': 'Client',
    'orders.comments.role.admin': 'Admin',
    'orders.comments.role.technician': 'Technician',
    'orders.comments.role.courier': 'Courier',
    'orders.phases.title': 'Phases',
    'orders.phases.add': 'Add phase',
    'orders.phases.addTitle': 'Add phase',
    'orders.phases.editTitle': 'Edit phase',
    'orders.phases.edit': 'Edit',
    'orders.phases.delete': 'Delete',
    'orders.phases.save': 'Save',
    'orders.phases.empty': 'No phases for this order yet.',
    'orders.phases.noDates': 'No dates set',
    'orders.phases.deleteConfirm': 'Delete phase "{{title}}"?',
    'orders.phases.created': 'Phase added',
    'orders.phases.updated': 'Phase updated',
    'orders.phases.deleted': 'Phase deleted',
    'orders.phases.createError': 'Failed to add phase',
    'orders.phases.updateError': 'Failed to update phase',
    'orders.phases.deleteError': 'Failed to delete phase',
    'orders.phases.loadError': 'Failed to load phases',
    'orders.phases.fields.template': 'Start from a standard phase',
    'orders.phases.fields.templateHint': 'Optional: fills in the title and details, which you can still edit.',
    'orders.phases.fields.templatePlaceholder': 'Select a standard phase',
    'orders.phases.fields.title': 'Title',
    'orders.phases.fields.titleAr': 'Title',
    'orders.phases.fields.titleRequired': 'Please enter a title',
    'orders.phases.fields.description': 'Details',
    'orders.phases.fields.descriptionAr': 'Details',
    'orders.phases.fields.technician': 'Technician',
    'orders.phases.fields.swap': 'Change phase',
    'orders.phases.fields.swapPlaceholder': 'Replace with a hidden phase',
    'orders.phases.fields.noHiddenPhases': 'No hidden phases',
    'orders.phases.swapped': 'Phase changed',
    'orders.phases.swapError': 'Could not change the phase',
    'orders.phases.visibilityError': 'Could not update the phases view',
    'orders.phases.fields.dates': 'Start and end date',
    'orders.phases.fields.startDate': 'Start date',
    'orders.phases.fields.endDate': 'End date',
    'orders.phases.setCurrent': 'Set as current',
    'orders.phases.moveUp': 'Move up',
    'orders.phases.moveDown': 'Move down',
    'orders.phases.currentSet': 'Current phase updated',
    'orders.phases.currentError': 'Failed to set the current phase',
    'orders.phases.reorderError': 'Failed to update the phase sequence',
    'orders.phases.showNext': 'Show next phase',
    'orders.phases.hidePhase': 'Hide this phase',
    'orders.phases.collapseAll': 'Hide phases after the current one',
    'orders.phases.manage': 'Manage',
    'orders.phases.doneManaging': 'Done',
    'orders.phases.assignTechnician': '-- Assign Technician --',
    'orders.phases.notReached': 'Phase not reached yet',
    'orders.phases.inProgress': 'In progress',
    'orders.phases.completed': 'Completed',
    'orders.phases.hideSection': 'Hide phases',
    'orders.phases.showSection': 'Show phases',
    'orders.phases.changeImage': 'Change image',
    'orders.phases.removeImage': 'Remove image',
    'orders.phases.removeImageConfirm': 'Remove this phase image and use the default one?',
    'orders.phases.imageUpdated': 'Phase image updated',
    'orders.phases.imageRemoved': 'Phase image removed',
    'orders.phases.imageError': 'Could not update the phase image',
    'orders.phases.imageInvalid': 'Please choose an image file',
    'orders.phases.imageTooLarge': 'The image must be 4 MB or smaller',
    'orders.versions.title': 'Order change history',
    'orders.versions.empty': 'No change history yet',
    'orders.versions.timelineTitle': 'Timeline',
    'orders.versions.by': 'Updated by',
    'orders.versions.fieldsChanged': 'Fields changed',
    'orders.versions.compareTitle': 'Compare with current',
    'orders.versions.selectVersion': 'Select a version',
    'orders.versions.noFields': 'No changed fields captured',
    'orders.versions.before': 'Before',
    'orders.versions.after': 'After (Current)',
    'orders.versions.unitLabel': 'Unit',
    'orders.versions.priceLabel': 'Price',
    'orders.actions.technician.label': 'Technicians',
    'orders.actions.technician.unassigned': 'Unassigned',
    'orders.actions.technician.change': 'Assign Technician',
    'orders.actions.viewInvoice': 'View Invoice',
    'orders.actions.technician.select': 'Select technicians',
    'orders.actions.technician.changeSuccess': 'Technicians updated',
    'orders.actions.technician.changeError': 'Failed to update technicians',
    'orders.actions.courier.label': 'Courier',
    'orders.actions.courier.unassigned': 'Unassigned',
    'orders.actions.courier.change': 'Assign Courier',
    'orders.actions.courier.select': 'Select courier',
    'orders.actions.courier.changeSuccess': 'Courier updated',
    'orders.actions.courier.changeError': 'Failed to update courier',
    'orders.actions.courier.unassign': 'Unassign',
    'orders.actions.disableClientEdit.label': 'Disable client edit',
    'orders.actions.disableClientEdit.enabled': 'Client cannot edit this order',
    'orders.actions.disableClientEdit.disabled': 'Client can edit this order',
    'orders.actions.disableClientEdit.lockedMessage': 'This order is locked. You cannot edit it. Contact the lab if you need changes.',
    'orders.actions.sharePhasesWithClient.label': 'Share phases with client',
    'orders.actions.sharePhasesWithClient.short': 'Share',
    'orders.actions.sharePhasesWithClient.enabled': 'Client can follow the order phases',
    'orders.actions.sharePhasesWithClient.disabled': 'Phases are visible to the lab only',
    'orders.actions.shareWorkflowWithClient.label': 'Share workflow with client',
    'orders.actions.shareWorkflowWithClient.enabled': 'Client can see Workflow & Operations',
    'orders.actions.shareWorkflowWithClient.disabled': 'Workflow & Operations is visible to the lab only',
    'orders.orderStatus.requested': 'Requested',
    'orders.orderStatus.review': 'Review',
    'orders.orderStatus.tx-review': 'Tx. Review',
    'orders.orderStatus.tx-approved': 'Tx. Approved',
    'orders.orderStatus.tx-replan': 'Tx. Replan',
    'orders.orderStatus.in-progress': 'In Progress',
    'orders.orderStatus.in-delivery': 'In Delivery',
    'orders.orderStatus.delivered': 'Delivered',
    'orders.orderStatus.finished': 'Finished',
    'orders.orderStatus.cancelled': 'Cancelled',
    'orders.orderStatus.dispute': 'Dispute',
    'orders.orderStatus.draft': 'Draft',
    'orders.orderStatus.pending_review': 'Pending Review',
    'orders.orderStatus.under_review': 'Under Review',
    'orders.orderStatus.more_info_required': 'More Info Required',
    'orders.orderStatus.resubmitted': 'Resubmitted',
    'orders.orderStatus.accepted': 'Accepted',
    'orders.orderStatus.rejected': 'Rejected',
    'orders.orderStatus.queued': 'Queued',
    'orders.orderStatus.ready_for_design': 'Ready for Design',
    'orders.orderStatus.design_in_progress': 'Design in Progress',
    'orders.orderStatus.pending_internal_design_review': 'Pending Internal Design Review',
    'orders.orderStatus.pending_design_approval': 'Pending Design Approval',
    'orders.orderStatus.design_revision_requested': 'Design Revision Requested',
    'orders.orderStatus.design_revision_in_progress': 'Design Revision in Progress',
    'orders.orderStatus.design_approved': 'Design Approved',
    'orders.orderStatus.design_rejected': 'Design Rejected',
    'orders.orderStatus.ready_for_try_in_production': 'Ready for Try-in Production',
    'orders.orderStatus.try_in_production_in_progress': 'Try-in Production in Progress',
    'orders.orderStatus.try_in_quality_check': 'Try-in Quality Check',
    'orders.orderStatus.ready_for_try_in': 'Ready for Try-in',
    'orders.orderStatus.out_for_try_in': 'Out for Try-in',
    'orders.orderStatus.pending_try_in_feedback': 'Pending Try-in Feedback',
    'orders.orderStatus.try_in_approved': 'Try-in Approved',
    'orders.orderStatus.try_in_revision_requested': 'Try-in Revision Requested',
    'orders.orderStatus.try_in_revision_in_progress': 'Try-in Revision in Progress',
    'orders.orderStatus.ready_for_repeat_try_in': 'Ready for Repeat Try-in',
    'orders.orderStatus.try_in_not_required': 'Try-in Not Required',
    'orders.orderStatus.in_progress': 'In Progress',
    'orders.orderStatus.manufacturing_try_in': 'Manufacturing Try-in',
    'orders.orderStatus.ready_for_final_production': 'Ready for Final Production',
    'orders.orderStatus.final_production': 'Final Production',
    'orders.orderStatus.ready_for_final_manufacturing': 'Ready for Final Manufacturing',
    'orders.orderStatus.final_manufacturing_in_progress': 'Final Manufacturing in Progress',
    'orders.orderStatus.manufacturing_paused': 'Manufacturing Paused',
    'orders.orderStatus.pending_external_work': 'Pending External Work',
    'orders.orderStatus.finishing_in_progress': 'Finishing in Progress',
    'orders.orderStatus.quality_control': 'Quality Control',
    'orders.orderStatus.quality_control_failed': 'Quality Control Failed',
    'orders.orderStatus.rework_in_progress': 'Rework in Progress',
    'orders.orderStatus.quality_control_passed': 'Quality Control Passed',
    'orders.orderStatus.ready_for_dispatch': 'Ready for Dispatch',
    'orders.orderStatus.awaiting_pickup': 'Awaiting Pickup',
    'orders.orderStatus.out_for_delivery': 'Out for Delivery',
    'orders.orderStatus.delivery_attempt_failed': 'Delivery Attempt Failed',
    'orders.orderStatus.delivery_disputed': 'Delivery Disputed',
    'orders.orderStatus.return_requested': 'Return Requested',
    'orders.orderStatus.returned_to_lab': 'Returned to Lab',
    'orders.orderStatus.pending_closure': 'Pending Closure',
    'orders.orderStatus.closed': 'Closed',
    'orders.orderStatus.on_hold': 'On Hold',
    'orders.orderStatus.awaiting_client_action': 'Awaiting Client Action',
    'orders.orderStatus.awaiting_payment': 'Awaiting Payment',
    'orders.orderStatus.cancel_requested': 'Cancel Requested',
    'orders.orderStatus.remake_requested': 'Remake Requested',
    'orders.orderStatus.remake_approved': 'Remake Approved',
    'orders.orderStatus.remake_in_progress': 'Remake in Progress',
    'orders.orderStatus.disputed': 'Disputed',
    'orders.invoice.notBillableYet': 'This order can be added to an invoice once it reaches the status set in the Order Status Workflow.',
    'orders.amount.notCountedYet': 'Not counted yet: this order has not reached the status set in the Order Status Workflow, so its amount is left out of the dashboard, client balances, account statements and the collection and revenue reports.',
    'orders.actions.status.noAllowedTransitions': 'No status changes are allowed from the current status',
    'orders.actions.status.label': 'Order Status',
    'orders.actions.status.change': 'Change Status',
    'orders.actions.status.changeSuccess': 'Status updated',
    'orders.actions.status.changeError': 'Failed to update status',
    'orders.actions.status.cannotCancelPaid': 'Cannot change status to cancelled when order is attached to a paid invoice.',
    'orders.actions.status.cannotSetClosedManually': 'Closed is set automatically when the invoice is paid. You cannot move an order to Closed manually.',
    'orders.actions.status.closedOnInvoice': 'Order status cannot be changed while the order is attached to an invoice. Detach it from the invoice first.',
    'orders.actions.status.advanceHint': 'Click to move to the next status',
    'orders.actions.status.nextSteps': 'Next step',
    'orders.actions.status.jumpTo': 'Jump to status',
    'orders.actions.status.moveTo': 'Move to {{status}}',
    'orders.actions.status.advanceConfirmTitle': 'Move order #{{id}}?',
    'orders.actions.status.advanceConfirmMessage': '{{from}} → {{to}}',
    'orders.actions.cancel.detachInvoiceFirst': 'This order is attached to an invoice. Detach it from the invoice first, then cancel it.',
    'orders.actions.cancel.alreadyCancelled': 'This order is already cancelled.',
    'orders.bulk.status.skippedHasInvoice': '{{count}} order(s) attached to an invoice were skipped. Detach them from the invoice before changing status.',
    'orders.bulk.actions': 'Bulk Actions ({{count}})',
    'orders.bulk.status.change': 'Change Status',
    'orders.bulk.status.title': 'Change Status ({{count}})',
    'orders.bulk.status.selectPlaceholder': 'Select status',
    'orders.bulk.status.selectRequired': 'Select a status',
    'orders.bulk.status.changeSuccess': 'Updated status for {{count}} order(s)',
    'orders.bulk.status.partialSuccess': 'Updated {{success}} order(s); {{failed}} failed',
    'orders.bulk.status.noneEligible': 'None of the selected orders can have their status changed.',
    'orders.bulk.status.skipped': '{{count}} order(s) were skipped',
    'orders.bulk.requestedAt.change': 'Change Requested Date',
    'orders.bulk.requestedAt.title': 'Change Requested Date ({{count}})',
    'orders.bulk.requestedAt.selectRequired': 'Select a requested date',
    'orders.bulk.requestedAt.changeSuccess': 'Updated requested date for {{count}} order(s)',
    'orders.bulk.requestedAt.partialSuccess': 'Updated requested date for {{success}} order(s); {{failed}} failed',
    'orders.bulk.requestedAt.noneEligible': 'None of the selected orders can have their requested date changed.',
    'orders.bulk.requestedAt.skipped': '{{count}} order(s) were skipped (closed).',
    'orders.bulk.deliveryDate.change': 'Change Delivery Date',
    'orders.bulk.deliveryDate.title': 'Change Delivery Date ({{count}})',
    'orders.bulk.deliveryDate.selectRequired': 'Select a delivery date',
    'orders.bulk.deliveryDate.changeSuccess': 'Updated delivery date for {{count}} order(s)',
    'orders.bulk.deliveryDate.partialSuccess': 'Updated delivery date for {{success}} order(s); {{failed}} failed',
    'orders.bulk.deliveryDate.noneEligible': 'None of the selected orders can have their delivery date changed.',
    'orders.bulk.deliveryDate.skipped': '{{count}} order(s) were skipped (closed).',
    'orders.bulk.attach.cta': 'Attach to Invoice',
    'orders.bulk.attach.title': 'Attach to Invoice ({{count}})',
    'orders.bulk.attach.success': 'Attached {{count}} order(s) to invoice',
    'orders.bulk.attach.sameClientRequired': 'Select orders from the same client to attach to one invoice.',
    'orders.bulk.attach.missingClient': 'Selected orders must belong to a client.',
    'orders.bulk.attach.noneEligible': 'None of the selected orders can be attached to an invoice.',
    'orders.bulk.attach.skipped': '{{count}} order(s) were skipped',
    'orders.bulk.attach.loadInvoicesError': 'Failed to load invoices',
    'orders.bulk.attach.noInvoices': 'This client has no unpaid invoices to attach these orders to. Create a new invoice instead.',
    'orders.bulk.createInvoice.cta': 'Create Invoice',
    'orders.bulk.createInvoice.confirmTitle': 'Create invoice for {{count}} order(s)?',
    'orders.bulk.createInvoice.summary': '{{count}} order(s) for {{client}} will be added to the new invoice · Total {{total}}',
    'orders.bulk.createInvoice.success': 'Invoice created with {{count}} order(s)',
    'orders.bulk.createInvoice.sameClientRequired': 'Select orders from the same client to create one invoice.',
    'orders.bulk.createInvoice.noneEligible': 'None of the selected orders can be added to a new invoice.',
    'orders.bulk.createInvoice.skipped': '{{count}} order(s) will be skipped (cancelled, on hold, in dispute or paid).',
    'orders.bulk.delete.cta': 'Delete Selected ({{count}})',
    'orders.bulk.delete.confirmTitle': 'Delete {{count}} selected order(s)?',
    'orders.bulk.delete.confirmSummary': '{{eligible}} of {{count}} selected order(s) will be deleted.',
    'orders.bulk.delete.confirmHint': 'Deleted orders are removed from the orders list, counts and reports.',
    'orders.bulk.delete.willSkip': '{{count}} order(s) cannot be deleted and will be left unchanged:',
    'orders.bulk.delete.confirmCta': 'Delete {{count}} order(s)',
    'orders.bulk.delete.success': '{{count}} order(s) deleted',
    'orders.bulk.delete.partialTitle': '{{deleted}} order(s) deleted, {{skipped}} not deleted',
    'orders.bulk.delete.partialMessage': 'These {{count}} order(s) were left unchanged:',
    'orders.bulk.delete.noneEligibleTitle': 'No orders were deleted',
    'orders.bulk.delete.noneEligible': 'None of the selected orders can be deleted:',
    'orders.bulk.delete.error': 'Failed to delete orders',
    'orders.delete.reason.has_invoice': 'Linked to an invoice. Detach it from the invoice first.',
    'orders.delete.reason.completed': 'Delivered or closed orders cannot be deleted.',
    'orders.delete.reason.revenue_recognized': 'The order has reached the status at which its amount is counted as revenue.',
    'orders.delete.reason.technician_settlement': 'Included in an approved or paid technician settlement.',
    'orders.delete.reason.materials_issued': 'Materials have been issued from stock to this order.',
    'orders.delete.reason.client_edit_disabled': 'This order is locked. Client edits are disabled by the lab administrator.',
    'orders.delete.reason.not_found': 'Order not found or already deleted.',
    'orders.actions.createWorkOrder.title': 'Create Work Order',
    'orders.actions.createWorkOrder.assignedTo': 'Assign To',
    'orders.actions.createWorkOrder.notes': 'Notes',
    'orders.actions.createWorkOrder.cta': 'Create Work Order',
    'orders.actions.createWorkOrder.success': 'Work order created',
    'orders.actions.createWorkOrder.error': 'Failed to create work order',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'Order items (by formula type)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} units',
    'orders.actions.createWorkOrder.unitLabel': 'Unit {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'No formula items in this order.',
    'orders.paymentStatus.draft': 'Draft',
    'orders.paymentStatus.due': 'Due',
    'orders.paymentStatus.not_due': 'Not Due',
    'orders.paymentStatus.unpaid': 'Unpaid',
    'orders.paymentStatus.paid': 'Paid',
    'orders.paymentStatus.partially_paid': 'Partially Paid',
    'orders.paymentStatus.void': 'Void',
    'orders.button.add': 'Add Order',
    'orders.button.create': 'Create Order',
    'orders.empty.noOrdersYet': 'No orders yet',
    'orders.empty.noneMatchFilters': 'No orders match the current filters. Try changing payment status or other filters.',
    'orders.button.cancel': 'Cancel',
    'orders.confirm.cancelTitle': 'Cancel Order',
    'orders.confirm.cancelMessage': 'Are you sure you want to cancel this order? This will mark it as a draft.',
    'orders.confirm.cancelSuccess': 'Order cancelled',
    'orders.confirm.cancelError': 'Failed to cancel order',
    'orders.button.assignInvoice': 'Assign to Invoice',
    'orders.assign.title': 'Assign Order to Invoice',
    'orders.assign.selectExisting': 'Select an existing invoice for this order\'s client',
    'orders.assign.selectPlaceholder': 'Select an invoice',
    'orders.assign.selectInvoice': 'Please select an invoice to assign',
    'orders.assign.success': 'Order assigned to invoice',
    'orders.assign.attachExisting': 'Attach to existing invoice',
    'orders.assign.created': 'Invoice created and order attached',
    'orders.assign.error': 'Failed to assign order to invoice',
    'orders.assign.assign': 'Assign',
    'orders.assign.create': 'Create Invoice',

    'orders.button.viewEdit': 'View | Edit',
    'orders.button.view': 'View',
    'orders.confirm.deleteTitle': 'Delete Order',
    'orders.confirm.deleteMessage': 'Are you sure you want to delete this order?',
    'orders.update.collectPayment': 'Collect Payment',
    'orders.update.refundPayment': 'Refund Payment',
    'orders.update.markDelivered': 'Mark as Delivered',
    'orders.update.invoiceButton': 'Invoice',
    'invoice.addOrder.modalTitle': 'Attach Order to Invoice',
    'invoice.addOrder.chooseExisting': 'Attach to existing invoice',
    'invoice.addOrder.selectPlaceholder': 'Select invoice',
    'invoice.addOrder.attach': 'Attach to Invoice',
    'invoice.addOrder.createNew': 'Create New Invoice',
    'invoice.addOrder.attached': 'Order attached to invoice',
    'invoice.addOrder.attachedSuccess': 'Order attached successfully',
    'orders.alert.noAccess': 'You do not have access to view orders.',
    'orders.alert.noCreate': 'You do not have permission to create orders.',
    'orders.alert.dentistNoClient': 'Your account is not linked to a client. Please contact your lab administrator before creating orders.',
    'orders.alert.noView': 'You do not have access to view this order.',
    'orders.alert.editBlocked': 'Order details cannot be edited because this order is finished, delivered, or attached to an invoice. Technician, courier, and status can still be updated when allowed.',
    'orders.alert.editBlockedBillable': 'Order details cannot be edited because this order has reached the status at which its amount is counted. Technician, courier, and status can still be updated when allowed.',
    'responses.permission.denied': 'You do not have permission to perform this action.',
    'responses.common.password_reset_link_sent': 'If an account exists for that email, a password reset link has been sent.',
    'responses.common.password_reset_success': 'Your password has been reset. You can now log in.',
    'colors.form.name.label': 'Color Name',
    'colors.form.name.placeholder': 'Enter color name',
    'colors.form.name.required': 'Please enter the color name',
    'colors.form.name.max': 'Color name must be 255 characters or fewer',
    'colors.form.code.label': 'Color Code',
    'colors.form.code.required': 'Color is required.',
    'colors.search.placeholder': 'Search colors by name',
    'colors.quickCreate.title': 'Add Color',
    'colors.quickCreate.button': 'Add new color',
    'colors.quickCreate.errorFallback': 'Unable to create color. Please try again.',
    'dentists.quickCreate.title': 'Add Dentist',
    'dentists.quickCreate.button': 'Add new dentist',
    'dentists.quickCreate.errorFallback': 'Unable to create dentist. Please try again.',
    'dentists.quickCreate.useClientName': 'Use client name',
    'dentists.quickCreate.missingType': 'Unable to detect dentist user type. Please refresh and try again.',
    'dentists.quickCreate.titleLabContact': 'Add Lab Contact',
    'dentists.quickCreate.buttonLabContact': 'Add new lab contact',
    'dentists.quickCreate.errorFallbackLabContact': 'Unable to create lab contact. Please try again.',
    'dentists.form.name.label': 'Dentist Name',
    'dentists.form.name.placeholder': 'Enter dentist name',
    'dentists.form.name.required': 'Please enter the dentist name',
    'dentists.form.name.labelLabContact': 'Lab Contact Name',
    'dentists.form.name.placeholderLabContact': 'Enter lab contact name',
    'dentists.form.name.requiredLabContact': 'Please enter the lab contact name',
    'dentists.form.email.label': 'Email',
    'dentists.form.email.placeholder': 'Enter email',
    'dentists.form.email.required': 'Please enter the email',
    'dentists.form.email.invalid': 'Please enter a valid email address',
    'dentists.form.username.label': 'Username',
    'dentists.form.username.placeholder': 'Enter username',
    'dentists.form.username.hint': 'Required if the dentist has no email',
    'dentists.form.username.optionalHint': 'Optional. Leave email and username empty to generate a username automatically.',
    'dentists.form.password.label': 'Password',
    'dentists.form.password.placeholder': 'Enter password',
    'dentists.form.password.required': 'Please enter the password',
    'dentists.form.password.min': 'Password must be at least 6 characters',
    'dentists.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'dentists.form.phone.label': 'Phone Number',
    'dentists.form.phone.placeholder': 'Enter phone number',
    'dentists.form.whatsapp.label': 'WhatsApp Number',
    'dentists.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'dentists.form.address.label': 'Address',
    'dentists.form.address.placeholder': 'Enter address',

    // Transactions
    'transactions.table.type': 'Type',
    'transactions.table.reference': 'Reference',
    'transactions.table.amount': 'Amount',
    'transactions.table.notes': 'Notes',
    'transactions.table.createdAt': 'Created On',
    'transactions.types.invoice': 'Invoice',
    'transactions.types.expense': 'Expense',
    'transactions.types.wallet_recharge': 'Wallet Recharge',
    'transactions.types.wallet': 'Wallet',
    'transactions.types.wallet_deduction': 'Wallet Deduction',
    'transactions.types.invoice_refund': 'Invoice Refund',
    'transactions.types.wallet_recharge_revert': 'Wallet Recharge Revert',
    'transactions.alert.noAccess': 'You do not have access to view transactions.',

    // Formula Types
    'formulaTypes.table.image': 'Image',
    'formulaTypes.table.name': 'Name',
    'formulaTypes.search.placeholder': 'Search by name or description',
    'formulaTypes.filter.unit.placeholder': 'Filter by unit or arch',
    'formulaTypes.table.cost': 'Unit Cost',
    'formulaTypes.table.description': 'Description',
    'formulaTypes.table.actions': 'Actions',
    'formulaTypes.button.add': 'Add Formula Type',
    'formulaTypes.modal.title': 'Formula Types',
    'formulaTypes.confirm.deleteTitle': 'Delete Formula Type',
    'formulaTypes.alert.noAccess': 'You do not have access to view formula types.',
    'formulaTypes.confirm.deleteMessage': 'Are you sure you want to delete this formula_type?',
    'formulaTypes.form.name.label': 'Formula Type Name',
    'formulaTypes.form.name.placeholder': 'Enter formula type name',
    'formulaTypes.form.name.required': 'Please enter the formula_type name',
    'formulaTypes.form.name.max': 'Name must be at most 255 characters',
    'formulaTypes.form.cost.label': 'Unit Cost',
    'formulaTypes.form.cost.placeholder': '0',
    'formulaTypes.form.cost.required': 'Please enter the unit cost',
    'formulaTypes.form.materialCostPerUnit.label': 'Material cost per unit',
    'formulaTypes.form.materialCostPerUnit.placeholder': '0',
    'formulaTypes.form.materialCostPerUnit.required': 'Please enter the material cost per unit',
    'formulaTypes.form.additionalOperationalCosts.label': 'Additional operational costs',
    'formulaTypes.form.additionalOperationalCosts.hint': 'Add any extra cost items, e.g. lab_to_lab = 10',
    'formulaTypes.form.additionalOperationalCosts.add': 'Add cost item',
    'formulaTypes.form.additionalOperationalCosts.itemPlaceholder': 'Cost item (e.g. lab_to_lab)',
    'formulaTypes.form.additionalOperationalCosts.itemRequired': 'Please enter the cost item',
    'formulaTypes.form.additionalOperationalCosts.itemDuplicate': 'This cost item is already added',
    'formulaTypes.form.additionalOperationalCosts.valuePlaceholder': 'Value',
    'formulaTypes.form.additionalOperationalCosts.valueRequired': 'Please enter the value',
    'formulaTypes.form.additionalOperationalCosts.valuePositive': 'The value must be greater than 0',
    'formulaTypes.form.sellingPrice.label': 'Selling price per unit',
    'formulaTypes.form.sellingPrice.placeholder': '0',
    'formulaTypes.form.sellingPrice.required': 'Please enter the selling price',
    'formulaTypes.form.technicianCostPerUnit.label': 'Technician cost per unit',
    'formulaTypes.form.technicianCostPerUnit.placeholder': '0',
    'formulaTypes.form.technicianCostPerUnit.required': 'Please enter the technician cost per unit',
    'formulaTypes.form.scope.label': 'Applies to',
    'formulaTypes.form.scope.placeholder': 'Unit or arch',
    'formulaTypes.form.scope.required': 'Please select unit or arch',
    'formulaTypes.scope.unit': 'Unit',
    'formulaTypes.scope.arch': 'Arch',
    'formulaTypes.table.materialCostPerUnit': 'Material cost / unit',
    'formulaTypes.table.additionalOperationalCosts': 'Additional operational costs',
    'formulaTypes.table.sellingPrice': 'Selling price',
    'formulaTypes.table.technicianCostPerUnit': 'Technician cost / unit',
    'formulaTypes.table.scope': 'Unit / arch',
    'formulaTypes.form.description.label': 'Formula Type Description',
    'formulaTypes.form.description.placeholder': 'Enter formula type description',
    'formulaTypes.form.image.label': 'Image',
    'formulaTypes.form.image.hint': 'JPG, PNG, GIF or WEBP (max 4 MB). A default image is shown when none is set.',
    'formulaTypes.form.image.choose': 'Upload image',
    'formulaTypes.form.image.change': 'Change image',
    'formulaTypes.form.image.remove': 'Remove image',
    'formulaTypes.form.attachments.label': 'Attachments',
    'formulaTypes.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'formulaTypes.form.attachments.choose': 'Choose files',
    'formulaTypes.form.attachments.existing': 'Existing attachments:',
    'formulaTypes.form.attachments.deleteConfirm': 'Remove attachment?',
    'formulaTypes.attachment.deleted': 'Attachment removed',
    'formulaTypes.attachment.deleteError': 'Failed to remove attachment',
    'formulaTypes.quickCreate.title': 'Add Formula Type',
    'formulaTypes.quickCreate.button': 'Add new formula type',
    'formulaTypes.setPrice.title': 'Set selling price',
    'formulaTypes.setPrice.description': '“{name}” has no selling price. Enter one so this order is priced correctly.',
    'formulaTypes.setPrice.descriptionGeneric': 'This formula type has no selling price. Enter one so this order is priced correctly.',
    'formulaTypes.setPrice.min': 'Selling price must be greater than zero',
    'formulaTypes.setPrice.success': 'Selling price saved',
    'formulaTypes.setPrice.errorFallback': 'Unable to save selling price. Please try again.',
    'deliveryCenters.quickCreate.title': 'Add Delivery Center',
    'deliveryCenters.quickCreate.button': 'Add new delivery center',
    'deliveryCenters.quickCreate.errorFallback': 'Unable to create delivery center. Please try again.',
    'deliveryCenters.form.name.label': 'Delivery Center Name',
    'deliveryCenters.form.name.placeholder': 'Enter delivery center name',
    'deliveryCenters.form.name.required': 'Please enter the delivery center name',
    'deliveryCenters.form.address.label': 'Address',
    'deliveryCenters.form.address.placeholder': 'Enter address',
    'deliveryCenters.form.phone.label': 'Phone Number',
    'deliveryCenters.form.phone.placeholder': 'Enter phone number',
    'deliveryCenters.form.whatsapp.label': 'WhatsApp Number',
    'deliveryCenters.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'deliveryCenters.form.email.label': 'Email',
    'deliveryCenters.form.email.placeholder': 'Enter email',
    'deliveryCenters.form.email.invalid': 'Please enter a valid email address',
    'deliveryCenters.form.notes.label': 'Notes',
    'deliveryCenters.form.notes.placeholder': 'Add notes (optional)',

    // Lab Profile
    'lab.title': 'Lab Information',
    'lab.subtitle': 'View and update your laboratory profile, contact details, and branding',
    'lab.delivery.subtitle': 'Configure delivery types, amounts, and the default option for orders',
    'lab.delivery.showCost.label': 'Show delivery',
    'lab.delivery.showCost.help': 'When off, delivery (delivery type and delivery cost) is hidden on create/edit/view order, public orders, order history, invoices, PDFs, public invoices, share messages and exports. Totals still include delivery.',
    'lab.delivery.showCost.show': 'Show',
    'lab.delivery.showCost.hide': 'Hide',
    'lab.delivery.showCost.saved': 'Delivery cost visibility updated.',
    'lab.payment.subtitle': 'Manage bank accounts and money transfer channels for client payments',
    'vacations.subtitle': 'Manage weekend days and lab closure periods shown on the calendar',
    'branchs.subtitle': 'Manage laboratory branches, addresses, and contact details',
    'assets.subtitle': 'Track laboratory assets, purchase costs, and notes',
    'assets.stats.totalAssets': 'Total assets',
    'expenses.subtitle': 'Record and track laboratory expenses by type, date, and amount',
    'expenses.stats.totalAmount': 'Total expenses amount',
    'expenseTypes.subtitle': 'Define expense categories used when recording lab expenses',
    'colors.subtitle': 'Manage shade catalog colors used across formulas and orders',
    'notificationSettings.subtitle': 'Choose which order emails you receive',
    'notificationSettings.loadError': 'Could not load notification settings',
    'notificationSettings.saved': 'Saved.',
    'notificationSettings.noAccess': 'You do not have access to notification settings.',
    'notificationSettings.emailStatusChanges': 'Email me when order status changes to',
    'notificationSettings.emailStatusChangesHelp': 'Statuses come from your lab order workflow. Turn off a status to stop email alerts for it.',
    'notificationSettings.noStatuses': 'No workflow statuses available.',
    'notificationSettings.emailOrderModified': 'Email me when an order is modified',
    'notificationSettings.emailOrderChat': 'Email me when there is a new chat in an order',
    'notificationSettings.emailOrderAssigned': 'Email me when an order is assigned to me',
    'notificationSettings.assignedOrdersOnly': 'Receive only notifications related to my assigned orders',
    'notificationSettings.assignedOrdersOnlyHelp': 'When on, order notifications are limited to orders where you are the dentist, technician, or courier. Lab admins still receive all order notifications.',
    'formulaTypes.subtitle': 'Configure formula types, pricing, units, and attachments',
    'activities.subtitle': 'Audit trail of user operations across the platform',
    'transactions.subtitle': 'Review invoice, expense, and wallet money movements',
    'lab.table.field': 'Field',
    'lab.table.value': 'Value',
    'lab.table.actions': 'Actions',
    'lab.table.branches': 'Branches',
    'lab.delivery.title': 'Delivery',
    'lab.delivery.col.name': 'Name',
    'lab.delivery.col.amount': 'Amount',
    'lab.delivery.default': 'Default',
    'lab.delivery.setDefault': 'Set as default',
    'lab.delivery.setDefaultSuccess': 'Set as default.',
    'lab.delivery.editValue': 'Change value',
    'lab.delivery.editStandardTitle': 'Change Standard Delivery value',
    'lab.delivery.amountForCurrency': 'Amount ({currency})',
    'lab.delivery.updateSuccess': 'Updated.',
    'lab.changeHistory': 'Change history',
    'lab.tax.changeHistory': 'Tax history',
    'lab.tax.versions.title': 'Tax change history',
    'lab.delivery.versions.title': 'Delivery settings change history',
    'lab.delivery.typeVersions.title': 'Delivery type change history',
    'lab.versions.empty': 'No change history yet',
    'lab.versions.by': 'Updated by',
    'lab.versions.noFields': 'No changed fields captured',
    'lab.versions.timelineTitle': 'Timeline',
    'lab.versions.compareTitle': 'Compare with current',
    'lab.versions.selectVersion': 'Select a version',
    'lab.versions.fieldsChanged': 'Fields changed',
    'lab.versions.before': 'Before',
    'lab.versions.after': 'After (Current)',
    'lab.field.name': 'Lab Name',
    'lab.field.logo': 'Logo',
    'lab.field.phone': 'Lab Phone',
    'lab.field.contactPhone': 'Contact Phone',
    'lab.field.vatPercentage': 'VAT %',
    'lab.field.delivery': 'Delivery',
    'lab.field.currency': 'Currency',
    'lab.field.showVat': 'Show VAT',
    'lab.field.showVat.show': 'Shown',
    'lab.field.showVat.hide': 'Hidden',
    'lab.field.showPriceDiscounts': 'Show discounts',
    'lab.field.showPriceDiscounts.show': 'Shown',
    'lab.field.showPriceDiscounts.hide': 'Hidden',
    'lab.field.shareContactsWithClients': 'Share contacts with clients',
    'lab.field.shareContactsWithClients.show': 'Shared',
    'lab.field.shareContactsWithClients.hide': 'Hidden',
    'lab.field.whatsapp': 'Lab WhatsApp',
    'orders.orderStatus.on-hold': 'On Hold',
    'lab.button.edit': 'Edit',
    'lab.modal.title': 'Edit Lab Information',
    'lab.form.name.label': 'Lab Name',
    'lab.form.name.placeholder': 'Enter lab name',
    'lab.form.name.required': 'Please enter the lab name',
    'lab.form.phone.label': 'Phone Number',
    'lab.form.phone.placeholder': 'Enter phone number',
    'lab.form.contactPhone.label': 'Contact Phone',
    'lab.form.contactPhone.placeholder': 'Enter contact phone',
    'lab.form.vatPercentage.label': 'VAT Percentage',
    'lab.form.vatPercentage.placeholder': '0',
    'lab.form.delivery.label': 'Delivery',
    'lab.form.delivery.placeholder': '0',
    'lab.form.showVat.label': 'Show VAT to clients',
    'lab.form.showVat.help': 'When off, VAT lines are hidden on orders, invoices, PDFs, public invoices, share messages and exports. Totals still include VAT.',
    'lab.form.showVat.show': 'Show',
    'lab.form.showVat.hide': 'Hide',
    'lab.form.showPriceDiscounts.label': 'Show discounts on orders & invoices',
    'lab.form.showPriceDiscounts.help': 'When off, discount labels and amounts are hidden on orders, invoices, PDFs, and public invoices. Charged totals still use the client’s prices.',
    'lab.form.showPriceDiscounts.show': 'Show',
    'lab.form.showPriceDiscounts.hide': 'Hide',
    'lab.form.shareContactsWithClients.label': 'Share lab contacts with clients',
    'lab.form.shareContactsWithClients.help': 'When off, the lab phone, WhatsApp and address are hidden from invoices, summary invoices, account statements, PDFs, exports and public invoices.',
    'lab.form.shareContactsWithClients.show': 'Share',
    'lab.form.shareContactsWithClients.hide': 'Hide',
    'lab.form.currency.label': 'Currency',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.readOnly': 'Currency cannot be changed after setup.',
    'lab.form.whatsapp.label': 'WhatsApp Number',
    'lab.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'lab.form.notes.label': 'Lab Description',
    'lab.form.notes.placeholder': 'Enter lab description',
    'lab.form.logo.label': 'Logo (navbar)',
    'lab.form.logo.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'lab.form.logo.uploadButton': 'Choose logo file',
    'lab.form.removeLogo': 'Remove current logo',
    'lab.saveSuccess': 'Settings saved',
    'lab.saveError': 'Could not save settings',
    'lab.button.save': 'Save',

    // Home
    'home.currency.egp': 'EGP',
    'home.welcome': 'Welcome {{labName}},',
    'home.lab_workspace_badge': 'Lab Workspace',
    'home.dentist_portal_badge': 'Dentist Portal',
    'home.dentist_welcome': 'Welcome, Dr. {{name}}',
    'home.summary': 'Summary of lab activity and performance.',
    'home.dentist_summary': 'Overview of your clinic cases, deliveries, and invoices.',
    'home.lab_contact_portal_badge': 'Lab Contact Portal',
    'home.lab_contact_welcome': 'Welcome, {{name}}',
    'home.lab_contact_summary': 'Overview of your lab cases, deliveries, and invoices.',
    'home.technician_workspace_badge': 'Technician',
    'home.technician_welcome': 'Welcome, {{name}}',
    'home.technician_summary': 'Your assigned orders and paid expenses.',
    'home.my_orders': 'Clinic Orders',
    'home.my_orders_count': 'Clinic Orders',
    'home.lab_orders': 'Lab Orders',
    'home.lab_orders_count': 'Lab Orders',
    'home.delivered_orders': 'Delivered',
    'home.finished_orders': 'Finished Orders',
    'home.pending_orders': 'Pending',
    'home.in_progress_orders': 'In Progress',
    'home.upcoming_deliveries': 'Upcoming Deliveries',
    'home.patients': 'Patients',
    'home.filter_by_clients': 'Filter by clients',
    'home.cases_this_month': 'Cases This Month',
    'home.clinic_invoices': 'Clinic Invoices',
    'home.lab_invoices': 'Lab Invoices',
    'home.patient': 'Patient',
    'home.delivery_date': 'Delivery Date',
    'home.invoices_amount': 'Invoices Amount',
    'home.paid_invoices': 'Paid Invoices',
    'home.orders': 'Orders',
    'home.dentists': 'Dentists',
    'home.invoices': 'Invoices',
    'home.unpaid_amount': 'Unpaid Amount',
    'home.statistics': 'Statistics',
    'home.recent_clinics': 'Top Clinics',
    'home.activity_overview': 'Activity Overview',
    'home.activity_subtitle': 'Overview of orders, invoices and revenue',
    'home.view_reports': 'View Reports',
    'home.dental_clinic': 'Dental Clinic',
    'home.active_invoices': 'Active Invoices',
    'home.active_expenses': 'Active Expenses',
    'home.invoices_label': 'Invoices',
    'home.expenses_label': 'Expenses',
    'home.amount': 'Amount',
    'home.count': 'Count',
    'home.revenue': 'Revenue',
    'home.paid_invoices_amount': 'Paid Invoices Amount',
    'home.unpaid_invoices_amount': 'Unpaid Invoices Amount',
    'home.total_orders_amount': 'Total Orders Amount',
    'home.paid_orders_amount': 'Total Paid Orders',
    'home.unpaid_orders_amount': 'Total Unpaid Orders',
    'home.expenses_amount': 'Total Expenses',
    'home.paid_invoices_count': 'Paid Invoices Count',
    'home.unpaid_invoices_count': 'Unpaid Invoices Count',
    'home.invoices_count': 'Invoices Count',
    'home.clients_count': 'Clients Count',
    'home.orders_count': 'Orders Count',
    'home.units_count': 'Units Count',
    'home.orders_trend': 'Orders Trend',
    'home.revenue_by_month': 'Revenue (6 months)',
    'home.invoices_breakdown': 'Invoices Breakdown',
    'home.active_clients': 'Active Clients',
    'home.active_orders': 'Active Orders',
    'home.active_dentists': 'Active Dentists',
    'home.clients_label': 'Clients',
    'home.orders_label': 'Orders',
    'home.full_period': 'Full period',

    // New home keys
    'home.new_orders': 'New Orders',
    'home.latest_orders': 'Latest Orders',
    'home.latest_assigned_orders': 'Latest Assigned Orders',
    'home.latest_invoices': 'Latest Invoices',
    'home.view_all_invoices': 'View All Invoices',
    'home.orders_tracker': 'Orders Tracker',
    'home.invoices_tracker': 'Invoices Tracker',
    'home.formula_types_tracker': 'Formula Types Tracker',
    'home.latest_formula_types': 'Latest Used Formula Types',
    'home.view_all_formula_types': 'View All Formula Types',
    'home.formula_types_label': 'Formula types',
    'home.most_used_formula_type': 'Most Used Formula Type',
    'home.total_units': 'Total Units',
    'home.units_label': 'Units',
    'home.last_order': 'Last Order',
    'home.last_used': 'Last Used',
    'home.formula_type': 'Formula Type',
    'home.formula_type_by_clients': 'By clients',
    'home.units_amount': 'Units Amount',
    'home.total_units_amount': 'Total Units Amount',
    'home.total_net_profit': 'Total Net Profit',
    'home.this_week': 'This week',
    'home.this_month': 'This month',
    'home.last_month': 'Last month',
    'home.last_3_months': 'Last 3 months',
    'home.last_6_months': 'Last 6 months',
    'home.last_year': 'Last year',
    'home.last_2_months': 'Last 2 months',
    'home.last_12_months': 'Last 12 months',
    'home.last_n_months': 'Last {count} months',
    'home.last_n_months_many': 'Last {count} months',
    'home.this_year': 'This year',
    'home.custom_range': 'Custom range',
    'home.revenue_tracker': 'Revenue Tracker',
    'home.collection_tracker': 'Collection Tracker',
    'home.revenue_collection_tracker': 'Revenue & Collection',
    'home.outstanding_balance': 'Outstanding Balance',
    'home.tracker_total_orders': 'Total Orders',
    'home.total_outstanding': 'Total Outstanding',
    'home.total_overdue': 'Overdue',
    'home.total_paid_orders': 'Total Collections',
    'home.total_invoices': 'Total Invoices',
    'home.total_invoices_amount': 'Total Invoices Amount',
    'home.total_expenses': 'Total Expenses',
    'home.net': 'Net',
    'home.total_revenue_net': 'Net Revenue',
    'home.total_collection_net': 'Net Collection',
    'home.total_due_orders': 'Total Revenue',
    'home.total_not_yet_due_orders': 'Not Yet Due',
    'home.total_collected_orders': 'Total Collected Orders',
    'home.due_orders_label': 'Revenue',
    'home.not_yet_due_orders_label': 'Not Yet Due',
    'home.collected_orders_label': 'Collections',
    'home.invoices_vs_expenses': 'Invoices vs Expenses',
    'home.order': 'Order',
    'home.client': 'Client',
    'home.status': 'Status',
    'home.date': 'Date',
    'home.total': 'Total',
    'home.total_orders': 'Total Orders',
    'home.total_assigned_orders': 'Total Assigned Orders',
    'home.total_orders_delivered': 'Total Orders Delivered',
    'home.total_expenses_paid': 'Total Expenses Paid',
    'home.requested': 'Requested',
    'home.in_progress': 'In Progress',
    'home.closed': 'Closed',
    'home.completed_percentage': 'Completed',
    'home.closed_orders': 'Closed Orders',
    'home.view_all_orders': 'View All Orders',

    // Profile
    'profile.title': 'Profile',
    'profile.error.title': 'Unable to load profile',
    'profile.avatar.upload': 'Upload photo',
    'profile.avatar.remove': 'Remove photo',
    'profile.avatar.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'profile.avatar.tooLarge': 'The uploaded image is too large. Please use an image up to 4 MB.',
    'profile.field.avatar': 'Photo',
    'profile.field.name': 'Name',
    'profile.field.username': 'Username',
    'profile.field.email': 'Email',
    'profile.field.userType': 'User Type',
    'profile.field.vendorName': 'Vendor Name',
    'profile.field.assignedClient': 'Assigned Client',
    'profile.section.assignedClient': 'Assigned Client',
    'profile.menu.profile': 'Profile',
    'profile.menu.settings': 'Settings',
    'profile.field.password': 'Password',
    'profile.field.passwordConfirm': 'Confirm Password',
    'profile.field.phone': 'Phone',
    'profile.field.whatsapp': 'WhatsApp',
    'profile.passwordSet': '••••••••',
    'profile.passwordPending': 'Pending invitation',
    'profile.field.currentPassword': 'Current Password',
    'profile.changePassword': 'Change Password',
    'profile.menu.logout': 'Log out',

    'notifications.title': 'Notifications',
    'notifications.empty': 'No notifications yet',
    'notifications.markAllRead': 'Mark all as read',
    'notifications.close': 'Close',
    'notifications.unread': 'Unread',
    'notifications.showMore': 'Show more',
    'notifications.page.subtitle': 'View and manage all of your notifications',
    'notifications.countLabel': 'total',
    'support.chat.title': 'Dentrist support',
    'support.chat.subtitle': 'Message our team directly — we usually reply within a few hours.',
    'support.chat.open': 'Message the Dentrist team',
    'support.chat.close': 'Close chat',
    'support.chat.greeting': 'Hi! How can we help you today?',
    'support.chat.greetingNamed': 'Hi {name}! How can we help you today?',
    'support.chat.placeholder': 'Write a message…',
    'support.chat.send': 'Send',
    'support.chat.seen': 'Seen',
    'support.chat.sendError': 'Could not send your message. Please try again.',
    'support.chat.files.attach': 'Attach images or files',
    'support.chat.files.dropHere': 'Drop files to attach them to your message',
    'support.chat.files.remove': 'Remove',
    'support.chat.files.processing': 'Finishing…',
    'support.chat.files.invalidType': '{{name}}: this file type is not allowed',
    'support.chat.files.tooLarge': '{{name}}: file is larger than 20 MB',
    'support.chat.files.tooMany': 'You can attach up to {{count}} files per message',

    // Users
    'users.page.title': 'Users',
    'users.header.title': 'Users',
    'users.header.subtitle': 'Manage lab staff accounts, invitations, permissions, and access',
    'users.filter.title': 'Filter Users',
    'users.filter.active': 'Active',
    'users.filter.clear': 'Reset Filters',
    'users.filter.search.placeholder': 'Search by name, email, phone, address or WhatsApp',
    'users.button.addUser': 'Add User',
    'users.modal.title': 'Users',
    'users.table.name': 'Name',
    'users.table.username': 'Username',
    'users.table.email': 'Email',
    'users.table.userType': 'User Type',
    'users.table.status': 'Status',
    'users.table.contact': 'Contact',
    'users.table.phone': 'Phone Number',
    'users.table.whatsapp': 'WhatsApp Number',
    'users.table.address': 'Address',
    'users.table.actions': 'Actions',
    'users.status.verified': 'Verified',
    'users.status.pending': 'Pending',
    'users.status.activated': 'User activated',
    'users.status.deactivated': 'User deactivated',
    'users.status.toggleFailed': 'Unable to update user status',
    'users.status.manualVerified': 'User verified',
    'users.status.manualUnverified': 'User marked as unverified',
    'users.status.verifyToggleFailed': 'Unable to update verification status',
    'users.actions.activate': 'Activate',
    'users.actions.deactivate': 'Deactivate',
    'users.actions.verify': 'Verify',
    'users.actions.unverify': 'Unverify',
    'users.table.accountStatus': 'Activation',
    'users.table.invitationStatus': 'Verification',
    'users.details.profileSection': 'Profile details',
    'users.details.invitationSection': 'Invitation',
    'users.details.clientNotAssigned': 'Not assigned',
    'users.details.assignedOrdersSection': 'Assigned orders',
    'users.details.noAssignedOrders': 'No assigned orders',
    'users.details.totalExpensesPaid': 'Total expenses paid',
    'users.confirm.activateTitle': 'Activate User',
    'users.confirm.activateMessage': 'This user will be able to sign in again.',
    'users.confirm.deactivateTitle': 'Deactivate User',
    'users.confirm.deactivateMessage': 'This user will be signed out and blocked from signing in until reactivated.',
    'users.confirm.verifyTitle': 'Verify User',
    'users.confirm.verifyMessage': 'Mark this user as verified without completing the invitation flow.',
    'users.confirm.unverifyTitle': 'Unverify User',
    'users.confirm.unverifyMessage': 'Mark this user as pending verification again.',
    'users.confirm.deleteTitle': 'Delete User',
    'users.confirm.deleteMessage': 'Are you sure you want to delete this user?',

    // Invitation
    'users.invitation.copyLink': 'Copy Invitation Link',
    'users.invitation.linkCopied': 'Invitation link copied to clipboard',
    'users.invitation.copyFailed': 'Failed to copy invitation link',
    'users.invitation.sendEmail': 'Send Invitation Email',
    'users.invitation.emailSent': 'Invitation email sent',
    'users.invitation.sendFailed': 'Failed to send invitation email',
    'users.invitation.regenerate': 'Regenerate Invitation Link',
    'users.invitation.regenerated': 'Invitation link regenerated',
    'users.invitation.regeneratedAndCopied': 'Invitation link regenerated and copied',
    'users.invitation.regenerateFailed': 'Failed to regenerate invitation link',
    'users.invitation.title': 'Invitation',
    'users.invitation.invalidToken': 'Invalid or expired form token',
    'users.invitation.completed': 'Account verified successfully! You can now log in.',
    'users.invitation.completeFailed': 'Failed to complete invitation',
    'users.invitation.error': 'Error',
    'users.invitation.backToLogin': 'Back to Login',
    'users.invitation.setPassword': 'Set Your Password',
    'users.invitation.welcome': 'Welcome!',
    'users.invitation.welcomeMessage': 'Please set a password for {{name}} ({{email}})',
    'users.invitation.complete': 'Complete Setup',
    'users.modal.createTitle': 'Add User',
    'users.modal.editTitle': 'Edit User',
    'users.changeHistory': 'Change history',
    'users.versions.title': 'User change history',
    'users.versions.empty': 'No change history yet',
    'users.versions.by': 'Updated by',
    'users.versions.noFields': 'No changed fields captured',
    'users.versions.timelineTitle': 'Timeline',
    'users.versions.compareTitle': 'Compare with current',
    'users.versions.selectVersion': 'Select a version',
    'users.versions.fieldsChanged': 'Fields changed',
    'users.versions.field': 'Field',
    'users.versions.versionValue': 'Version value',
    'users.versions.currentValue': 'Current value',
    'users.versions.current': 'Current',
    'users.versions.before': 'Before',
    'users.versions.after': 'After (Current)',
    'users.versions.status': 'Status',
    'users.versions.changed': 'Changed',
    'users.versions.same': 'Same',
    'users.form.name.label': 'Name',
    'users.form.name.placeholder': 'Enter name',
    'users.form.name.required': 'Please enter the name',
    'users.form.email.label': 'Email',
    'users.form.email.placeholder': 'Enter email',
    'users.form.email.required': 'Please enter the email',
    'users.form.email.invalid': 'Please enter a valid email',
    'users.form.username.label': 'Username',
    'users.form.username.placeholder': 'Enter username',
    'users.form.username.hint': 'Required if the user has no email',
    'users.form.password.label': 'Password',
    'users.form.password.placeholder': 'Enter password',
    'users.form.password.required': 'Please enter the password',
    'users.form.password.invitationHint': 'Leave empty to send invitation link instead',
    'users.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'users.form.password.minLength': 'Password must be at least 8 characters',
    'users.form.password.confirm': 'Confirm Password',
    'users.form.password.confirmRequired': 'Please confirm your password',
    'users.form.password.mismatch': 'Passwords do not match',
    'users.form.password.confirmPlaceholder': 'Confirm your password',
    'users.form.phone.label': 'Phone Number',
    'users.form.phone.placeholder': 'Enter phone number',
    'users.form.whatsapp.label': 'WhatsApp Number',
    'users.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'users.form.address.label': 'Address',
    'users.form.address.placeholder': 'Enter address',
    'users.form.userType.label': 'User Type',
    'users.form.userType.placeholder': 'Select a user type',
    'users.form.userType.required': 'Please select a user type',
    'users.resetPassword.button': 'Reset password',
    'users.resetPassword.confirmTitle': 'Reset to temporary password?',
    'users.resetPassword.confirmMessage': 'This sets the password to temp123. Share it with the user so they can log in and change it.',
    'users.resetPassword.successTitle': 'Temporary password ready',
    'users.resetPassword.successHint': 'Give this password to the user. They should log in and change it from their profile.',
    'users.resetPassword.failed': 'Unable to reset the password',
    'users.form.client.label': 'Client',
    'users.form.client.required': 'Please select a client for dentist users',
    'users.form.permissions.label': 'Permissions',
    'users.form.permissions.placeholder': 'Select permissions',
    'users.form.permissions.selectAll': 'Select all',
    'users.permissions.groups.asset': 'Assets',
    'users.permissions.groups.branch': 'Branches',
    'users.permissions.groups.delivery_center': 'Delivery Centers',
    'users.permissions.groups.color': 'Colors',
    'users.permissions.groups.dentist': 'Dentists',
    'users.permissions.groups.expense': 'Expenses',
    'users.permissions.groups.expense_type': 'Expense Types',
    'users.permissions.groups.invoice': 'Invoices',
    'users.permissions.groups.formula_type': 'Formula Types',
    'users.permissions.groups.order': 'Orders',
    'users.permissions.groups.order_phase': 'Order Phases',
    'users.permissions.groups.client': 'Clients',
    'users.permissions.groups.transaction': 'Transactions',
    'users.permissions.groups.unit': 'Units',
    'users.permissions.groups.unit_type': 'Unit Types',
    'users.permissions.groups.user': 'Users',
    'users.permissions.groups.dashboard': 'Dashboard',
    'users.permissions.groups.vendor': 'Vendors',
    'users.permissions.groups.vendor_bank_accounts': 'Bank Accounts',
    'users.permissions.groups.vendor_money_transfer_channels': 'Money Transfer Channels',
    'users.permissions.groups.setting': 'Settings',
    'users.permissions.groups.client_settings': 'Dentist Settings',
    'users.permissions.groups.client_transactions': 'Dentist Transactions',
    'users.permissions.groups.client_statement': 'Client Account Statement',
    'users.permissions.groups.client_wallet': 'Client Wallet',

    'users.permissions.items.view_dashboard_kpi_orders': 'View Orders KPI',
    'users.permissions.items.view_dashboard_kpi_invoices': 'View Invoices KPI',
    'users.permissions.items.view_dashboard_kpi_clients': 'View Clients KPI',
    'users.permissions.items.view_dashboard_kpi_units': 'View Units KPI',
    'users.permissions.items.view_dashboard_kpi_expenses': 'View Expenses KPI',
    'users.permissions.items.view_dashboard_collection_tracker': 'View Collection Tracker',
    'users.permissions.items.view_dashboard_revenue_tracker': 'View Revenue Tracker',
    'users.permissions.items.view_dashboard_latest_orders': 'View Latest Orders',
    'users.permissions.items.view_dashboard_orders_tracker': 'View Orders Tracker',
    'users.permissions.items.view_dashboard_latest_invoices': 'View Latest Invoices',
    'users.permissions.items.view_dashboard_invoices_tracker': 'View Invoices Tracker',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'View Formula Types Tracker',
    'users.permissions.items.view_dashboard_active_clients': 'View Active Clients',
    'users.permissions.items.view_dashboard_active_orders': 'View Active Orders',
    'users.permissions.items.view_dashboard_active_invoices': 'View Active Invoices',
    'users.permissions.items.view_dashboard_active_expenses': 'View Active Expenses',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'Download Invoice (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'Send Invoice via WhatsApp',
    'users.permissions.items.send_invoice_email': 'Send Invoice via Email',
    'users.permissions.items.detach_order_from_invoice': 'Detach Order from Invoice',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'View Vendors',
    'users.permissions.items.add_vendor': 'Add Vendors',
    'users.permissions.items.edit_vendor': 'Edit Vendors',
    'users.permissions.items.delete_vendor': 'Delete Vendors',

    'users.permissions.items.view_vendor_bank_accounts': 'View Bank Accounts',
    'users.permissions.items.add_vendor_bank_accounts': 'Add Bank Accounts',
    'users.permissions.items.edit_vendor_bank_accounts': 'Edit Bank Accounts',
    'users.permissions.items.delete_vendor_bank_accounts': 'Delete Bank Accounts',

    'users.permissions.items.view_vendor_money_transfer_channels': 'View Money Transfer Channels',
    'users.permissions.items.add_vendor_money_transfer_channels': 'Add Money Transfer Channels',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'Edit Money Transfer Channels',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'Delete Money Transfer Channels',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'View Settings',
    'users.permissions.items.edit_settings': 'Edit Settings',

    // Dentist portal settings
    'users.permissions.items.view_client_settings_client_info': 'View client info (Settings)',
    'users.permissions.items.view_client_settings_wallet_balance': 'View wallet balance (Settings)',
    'users.permissions.items.view_client_settings_wallet_history': 'View wallet history (Settings)',
    'users.permissions.items.view_client_settings_transactions': 'View transactions (Settings)',
    'users.permissions.items.view_client_transactions': 'View client transactions',
    'users.permissions.items.view_client_statement': 'View client account statement',
    'users.permissions.items.view_client_wallet': 'View client wallet',
    'users.permissions.items.export_clients': 'Export clients',
    'users.permissions.items.export_invoices': 'Export invoices',
    'users.permissions.items.export_orders': 'Export orders',
    'users.permissions.items.export_users': 'Export users',

    'clientTransactions.title': 'Transactions',
    'clientTransactions.alert.noAccess': 'You do not have access to transactions.',
    'clientStatement.title': 'Account Statement',
    'clientStatement.alert.noAccess': 'You do not have access to the account statement.',
    'clientWallet.title': 'Wallet',
    'clientWallet.alert.noAccess': 'You do not have access to the wallet.',
    'users.permissions.items.view_client_settings_wallet': 'View client wallet (Settings)',

    'clientSettings.title': 'Settings',
    'clientSettings.alert.noAccess': 'You do not have access to settings.',
    'clientSettings.alert.noClientAssigned': 'No client is assigned to your account. Contact your lab administrator.',
    'clientSettings.clientInfo.title': 'Client info',
    'clientSettings.clientInfo.clientName': 'Client Name',
    'clientSettings.clientInfo.clientType': 'Client Type',
    'clientSettings.clientInfo.phone': 'Phone Number',
    'clientSettings.clientInfo.whatsapp': 'WhatsApp Number',
    'clientSettings.clientInfo.email': 'Email',
    'clientSettings.clientInfo.assignedDentists': 'Assigned Dentists',
    'clientSettings.clientInfo.assignedLabContacts': 'Assigned Lab Contacts',
    'clientSettings.clientInfo.deliveryCenters': 'Delivery Centers',
    'clientSettings.accounts.title': 'Accounts',
    'clientSettings.accounts.titleDentists': 'Client accounts',
    'clientSettings.accounts.titleLabContacts': 'Lab contact accounts',
    'clientSettings.accounts.description': 'Other accounts linked to this client. Only the main account can view this list.',
    'clientSettings.accounts.you': 'You',
    'clientSettings.accounts.status': 'Status',
    'clientSettings.accounts.statusActive': 'Active',
    'clientSettings.accounts.statusInactive': 'Inactive',
    'clientSettings.wallet.title': 'Wallet',
    'clientSettings.transactions.title': 'Transactions',

    'users.permissions.items.view_asset': 'View Assets',
    'users.permissions.items.add_asset': 'Add Assets',
    'users.permissions.items.edit_asset': 'Edit Assets',
    'users.permissions.items.delete_asset': 'Delete Assets',
    'users.permissions.items.view_branch': 'View Branches',
    'users.permissions.items.add_branch': 'Add Branches',
    'users.permissions.items.edit_branch': 'Edit Branches',
    'users.permissions.items.delete_branch': 'Delete Branches',
    'users.permissions.items.view_delivery_center': 'View Delivery Centers',
    'users.permissions.items.add_delivery_center': 'Add Delivery Centers',
    'users.permissions.items.edit_delivery_center': 'Edit Delivery Centers',
    'users.permissions.items.delete_delivery_center': 'Delete Delivery Centers',
    'users.permissions.items.view_color': 'View Colors',
    'users.permissions.items.add_color': 'Add Colors',
    'users.permissions.items.edit_color': 'Edit Colors',
    'users.permissions.items.delete_color': 'Delete Colors',
    'users.permissions.items.view_dentist': 'View Dentists',
    'users.permissions.items.add_dentist': 'Add Dentists',
    'users.permissions.items.edit_dentist': 'Edit Dentists',
    'users.permissions.items.delete_dentist': 'Delete Dentists',
    'users.permissions.items.view_expense': 'View Expenses',
    'users.permissions.items.add_expense': 'Add Expenses',
    'users.permissions.items.edit_expense': 'Edit Expenses',
    'users.permissions.items.delete_expense': 'Delete Expenses',
    'users.permissions.items.view_expense_type': 'View Expense Types',
    'users.permissions.items.add_expense_type': 'Add Expense Types',
    'users.permissions.items.edit_expense_type': 'Edit Expense Types',
    'users.permissions.items.delete_expense_type': 'Delete Expense Types',
    'users.permissions.items.view_invoice': 'View Invoices',
    'users.permissions.items.add_invoice': 'Add Invoices',
    'users.permissions.items.edit_invoice': 'Edit Invoices',
    'users.permissions.items.delete_invoice': 'Delete Invoices',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'Create Invoice From Order',
    'users.permissions.items.attach_order_to_invoice': 'Attach Order To Existing Invoice',
    'users.permissions.items.create_work_order': 'Work Order',
    'users.permissions.items.view_assigned_orders': 'View Assigned Orders',
    'users.permissions.items.view_order_public_page': 'View Order Public Page',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'Create Invoice',
    'orders.actions.createInvoice.description': 'Create an invoice using the current order.',
    'orders.actions.createInvoice.cta': 'Create Invoice',
    'orders.actions.createInvoice.success': 'Invoice created successfully',
    'orders.actions.createInvoice.error': 'Failed to create invoice',

    'orders.actions.attach.title': 'Attach to Existing Invoice',
    'orders.actions.attach.selectPlaceholder': 'Select an invoice',
    'orders.actions.attach.cta': 'Attach',
    'orders.actions.attach.success': 'Order attached to invoice',
    'orders.actions.attach.error': 'Failed to attach to invoice',

    'orders.actions.workOrder.title': 'Work Order',
    'orders.actions.workOrder.assignedTo': 'Assign To',
    'orders.actions.workOrder.notes': 'Notes',
    'orders.actions.workOrder.cta': 'Work Order',
    'orders.actions.workOrder.success': 'Work order created',
    'orders.actions.workOrder.error': 'Failed to create work order',
    'users.permissions.items.view_formula_type': 'View Formula Types',
    'users.permissions.items.add_formula_type': 'Add Formula Types',
    'users.permissions.items.edit_formula_type': 'Edit Formula Types',
    'users.permissions.items.delete_formula_type': 'Delete Formula Types',
    'users.permissions.items.view_all_formula_types': 'View All Formula Types',
    'users.permissions.items.view_client': 'View Clients',
    'users.permissions.items.add_client': 'Add Clients',
    'users.permissions.items.edit_client': 'Edit Clients',
    'users.permissions.items.delete_client': 'Delete Clients',
    'users.permissions.items.revert_wallet_recharge': 'Revert Wallet Recharges',
    'users.permissions.items.view_order': 'View Orders',
    'users.permissions.items.add_order': 'Add Orders',
    'users.permissions.items.edit_order': 'Edit Orders',
    'users.permissions.items.delete_order': 'Delete Orders',
    'users.permissions.items.view_order_phase': 'View Order Phases',
    'users.permissions.items.add_order_phase': 'Add Order Phases',
    'users.permissions.items.edit_order_phase': 'Edit Order Phases',
    'users.permissions.items.delete_order_phase': 'Delete Order Phases',
    'users.permissions.items.view_transaction': 'View Transactions',
    'users.permissions.items.add_transaction': 'Add Transactions',
    'users.permissions.items.edit_transaction': 'Edit Transactions',
    'users.permissions.items.delete_transaction': 'Delete Transactions',
    'users.permissions.items.view_unit': 'View Units',
    'users.permissions.items.add_unit': 'Add Units',
    'users.permissions.items.edit_unit': 'Edit Units',
    'users.permissions.items.delete_unit': 'Delete Units',
    'users.permissions.items.view_unit_type': 'View Unit Types',
    'users.permissions.items.add_unit_type': 'Add Unit Types',
    'users.permissions.items.edit_unit_type': 'Edit Unit Types',
    'users.permissions.items.delete_unit_type': 'Delete Unit Types',
    'users.permissions.items.view_user': 'View Users',
    'users.permissions.items.add_user': 'Add Users',
    'users.permissions.items.edit_user': 'Edit Users',
    'users.permissions.items.delete_user': 'Delete Users',
    'users.permissions.groups.delivery_type': 'Delivery Types',
    'users.permissions.groups.activity_logs': 'Activity Logs',
    'users.permissions.groups.change_history': 'Change History',
    'users.permissions.actions.view': 'View',
    'users.permissions.actions.add': 'Add',
    'users.permissions.actions.edit': 'Edit',
    'users.permissions.actions.delete': 'Delete',
    'users.permissions.actions.change': 'Change',
    'users.permissions.actions.create': 'Create',
    'users.permissions.actions.view_all': 'View All',
    'users.permissions.items.view_delivery_type': 'View Delivery Types',
    'users.permissions.items.add_delivery_type': 'Add Delivery Types',
    'users.permissions.items.edit_delivery_type': 'Edit Delivery Types',
    'users.permissions.items.delete_delivery_type': 'Delete Delivery Types',
    'users.permissions.items.view_assigned_technician': 'View Assigned Technician',
    'users.permissions.items.change_assigned_technician': 'Change Assigned Technician',
    'users.permissions.items.view_assigned_courier': 'View Assigned Courier',
    'users.permissions.items.change_assigned_courier': 'Change Assigned Courier',
    'users.permissions.items.view_order_status': 'View Order Status',
    'users.permissions.items.change_order_status': 'Change Order Status',
    'users.permissions.items.view_activity_logs': 'View Activity Logs',
    'users.permissions.items.view_notification_settings': 'View Notification Settings',
    'users.permissions.items.edit_notification_settings': 'Edit Notification Settings',
    'users.permissions.items.view_change_history': 'View Change History',
    'users.permissions.items.view_all_colors': 'View All Colors',
    'users.form.submit.add': 'Add',
    'users.form.submit.edit': 'Update',
    'users.alert.noAccess': 'You do not have access to view users.',

    // Invoice page
    'invoice.title': 'Invoice',
    'invoice.detailsTitle': 'Invoice Details',
    'invoice.placeholder': 'Invoice view placeholder — awaiting layout specification.',
    'invoice.alert.noView': 'You do not have access to view this invoice.',
    'invoice.button.print': 'Print',
    'invoice.button.addOrder': 'Add Order',
    'invoice.field.dentistName': "Dentist's Name",
    'invoice.field.date': 'Invoice Date',
    'invoice.field.client': 'Client',
    'invoice.field.status': 'Status',
    'invoice.field.units': 'Units Count',
    'invoice.field.orders': 'Orders',
    'invoice.field.unitCost': 'Unit Cost',
    'invoice.field.issueDate': 'Issue Date',
    'invoice.field.dueDate': 'Due Date',
    'invoice.field.paidAt': 'Paid At',
    'invoice.field.paymentMethod': 'Payment Method',
    'invoice.field.paymentStatus': 'Payment Status',
    'invoice.field.transferReference': 'Transfer reference',
    'invoice.field.moneyTransferChannel': 'Money Transfer Channel',
    'invoice.field.deliveredAt': 'Delivered At',
    'invoice.orders.viewFormulas': 'View Formulas',
    'invoice.orders.hideFormulas': 'Hide Formulas',
    'invoice.orders.expandAll': 'Expand All Formulas',
    'invoice.orders.collapseAll': 'Collapse All Formulas',
    'invoice.orders.formulasCount': '{{count}} Formulas',
    'invoice.orders.unitsCount': '{{count}} Units',
    'invoice.orders.formulaList': 'Formulas & Shades',
    'invoice.orders.financialSummary': 'Financial Details',
    'invoice.orders.teeth': 'Teeth',
    'invoice.button.detach': 'Detach from invoice',
    'invoice.detach.confirmMessage': 'Are you sure you want to detach this order from the invoice?',
    'invoice.detach.success': 'Order detached successfully',


    'invoice.detach.error': 'Failed to detach order',
    'invoice.cancel.confirmMessage': 'Detaching the last order will convert this invoice to a draft. Continue?',
    'invoice.cancel.success': 'Invoice converted to draft',
    'invoice.cancel.error': 'Failed to cancel invoice',
    'invoice.alert.draft': 'This invoice is a draft',
    'invoice.alert.paidReadOnly': 'This invoice is paid. Most editing is disabled; you can still change the payment date. Use Undo Payment in the invoice header if it was marked paid by mistake, or Refund to credit the client wallet.',
    'invoice.paidAt.success': 'Payment date updated',
    'invoice.paidAt.error': 'Failed to update payment date',
    'invoice.button.cancel': 'Cancel Invoice',
    'invoice.button.downloadPdf': 'Download PDF',
    'invoice.button.downloadSummaryPdf': 'Download Invoice PDF',
    'invoice.taxInvoice.title': 'Tax invoice (E-Invoice)',
    'invoice.taxInvoice.badge': 'Tax invoice',
    'invoice.taxInvoice.downloadPdf': 'Download tax invoice PDF',
    'invoice.taxInvoice.downloadError': 'Could not download the tax invoice',
    'invoice.taxInvoice.loadError': 'Could not load the tax invoice',
    'invoice.taxInvoice.makeTax': 'Convert to tax invoice (E-Invoice)',
    'invoice.taxInvoice.makeRegular': 'Convert to regular invoice',
    'invoice.taxInvoice.toggleError': 'Could not change the invoice type',
    'invoice.taxInvoice.createLabel': 'Tax invoice (E-Invoice)',
    'invoice.taxInvoice.createHint': 'Issue this invoice in the bilingual tax invoice format: lab and client tax details, services table, net before tax, VAT and total due.',
    'invoice.taxInvoice.createButton': 'Create E-Invoice',
    'invoice.taxInvoice.typeFilter': 'Invoice type',
    'invoice.taxInvoice.typeTax': 'Tax invoices (E-Invoice)',
    'invoice.taxInvoice.typeRegular': 'Regular invoices',
    'invoice.button.downloadExcel': 'Download Excel',
    'invoice.button.downloadCsv': 'Download CSV',
    'invoice.button.sendWhatsapp': 'Send WhatsApp',
    'invoice.button.sendEmail': 'Send Email',
    'invoice.changeHistory': 'Change history',
    'invoice.versions.title': 'Invoice change history',
    'invoice.versions.empty': 'No change history yet',
    'invoice.versions.timelineTitle': 'Timeline',
    'invoice.versions.by': 'Updated by',
    'invoice.versions.fieldsChanged': 'Fields changed',
    'invoice.versions.compareTitle': 'Compare with current',
    'invoice.versions.selectVersion': 'Select a version',
    'invoice.versions.noFields': 'No changed fields captured',
    'invoice.versions.currentVersion': 'Current version',
    'invoice.versions.before': 'Before',
    'invoice.versions.after': 'After (Current)',
    'invoice.field.phone': 'Phone',
    'invoice.field.message': 'Message',
    'invoice.button.markPaid': 'Mark as Paid',
    'invoice.markPaid.title': 'Record Payment',
    'invoice.markPaid.paymentMethod': 'Payment Method',
    'invoice.markPaid.channel': 'Money Transfer Channel',
    'invoice.markPaid.channelOther': 'Other Channel',
    'invoice.markPaid.notes': 'Notes',
    'invoice.markPaid.attachment': 'Attachment (image)',
    'invoice.markPaid.success': 'Invoice marked as paid',
    'invoice.markPaid.error': 'Failed to mark invoice as paid',
    'invoice.button.partialPayment': 'Partial Payment',
    'invoice.partialPayment.title': 'Record Partial Payment',
    'invoice.partialPayment.type': 'Payment type',
    'invoice.partialPayment.typeFull': 'Full invoice payment (invoice total)',
    'invoice.partialPayment.typeOrders': 'Partial payment for selected orders',
    'invoice.partialPayment.typeAmount': 'Partial payment on the invoice (enter amount; not tied to specific orders)',
    'invoice.partialPayment.paymentDate': 'Payment date',
    'invoice.partialPayment.amount': 'Amount to pay',
    'invoice.partialPayment.remaining': 'Remaining',
    'invoice.partialPayment.selectOrders': 'Select the orders to pay',
    'invoice.partialPayment.selectedTotal': 'Selected orders total',
    'invoice.partialPayment.noUnpaidOrders': 'All orders on this invoice are already paid',
    'invoice.partialPayment.amountRequired': 'Enter a payment amount greater than zero',
    'invoice.partialPayment.amountExceeds': 'The amount cannot exceed the remaining balance',
    'invoice.partialPayment.amountExceedsRemaining': 'The amount is more than the remaining balance ({{remaining}}). Please enter a proper amount.',
    'invoice.partialPayment.ordersRequired': 'Select at least one order',
    'invoice.partialPayment.ordersExceed': 'The selected orders total exceeds the remaining balance',
    'invoice.partialPayment.success': 'Partial payment recorded',
    'invoice.partialPayment.error': 'Failed to record partial payment',
    'invoice.payments.title': 'Transactions History',
    'invoice.payments.date': 'Date',
    'invoice.payments.amount': 'Amount',
    'invoice.payments.method': 'Method',
    'invoice.payments.count': '{{count}} payment(s)',
    'invoice.payments.empty': 'No payments recorded yet',
    'invoice.payments.typePartial': 'Partial payment',
    'invoice.payments.typeFull': 'Full payment',
    'invoice.payments.ordersPaid': 'Orders paid',
    'invoice.button.refund': 'Refund',
    'invoice.refund.confirmTitle': 'Refund invoice?',
    'invoice.refund.confirmMessage': 'The paid amount will be credited to the client wallet, the invoice will be marked as unpaid, and included orders will be cancelled.',
    'invoice.refund.success': 'Invoice refunded successfully',
    'invoice.refund.error': 'Failed to refund invoice',
    'invoice.button.undoMarkPaid': 'Undo Payment',
    'invoice.undoMarkPaid.confirmTitle': 'Undo payment?',
    'invoice.undoMarkPaid.confirmMessage': 'This will reverse the mark-as-paid action as if it never happened. Related payment transactions will be soft-deleted, the invoice will return to unpaid, and included orders will reopen to their status before Closed.',
    'invoice.undoMarkPaid.success': 'Invoice payment undone',
    'invoice.undoMarkPaid.error': 'Failed to undo invoice payment',
    'invoice.paymentSummary.toggle': 'Amounts',
    'invoice.paymentSummary.hide': 'Hide Amounts',
    'invoice.paymentSummary.show': 'Show Amounts',
    'invoice.dentist.title': 'Dentist',
    'invoice.deliveryCenter.title': 'Delivery Centers',
    'invoice.customer.title': 'Customer',
    'invoice.client.title': 'Client',
    'invoice.paymentSummary.title': 'Payment Summary',
    'invoice.clientBalance.title': "Total Client's Orders Due Amount",
    'invoice.clientBalance.totalDue': 'Total due (all unpaid orders)',
    'invoice.clientBalance.unpaidOrders': 'Unpaid orders',
    'invoice.clientBalance.hint': 'Includes every unpaid or partially paid order for this client, invoiced or not.',
    'invoice.notes.title': 'Notes',
    'invoice.notes.edit': 'Edit',
    'invoice.notes.save': 'Save',
    'invoice.notes.cancel': 'Cancel',
    'invoice.dates.title': 'Invoice Dates',
    'invoice.dates.dueIn': 'Due in {{count}} days',
    'invoice.dates.dueToday': 'Due today',
    'invoice.dates.overdueBy': 'Overdue by {{count}} days',
    'invoice.dates.notSet': 'Not set',
    'invoice.dates.paymentTerms': 'Payment terms',
    'invoice.dates.paymentTermsNet': 'Net {{count}} days',
    'invoice.summary.title': 'Invoice Summary',
    'invoice.summary.statusOverdue': 'Overdue',
    'invoice.summary.subtotal': 'Subtotal',
    'invoice.summary.vat': 'VAT ({{percent}}%)',
    'invoice.summary.totalVat': 'Total VAT',
    'invoice.summary.discount': 'Discount',
    'invoice.summary.delivery': 'Delivery',
    'invoice.summary.total': 'Total',
    'invoice.summary.paid': 'Paid',
    'invoice.summary.remaining': 'Remaining',
    'invoice.button.download': 'Download',
    'invoice.button.share': 'Share',
    'invoice.button.more': 'More',
    'invoice.button.qrCode': 'QR code',
    'invoice.clientBalance.inline': 'Client outstanding balance',
    'invoice.clientBalance.unpaidOrdersCount': '{{count}} unpaid orders',
    'invoice.orders.expandAll': 'Expand all',
    'invoice.orders.collapseAll': 'Collapse all',
    'invoice.attachments.title': 'Attachments',
    'invoice.addOrder.selectRequired': 'Please select at least one order',

    // UI invoice labels (used by public invoice view)
    'ui.invoice.number': 'Invoice',
    'ui.invoice.status': 'Status',
    'ui.invoice.issue_date': 'Issue Date',
    'ui.invoice.due_date': 'Due Date',
    'ui.invoice.section_vendor': 'Seller',
    'ui.invoice.section_client': 'Client',
    'ui.invoice.section_dentist': 'Dentist',
    'ui.invoice.section_delivery_center': 'Delivery Center',
    'ui.delivery_cost': 'Delivery Cost',
    'ui.invoice.table.order_ref': 'Order Ref',
    'ui.invoice.table.formula_type': 'Formula Type',
    'ui.invoice.table.units': 'Units',
    'ui.invoice.table.shipment_date': 'Shipment Date',
    'ui.invoice.table.patient': 'Patient',
    'ui.invoice.table.amount': 'Amount',
    'ui.invoice.table.discount': 'Discount',
    'ui.invoice.table.vat': 'VAT',
    'ui.invoice.table.total': 'Total',
    'ui.invoice.status_paid': 'Paid',
    'ui.invoice.status_past_due': 'Past Due',
    'ui.invoice.status_unpaid': 'Unpaid',

    // Generic error messages
    'errors.fetchFailed': 'Failed to load data',
    'invoice.addOrder.added': 'Orders added to invoice',
    'invoice.addOrder.fetchError': 'Unable to fetch orders',
    'invoice.addOrder.attachedHint': 'Attached to Invoice #{id} ({status}) — will be detached if selected',
    'invoice.addOrder.attachedWillDetach': 'Will be detached if selected',
    'invoice.addOrder.noOrders': 'No unpaid orders for this client',
    'invoice.addOrder.detachConfirmTitle': 'Detach orders from other invoices?',
    'invoice.addOrder.detachConfirmMessage': 'Some selected orders belong to other invoices. Selecting them will detach them from their current invoice(s). Do you want to continue?',

    'invoices.detach.title': 'Detach Orders',
    'invoices.detach.noInvoice': 'Invoice not found',
    'invoice.addOrder.attachError': 'Unable to attach orders',
    'invoice.addOrder.issueDateFrom': 'Issue date from',
    'invoice.addOrder.issueDateTo': 'Issue date to',
    'invoice.addOrder.loadByIssueDate': 'Load by issue date',
    'invoice.addOrder.selectAllInRange': 'Select all',
    'invoice.addOrder.clearIssueDateFilter': 'Clear date filter',
    'invoice.addOrder.issueDateRangeRequired': 'Please select an issue date range',
    'invoice.addOrder.noMatches': 'No matching unpaid invoices found for this client/dentist',

    'invoices.button.add': 'Create Invoice',
    'invoices.button.summary': 'Summary Invoice',
    'invoice.create.title': 'Create Invoice',
    'invoice.create.subtitle': 'Select a client, filter the unpaid orders, then create the invoice',
    'invoice.create.nextCode': 'Invoice code',
    'invoice.create.nextCodeHint': 'Final code is assigned when the invoice is saved.',
    'invoice.create.backToInvoices': 'Back to invoices',
    'invoice.create.backToOrders': 'Back to orders',
    'invoice.create.setupTitle': 'Filters',
    'invoice.create.clientPlaceholder': 'Client',
    'invoice.create.dentistPlaceholder': 'Dentist (optional)',
    'invoice.create.formulaTypePlaceholder': 'Formula type',
    'invoice.create.ordersTitle': 'Unpaid orders',
    'invoice.create.ordersHint': 'Select the orders to bill. Orders already on another unpaid invoice will be detached if selected.',
    'invoice.create.selectedCount': '{{count}} selected',
    'invoice.create.selected': 'Selected',
    'invoice.create.ordersCount': '{{count}} orders',
    'invoice.create.totalDue': 'Total due',
    'invoice.create.emptyClient': 'Select a client to load unpaid orders',
    'invoice.create.search': 'Search',
    'invoice.create.narrowByDate': 'Issue date range',
    'invoice.create.deliveryDateRange': 'Delivery date',
    'invoice.create.clearSelection': 'Clear selection',
    'invoice.created': 'Invoice created',
    'invoice.form.clientPlaceholder': 'Select a client to load unpaid orders',
    'invoice.summary.pageTitle': 'Summary Invoice',
    'invoice.summary.dentistPlaceholder': 'Select a dentist (optional)',
    'invoice.summary.clientOrDentistRequired': 'Select a client and/or dentist',
    'invoice.summary.dateRangeRequired': 'Select a date range',
    'invoice.summary.preview': 'Preview',
    'invoice.summary.downloadPdf': 'Download PDF',
    'invoice.summary.loadError': 'Unable to load summary invoice',
    'invoice.summary.downloadError': 'Unable to download summary invoice',
    'invoice.summary.caseDescription': 'Case description',
    'invoice.summary.caseType': 'Case type',
    'invoice.summary.quantity': 'Quantity',
    'invoice.summary.date': 'Date',
    'invoice.summary.patient': 'Patient',
    'invoice.summary.status': 'Order Status',
    'invoice.summary.unitPrice': 'Unit price',
    'invoice.summary.numberOfUnits': 'Number of restorations',
    'invoice.summary.periodTotal': 'Period total',
    'invoice.summary.paidDuringPeriod': 'Paid during period',
    'invoice.summary.previousBalance': 'Previous balance',
    'invoice.summary.totalAmountDue': 'Total amount due',
    'invoice.summary.noCases': 'No cases in the selected period',
    'invoice.summary.filterTitle': 'Filter Parameters',
    'invoice.summary.resultsTitle': 'Summary Results',
    'invoice.summary.totalCases': 'Cases',
    'invoice.button.downloading': 'Downloading...',
    'invoice.field.formula_type': 'Formula Type Type',
    'invoice.field.color': 'Color',
    'invoice.field.subtotal': 'Subtotal',
    'invoice.field.discountType': 'Discount Type',
    'invoice.field.discountValue': 'Discount Value',
    'invoice.field.total': 'Total Due',
    'invoice.field.paid': 'Total Paid',

    // Payment / bank accounts (settings + invoice payment section)
    'lab.payment.title': 'Payment Settings',
    'lab.payment.bank_accounts_title': 'Bank Accounts',
    'lab.payment.addAccount': 'Add Bank Account',
    'lab.payment.editAccount': 'Edit Bank Account',
    'lab.payment.accountHolder': 'Account Holder',
    'lab.payment.accountHolder.required': 'Account holder is required',
    'lab.payment.accountHolder.max': 'Account holder name is too long',
    'lab.payment.accountNumber': 'Account Number',
    'lab.payment.accountNumber.required': 'Account number is required',
    'lab.payment.accountNumber.invalid': 'Invalid account number',
    'lab.payment.accountNumber.min': 'Account number is too short',
    'lab.payment.iban': 'IBAN',
    'lab.payment.iban.invalid': 'Invalid IBAN',
    'lab.payment.swiftCode': 'Swift Code',
    'lab.payment.swiftCode.invalid': 'Invalid SWIFT/BIC',
    'lab.payment.bankName': 'Bank Name',
    'lab.payment.bankName.required': 'Bank name is required',
    'lab.payment.bankName.max': 'Bank name is too long',
    'lab.payment.branch': 'Bank Branch',
    'lab.payment.branch.max': 'Branch details are too long',
    'lab.payment.no_accounts': 'No bank accounts',
    'lab.payment.no_transfer': 'No active transfer channels',
    'lab.payment.addTransfer': 'Add Transfer Channel',
    'lab.payment.editTransfer': 'Edit Transfer Channel',
    'lab.payment.channel': 'Transfer Channel',
    'lab.payment.deactivate': 'Deactivate',
    'lab.payment.channel.required': 'Please select a transfer channel',
    'lab.payment.phone.invalid': 'Invalid phone number',
    'lab.payment.transfer_title': 'Money Transfer',
    'lab.payment.activate': 'Activate',
    'lab.payment.activated': 'Activated',
    'lab.payment.deactivated': 'Deactivated',
    'ui.invoice.bank_account': 'Bank Account',
    'ui.invoice.bank_account_numbered': 'Bank Account {{n}}',
    'ui.invoice.bank_name': 'Bank Name',
    'ui.invoice.bank_swift': 'Swift Code',
    'ui.invoice.bank_iban': 'IBAN',
    'ui.invoice.account_holder': 'Account Holder',
    'ui.invoice.account_number': 'Account Number',
    'ui.invoice.vendor_payment_data': 'Vendor Payment Data',
    'ui.invoice.money_transfer_channels': 'Money Transfer Channels',
    'ui.invoice.channel.instapay': 'Instapay',
    'ui.invoice.channel.vodafone_cash': 'Vodafone Cash',
    'ui.invoice.channel.vodafone-cash': 'Vodafone Cash',
    'ui.invoice.channel.etisalat_cash': 'Etisalat Cash',
    'ui.invoice.channel.etisalat-cash': 'Etisalat Cash',
    'ui.invoice.channel.we_pay': 'WE Pay',
    'ui.invoice.channel.we-pay': 'WE Pay',
    'ui.invoice.channel.fawry': 'Fawry',
    'ui.invoice.channel.bank_transfer': 'Bank Transfer',
    'ui.invoice.channel.bank-transfer': 'Bank Transfer',
    'ui.invoice.channel.meeza': 'Meeza',
    'ui.invoice.channel.masary': 'Masary',

    // Enhanced Public Invoice UI
    'ui.invoice.view_title': 'Invoice',
    'ui.invoice.loading_details': 'Loading invoice details...',
    'ui.invoice.financial_summary': 'Financial Summary',
    
    'ui.invoice.payment_details': 'Payment & Bank Instructions',
    'ui.invoice.scan_qr_hint': 'Scan QR code to view and verify invoice online',
    'ui.invoice.copy_iban': 'Copy IBAN',
    'ui.invoice.copy_account': 'Copy Account Number',
    'ui.invoice.copy_number': 'Copy Number',
    'ui.invoice.copied': 'Copied to clipboard',
    'ui.invoice.public_disclaimer': 'This official dental laboratory invoice is provided for clinical and financial verification. No login required.',
    'ui.invoice.included_orders': 'Included Orders',
    'ui.invoice.orders_count': '{{count}} Orders',
    'ui.invoice.total_restorations': '{{count}} Restorations',
    'ui.invoice.paid_in_full': 'Paid in Full',
    'ui.invoice.remaining_balance': 'Remaining Due',
    'ui.invoice.billing_signoff': 'Billing Approval & Lab Sign-off',
    'ui.invoice.accountant_signature': 'Authorized Signature / Stamp',
    'ui.invoice.accountant_name': 'Prepared By',
    'ui.invoice.verification_date': 'Verification Date',
    'ui.invoice.channel_transfer_notice': 'Please reference the invoice number when submitting payments.',
    'ui.invoice.bank_details': 'Bank Details',
    'ui.invoice.no_bank_accounts': 'No bank account details provided.',
    'ui.invoice.no_transfer_channels': 'No money transfer channels provided.',
    'ui.invoice.balance_cleared': 'Balance Cleared',
    'ui.invoice.unpaid_balance_alert': 'Payment is pending. Please use the payment details below to settle.',
    'ui.invoice.past_due_alert': 'This invoice is past due. Please settle the remaining amount as soon as possible.',

    // Synced missing keys
    'activities.fields.formula_type': 'Formula type',
    'assets.title': 'Assets',
    'common.deleted': 'Deleted',
    'common.download_success': 'Downloaded successfully',
    'common.error': 'Something went wrong',
    'common.noAccess': 'You do not have access',
    'common.noData': 'No data',
    'common.popupBlocked': 'Popup blocked. Please allow popups for this site.',
    'common.unauthorized': 'Please log in',
    'errors.notFound': 'Not found',
    'errors.noViewPermission': 'You do not have permission to view this',
    'entity.generic': 'Record',
    'entity.notFound': '{entity} Not Found',
    'entity.notFoundDescription': '{entity} #{id} was not found.',
    'entity.notFoundHint': 'The record you are looking for does not exist or was removed.',
    'entity.backToList': 'Back to list',
    'entity.backToInvoices': 'Back to invoices',
    'entity.backToOrders': 'Back to orders',
    'entity.backToClients': 'Back to clients',
    'entity.backToDentists': 'Back to dentists',
    'entity.backToUsers': 'Back to users',
    'entity.order': 'Order',
    'entity.invoice': 'Invoice',
    'entity.client': 'Client',
    'entity.dentist': 'Dentist',
    'entity.user': 'User',
    'entity.wallet': 'Wallet',
    'home.no_data': 'No data',
    'home.tracker_description': 'Order tracking details',
    'invoices.pdf.client': 'Client',
    'invoices.pdf.dentist': 'Dentist',
    'lab.field.notes': 'Lab description',
    'orders.actions.noInvoiceAttached': 'No invoice attached to this order yet',
    'orders.actions.operationalBlocked': 'Operational actions are locked for this order',
    'orders.form.unitsCount.label': 'Units count',
    'orders.summary.discountDentistFormulaType': 'Dentist formula type discount',
    'orders.table.deliveryCost': 'Delivery cost',
    'orders.table.reference': 'Reference',
    'orders.update.section.invoicing': 'Invoice & Billing',
    'orders.update.section.quickActions': 'Quick Actions',
    'orders.update.section.workflow': 'Workflow & Operations',
    'responses.common.locale_updated': 'Language updated',
    'ui.invoice.money_transfer_channel': 'Money transfer channel',
    'ui.invoice.paid_at': 'Paid at',
    'ui.invoice.payment_method': 'Payment method',
    'ui.invoice.payment_method_cash_on_delivery': 'Cash on delivery',
    'ui.invoice.payment_method_credit_card': 'Credit card',
    'ui.invoice.payment_method_money_transfer': 'Bank transfer',
    'ui.invoice.payment_method_wallet': 'Wallet',
    'ui.invoice.public_link': 'View invoice',
    'ui.invoice.view_order': 'View order',
    'ui.order.dates_and_timeline': 'Timeline & Dates',
    'ui.order.formula_type': 'Formula type',

    // Subscription
    'subscription.title': 'Subscription',
    'subscription.loadError': 'Could not load subscription details',
    'subscription.adminOnly': 'Only lab admins can manage the subscription plan.',
    'subscription.currentPlan': 'Current plan',
    'subscription.noPlan': 'No subscription plan assigned.',
    'subscription.choosePlan': 'Choose a plan',
    'subscription.choosePlanHint': 'Request a paid plan. Our team will review your request and activate the new plan once approved.',
    'subscription.popular': 'Popular',
    'subscription.month': 'month',
    'subscription.current': 'Current plan',
    'subscription.requestPlan': 'Request plan',
    'subscription.requestConfirm': 'Send a request to switch to the {plan} plan?',
    'subscription.requestSubmitted': 'Plan change request sent. We will activate it once approved.',
    'subscription.requestError': 'Could not send the plan change request',
    'subscription.awaitingApproval': 'Awaiting approval',
    'subscription.requestPending': 'Your request to switch to the {plan} plan is awaiting approval.',
    'subscription.requestPendingHint': 'Your current plan stays active until our team approves the request.',
    'subscription.cancelRequest': 'Cancel request',
    'subscription.cancelRequestConfirm': 'Cancel this plan change request?',
    'subscription.requestCancelled': 'Plan change request cancelled',
    'subscription.requestCancelError': 'Could not cancel the plan change request',
    'subscription.requestRejected': 'Your request to switch to the {plan} plan was rejected.',
    'subscription.rejectionReason': 'Reason',
    'subscription.noPaidPlans': 'No paid plans are available right now.',
    'subscription.trialEndsAt': 'Trial ends',
    'subscription.trialActive': 'Free trial active — {days} day(s) remaining.',
    'subscription.trialEndingSoon': 'Your free trial ends in {days} day(s). Choose a plan to keep access.',
    'subscription.trialExpired': 'Your free trial has ended. Choose a plan to restore access.',
    'subscription.billing.trialing': 'Trialing',
    'subscription.billing.active': 'Active',
    'subscription.billing.past_due': 'Past due',
    'subscription.billing.cancelled': 'Cancelled',
    'subscription.billing.manual': 'Manual',
    'subscription.status.pending': 'Pending',
    'subscription.status.under_review': 'Under review',
    'subscription.status.active': 'Active',
    'subscription.status.suspended': 'Suspended',
    'subscription.status.cancelled': 'Cancelled',
    'subscription.status.rejected': 'Rejected',

    // Not Found
    'notFound.title': 'Page Not Found',
  },
  ar: {
    'common.add': 'إضافة',
    'common.addNew': 'إضافة جديد',
    'common.edit': 'تعديل',
    'common.update': 'تحديث',
    'common.delete': 'حذف',
    'common.remove': 'إزالة',
    'common.view': 'عرض',
    'common.hide': 'إخفاء',
    'common.viewOrders': 'عرض الطلبات',
    'common.viewInvoices': 'عرض الفواتير',
    'common.cancel': 'إلغاء',
    'common.optional': 'اختياري',
    'common.close': 'إغلاق',
    'common.details': 'التفاصيل',
    'common.openDetailsPage': 'فتح الصفحة الكاملة',
    'common.createdAt': 'تاريخ الإنشاء',
    'common.updatedAt': 'تاريخ التحديث',
    'common.actions': 'العمليات',
    'common.refresh': 'تحديث',
    'common.confirmDeleteTitle': 'حذف عنصر',
    'common.confirmDeleteMessage': 'هل تريد حذف هذا العنصر؟',
    'common.back': 'رجوع',
    'common.deleteConfirm': 'حذف',
    'common.added': 'مضاف',
    'common.zeroPlaceholder': '٠',
    'common.notes': 'ملاحظات',
    'common.phone': 'رقم التليفون',
    'common.whatsapp': 'رقم الواتساب',
    'common.address': 'العنوان',
    'common.email': 'البريد الإلكتروني',
    'common.subject': 'الموضوع',
    'common.required': 'هذا الحقل مطلوب',
    'common.confirm': 'تأكيد',
    'common.validationError': 'خطأ في التحقق',
    'api.errors.validation_error': 'خطأ في التحقق من البيانات',
    'api.errors.invalid_credentials': 'بيانات الدخول غير صحيحة',
    'api.errors.unauthenticated': 'غير مصرح لك',
    'api.errors.permission_denied': 'ليس لديك صلاحية القيام بهذا الإجراء',
    'api.errors.invalid_current_password': 'كلمة المرور الحالية غير صحيحة',
    'api.errors.login_identifier_required': 'يرجى إدخال بريد إلكتروني أو اسم مستخدم.',
    'api.errors.email_invalid': 'يرجى إدخال بريد إلكتروني صالح.',
    'api.errors.email_taken': 'هذا البريد الإلكتروني مسجل بالفعل.',
    'api.errors.username_taken': 'اسم المستخدم مستخدم بالفعل.',
    'api.errors.already_taken': 'هذه القيمة مستخدمة بالفعل.',
    'api.errors.backoffice_access_denied': 'لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.',
    'api.errors.vendor_portal_only': 'يجب تسجيل الدخول عبرصفحة دخول المعمل.',
    'api.errors.not_found': 'غير موجود',
    'api.errors.request_failed': 'حدث خطأ ما',
    'forms.whatsappSameAsPhone': 'الواتساب نفس رقم الهاتف',
    'forms.phone.placeholder': 'ادخل رقم الهاتف',
    'forms.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'forms.copyFromVendor.label': 'استخدام بيانات التواصل للمختبر',
    'forms.copyFromVendor.phone': 'هاتف المختبر',
    'forms.copyFromVendor.whatsapp': 'واتساب المختبر',
    'forms.copyFromVendor.address': 'عنوان المختبر',
    'forms.copyFromClient.label': 'استخدام بيانات التواصل للعميل',
    'forms.copyFromClient.phone': 'هاتف العميل',
    'forms.copyFromClient.whatsapp': 'واتساب العميل',
    'forms.copyFromClient.address': 'عنوان العميل',
    'common.clear': 'مسح',
    'common.resetFilters': 'إعادة تعيين عوامل التصفية',
    'common.filters': 'تصفية',
    'common.general': 'عام',
    'validation.name.required': 'الاسم مطلوب',
    'validation.name.min': 'يجب أن يكون الاسم حرفين على الأقل',
    'validation.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'validation.email.required': 'البريد الإلكتروني مطلوب',
    'validation.email.invalid': 'يرجى إدخال بريد إلكتروني صالح',
    'validation.email.max': 'يجب ألا يزيد البريد الإلكتروني عن 255 حرفًا',
    'validation.username.required': 'اسم المستخدم مطلوب',
    'validation.username.min': 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
    'validation.username.max': 'يجب ألا يزيد اسم المستخدم عن 50 حرفًا',
    'validation.username.invalid': 'اسم المستخدم يمكن أن يحتوي على حروف وأرقام ونقاط وشرطات سفلية وشرطات فقط',
    'validation.login.identifierRequired': 'أدخل بريدًا إلكترونيًا أو اسم مستخدم',
    'validation.phone.required': 'رقم الهاتف مطلوب',
    'validation.phone.invalid': 'يرجى إدخال رقم هاتف صالح',
    'validation.phone.max': 'يجب ألا يزيد رقم الهاتف عن 50 حرفًا',
    'validation.whatsapp.required': 'رقم الواتساب مطلوب',
    'validation.whatsapp.invalid': 'يرجى إدخال رقم واتساب صالح',
    'validation.whatsapp.max': 'يجب ألا يزيد رقم الواتساب عن 50 حرفًا',
    'common.loading': 'جاري التحميل...',
    'common.saved': 'تم الحفظ بنجاح',

    'sidebar.dashboard': 'الإحصائيات',
    'sidebar.reports': 'التقارير',
    'sidebar.month_summary': 'تقرير التحصيلات',
    'sidebar.collection_report': 'تقرير التحصيلات',
    'sidebar.revenue_report': 'تقرير الإيرادات',
    'sidebar.chart_of_accounts': 'دليل الحسابات',
    'sidebar.journal_entries': 'قيود اليومية',
    'accounting.noAccess': 'ليس لديك صلاحية الوصول إلى المحاسبة.',
    'accounting.debit': 'مدين',
    'accounting.credit': 'دائن',
    'accounting.balance': 'الرصيد',
    'accounting.error.load': 'تعذر تحميل بيانات المحاسبة.',
    'accounting.error.save': 'تعذر حفظ التغيير.',
    'accounting.type.all': 'الكل',
    'accounting.type.asset': 'الأصول',
    'accounting.type.liability': 'الالتزامات',
    'accounting.type.equity': 'حقوق الملكية',
    'accounting.type.revenue': 'الإيرادات',
    'accounting.type.expense': 'المصروفات',
    'accounting.source.order': 'الطلبات',
    'accounting.source.transaction': 'المدفوعات والمحافظ',
    'accounting.source.expense': 'المصروفات',
    'accounting.source.asset': 'الأصول',
    'accounting.source.manual': 'قيود يدوية',
    'accounting.tabs.accounts': 'الحسابات',
    'accounting.tabs.maps': 'قواعد الترحيل',
    'accounting.tabs.health': 'المطابقة',
    'accounting.tabs.events': 'الأحداث',
    'accounting.postingEvents.hint': 'كل عملية في النظام تُنشئ قيدًا يوميًا، والحسابات التي يُرحّل إليها كل طرف من القيد. الحسابات المربوطة تتبع تبويب "قواعد الترحيل"؛ والحسابات التي تُختار في العملية نفسها تظهر بخط مائل.',
    'accounting.postingEvents.editMaps': 'تعديل قواعد الترحيل',
    'accounting.postingEvents.search': 'ابحث في الأحداث أو الحسابات',
    'accounting.postingEvents.usedOnly': 'الأحداث التي لها قيود فقط',
    'accounting.postingEvents.event': 'الحدث',
    'accounting.postingEvents.lines': 'يُرحّل إلى',
    'accounting.postingEvents.activity': 'النشاط',
    'accounting.postingEvents.side.debit': 'مدين',
    'accounting.postingEvents.side.credit': 'دائن',
    'accounting.postingEvents.side.either': 'مدين / دائن',
    'accounting.postingEvents.entries': '{count} قيد',
    'accounting.postingEvents.lastEntry': 'آخر قيد: {date}',
    'accounting.postingEvents.noEntries': 'لا توجد قيود بعد',
    'accounting.postingEvents.notMapped': 'غير مربوط',
    'accounting.postingEvents.showMore': 'عرض {count} أخرى',
    'accounting.postingEvents.showLess': 'عرض أقل',
    'accounting.setup.enabled': 'الدفتر مفعّل',
    'accounting.setup.disabled': 'الدفتر متوقف',
    'accounting.setup.enable': 'تفعيل المحاسبة',
    'accounting.setup.disable': 'إيقاف',
    'accounting.setup.disableConfirm': 'إيقاف ترحيل العمليات الجديدة إلى الدفتر؟ ستبقى القيود الحالية.',
    'accounting.setup.resync': 'إعادة مزامنة الدفتر',
    'accounting.setup.disabledTitle': 'المحاسبة غير مفعّلة',
    'accounting.setup.disabledBody': 'عند التفعيل يتم ترحيل كل الطلبات والمدفوعات وحركات المحافظ والمصروفات والأصول الحالية إلى الدفتر (في الخلفية)، ثم يتحدث الدفتر تلقائياً.',
    'accounting.setup.running': 'جارٍ ترحيل السجلات الحالية إلى الدفتر…',
    'accounting.setup.starting': 'جارٍ البدء…',
    'accounting.setup.failed': 'لم تكتمل آخر مزامنة للدفتر',
    'accounting.setup.stale': 'توقفت المزامنة في الخلفية عن الاستجابة. شغّل إعادة المزامنة.',
    'accounting.setup.healthIssues': 'الدفتر لا يطابق العمليات بالكامل',
    'accounting.setup.healthIssuesBody': 'افتح تبويب المطابقة لمعرفة العملاء المختلفين.',
    'accounting.accounts.subtitle': 'الحسابات وأرصدتها وقواعد ترحيل عمليات المعمل إلى الدفتر',
    'accounting.accounts.countLabel': 'حساب',
    'accounting.accounts.add': 'إضافة حساب',
    'accounting.accounts.edit': 'تعديل الحساب',
    'accounting.accounts.code': 'الكود',
    'accounting.accounts.name': 'الحساب',
    'accounting.accounts.type': 'النوع',
    'accounting.accounts.parent': 'الحساب الرئيسي',
    'accounting.accounts.description': 'الوصف',
    'accounting.accounts.active': 'نشط',
    'accounting.accounts.inactive': 'غير نشط',
    'accounting.accounts.system': 'نظام',
    'accounting.accounts.systemHint': 'يُستخدم في الترحيل التلقائي: يمكن تغيير الكود والاسم، ولا يمكن تغيير النوع ويظل نشطاً.',
    'accounting.accounts.deleteConfirm': 'حذف هذا الحساب؟',
    'accounting.accounts.search': 'ابحث بالكود أو الاسم',
    'accounting.accounts.asOf': 'الأرصدة حتى تاريخ (اليوم)',
    'accounting.accounts.trialBalance': 'ميزان المراجعة',
    'accounting.maps.hint': 'اختر الحساب الذي تُرحّل إليه كل عملية. التغييرات تُطبّق على القيود الجديدة؛ شغّل "إعادة مزامنة الدفتر" لإعادة ترحيل السجل السابق بالحسابات الجديدة.',
    'accounting.maps.rule': 'العملية',
    'accounting.maps.account': 'تُرحّل إلى حساب',
    'accounting.maps.default': 'الافتراضي',
    'accounting.maps.isDefault': 'افتراضي',
    'accounting.maps.custom': 'مخصص',
    'accounting.maps.reset': 'استعادة',
    'accounting.maps.save': 'حفظ الربط',
    'accounting.maps.group.core': 'الطلبات والعملاء',
    'accounting.maps.group.payment_methods': 'طرق الدفع (تُحصّل في)',
    'accounting.maps.group.expenses': 'المصروفات',
    'accounting.maps.group.assets': 'الأصول',
    'accounting.health.run': 'تشغيل الفحص',
    'accounting.health.ok': 'متوازن',
    'accounting.health.issues': 'فروقات',
    'accounting.health.totalDebit': 'إجمالي المدين',
    'accounting.health.totalCredit': 'إجمالي الدائن',
    'accounting.health.trialBalance': 'ميزان المراجعة',
    'accounting.health.unbalanced': 'قيود غير متوازنة',
    'accounting.health.receivable': 'مديونيات العملاء مقابل الطلبات والمدفوعات',
    'accounting.health.receivableHint': 'لكل عميل: المديونية في الدفتر مقابل الطلبات المستحقة ناقص المدفوعات زائد المستردات.',
    'accounting.health.wallets': 'التزامات المحافظ مقابل أرصدة المحافظ',
    'accounting.health.walletsHint': 'لكل عميل: التزام المحفظة في الدفتر مقابل رصيد المحفظة.',
    'accounting.health.statement': 'مديونيات العملاء مقابل كشف الحساب',
    'accounting.health.statementHint': 'كشف الحساب يستبعد الطلبات المعلقة والمتنازع عليها ولا يظهر أقل من صفر، لذا الفروقات هنا متوقعة.',
    'accounting.health.informational': 'للعلم',
    'accounting.health.client': 'العميل',
    'accounting.health.noClient': 'بدون عميل',
    'accounting.health.ledger': 'الدفتر',
    'accounting.health.operations': 'العمليات',
    'accounting.health.wallet_balance': 'رصيد المحفظة',
    'accounting.health.statement_col': 'كشف الحساب',
    'accounting.health.difference': 'الفرق',
    'accounting.health.noDifferences': 'لا توجد فروقات',
    'accounting.journal.subtitle': 'كل ما رُحّل إلى الدفتر من العمليات والقيود اليدوية',
    'accounting.journal.countLabel': 'قيد',
    'accounting.journal.newEntry': 'قيد يومية جديد',
    'accounting.journal.entry': 'قيد يومية',
    'accounting.journal.number': 'رقم القيد',
    'accounting.journal.date': 'التاريخ',
    'accounting.journal.event': 'العملية',
    'accounting.journal.source': 'المصدر',
    'accounting.journal.reference': 'المرجع',
    'accounting.journal.memo': 'البيان',
    'accounting.journal.amount': 'المبلغ',
    'accounting.journal.statusLabel': 'الحالة',
    'accounting.journal.status.draft': 'مسودة',
    'accounting.journal.status.posted': 'مرحّل',
    'accounting.journal.status.reversed': 'معكوس',
    'accounting.journal.status.reversal': 'قيد عكسي',
    'accounting.journal.account': 'الحساب',
    'accounting.journal.details': 'التفاصيل',
    'accounting.journal.invoice': 'فاتورة',
    'accounting.journal.total': 'الإجمالي',
    'accounting.journal.filteredTotal': 'إجمالي القيود المعروضة',
    'accounting.journal.post': 'ترحيل',
    'accounting.journal.saveDraft': 'حفظ كمسودة',
    'accounting.journal.void': 'إلغاء',
    'accounting.journal.voidConfirm': 'إلغاء هذا القيد؟ سيتم ترحيل قيد عكسي.',
    'accounting.journal.deleteConfirm': 'حذف هذه المسودة؟',
    'accounting.journal.revision': 'تعديل {n}',
    'accounting.journal.reverses': 'يعكس',
    'accounting.journal.reversedBy': 'عُكس بواسطة',
    'accounting.journal.createdBy': 'أنشأه',
    'accounting.journal.system': 'النظام',
    'accounting.journal.automaticTitle': 'قيد تلقائي',
    'accounting.journal.automaticHint': 'تم إنشاء هذا القيد من {source}. لا يمكن حذفه أو إلغاؤه من هنا: احذف أو عدّل المصدر وسيتم عكس القيد تلقائيًا.',
    'accounting.journal.openSource': 'فتح المصدر',
    'accounting.journal.postedAt': 'تاريخ الترحيل',
    'accounting.journal.search': 'رقم القيد أو المرجع أو البيان',
    'accounting.journal.hideReversed': 'إخفاء القيود المعكوسة وقيودها العكسية',
    'accounting.journal.addLine': 'إضافة سطر',
    'accounting.journal.lineDescription': 'وصف السطر',
    'accounting.journal.accountRequired': 'اختر حساباً',
    'accounting.journal.difference': 'الفرق',
    'accounting.journal.tax': 'الضريبة',
    'accounting.journal.taxLine': 'ضريبة',
    'accounting.journal.taxBase': 'وعاء الضريبة: {{amount}}',
    'accounting.journal.taxedWith': 'خاضع لـ: {{tax}}',
    'accounting.journal.taxTotal': 'إجمالي الضريبة',
    'accounting.journal.taxHint': 'تُضاف سطور الضريبة تلقائياً على حساب الضريبة المناسب عند حفظ القيد.',
    'accounting.journal.withTax': 'القيود التي بها ضريبة فقط',
    'accounting.journal.disabledHint': 'لن تُرحّل العمليات الجديدة حتى يتم تفعيل المحاسبة من صفحة دليل الحسابات.',
    'sidebar.cash_bank': 'النقدية والبنوك',
    'sidebar.suppliers': 'الموردون',
    'sidebar.supplier_bills': 'فواتير الموردين',
    'sidebar.aging_reports': 'أعمار الديون',
    'accounting.source.cash_account': 'الأرصدة الافتتاحية',
    'accounting.source.cash_transfer': 'التحويلات',
    'accounting.source.bill': 'فواتير الموردين',
    'accounting.source.bill_payment': 'مدفوعات الموردين',
    'accounting.maps.group.suppliers': 'الموردون',
    'accounting.maps.group.cash': 'النقدية والبنوك',
    'accounting.health.payables': 'مستحقات الموردين مقابل الفواتير والمدفوعات',
    'accounting.health.payablesHint': 'لكل مورد: الرصيد الدائن في الدفاتر مقابل الفواتير غير المدفوعة ناقص الدفعات غير الموزعة.',
    'accounting.health.supplier': 'المورد',
    'accounting.health.bills_col': 'الفواتير − المدفوعات',
    'accounting.deposit.placeholder': 'الحساب الافتراضي',
    'accounting.deposit.defaultPlaceholder': 'الافتراضي: {name}',
    'accounting.cash.subtitle': 'الخزائن والحسابات البنكية وقنوات التحويل وأرصدتها من الدفاتر',
    'accounting.cash.countLabel': 'حساب',
    'accounting.cash.add': 'إضافة حساب',
    'accounting.cash.edit': 'تعديل الحساب',
    'accounting.cash.name': 'الحساب',
    'accounting.cash.namePlaceholder': 'مثال: خزينة الاستقبال، حساب البنك الجاري',
    'accounting.cash.nameRequired': 'أدخل الاسم',
    'accounting.cash.type': 'النوع',
    'accounting.cash.types.cash': 'نقدية',
    'accounting.cash.types.bank': 'بنك',
    'accounting.cash.types.transfer': 'قناة تحويل',
    'accounting.cash.typesPlural.cash': 'النقدية',
    'accounting.cash.typesPlural.bank': 'البنوك',
    'accounting.cash.typesPlural.transfer': 'قنوات التحويل',
    'accounting.cash.bankDetails': 'بيانات البنك',
    'accounting.cash.bankDetailsHint': 'اربط أحد الحسابات البنكية من إعدادات الدفع (اختياري).',
    'accounting.cash.openingBalance': 'الرصيد الافتتاحي',
    'accounting.cash.openingDate': 'تاريخ الرصيد الافتتاحي',
    'accounting.cash.openingDateHint': 'اتركه فارغاً لاستخدام تاريخ إنشاء الحساب.',
    'accounting.cash.receives': 'يستقبل مدفوعات العملاء عن طريق',
    'accounting.cash.receivesHint': 'المدفوعات بهذه الطرق تودع هنا ما لم يتم اختيار حساب آخر عند الدفع.',
    'accounting.cash.methods.cash_on_delivery': 'الدفع عند الاستلام',
    'accounting.cash.methods.money_transfer': 'تحويل مالي',
    'accounting.cash.methods.credit_card': 'بطاقة ائتمان',
    'accounting.cash.expenseDefault': 'يدفع المصروفات افتراضياً',
    'accounting.cash.expenseDefaultHint': 'المصروفات اليدوية التي لم يحدد لها حساب "مدفوع من" تُدفع من هنا.',
    'accounting.cash.paysExpenses': 'يدفع المصروفات',
    'accounting.cash.active': 'نشط',
    'accounting.cash.defaults': 'يُستخدم افتراضياً لـ',
    'accounting.cash.moneyIn': 'وارد',
    'accounting.cash.moneyOut': 'صادر',
    'accounting.cash.movements': 'الحركات',
    'accounting.cash.opening': 'الرصيد الافتتاحي',
    'accounting.cash.closing': 'الرصيد الختامي',
    'accounting.cash.totalBalance': 'إجمالي الرصيد',
    'accounting.cash.showInactive': 'إظهار غير النشط',
    'accounting.cash.deleteConfirm': 'حذف هذا الحساب؟',
    'accounting.cash.disabledHint': 'الأرصدة والحركات تأتي من الدفاتر. فعّل المحاسبة من صفحة دليل الحسابات لعرضها.',
    'accounting.cash.tabs.accounts': 'الحسابات',
    'accounting.cash.tabs.transfers': 'التحويلات',
    'accounting.cash.transfer': 'تحويل أموال',
    'accounting.cash.from': 'من',
    'accounting.cash.to': 'إلى',
    'accounting.cash.sameAccount': 'اختر حساباً مختلفاً',
    'accounting.cash.amount': 'المبلغ',
    'accounting.cash.date': 'التاريخ',
    'accounting.cash.reference': 'المرجع',
    'accounting.cash.operation': 'العملية',
    'accounting.cash.counterparty': 'الطرف المقابل',
    'accounting.cash.deleteTransferConfirm': 'حذف هذا التحويل؟ سيتم عكس قيده في الدفاتر.',
    'accounting.suppliers.subtitle': 'من تشتري منهم، وما تدين لهم به، وكشوف حساباتهم',
    'accounting.suppliers.countLabel': 'مورد',
    'accounting.suppliers.add': 'إضافة مورد',
    'accounting.suppliers.edit': 'تعديل المورد',
    'accounting.suppliers.name': 'المورد',
    'accounting.suppliers.nameRequired': 'أدخل اسم المورد',
    'accounting.suppliers.terms': 'مدة السداد',
    'accounting.suppliers.termsHint': 'عدد الأيام حتى استحقاق الفاتورة (يحدد تاريخ الاستحقاق للفواتير الجديدة).',
    'accounting.suppliers.termsValue': '{n} يوم',
    'accounting.suppliers.days': 'يوم',
    'accounting.suppliers.taxNumber': 'الرقم الضريبي',
    'accounting.suppliers.search': 'الاسم أو الهاتف أو البريد أو الرقم الضريبي',
    'accounting.suppliers.onlyWithBalance': 'الموردون الذين لديهم رصيد فقط',
    'accounting.suppliers.openBills': 'فواتير مفتوحة',
    'accounting.suppliers.totalBilled': 'إجمالي الفواتير',
    'accounting.suppliers.outstanding': 'المستحق',
    'accounting.suppliers.overdue': 'متأخر السداد',
    'accounting.suppliers.credit': 'رصيد دائن غير موزع',
    'accounting.suppliers.statement': 'كشف الحساب',
    'accounting.suppliers.deleteConfirm': 'حذف هذا المورد؟',
    'accounting.suppliers.document': 'المستند',
    'accounting.suppliers.docType.bill': 'فاتورة',
    'accounting.suppliers.docType.payment': 'دفعة',
    'accounting.suppliers.billed': 'الفواتير',
    'accounting.suppliers.paid': 'المدفوع',
    'accounting.bills.subtitle': 'فواتير الموردين والمدفوعات التي تسددها',
    'accounting.bills.tabs.bills': 'الفواتير',
    'accounting.bills.tabs.payments': 'المدفوعات',
    'accounting.bills.add': 'فاتورة جديدة',
    'accounting.bills.edit': 'تعديل الفاتورة',
    'accounting.bills.bill': 'فاتورة',
    'accounting.bills.number': 'رقم الفاتورة',
    'accounting.bills.supplier': 'المورد',
    'accounting.bills.supplierRequired': 'اختر المورد',
    'accounting.bills.supplierReference': 'رقم فاتورة المورد',
    'accounting.bills.supplierReferencePlaceholder': 'الرقم المطبوع على فاتورتهم',
    'accounting.bills.billDate': 'تاريخ الفاتورة',
    'accounting.bills.dueDate': 'تاريخ الاستحقاق',
    'accounting.bills.dueFromTerms': 'اتركه فارغاً لاستخدام مدة سداد المورد: {date}',
    'accounting.bills.category': 'نوع المصروف أو الحساب',
    'accounting.bills.expenseAccount': 'حساب المصروف',
    'accounting.bills.categoryRequired': 'اختر بند هذا السطر',
    'accounting.bills.expenseTypes': 'أنواع المصروفات',
    'accounting.bills.ledgerAccounts': 'حسابات الدفاتر',
    'accounting.bills.lineDescription': 'الوصف',
    'accounting.bills.quantity': 'الكمية',
    'accounting.bills.unitPrice': 'سعر الوحدة',
    'accounting.bills.total': 'الإجمالي',
    'accounting.bills.paid': 'المدفوع',
    'accounting.bills.paidOnBill': 'المدفوع على هذه الفاتورة',
    'accounting.bills.ofPayment': 'من دفعة بقيمة {amount}',
    'accounting.bills.remaining': 'المتبقي',
    'accounting.bills.search': 'رقم الفاتورة أو رقم فاتورة المورد أو الملاحظات',
    'accounting.bills.status.label': 'الحالة',
    'accounting.bills.status.open': 'مفتوحة',
    'accounting.bills.status.partially_paid': 'مدفوعة جزئياً',
    'accounting.bills.status.paid': 'مدفوعة',
    'accounting.bills.status.void': 'ملغاة',
    'accounting.bills.status.draft': 'مسودة',
    'accounting.bills.accountingDate': 'تاريخ القيد',
    'accounting.bills.accountingDateHint': 'اختياري: يُرحّل القيد بهذا التاريخ بدلاً من تاريخ الفاتورة.',
    'accounting.bills.approve': 'اعتماد',
    'accounting.bills.approveConfirm': 'اعتماد هذه الفاتورة؟ سيتم ترحيلها إلى الدفاتر واستلام أصناف المخزون فيها.',
    'accounting.bills.approvedBy': 'اعتمدها',
    'accounting.bills.audit': 'السجل',
    'accounting.bills.attachments.label': 'المرفقات',
    'accounting.bills.attachments.hint': 'فاتورة المورد أو الإيصالات أو الصور. حتى 20 ميجابايت لكل ملف.',
    'accounting.bills.attachments.choose': 'إرفاق ملفات أو صور',
    'accounting.bills.attachments.tooLarge': 'حجم هذا الملف أكبر من 20 ميجابايت.',
    'accounting.bills.attachments.deleteConfirm': 'حذف هذا المرفق؟',
    'accounting.bills.attachments.deleteFailed': 'تعذّر حذف المرفق.',
    'accounting.bills.attachments.uploadFailed': 'تم حفظ الفاتورة، لكن تعذّر رفع الملفات.',
    'accounting.bills.discount': 'الخصم',
    'accounting.bills.draftHint': 'هذه الفاتورة مسودة: غير مستحقة ولم تُرحّل إلى الدفاتر ولم يُستلم أي مخزون بعد.',
    'accounting.bills.draftsWaiting': '{n} فاتورة مسودة بانتظار الاعتماد.',
    'accounting.bills.showDrafts': 'عرض المسودات',
    'accounting.bills.entry.accountingOff': 'المحاسبة غير مفعلة، لذلك لا يتم ترحيل أي قيد.',
    'accounting.bills.entry.onApproval': 'يُرحّل عند اعتماد الفاتورة.',
    'accounting.bills.lineType.label': 'نوع البند',
    'accounting.bills.lineType.expense': 'مصروف',
    'accounting.bills.lineType.inventory': 'صنف مخزون',
    'accounting.bills.lineType.production': 'إنتاج',
    'accounting.bills.lineType.asset': 'أصل ثابت',
    'accounting.bills.noStockItems': 'لا توجد أصناف مخزون بعد. أضفها من صفحة المخزون.',
    'accounting.bills.noStockItemsCreate': 'لا توجد أصناف مخزون بعد. أنشئ صنفًا من الأسفل.',
    'accounting.bills.newStockItem': 'صنف مخزون جديد',
    'accounting.bills.manageStockItems': 'إدارة أصناف المخزون',
    'accounting.bills.printTitle': 'فاتورة مورد',
    'accounting.bills.printedAt': 'طُبعت في {date}',
    'accounting.bills.currency': 'العملة',
    'accounting.bills.saveApprove': 'حفظ واعتماد',
    'accounting.bills.saveDraft': 'حفظ كمسودة',
    'accounting.bills.stockItem': 'صنف المخزون',
    'accounting.bills.stockItemRequired': 'اختر صنف المخزون',
    'accounting.bills.debitAccount': 'الحساب المدين',
    'accounting.bills.stockAccountHint': 'يُحمّل المخزون على حساب المخزون الخاص بالصنف (المخزون / الخامات ما لم يكن للصنف حساب خاص). يمكن تغييره من الصنف في صفحة المخزون.',
    'accounting.bills.stockMovements': 'المخزون المستلم',
    'accounting.bills.tabs.summary': 'المشتريات مقابل التكاليف',
    'accounting.bills.summary.hint': 'المشتريات هي ما اشترته الفواتير المعتمدة خلال الفترة. التكاليف هي ما أثبتته الدفاتر: يصبح المخزون تكلفة عند استخدامه (وفي الإنتاج تحت التشغيل عند فوترة الطلب الذي صُرف له). فواتير الموردين لا تُربط بالطلبات أبداً.',
    'accounting.bills.summary.purchases': 'المشتريات حسب النوع',
    'accounting.bills.summary.recognized': 'المُثبت في الدفاتر',
    'accounting.bills.summary.bills': 'الفواتير',
    'accounting.bills.summary.net': 'الصافي',
    'accounting.bills.summary.revenue': 'الإيرادات',
    'accounting.bills.summary.directCosts': 'التكاليف المباشرة',
    'accounting.bills.summary.grossProfit': 'مجمل الربح',
    'accounting.bills.summary.grossMargin': 'هامش مجمل الربح',
    'accounting.bills.taxNotRecoverable': 'غير قابلة للاسترداد',
    'accounting.bills.taxNotRecoverableHint': 'لا يمكن استرداد هذه الضريبة، لذلك تُضاف إلى تكلفة البند.',
    'accounting.postedEntries.empty': 'لا توجد قيود يومية.',
    'accounting.postedEntries.reversal': 'قيد عكسي',
    'accounting.postedEntries.reversed': 'معكوس',
    'accounting.costing.productionFlow': 'تكاليف الإنتاج',
    'accounting.costing.productionFlows.direct': 'تحميل مباشر على المصروفات',
    'accounting.costing.productionFlows.wip': 'إنتاج تحت التشغيل',
    'accounting.costing.productionFlowHints.direct': 'الخامات المصروفة لطلب تُحمّل على المصروفات عند صرفها.',
    'accounting.costing.productionFlowHints.wip': 'الخامات المصروفة لطلب تُحتجز في الإنتاج تحت التشغيل وتُنقل إلى تكلفة المبيعات عند وصول الطلب لحالة الفوترة. تغيير هذا الإعداد يعيد ترحيل القيود السابقة.',
    'accounting.costing.orderCost.title': 'تكلفة الإنتاج',
    'accounting.costing.orderCost.open': 'تفاصيل تكلفة الإنتاج',
    'accounting.costing.orderCost.released': 'حُمّلت على تكلفة المبيعات بتاريخ',
    'accounting.costing.orderCost.notReleased': 'ما زالت تحت التشغيل (لم يُفوتر الطلب بعد)',
    'accounting.costing.orderCost.wip': 'تحت التشغيل',
    'accounting.costing.orderCost.recognized': 'التكاليف المُثبتة',
    'accounting.costing.orderCost.grossProfit': 'مجمل الربح',
    'accounting.costing.orderCost.sources': 'تكاليف هذا الطلب',
    'accounting.costing.orderCost.source': 'المصدر',
    'accounting.costing.orderCost.sourceTypes.stock_movement': 'صرف مخزون',
    'accounting.costing.orderCost.productionCost': 'تكلفة الإنتاج',
    'accounting.costing.orderCost.noSources': 'لا توجد تكاليف مسجلة لهذا الطلب.',
    'accounting.costing.orderCost.ledger': 'المُرحّل في الدفاتر',
    'accounting.costing.orderCost.noLedger': 'لم يُرحّل شيء لهذا الطلب بعد.',
    'accounting.costing.orderCost.section': 'القسم',
    'accounting.costing.orderCost.sections.revenue': 'الإيرادات',
    'accounting.costing.orderCost.sections.work_in_progress': 'تحت التشغيل',
    'accounting.costing.orderCost.sections.cost': 'التكلفة',
    'accounting.costing.orderCost.sections.formula_cost': 'تكلفة مبيعات التركيبة (تقديرية)',
    'accounting.inventory.subtitle': 'أصناف المخزون والحركات والتقييم',
    'accounting.inventory.receiptsFromBills': 'يُستلم المخزون باعتماد فاتورة مورد تحتوي على بنود أصناف مخزون. يتم تسجيل الصرف والتسويات ومرتجعات الموردين هنا.',
    'accounting.inventory.tabs.items': 'الأصناف',
    'accounting.inventory.tabs.movements': 'الحركات',
    'accounting.inventory.tabs.valuation': 'التقييم',
    'accounting.inventory.addItem': 'إضافة صنف مخزون',
    'accounting.inventory.editItem': 'تعديل صنف المخزون',
    'accounting.inventory.item': 'الصنف',
    'accounting.inventory.items': 'الأصناف',
    'accounting.inventory.itemName': 'الاسم',
    'accounting.inventory.sku': 'الكود',
    'accounting.inventory.unit': 'الوحدة',
    'accounting.inventory.unitPlaceholder': 'قطعة، جم، مل…',
    'accounting.inventory.account': 'حساب المخزون',
    'accounting.inventory.accountHint': 'اتركه فارغاً لاستخدام حساب المخزون الافتراضي.',
    'accounting.inventory.accountLocked': 'لا يمكن تغيير الحساب بعد وجود حركات مخزون للصنف.',
    'accounting.inventory.defaultAccount': 'الافتراضي',
    'accounting.inventory.reorderLevel': 'حد إعادة الطلب',
    'accounting.inventory.active': 'نشط',
    'accounting.inventory.inactive': 'غير نشط',
    'accounting.inventory.belowReorder': 'أقل من حد إعادة الطلب',
    'accounting.inventory.showInactive': 'عرض غير النشط',
    'accounting.inventory.searchItems': 'ابحث بالاسم أو الكود',
    'accounting.inventory.searchMovements': 'ابحث في الحركات',
    'accounting.inventory.onHandQty': 'الرصيد',
    'accounting.inventory.averageCost': 'متوسط التكلفة',
    'accounting.inventory.value': 'القيمة',
    'accounting.inventory.stockValue': 'قيمة المخزون',
    'accounting.inventory.noItems': 'لا توجد أصناف مخزون.',
    'accounting.inventory.noMovements': 'لا توجد حركات مخزون.',
    'accounting.inventory.deleteConfirm': 'حذف هذا الصنف؟ الأصناف التي لها حركات يتم إيقافها بدلاً من حذفها.',
    'accounting.inventory.recordMovement': 'تسجيل حركة',
    'accounting.inventory.movement': 'حركة مخزون',
    'accounting.inventory.number': 'الرقم',
    'accounting.inventory.type': 'النوع',
    'accounting.inventory.movementType.receipt': 'استلام',
    'accounting.inventory.movementType.issue': 'صرف',
    'accounting.inventory.movementType.adjustment': 'تسوية',
    'accounting.inventory.movementType.supplier_return': 'مرتجع لمورد',
    'accounting.inventory.typeHint.issue': 'يصرف المخزون بمتوسط التكلفة إلى الطلب (تحت التشغيل أو مصروف خامات).',
    'accounting.inventory.typeHint.adjustment': 'يصحح المخزون بعد جرد أو تلف أو فقد. يُرحّل على حساب تسويات المخزون.',
    'accounting.inventory.typeHint.supplier_return': 'يرجع المخزون إلى المورد ويخفض المستحق له.',
    'accounting.inventory.counter': 'حركة عكسية',
    'accounting.inventory.voided': 'ملغاة',
    'accounting.inventory.quantity': 'الكمية',
    'accounting.inventory.unitCost': 'تكلفة الوحدة',
    'accounting.inventory.unitCostHint': 'اتركه فارغاً لاستخدام متوسط التكلفة الحالي.',
    'accounting.inventory.direction': 'الاتجاه',
    'accounting.inventory.increase': 'إضافة مخزون',
    'accounting.inventory.decrease': 'خصم مخزون',
    'accounting.inventory.reason': 'السبب',
    'accounting.inventory.reasons.count': 'جرد',
    'accounting.inventory.reasons.damage': 'تالف',
    'accounting.inventory.reasons.expiry': 'منتهي الصلاحية',
    'accounting.inventory.reasons.loss': 'مفقود',
    'accounting.inventory.reasons.found': 'زيادة جرد',
    'accounting.inventory.reasons.opening': 'رصيد افتتاحي',
    'accounting.inventory.reasons.other': 'أخرى',
    'accounting.inventory.order': 'الطلب',
    'accounting.inventory.orderHint': 'اختياري: الطلب الذي استُخدمت فيه الخامات (يُحمّل على مصروف الخامات).',
    'accounting.inventory.orderWipHint': 'اختياري: يُحتجز تحت التشغيل للطلب حتى فوترته.',
    'accounting.inventory.originalBill': 'الفاتورة الأصلية',
    'accounting.inventory.creditAmount': 'رصيد المورد الدائن',
    'accounting.inventory.creditAmountHint': 'المبلغ الذي يخصمه المورد لك. اتركه فارغاً لقيمة المخزون؛ أي فرق يذهب إلى فروق أسعار الشراء.',
    'accounting.inventory.returnCurrencyHint': 'الموردون الذين يصدرون فواتيرهم بعملتك فقط.',
    'accounting.inventory.onHand': 'الرصيد: {qty} · متوسط التكلفة {cost}',
    'accounting.inventory.estimatedValue': 'القيمة التقديرية: {value}',
    'accounting.inventory.estimatedAll': 'يصرف كل الرصيد المتبقي (حوالي {value}).',
    'accounting.inventory.reference': 'المرجع',
    'accounting.inventory.void': 'إلغاء',
    'accounting.inventory.voidConfirm': 'إلغاء هذه الحركة؟ سيتم تسجيل حركة عكسية بتاريخ اليوم وعكس قيدها.',
    'accounting.inventory.receiptHint': 'حركات الاستلام تتبع فاتورة المورد: عدّل الفاتورة أو ألغها لتغييرها.',
    'accounting.inventory.receiptNoEntry': 'يُرحّل الاستلام من خلال فاتورة المورد.',
    'accounting.inventory.asOf': 'في تاريخ',
    'accounting.inventory.itemsValue': 'قيمة الأصناف',
    'accounting.inventory.ledgerBalance': 'رصيد الدفاتر',
    'accounting.inventory.valueOnly': 'غير متابع بالأصناف',
    'accounting.inventory.valueOnlyHint': 'مخزون مُرحّل بدون أصناف (تكاليف خامات المعادلات، الجرد، القيود اليدوية).',
    'accounting.inventory.byItem': 'حسب الصنف',
    'accounting.inventory.byAccount': 'حسب حساب المخزون',
    'accounting.tax.input_recoverable': 'قابلة للاسترداد على المشتريات',
    'accounting.tax.input_recoverable_hint': 'عند إيقافها، تُضاف هذه الضريبة في فواتير الموردين إلى التكلفة بدلاً من حساب ضريبة المدخلات القابلة للاسترداد.',
    'accounting.tax.not_recoverable': 'غير قابلة للاسترداد',
    'accounting.bills.status.unpaid': 'غير مدفوعة (مفتوحة + جزئية)',
    'accounting.bills.status.overdue': 'متأخرة',
    'accounting.bills.overdueDays': 'متأخرة {n} يوم',
    'accounting.bills.void': 'إلغاء',
    'accounting.bills.voidConfirm': 'إلغاء هذه الفاتورة؟ سيتم عكس قيدها في الدفاتر.',
    'accounting.bills.deleteConfirm': 'حذف هذه الفاتورة؟',
    'accounting.bills.payments': 'المدفوعات',
    'accounting.bills.noPayments': 'لا توجد مدفوعات بعد',
    'accounting.bills.noSuppliers': 'أضف مورداً أولاً من صفحة الموردين.',
    'accounting.payments.add': 'دفع لمورد',
    'accounting.payments.edit': 'تعديل الدفعة',
    'accounting.payments.number': 'رقم الدفعة',
    'accounting.payments.paidFrom': 'مدفوع من',
    'accounting.payments.reference': 'المرجع',
    'accounting.payments.referencePlaceholder': 'رقم الشيك أو التحويل',
    'accounting.payments.allocation': 'التوزيع على الفواتير',
    'accounting.payments.autoAllocate': 'الأقدم أولاً',
    'accounting.payments.allocate': 'المبلغ الموزع',
    'accounting.payments.allocated': 'موزع على الفواتير',
    'accounting.payments.unallocated': 'غير موزع',
    'accounting.payments.unallocatedHint': 'المبلغ غير الموزع يبقى رصيداً دائناً لدى المورد ويمكن توزيعه على فواتير لاحقة.',
    'accounting.payments.overAllocated': 'المبالغ الموزعة على الفواتير أكبر من مبلغ الدفعة.',
    'accounting.payments.noOpenBills': 'لا توجد فواتير غير مدفوعة لهذا المورد',
    'accounting.payments.pickSupplier': 'اختر مورداً لعرض فواتيره غير المدفوعة',
    'accounting.payments.deleteConfirm': 'حذف هذه الدفعة؟ ستعود الفواتير التي سددتها غير مدفوعة.',
    'accounting.payments.totalPaid': 'إجمالي المدفوع',
    'accounting.aging.subtitle': 'مدة استحقاق المبالغ لدى العملاء والموردين',
    'accounting.aging.receivables': 'مستحقات العملاء',
    'accounting.aging.payables': 'مستحقات الموردين',
    'accounting.aging.receivablesHint': 'الطلبات غير المدفوعة حتى {date}. الطلبات المستحقة محسوبة من يوم وصولها إلى حالة الاستحقاق، والإجمالي يطابق رصيد العميل. الطلبات التي لم تصل إلى حالة الاستحقاق بعد تظهر تحت "لم يستحق بعد" ولا تُحسب في الإجمالي.',
    'accounting.aging.payablesHint': 'فواتير الموردين غير المدفوعة حتى {date}، محسوبة من تاريخ استحقاقها.',
    'accounting.aging.buckets.current': 'لم يستحق بعد',
    'accounting.aging.buckets.1_30': '1–30 يوم',
    'accounting.aging.buckets.31_60': '31–60 يوم',
    'accounting.aging.buckets.61_90': '61–90 يوم',
    'accounting.aging.buckets.over_90': 'أكثر من 90 يوم',
    'accounting.aging.total': 'الإجمالي',
    'accounting.aging.client': 'العميل',
    'accounting.aging.supplier': 'المورد',
    'accounting.aging.oldestDue': 'أقدم استحقاق',
    'accounting.aging.order': 'الطلب',
    'accounting.aging.invoice': 'الفاتورة',
    'accounting.aging.notInvoiced': 'بدون فاتورة',
    'accounting.aging.dueDate': 'تاريخ الاستحقاق',
    'accounting.aging.age': 'العمر',
    'accounting.aging.daysOverdue': 'متأخر {n} يوم',
    'accounting.aging.dueToday': 'مستحق اليوم',
    'accounting.aging.outstanding': 'المستحق',
    'accounting.aging.net': 'صافي المستحق',
    'accounting.aging.refresh': 'تحديث',
    'sidebar.financial_reports': 'التقارير المالية',
    'sidebar.bank_reconciliation': 'التسوية البنكية',
    'sidebar.period_close': 'إقفال الفترات',
    'sidebar.technician_settlements': 'تسويات الفنيين',
    'sidebar.salaries': 'الرواتب',
    'sidebar.lab_costing': 'تكاليف المعمل',
    'sidebar.inventory': 'المخزون',
    'sidebar.tax': 'الضرائب',
    'sidebar.financial_insights': 'المؤشرات المالية',
    'sidebar.finance_group_sales': 'المبيعات',
    'sidebar.finance_group_expenses': 'المصروفات والموردون',
    'sidebar.finance_group_cash_bank': 'النقدية والبنوك',
    'sidebar.finance_group_accounting': 'المحاسبة',
    'sidebar.finance_group_reports': 'التقارير والمؤشرات',
    'accounting.maps.group.tax': 'الضرائب',
    'accounting.maps.group.currency': 'العملات الأجنبية',
    'accounting.source.fx_revaluation': 'إعادة تقييم العملات',
    'accounting.export.button': 'تصدير',
    'accounting.export.csv': 'CSV',
    'accounting.export.excel': 'Excel',
    'accounting.reports.tabs.subsidiary_ledger': 'الأستاذ المساعد',
    'accounting.reports.gl.partyFilter': '{type}: {name}',
    'accounting.reports.sub.pickAccount': 'اختر حساب المراقبة',
    'accounting.reports.sub.pickAccountHint': 'اختر حساب مراقبة (العملاء، الموردين، الفنيين…) أو حسابًا رئيسيًا لعرض رصيد كل طرف أو حساب فرعي تحته.',
    'accounting.reports.sub.byParty': 'حسب الطرف',
    'accounting.reports.sub.byAccount': 'حسب الحساب الفرعي',
    'accounting.reports.sub.search': 'بحث بالاسم',
    'accounting.reports.sub.party': 'الطرف',
    'accounting.reports.sub.opening': 'الرصيد الافتتاحي',
    'accounting.reports.sub.closing': 'الرصيد الختامي',
    'accounting.reports.sub.foreign': 'الرصيد بالعملة الأجنبية',
    'accounting.reports.sub.lastActivity': 'آخر حركة',
    'accounting.reports.sub.total': 'الإجمالي ({count})',
    'accounting.reports.sub.unassigned': 'غير مرتبط بطرف',
    'accounting.reports.sub.unassignedHint': '{amount} من هذا الحساب غير مرتبط بأي طرف. افتح الصف لمراجعة هذه القيود.',
    'accounting.reports.sub.partyTypes.client': 'عميل',
    'accounting.reports.sub.partyTypes.supplier': 'مورد',
    'accounting.reports.sub.partyTypes.user': 'فني',
    'accounting.reports.sub.partyTypes.none': 'بدون طرف',
    'accounting.cash.amountIn': 'المبلغ ({currency})',
    'accounting.cash.receivedIn': 'المبلغ المستلم ({currency})',
    'accounting.cash.receivedBase': 'المبلغ المستلم (العملة الأساسية)',
    'accounting.cash.receivedHint': 'الحسابان بعملتين مختلفتين. أدخل المبلغ الذي وصل فعلًا، أو اتركه فارغًا للتحويل بسعر اليوم.',
    'accounting.bills.exchangeRate': 'السعر: 1 {currency} = ؟ {base}',
    'accounting.bills.exchangeRateHint': 'اتركه فارغًا لاستخدام السعر المسجل لهذا التاريخ.',
    'accounting.bills.foreignHint': 'المبالغ في هذه الفاتورة بعملة {currency}.',
    'accounting.bills.noTax': 'بدون ضريبة',
    'accounting.bills.itemsPurchased': 'الأصناف المشتراة',
    'accounting.bills.item': 'الصنف',
    'accounting.bills.itemPlaceholder': 'الصنف، مثل أقراص الزركونيا',
    'accounting.bills.postTo': 'يُسجَّل على',
    'accounting.bills.tax': 'الضريبة',
    'accounting.bills.subtotal': 'الإجمالي قبل الضريبة',
    'accounting.bills.totalBill': 'إجمالي الفاتورة',
    'accounting.bills.outstanding': 'المستحق',
    'accounting.bills.paidNow.title': 'المدفوع بالفعل من هذه الفاتورة',
    'accounting.bills.paidNow.label': 'المدفوع الآن',
    'accounting.bills.paidNow.payInFull': 'مدفوعة بالكامل',
    'accounting.bills.paidNow.paidFromRequired': 'اختر الحساب الذي تم الدفع منه',
    'accounting.bills.paidNow.aboveTotal': 'لا يمكن أن يزيد عن إجمالي الفاتورة',
    'accounting.bills.paidNow.hint': 'اتركه فارغاً إذا لم يُدفع شيء بعد. يُسجَّل كدفعة للمورد بتاريخ الفاتورة؛ وادفع الباقي لاحقاً من "دفع لمورد".',
    'accounting.bills.entry.title': 'كيف تُسجَّل في الحسابات',
    'accounting.bills.entry.onBill': 'عند حفظ الفاتورة',
    'accounting.bills.entry.onPayment': 'عند تسجيل الدفعة',
    'accounting.bills.entry.payable': 'الموردون (ذمم دائنة)',
    'accounting.bills.entry.inputTax': 'ضريبة المدخلات القابلة للاسترداد',
    'accounting.bills.entry.cash': 'النقدية / البنك',
    'accounting.bills.entry.empty': 'أدخل مبالغ الأصناف لعرض القيد',
    'accounting.bills.entry.foreign': 'المبالغ بعملة {currency}؛ وتُسجَّل في الدفاتر بعملة {base} بسعر صرف الفاتورة.',
    'accounting.statement.tab': 'كشوف الحساب البنكية',
    'accounting.statement.import': 'استيراد كشف حساب',
    'accounting.statement.import_lines': 'استيراد {count} سطر',
    'accounting.statement.imported': 'تم استيراد الكشف.',
    'accounting.statement.account': 'الحساب البنكي أو النقدي',
    'accounting.statement.drop': 'انقر أو اسحب ملف كشف الحساب هنا',
    'accounting.statement.drop_hint': 'ملف CSV من البنك أو ملف OFX/QFX حتى 5 ميجابايت. يتم تخطي الأسطر المستوردة سابقًا.',
    'accounting.statement.mapping': 'الأعمدة',
    'accounting.statement.columns.date': 'التاريخ',
    'accounting.statement.columns.description': 'البيان',
    'accounting.statement.columns.reference': 'المرجع',
    'accounting.statement.columns.amount': 'المبلغ (+/−)',
    'accounting.statement.columns.money_in': 'إيداع',
    'accounting.statement.columns.money_out': 'سحب',
    'accounting.statement.columns.balance': 'الرصيد',
    'accounting.statement.date_format': 'صيغة التاريخ',
    'accounting.statement.decimal': 'صيغة الأرقام',
    'accounting.statement.delimiter': 'الفاصل',
    'accounting.statement.auto': 'تلقائي',
    'accounting.statement.skip_rows': 'تخطي أسطر من الأعلى',
    'accounting.statement.negate': 'عكس الإشارات (البنك يعرض السحب كقيمة موجبة)',
    'accounting.statement.preview_count': 'عرض {shown} من {total} سطر',
    'accounting.statement.date': 'التاريخ',
    'accounting.statement.description': 'البيان',
    'accounting.statement.reference': 'المرجع',
    'accounting.statement.amount': 'المبلغ',
    'accounting.statement.balance': 'الرصيد',
    'accounting.statement.status': 'الحالة',
    'accounting.statement.statuses.unmatched': 'غير مطابق',
    'accounting.statement.statuses.matched': 'مطابق',
    'accounting.statement.statuses.ignored': 'متجاهل',
    'accounting.statement.match': 'مطابقة',
    'accounting.statement.unmatch': 'إلغاء المطابقة',
    'accounting.statement.ignore': 'تجاهل',
    'accounting.statement.restore': 'استعادة',
    'accounting.statement.create_entry': 'إنشاء قيد',
    'accounting.statement.post_entry': 'ترحيل القيد',
    'accounting.statement.entry_hint_in': 'دخل {amount} إلى الحساب بتاريخ {date}. اختر مصدره.',
    'accounting.statement.entry_hint_out': 'خرج {amount} من الحساب بتاريخ {date}. اختر ما دُفع مقابله.',
    'accounting.statement.counter_account': 'الحساب المقابل',
    'accounting.statement.memo': 'البيان',
    'accounting.statement.auto_match': 'مطابقة تلقائية',
    'accounting.statement.auto_match_hint': 'يطابق الأسطر غير المطابقة مع حركات الدفتر بنفس المبلغ خلال أيام قليلة.',
    'accounting.statement.search': 'البيان أو المرجع',
    'accounting.statement.empty': 'لا توجد أسطر. استورد كشف حساب لبدء المطابقة.',
    'accounting.statement.imports': 'الملفات المستوردة',
    'accounting.statement.file': 'الملف',
    'accounting.statement.period': 'الفترة',
    'accounting.statement.lines': 'الأسطر',
    'accounting.statement.lines_summary': '{lines} سطر · {matched} مطابق · {duplicates} تم تخطيه',
    'accounting.statement.closing_balance': 'الرصيد الختامي',
    'accounting.statement.imported_by': 'استورده',
    'accounting.statement.delete_import_confirm': 'حذف هذا الاستيراد وكل أسطره؟ ستُزال المطابقات وتبقى القيود.',
    'accounting.statement.find_match': 'البحث عن مطابقة في الدفتر',
    'accounting.statement.fit': 'مدى التطابق',
    'accounting.statement.exact_amount': 'نفس المبلغ',
    'accounting.statement.days_apart': 'فرق {days} يوم',
    'accounting.statement.no_suggestions': 'لا توجد حركات في الدفتر بمبلغ مقارب حول هذا التاريخ',
    'accounting.statement.apply': 'التحديد من الكشف',
    'accounting.statement.apply_hint': 'يحدد كمسوّاة كل سطر في الدفتر مطابق لسطر كشف مستورد حتى تاريخ الكشف، ويملأ رصيد الكشف إذا كان الملف يحتويه.',
    'accounting.tax.title': 'الضرائب',
    'accounting.tax.subtitle': 'قواعد ونسب الضرائب وبيانات العملاء الضريبية والتقارير والفاتورة الإلكترونية',
    'accounting.tax.tabs.profile': 'الإعدادات',
    'accounting.tax.tabs.rates': 'النسب',
    'accounting.tax.tabs.rules': 'القواعد',
    'accounting.tax.tabs.clients': 'بيانات العملاء الضريبية',
    'accounting.tax.tabs.report': 'التقرير الضريبي',
    'accounting.tax.profile': 'الملف الضريبي',
    'accounting.tax.jurisdiction': 'الدولة / النظام الضريبي',
    'accounting.tax.jurisdiction_hint': 'حسب عملة المعمل ({currency}).',
    'accounting.tax.enabled': 'استخدام محرك الضرائب',
    'accounting.tax.enabled_hint': 'عند الإيقاف تستمر الطلبات في استخدام إعداد ضريبة القيمة المضافة البسيط.',
    'accounting.tax.simple_vat': 'نسبة ضريبة القيمة المضافة البسيطة %',
    'accounting.tax.simple_vat_hint': 'تُطبق على الطلبات الجديدة طالما محرك الضرائب متوقف. تحتفظ الطلبات الحالية بضريبتها.',
    'accounting.tax.registered': 'مسجل ضريبيًا',
    'accounting.tax.registration_number': 'رقم التسجيل الضريبي',
    'accounting.tax.invoice_address': 'العنوان على الفواتير الضريبية',
    'accounting.tax.invoice_address_hint': 'يُطبع تحت اسم المعمل في الفواتير الضريبية (الإلكترونية). اتركه فارغاً لاستخدام عنوان ملف المعمل.',
    'accounting.tax.profile_saved': 'تم حفظ الإعدادات الضريبية.',
    'accounting.tax.tax_types': 'أنواع الضرائب',
    'accounting.tax.no_tax_types': 'اختر دولة لتحميل أنواع الضرائب الخاصة بها.',
    'accounting.tax.install_templates': 'تثبيت النسب القياسية',
    'accounting.tax.install_templates_hint': 'يضيف النسب الرسمية للدولة المختارة مع الإبقاء على النسب الحالية.',
    'accounting.tax.templates_installed': 'تم تثبيت النسب القياسية.',
    'accounting.tax.recalculate': 'إعادة احتساب الضريبة',
    'accounting.tax.recalculate_hint': 'يعيد تطبيق القواعد الحالية على الطلبات غير المدفوعة من هذا التاريخ. لا تتغير الطلبات المدفوعة أو الفترات المقفلة.',
    'accounting.tax.recalculate_confirm': 'إعادة احتساب الضريبة على الطلبات غير المدفوعة من هذا التاريخ؟',
    'accounting.tax.recalculated': 'تمت إعادة احتساب {count} طلب.',
    'accounting.tax.add_rate': 'إضافة نسبة',
    'accounting.tax.edit_rate': 'تعديل النسبة',
    'accounting.tax.rate_name': 'الاسم',
    'accounting.tax.tax_type': 'نوع الضريبة',
    'accounting.tax.treatment': 'المعاملة الضريبية',
    'accounting.tax.treatments.standard': 'قياسي',
    'accounting.tax.treatments.reduced': 'مخفض',
    'accounting.tax.treatments.zero_rated': 'بنسبة صفر',
    'accounting.tax.treatments.exempt': 'معفى',
    'accounting.tax.treatments.out_of_scope': 'خارج النطاق',
    'accounting.tax.treatments.reverse_charge': 'احتساب عكسي',
    'accounting.tax.treatments.additional': 'ضريبة إضافية',
    'accounting.tax.treatments.withholding': 'خصم من المنبع',
    'accounting.tax.rate': 'النسبة',
    'accounting.tax.fixed_amount': 'مبلغ ثابت',
    'accounting.tax.subtype': 'الرمز الفرعي الرسمي',
    'accounting.tax.subtype_hint': 'الرمز المطلوب من مصلحة الضرائب، مثل V009 لمصر.',
    'accounting.tax.effective_period': 'سارية',
    'accounting.tax.effective_from': 'سارية من',
    'accounting.tax.effective_until': 'سارية حتى',
    'accounting.tax.usage': 'مرات الاستخدام',
    'accounting.tax.default': 'افتراضي',
    'accounting.tax.default_hint': 'تُطبّق عند عدم تطابق أي قاعدة.',
    'accounting.tax.active': 'نشط',
    'accounting.tax.inactive': 'غير نشط',
    'accounting.tax.rate_saved': 'تم حفظ النسبة الضريبية.',
    'accounting.tax.rate_deleted': 'تمت إزالة النسبة الضريبية.',
    'accounting.tax.rate_delete_confirm': 'حذف هذه النسبة؟',
    'accounting.tax.rate_deactivate_confirm': 'هذه النسبة مستخدمة، لذا سيتم إيقافها بدلًا من حذفها. متابعة؟',
    'accounting.tax.rules_hint': 'تحدد القواعد النسبة الضريبية لكل سطر في الطلب. تُطبّق القاعدة المطابقة ذات الأولوية الأعلى، وإن لم تطابق أي قاعدة تُطبّق النسبة الافتراضية.',
    'accounting.tax.add_rule': 'إضافة قاعدة',
    'accounting.tax.edit_rule': 'تعديل القاعدة',
    'accounting.tax.priority': 'الأولوية',
    'accounting.tax.priority_hint': 'الأعلى يفوز',
    'accounting.tax.applies_to': 'تنطبق على',
    'accounting.tax.applies.all': 'الكل',
    'accounting.tax.applies.formula_type': 'نوع منتج',
    'accounting.tax.applies.additional_cost': 'التكاليف الإضافية',
    'accounting.tax.applies.delivery': 'التوصيل',
    'accounting.tax.formula_type': 'نوع المنتج',
    'accounting.tax.conditions': 'شروط العميل',
    'accounting.tax.any_client': 'أي عميل',
    'accounting.tax.any': 'أي',
    'accounting.tax.client_type': 'نوع العميل',
    'accounting.tax.client_types.business': 'شركة',
    'accounting.tax.client_types.individual': 'فرد',
    'accounting.tax.client_types.government': 'جهة حكومية',
    'accounting.tax.client_country': 'دولة العميل',
    'accounting.tax.country_hint': 'رمز الدولة من حرفين، مثل EG',
    'accounting.tax.notes': 'ملاحظات',
    'accounting.tax.rule_saved': 'تم حفظ القاعدة الضريبية.',
    'accounting.tax.rule_deleted': 'تم حذف القاعدة الضريبية.',
    'accounting.tax.rule_delete_confirm': 'حذف هذه القاعدة؟',
    'accounting.tax.client': 'العميل',
    'accounting.tax.tax_id': 'رقم التسجيل الضريبي',
    'accounting.tax.tax_id_hint': 'للأفراد في مصر أدخل الرقم القومي (مطلوب في الفواتير التي تتجاوز 50,000 جنيه).',
    'accounting.tax.country': 'الدولة',
    'accounting.tax.exemption': 'مرجع الإعفاء',
    'accounting.tax.address': 'العنوان الضريبي',
    'accounting.tax.address_fields.governate': 'المحافظة',
    'accounting.tax.address_fields.regionCity': 'المدينة / المنطقة',
    'accounting.tax.address_fields.street': 'الشارع',
    'accounting.tax.address_fields.buildingNumber': 'رقم المبنى',
    'accounting.tax.not_set': 'غير محدد',
    'accounting.tax.search_clients': 'بحث عن عميل',
    'accounting.tax.missing_only': 'العملاء الذين تنقصهم البيانات الضريبية فقط',
    'accounting.tax.edit_client': 'البيانات الضريبية · {name}',
    'accounting.tax.client_saved': 'تم حفظ البيانات الضريبية للعميل.',
    'accounting.tax.summary': 'الملخص',
    'accounting.tax.output_tax': 'ضريبة المخرجات (المبيعات)',
    'accounting.tax.input_tax': 'ضريبة المدخلات (المشتريات)',
    'accounting.tax.net_payable': 'الصافي المستحق',
    'accounting.tax.output_detail': 'المبيعات حسب النسبة',
    'accounting.tax.input_detail': 'المشتريات حسب النسبة',
    'accounting.tax.taxable_base': 'المبلغ الخاضع',
    'accounting.tax.tax_amount': 'الضريبة',
    'accounting.tax.documents': 'المستندات',
    'accounting.tax.ledger_movement': 'حسابات الضرائب في الدفتر',
    'accounting.tax.ledger_hint': 'حركة حسابات الضرائب في نفس الفترة للمطابقة مع التقرير.',
    'accounting.tax.account': 'الحساب',
    'accounting.tax.debit': 'مدين',
    'accounting.tax.credit': 'دائن',
    'accounting.tax.net': 'الصافي',
    'accounting.tax.report_legacy_hint': 'محرك الضرائب متوقف، لذا تأتي ضريبة المبيعات من إعداد ضريبة القيمة المضافة البسيط في كل طلب.',
    'accounting.tax.engine': 'محرك الضرائب',
    'accounting.tax.engine_on': 'يعمل',
    'accounting.tax.engine_off': 'متوقف (ضريبة قيمة مضافة بسيطة)',
    'accounting.einvoice.tab': 'الفاتورة الإلكترونية',
    'accounting.einvoice.menu': 'الفاتورة الإلكترونية',
    'accounting.einvoice.settings': 'إعدادات الربط',
    'accounting.einvoice.settings_saved': 'تم حفظ إعدادات الفاتورة الإلكترونية.',
    'accounting.einvoice.provider': 'المزوّد',
    'accounting.einvoice.environment': 'البيئة',
    'accounting.einvoice.environments.sandbox': 'تجريبية',
    'accounting.einvoice.environments.production': 'فعلية',
    'accounting.einvoice.enabled': 'مفعّل',
    'accounting.einvoice.auto_submit': 'إرسال الفواتير الجديدة تلقائيًا',
    'accounting.einvoice.auto_submit_hint': 'الفواتير التي تنقصها بيانات مطلوبة تُسجّل كمرفوضة لتتمكن من إصلاحها وإعادة إرسالها.',
    'accounting.einvoice.integration.not_configured': 'غير مُعد',
    'accounting.einvoice.integration.configured': 'مُعد',
    'accounting.einvoice.integration.connected': 'متصل',
    'accounting.einvoice.integration.failed': 'فشل الاتصال',
    'accounting.einvoice.last_tested': 'آخر اختبار {at}',
    'accounting.einvoice.missing_trn': 'أضف رقم التسجيل الضريبي للمعمل في تبويب الإعدادات قبل إرسال الفواتير الإلكترونية.',
    'accounting.einvoice.config.activity_code': 'رمز النشاط',
    'accounting.einvoice.config.activity_code_hint': 'رمز النشاط المسجل لدى مصلحة الضرائب، مثل 8690.',
    'accounting.einvoice.config.branch_id': 'رقم الفرع',
    'accounting.einvoice.config.branch_id_hint': 'استخدم 0 للفرع الرئيسي.',
    'accounting.einvoice.config.issuer_address': 'عنوان فرع المعمل',
    'accounting.einvoice.config.item_type': 'نظام ترميز الأصناف',
    'accounting.einvoice.config.default_item_code': 'رمز الصنف الافتراضي',
    'accounting.einvoice.config.default_item_code_hint': 'رمز EGS/GS1 المسجل ويُستخدم للطلبات التي ليس لها رمز خاص.',
    'accounting.einvoice.config.item_codes': 'رموز الأصناف لكل نوع منتج',
    'accounting.einvoice.config.item_codes_hint': '(اختياري، يتجاوز الرمز الافتراضي)',
    'accounting.einvoice.config.unit_type': 'نوع الوحدة',
    'accounting.einvoice.config.unit_type_hint': 'رمز الوحدة لدى المصلحة، عادة EA.',
    'accounting.einvoice.config.document_version': 'إصدار المستند',
    'accounting.einvoice.config.document_version_hint': 'الإصدار 0.9 غير موقّع ومسموح في البيئة التجريبية فقط؛ الإصدار 1.0 يحتاج خدمة توقيع.',
    'accounting.einvoice.config.signer_url': 'رابط خدمة التوقيع',
    'accounting.einvoice.config.signer_url_hint': 'الخدمة التي توقّع المستندات بالختم أو التوكن الإلكتروني (مطلوبة للإصدار 1.0).',
    'accounting.einvoice.fields.client_id': 'معرّف العميل (Client ID)',
    'accounting.einvoice.fields.client_secret': 'الرمز السري (Client secret)',
    'accounting.einvoice.fields.signer_token': 'رمز خدمة التوقيع',
    'accounting.einvoice.credentials': 'بيانات الدخول',
    'accounting.einvoice.credentials_hint': 'تُحفظ مشفرة ولا تظهر مرة أخرى. اترك الحقل فارغًا للإبقاء على القيمة المحفوظة.',
    'accounting.einvoice.stored': 'محفوظ',
    'accounting.einvoice.clear': 'إزالة',
    'accounting.einvoice.test_connection': 'اختبار الاتصال',
    'accounting.einvoice.connection_ok': 'تم الاتصال بنجاح.',
    'accounting.einvoice.documents': 'المستندات المرسلة',
    'accounting.einvoice.invoice_id': 'رقم الفاتورة',
    'accounting.einvoice.check_invoice': 'فحص فاتورة',
    'accounting.einvoice.status': 'الحالة',
    'accounting.einvoice.statuses.pending': 'في الانتظار',
    'accounting.einvoice.statuses.submitted': 'مُرسلة',
    'accounting.einvoice.statuses.accepted': 'مقبولة',
    'accounting.einvoice.statuses.rejected': 'مرفوضة',
    'accounting.einvoice.statuses.retry_pending': 'ستتم إعادة المحاولة',
    'accounting.einvoice.statuses.cancelled': 'ملغاة',
    'accounting.einvoice.search': 'رقم الفاتورة أو UUID أو العميل',
    'accounting.einvoice.invoice': 'الفاتورة',
    'accounting.einvoice.amount': 'المبلغ',
    'accounting.einvoice.uuid': 'UUID لدى المصلحة',
    'accounting.einvoice.submitted_at': 'تاريخ الإرسال',
    'accounting.einvoice.attempts': 'المحاولات',
    'accounting.einvoice.error': 'الخطأ',
    'accounting.einvoice.open_portal': 'فتح في بوابة مصلحة الضرائب',
    'accounting.einvoice.refresh': 'تحديث الحالة',
    'accounting.einvoice.retry': 'إعادة الإرسال',
    'accounting.einvoice.updated': 'تم التحديث.',
    'accounting.einvoice.cancel': 'إلغاء الفاتورة الإلكترونية',
    'accounting.einvoice.cancel_title': 'إلغاء الفاتورة الإلكترونية {reference}',
    'accounting.einvoice.cancel_hint': 'تشترط مصلحة الضرائب ذكر السبب، والإلغاء ممكن فقط خلال المدة المسموح بها.',
    'accounting.einvoice.cancel_reason': 'السبب',
    'accounting.einvoice.cancelled': 'تم إلغاء الفاتورة الإلكترونية.',
    'accounting.einvoice.invoice_title': 'الفاتورة الإلكترونية · {reference}',
    'accounting.einvoice.not_ready': 'لا يمكن إرسال هذه الفاتورة بعد',
    'accounting.einvoice.ready': 'جميع البيانات المطلوبة متوفرة',
    'accounting.einvoice.submit': 'إرسال إلى مصلحة الضرائب',
    'accounting.einvoice.queued': 'تمت جدولة الإرسال.',
    'accounting.einvoice.payload': 'معاينة المستند (JSON)',
    'accounting.einvoice.no_documents': 'لم تُرسل بعد',
    'accounting.einvoice.total': 'إجمالي الفاتورة: {amount}',
    'accounting.insights.title': 'المؤشرات المالية',
    'accounting.insights.subtitle': 'تنبيهات الهوامش والمستحقات المتأخرة ومدة كفاية النقد',
    'accounting.insights.analysis_period': 'فترة تحليل الهوامش',
    'accounting.insights.thresholds': 'حدود التنبيه',
    'accounting.insights.thresholds_saved': 'تم حفظ حدود التنبيه.',
    'accounting.insights.threshold_margin': 'تنبيه عندما يقل هامش الطلب عن (%)',
    'accounting.insights.threshold_overdue': 'المستحقات المتأخرة بعد (يوم)',
    'accounting.insights.threshold_runway': 'تنبيه عندما يكفي النقد أقل من (شهر)',
    'accounting.insights.disabled': 'المحاسبة غير مفعلة، لذا قد تكون الأرقام المعتمدة على الدفتر فارغة.',
    'accounting.insights.alerts': 'التنبيهات',
    'accounting.insights.no_alerts': 'لا يوجد ما يستدعي الانتباه حاليًا.',
    'accounting.insights.kpi.revenue': 'الإيرادات (الشهر حتى الآن)',
    'accounting.insights.kpi.gross_profit': 'مجمل الربح',
    'accounting.insights.kpi.net_profit': 'صافي الربح',
    'accounting.insights.kpi.expenses': 'التكاليف والمصروفات',
    'accounting.insights.vs_last_month': 'الشهر الماضي: {amount}',
    'accounting.insights.mtd_note': '{from} ← {to}، مقارنة بـ {compare_from} ← {compare_to}',
    'accounting.insights.gross_margin': 'هامش الربح الإجمالي {pct}',
    'accounting.insights.trend': 'آخر 12 شهرًا',
    'accounting.insights.revenue': 'الإيرادات',
    'accounting.insights.expenses': 'المصروفات',
    'accounting.insights.net_cash': 'صافي التدفق النقدي',
    'accounting.insights.runway': 'مدة كفاية النقد',
    'accounting.insights.runway_months': 'عدد الأشهر المتبقية',
    'accounting.insights.cash_positive': 'تدفق نقدي موجب',
    'accounting.insights.cash_balance': 'النقدية والبنوك',
    'accounting.insights.avg_inflow': 'متوسط الوارد الشهري',
    'accounting.insights.avg_outflow': 'متوسط الصادر الشهري',
    'accounting.insights.monthly_burn': 'الاستهلاك الشهري',
    'accounting.insights.measured': 'بناءً على {from} ← {to}',
    'accounting.insights.low_margin_orders': 'طلبات بهامش أقل من {threshold}%',
    'accounting.insights.low_margin_clients': 'عملاء بهامش أقل من {threshold}%',
    'accounting.insights.overall_margin': 'الهامش الإجمالي {pct}',
    'accounting.insights.showing_of': 'عرض {shown} من {total}',
    'accounting.insights.order': 'الطلب',
    'accounting.insights.client': 'العميل',
    'accounting.insights.orders': 'الطلبات',
    'accounting.insights.margin': 'الهامش',
    'accounting.insights.margin_pct': 'نسبة الهامش',
    'accounting.insights.overdue_receivables': 'مستحقات متأخرة أكثر من {days} يوم',
    'accounting.insights.total_receivable': 'إجمالي المستحقات',
    'accounting.insights.overdue_amount': 'المتأخر',
    'accounting.insights.overdue_share': 'نسبة المتأخر',
    'accounting.insights.oldest_days': 'الأقدم (يوم)',
    'accounting.insights.payables': 'فواتير الموردين المستحقة (خلال {days} يوم)',
    'accounting.insights.total_payable': 'إجمالي المستحق للموردين',
    'accounting.insights.due_soon_amount': 'مستحق قريبًا',
    'accounting.insights.bill': 'الفاتورة',
    'accounting.insights.due_date': 'تاريخ الاستحقاق',
    'accounting.insights.amount': 'المبلغ',
    'accounting.insights.status': 'الحالة',
    'accounting.insights.days_overdue': 'متأخرة {days} يوم',
    'accounting.insights.due_soon': 'تستحق قريبًا',
    'accounting.source.technician_settlement': 'تسويات الفنيين',
    'accounting.source.technician_payment': 'مدفوعات الفنيين',
    'accounting.maps.group.costing': 'تكاليف المعمل',
    'accounting.health.technicians': 'مستحقات الفنيين مقابل التسويات',
    'accounting.health.techniciansHint': 'لكل فني: الرصيد المستحق في الدفاتر مقابل التسويات المعتمدة ناقص مدفوعاتها.',
    'accounting.health.technician': 'الفني',
    'accounting.health.settlements_col': 'التسويات − المدفوعات',
    'accounting.settlements.subtitle': 'حاسب الفنيين عن كل فترة من الطلبات المسندة إليهم، ثم سجّل ما دفعته.',
    'accounting.settlements.tabs.settlements': 'التسويات',
    'accounting.settlements.tabs.payments': 'المدفوعات',
    'accounting.settlements.add': 'تسوية جديدة',
    'accounting.settlements.edit': 'تعديل التسوية',
    'accounting.settlements.settlement': 'التسوية',
    'accounting.settlements.number': 'رقم التسوية',
    'accounting.settlements.technician': 'الفني',
    'accounting.settlements.technicianRequired': 'اختر الفني',
    'accounting.settlements.period': 'الفترة',
    'accounting.settlements.date': 'تاريخ التسوية',
    'accounting.settlements.loadOrders': 'تحميل الطلبات',
    'accounting.settlements.pickTechnicianPeriod': 'اختر الفني والفترة أولاً.',
    'accounting.settlements.noOrders': 'لا توجد طلبات محمّلة. اختر الفني والفترة ثم اضغط "تحميل الطلبات".',
    'accounting.settlements.order': 'الطلب',
    'accounting.settlements.units': 'الوحدات',
    'accounting.settlements.share': 'الحصة',
    'accounting.settlements.editSplit': 'تعديل التقسيم بين الفنيين',
    'accounting.settlements.splitTitle': 'التقسيم بين الفنيين',
    'accounting.settlements.rateTotal': 'أجر القطعة للطلب',
    'accounting.settlements.splitEqually': 'تقسيم بالتساوي',
    'accounting.settlements.splitMustTotal': 'يجب أن يكون مجموع الحصص 100%.',
    'accounting.settlements.splitLocked': 'تسوية هذا الفني للطلب معتمدة، لذا حصته ثابتة. ألغِ التسوية لتغييرها.',
    'accounting.settlements.splitHint': 'ينطبق التقسيم على تسويات كل الفنيين لهذا الطلب. يتم تحديث التسويات المسودة بالحصة الجديدة.',
    'accounting.settlements.paidAsExpenses': 'تم دفع {count} مصروف/مصروفات بإجمالي {amount} لهذا الفني خلال الفترة كمصروفات يدوية. تأكد من عدم دفعها مرتين.',
    'accounting.settlements.adjustments': 'التعديلات',
    'accounting.settlements.adjustment': 'تعديل',
    'accounting.settlements.addAdjustment': 'إضافة مكافأة أو خصم',
    'accounting.settlements.adjustmentDescription': 'اكتب وصف التعديل',
    'accounting.settlements.adjustmentPlaceholder': 'مثال: مكافأة عطلة، خصم سلفة',
    'accounting.settlements.adjustmentAmount': 'المبلغ (− للخصم)',
    'accounting.settlements.ordersTotal': 'الطلبات',
    'accounting.settlements.total': 'الإجمالي',
    'accounting.settlements.postingHint': 'المسودات لا تُرحّل شيئاً. الاعتماد يُحمّل المبلغ على أجور الفنيين ويضيفه لمستحقات الفنيين.',
    'accounting.settlements.saveDraft': 'حفظ كمسودة',
    'accounting.settlements.saveApprove': 'حفظ واعتماد',
    'accounting.settlements.approve': 'اعتماد',
    'accounting.settlements.approvedBy': 'اعتمدها',
    'accounting.settlements.void': 'إلغاء',
    'accounting.settlements.voidConfirm': 'إلغاء هذه التسوية؟ سيتم عكس قيدها وتصبح طلباتها متاحة مرة أخرى.',
    'accounting.settlements.deleteConfirm': 'حذف هذه التسوية؟',
    'accounting.settlements.pay': 'دفع للفني',
    'accounting.settlements.noUnpaid': 'لا توجد تسويات معتمدة متبقية للدفع',
    'accounting.settlements.line': 'البند',
    'accounting.settlements.search': 'ابحث بالرقم أو الفني أو الملاحظات',
    'accounting.settlements.approvedTotal': 'المعتمد',
    'accounting.settlements.owed': 'المتبقي للفنيين',
    'accounting.settlements.drafts': 'المسودات',
    'accounting.settlements.owedTo': 'مبالغ متبقية للفنيين',
    'accounting.settlements.noTechnicians': 'لا يوجد فنيون بعد. أضف مستخدمين من نوع فني لتسوية أعمالهم.',
    'accounting.settlements.status.label': 'الحالة',
    'accounting.settlements.status.draft': 'مسودة',
    'accounting.settlements.status.approved': 'معتمدة',
    'accounting.settlements.status.partially_paid': 'مدفوعة جزئياً',
    'accounting.settlements.status.paid': 'مدفوعة',
    'accounting.settlements.status.void': 'ملغاة',
    'accounting.settlements.status.unpaid': 'غير مدفوعة',
    'accounting.settlements.printTitle': 'تسوية فني',
    'accounting.settlements.patient': 'المريض',
    'accounting.settlements.technicianSignature': 'توقيع الفني',
    'accounting.source.salary_run': 'مسيرات الرواتب',
    'accounting.source.salary_payment': 'صرف الرواتب',
    'accounting.maps.group.payroll': 'الرواتب',
    'accounting.health.salaries': 'الرواتب المستحقة مقابل مسيرات الرواتب',
    'accounting.health.salariesHint': 'لكل موظف: الرواتب المستحقة في الدفاتر مقابل مسيرات الرواتب المعتمدة ناقص مدفوعاتها.',
    'accounting.health.employee': 'الموظف',
    'accounting.health.salary_runs_col': 'مسيرات الرواتب − المدفوعات',
    'accounting.health.materials': 'مخزون الخامات',
    'accounting.health.materialsOk': 'لا توجد تنبيهات',
    'accounting.health.materialsWarning': 'تحتاج إلى مراجعة',
    'accounting.health.materialsHint': 'طريقة تكلفة الخامات: {method}. هذه التنبيهات لا تؤثر على النتيجة العامة.',
    'accounting.health.inventoryBalance': 'مخزون الخامات (1500)',
    'accounting.health.inventoryNegative': 'صُرفت من المخزون خامات أكثر مما أضافته فواتير الموردين والجرد. أدخل فواتير الموردين الناقصة أو قم بجرد المخزون.',
    'accounting.salaries.subtitle': 'الرواتب الشهرية لموظفيك (المديرون، الفنيون، المندوبون، المحاسبون): أنشئ مسير الرواتب كل شهر ثم سجّل ما دفعته.',
    'accounting.salaries.tabs.runs': 'مسيرات الرواتب',
    'accounting.salaries.tabs.employees': 'الموظفون',
    'accounting.salaries.tabs.recurring': 'التكرار الشهري',
    'accounting.salaries.addRun': 'مسير رواتب جديد',
    'accounting.salaries.editRun': 'تعديل مسير الرواتب',
    'accounting.salaries.run': 'مسير الرواتب',
    'accounting.salaries.number': 'رقم المسير',
    'accounting.salaries.month': 'الشهر',
    'accounting.salaries.runDate': 'تاريخ الترحيل',
    'accounting.salaries.runDateHint': 'يُسجَّل مصروف الرواتب بهذا التاريخ.',
    'accounting.salaries.pickMonth': 'اختر الشهر أولاً.',
    'accounting.salaries.loadEmployees': 'تحميل الموظفين',
    'accounting.salaries.addEmployee': 'إضافة موظف',
    'accounting.salaries.nothingToLoad': 'لا يوجد موظفون للتحميل: كل من له راتب موجود بالفعل في مسير لهذا الشهر.',
    'accounting.salaries.prorated': 'نسبي: {days} من {total} يوم',
    'accounting.salaries.noLines': 'أضف موظفاً واحداً على الأقل.',
    'accounting.salaries.noLinesLoaded': 'لا يوجد موظفون بعد. اختر الشهر ثم اضغط "تحميل الموظفين" أو أضف الموظفين واحداً تلو الآخر.',
    'accounting.salaries.employee': 'الموظف',
    'accounting.salaries.type': 'النوع',
    'accounting.salaries.base': 'الراتب',
    'accounting.salaries.allowances': 'البدلات',
    'accounting.salaries.deductions': 'الخصومات',
    'accounting.salaries.net': 'الصافي',
    'accounting.salaries.employeesCount': 'عدد الموظفين',
    'accounting.salaries.printTitle': 'كشف الرواتب',
    'accounting.salaries.signature': 'التوقيع',
    'accounting.salaries.preparedBy': 'أعدّه',
    'accounting.salaries.approvedBy': 'اعتمده',
    'accounting.salaries.postingHint': 'المسودات لا تُرحّل شيئاً. الاعتماد يسجّل صافي كل راتب كمصروف ويضيفه إلى الرواتب المستحقة؛ والصرف ينقله من الرواتب المستحقة إلى حساب النقدية.',
    'accounting.salaries.pay': 'صرف الرواتب',
    'accounting.salaries.payAll': 'صرف الكل',
    'accounting.salaries.pickRun': 'اختر مسير رواتب معتمداً لعرض من تبقّى صرف راتبه.',
    'accounting.salaries.selectEmployees': 'اختر موظفاً واحداً على الأقل للصرف.',
    'accounting.salaries.noUnpaid': 'لا توجد مسيرات رواتب معتمدة متبقية للصرف',
    'accounting.salaries.voidConfirm': 'إلغاء مسير الرواتب؟ سيتم عكس قيده ويمكن صرف رواتب موظفيه لهذا الشهر مرة أخرى.',
    'accounting.salaries.deleteConfirm': 'حذف مسير الرواتب؟',
    'accounting.salaries.deletePaymentConfirm': 'حذف هذه الدفعة؟ سيعود الراتب غير مدفوع.',
    'accounting.salaries.automatic': 'تلقائي',
    'accounting.salaries.search': 'ابحث برقم المسير أو الملاحظات',
    'accounting.salaries.searchEmployees': 'ابحث بالاسم أو البريد الإلكتروني أو الهاتف',
    'accounting.salaries.employeeName': 'اسم الموظف',
    'accounting.salaries.noAccount': 'بدون حساب مستخدم',
    'accounting.salaries.noAccountHint': 'استخدم هذا للموظفين الذين لا يستخدمون النظام. لا يُنشأ لهم حساب مستخدم، ولا يمكنهم تسجيل الدخول، ولا يظهرون في صفحة المستخدمين.',
    'accounting.salaries.deleteEmployeeConfirm': 'حذف هذا الموظف وراتبه؟',
    'accounting.salaries.monthlySalary': 'الراتب الشهري',
    'accounting.salaries.notSet': 'غير محدد',
    'accounting.salaries.employment': 'فترة العمل',
    'accounting.salaries.startDate': 'تاريخ البداية',
    'accounting.salaries.endDate': 'تاريخ الانتهاء',
    'accounting.salaries.datesHint': 'اختياري. الشهر الأول أو الأخير غير الكامل يُحسب بنسبة الأيام.',
    'accounting.salaries.includeInRuns': 'ضمن مسيرات الرواتب',
    'accounting.salaries.editSalary': 'تعديل الراتب',
    'accounting.salaries.monthlyPayroll': 'إجمالي الرواتب الشهرية',
    'accounting.salaries.withoutSalary': '{count} موظف/موظفين بدون راتب محدد بعد.',
    'accounting.salaries.owedTo': 'رواتب مستحقة لم تُصرف',
    'accounting.salaries.autoRun': 'مسير الرواتب الشهري التلقائي',
    'accounting.salaries.autoRunMode.off': 'إيقاف (إنشاء المسيرات يدوياً)',
    'accounting.salaries.autoRunMode.draft': 'إنشاء مسير كمسودة',
    'accounting.salaries.autoRunMode.approve': 'إنشاء المسير واعتماده',
    'accounting.salaries.autoRunHint.off': 'لا يتم إنشاء مسيرات الرواتب إلا عند الضغط على "مسير رواتب جديد".',
    'accounting.salaries.autoRunHint.draft': 'في يوم الصرف يُنشأ مسير الشهر كمسودة من رواتب الجميع لتراجعه وتعتمده.',
    'accounting.salaries.autoRunHint.approve': 'في يوم الصرف يُنشأ مسير الشهر من رواتب الجميع ويُعتمد، فتُسجَّل الرواتب تلقائياً. أما الصرف فتسجّله أنت.',
    'accounting.salaries.payDay': 'يوم الصرف',
    'accounting.salaries.payDayHint': 'يوم من الشهر (1–31). في الشهور الأقصر يُستخدم آخر يوم.',
    'accounting.salaries.lastAutoMonth': 'آخر مسير تلقائي: {month}',
    'accounting.costing.subtitle': 'هامش كل طلب من الدفاتر، تكلفة إعادة التصنيع، مخزون الخامات وتوزيع المصروفات العامة.',
    'accounting.costing.tabs.margins': 'هوامش الطلبات',
    'accounting.costing.tabs.remakes': 'إعادة التصنيع',
    'accounting.costing.tabs.inventory': 'المخزون والإعدادات',
    'accounting.costing.groupBy.order': 'حسب الطلب',
    'accounting.costing.groupBy.client': 'حسب العميل',
    'accounting.costing.groupBy.technician': 'حسب الفني',
    'accounting.costing.groupBy.formula_type': 'حسب نوع التركيبة',
    'accounting.costing.groups.client': 'العميل',
    'accounting.costing.groups.technician': 'الفني',
    'accounting.costing.groups.formula_type': 'نوع التركيبة',
    'accounting.costing.unassigned': 'غير مسند',
    'accounting.costing.ordersUnits': '{orders} طلب · {units} وحدة',
    'accounting.costing.search': 'ابحث بالطلب أو المريض أو العميل',
    'accounting.costing.remakesOnly': 'إعادة التصنيع فقط',
    'accounting.costing.orders': 'الطلبات',
    'accounting.costing.revenue': 'الإيراد',
    'accounting.costing.cost.materials': 'الخامات',
    'accounting.costing.cost.technician': 'الفني',
    'accounting.costing.cost.additional': 'إضافية',
    'accounting.costing.cost.delivery': 'التوصيل',
    'accounting.costing.cost.other': 'أخرى',
    'accounting.costing.directCost': 'التكلفة المباشرة',
    'accounting.costing.overhead': 'مصروفات عامة',
    'accounting.costing.margin': 'الهامش',
    'accounting.costing.marginPct': 'نسبة الهامش',
    'accounting.costing.remake': 'إعادة تصنيع',
    'accounting.costing.noRevenue': 'بدون إيراد بعد',
    'accounting.costing.noRevenueHint': 'لم يُرحّل إيراد لهذا الطلب بعد (لم يصل لحالة الفوترة أو إجماليه صفر).',
    'accounting.costing.unposted': '{count} طلب في هذه الفترة بدون إيراد مُرحّل بعد، لذلك يظهر هامشها بالتكاليف فقط.',
    'accounting.costing.notEnabled': 'المحاسبة غير مفعّلة، لذلك لا توجد قيود لتحليلها.',
    'accounting.costing.purchaseExpenseHint': 'الخامات تُحمّل كمصروف عند الشراء، لذلك لا تظهر تكلفة خامات لكل طلب.',
    'accounting.costing.overheadInfo.percent_of_revenue': 'وعاء المصروفات العامة {pool} (مصروفات تشغيل {operating} + إهلاك {depreciation}) موزّع بنسبة {rate} من الإيراد.',
    'accounting.costing.overheadInfo.per_unit': 'وعاء المصروفات العامة {pool} (مصروفات تشغيل {operating} + إهلاك {depreciation}) موزّع بمقدار {rate} لكل وحدة.',
    'accounting.costing.remakes': 'إعادة التصنيع / الطلبات',
    'accounting.costing.remakeRate': 'نسبة إعادة التصنيع',
    'accounting.costing.netCost': 'صافي التكلفة',
    'accounting.costing.labNetCost': 'تكلفة بسبب المعمل',
    'accounting.costing.charged': 'المحصّل',
    'accounting.costing.byReason': 'حسب السبب',
    'accounting.costing.byResponsibility': 'حسب المسؤولية',
    'accounting.costing.byTechnician': 'حسب الفني',
    'accounting.costing.count': 'العدد',
    'accounting.costing.noRemakes': 'لا توجد طلبات إعادة تصنيع موسومة في هذه الفترة.',
    'accounting.costing.tagRemake': 'وسم كإعادة تصنيع',
    'accounting.costing.editRemake': 'تعديل وسم إعادة التصنيع',
    'accounting.costing.tag': 'وسم',
    'accounting.costing.untagConfirm': 'إزالة وسم إعادة التصنيع من هذا الطلب؟',
    'accounting.costing.remakeOrder': 'طلب إعادة التصنيع',
    'accounting.costing.remakeOrderHint': 'الطلب الذي يعيد العمل. تُحسب تكاليفه كتكلفة إعادة تصنيع.',
    'accounting.costing.originalOrder': 'الطلب الأصلي',
    'accounting.costing.searchOrder': 'ابحث برقم الطلب أو المريض أو العميل',
    'accounting.costing.reason': 'السبب',
    'accounting.costing.responsibility': 'المسؤولية',
    'accounting.costing.reasons.fit': 'المقاس / التركيب',
    'accounting.costing.reasons.shade': 'اللون',
    'accounting.costing.reasons.fracture': 'كسر',
    'accounting.costing.reasons.design': 'التصميم',
    'accounting.costing.reasons.impression': 'الطبعة',
    'accounting.costing.reasons.damaged_in_delivery': 'تلف أثناء التوصيل',
    'accounting.costing.reasons.clinic_request': 'طلب العيادة',
    'accounting.costing.reasons.other': 'أخرى',
    'accounting.costing.responsibilities.lab': 'المعمل',
    'accounting.costing.responsibilities.clinic': 'العيادة',
    'accounting.costing.responsibilities.shared': 'مشتركة',
    'accounting.costing.responsibilities.unknown': 'غير معروفة',
    'accounting.costing.suggestions': 'طلبات محتملة لإعادة التصنيع غير موسومة',
    'accounting.costing.suggestionsHint': 'طلبات مرّت بحالة إعادة تصنيع أو إعادة عمل أو فشل في مراقبة الجودة.',
    'accounting.costing.patientClient': 'المريض · العميل',
    'accounting.costing.status': 'الحالة',
    'accounting.costing.settings': 'إعدادات التكاليف',
    'accounting.costing.materialMethod': 'طريقة احتساب تكلفة الخامات',
    'accounting.costing.materialMethods.accrual': 'الاستحقاق (افتراضي)',
    'accounting.costing.materialMethods.inventory': 'المخزون',
    'accounting.costing.materialMethods.purchase_expense': 'مصروف عند الشراء',
    'accounting.costing.materialMethodHints.accrual': 'مشتريات الخامات تُحمّل كمصروف عند تسجيل الفاتورة. تكاليف تركيبات الطلبات تُرحّل منفصلة على تكلفة خامات مبيعات (التركيبة).',
    'accounting.costing.materialMethodHints.inventory': 'مشتريات الخامات تدخل المخزون وتخرج منه عند الصرف. استخدم الجرد لتصحيح القيمة الدفترية. تكاليف تركيبات الطلبات تُرحّل منفصلة على تكلفة خامات مبيعات (التركيبة) ولا تمس المخزون.',
    'accounting.costing.materialMethodHints.purchase_expense': 'مشتريات الخامات تُحمّل كمصروف عند تسجيل الفاتورة. تكاليف تركيبات الطلبات تُرحّل منفصلة على تكلفة خامات مبيعات (التركيبة).',
    'accounting.costing.changeMethodTitle': 'تغيير طريقة احتساب تكلفة الخامات؟',
    'accounting.costing.changeMethodBody': 'سيتم إعادة ترحيل كل المصروفات وفواتير الموردين بالطريقة الجديدة في الخلفية. الفترات المقفلة لا تتغير؛ والتصحيحات تُرحّل في أول يوم مفتوح.',
    'accounting.costing.overheadMethod': 'توزيع المصروفات العامة',
    'accounting.costing.overheadMethodHint': 'يوزّع مصروفات التشغيل (وإهلاك الأصول) على الطلبات في تقارير الهامش. لا يُرحّل أي قيد.',
    'accounting.costing.overheadMethods.none': 'بدون توزيع',
    'accounting.costing.overheadMethods.percent_of_revenue': 'نسبة من الإيراد',
    'accounting.costing.overheadMethods.per_unit': 'لكل وحدة',
    'accounting.costing.assetLife': 'العمر الإنتاجي للأصول (سنوات)',
    'accounting.costing.assetLifeHint': 'يضيف إهلاك الأصول بطريقة القسط الثابت إلى وعاء المصروفات العامة. اتركه فارغاً لتجاهله.',
    'accounting.costing.inventory': 'مخزون الخامات',
    'accounting.costing.inventoryNotUsed': 'طريقة المخزون غير مختارة، لذلك لا يتحرك هذا الحساب إلا بالجرد والمشتريات المربوطة به.',
    'accounting.costing.opening': 'أول المدة',
    'accounting.costing.closing': 'آخر المدة',
    'accounting.costing.formulaMaterial': 'تكلفة خامات التركيبات',
    'accounting.costing.formulaMaterialHint': 'تكلفة الخامات التي سجّلتها الطلبات في الفترة، أياً كانت طريقة الاحتساب.',
    'accounting.costing.movement': 'الحركة',
    'accounting.costing.in': 'وارد',
    'accounting.costing.out': 'منصرف',
    'accounting.costing.noMovements': 'لا توجد حركات في هذه الفترة.',
    'accounting.costing.stockCount': 'جرد المخزون',
    'accounting.costing.stockCountHint': 'أدخل قيمة الخامات الموجودة فعلياً. يُرحّل الفرق عن القيمة الدفترية مقابل مصروف الخامات.',
    'accounting.costing.countedValue': 'القيمة الفعلية',
    'accounting.costing.postCount': 'ترحيل التسوية',
    'accounting.costing.noCounts': 'لا توجد عمليات جرد بعد.',
    'accounting.costing.adjustment': 'التسوية',
    'accounting.costing.reversed': 'ملغاة',
    'accounting.journal.movedFromClosed': 'منقول من {date}',
    'accounting.journal.movedFromClosedHint': 'تاريخ العملية يقع في فترة مقفلة، لذلك تم ترحيلها في أول يوم مفتوح.',
    'accounting.accounts.cashFlowCategory': 'قسم التدفقات النقدية',
    'accounting.accounts.cashFlowCategoryHint': 'المكان الذي تظهر فيه تغيرات هذا الحساب في قائمة التدفقات النقدية.',
    'accounting.accounts.cashFlowAuto': 'تلقائي',
    'accounting.reports.subtitle': 'قوائم مبنية من القيود المرحّلة: الدفاتر الرسمية.',
    'accounting.reports.tabs.trial_balance': 'ميزان المراجعة',
    'accounting.reports.tabs.general_ledger': 'دفتر الأستاذ العام',
    'accounting.reports.tabs.profit_and_loss': 'الأرباح والخسائر',
    'accounting.reports.tabs.balance_sheet': 'الميزانية العمومية',
    'accounting.reports.tabs.cash_flow': 'التدفقات النقدية',
    'accounting.reports.presets.thisMonth': 'هذا الشهر',
    'accounting.reports.presets.lastMonth': 'الشهر الماضي',
    'accounting.reports.presets.thisQuarter': 'هذا الربع',
    'accounting.reports.presets.yearToDate': 'منذ بداية السنة',
    'accounting.reports.presets.lastYear': 'السنة الماضية',
    'accounting.reports.compare.none': 'بدون مقارنة',
    'accounting.reports.compare.previous_period': 'مقارنة بالفترة السابقة',
    'accounting.reports.compare.previous_year': 'مقارنة بنفس الفترة من العام الماضي',
    'accounting.reports.compare.bs_previous_period': 'مقارنة ببداية الفترة',
    'accounting.reports.compare.bs_previous_year': 'مقارنة بنفس التاريخ من العام الماضي',
    'accounting.reports.includeZero': 'إظهار الأرصدة الصفرية',
    'accounting.reports.asOfLabel': 'حتى تاريخ',
    'accounting.reports.asOf': 'حتى {date}',
    'accounting.reports.periodRange': 'من {from} إلى {to}',
    'accounting.reports.beginning': 'البداية',
    'accounting.reports.today': 'اليوم',
    'accounting.reports.lockedThrough': 'الدفاتر مقفلة حتى {date}',
    'accounting.reports.refresh': 'تحديث',
    'accounting.reports.print': 'طباعة',
    'accounting.reports.disabledHint': 'فعّل المحاسبة من دليل الحسابات لبناء الدفتر الذي تقرأ منه هذه التقارير.',
    'accounting.reports.noActivity': 'لا توجد حركات مرحّلة لهذا الاختيار.',
    'accounting.reports.line': 'البند',
    'accounting.reports.account': 'الحساب',
    'accounting.reports.type': 'النوع',
    'accounting.reports.amount': 'المبلغ',
    'accounting.reports.change': 'التغير',
    'accounting.reports.debit': 'مدين',
    'accounting.reports.credit': 'دائن',
    'accounting.reports.balance': 'الرصيد',
    'accounting.reports.total': 'الإجمالي',
    'accounting.reports.tb.opening': 'افتتاحي',
    'accounting.reports.tb.movement': 'الحركة',
    'accounting.reports.tb.closing': 'ختامي',
    'accounting.reports.tb.unbalanced': 'المدين لا يساوي الدائن. شغّل فحص سلامة الدفتر من دليل الحسابات.',
    'accounting.reports.gl.pickAccount': 'اختر حساباً',
    'accounting.reports.gl.pickAccountHint': 'اختر حساباً لعرض بنوده المرحّلة ورصيده الجاري.',
    'accounting.reports.gl.includeChildren': 'تضمين الحسابات الفرعية',
    'accounting.reports.gl.description': 'العملية',
    'accounting.reports.gl.counter': 'الطرف المقابل',
    'accounting.reports.gl.opening': 'الرصيد الافتتاحي',
    'accounting.reports.gl.debits': 'المدين',
    'accounting.reports.gl.credits': 'الدائن',
    'accounting.reports.gl.closing': 'الرصيد الختامي',
    'accounting.reports.gl.normalSide.debit': 'الأرصدة معروضة كمدين ناقص دائن.',
    'accounting.reports.gl.normalSide.credit': 'الأرصدة معروضة كدائن ناقص مدين.',
    'accounting.reports.pl.revenue': 'الإيرادات',
    'accounting.reports.pl.direct_costs': 'التكاليف المباشرة',
    'accounting.reports.pl.operating_expenses': 'المصروفات التشغيلية',
    'accounting.reports.pl.total_revenue': 'إجمالي الإيرادات',
    'accounting.reports.pl.total_direct_costs': 'إجمالي التكاليف المباشرة',
    'accounting.reports.pl.total_operating_expenses': 'إجمالي المصروفات التشغيلية',
    'accounting.reports.pl.gross_profit': 'مجمل الربح',
    'accounting.reports.pl.net_profit': 'صافي الربح',
    'accounting.reports.bs.current_assets': 'الأصول المتداولة',
    'accounting.reports.bs.non_current_assets': 'الأصول غير المتداولة',
    'accounting.reports.bs.liabilities': 'الالتزامات',
    'accounting.reports.bs.equity': 'حقوق الملكية',
    'accounting.reports.bs.total_current_assets': 'إجمالي الأصول المتداولة',
    'accounting.reports.bs.total_non_current_assets': 'إجمالي الأصول غير المتداولة',
    'accounting.reports.bs.total_assets': 'إجمالي الأصول',
    'accounting.reports.bs.total_liabilities': 'إجمالي الالتزامات',
    'accounting.reports.bs.total_equity': 'إجمالي حقوق الملكية',
    'accounting.reports.bs.total_liabilities_and_equity': 'إجمالي الالتزامات وحقوق الملكية',
    'accounting.reports.bs.retained_earnings': 'الأرباح المحتجزة',
    'accounting.reports.bs.current_year_earnings': 'أرباح السنة الحالية',
    'accounting.reports.bs.unbalanced': 'الأصول لا تساوي الالتزامات وحقوق الملكية. شغّل فحص سلامة الدفتر من دليل الحسابات.',
    'accounting.reports.bs.fiscalYearHint': 'أرباح السنة الحالية محسوبة من {date}، والأرباح السابقة تظهر كأرباح محتجزة.',
    'accounting.reports.cf.operating': 'الأنشطة التشغيلية',
    'accounting.reports.cf.investing': 'الأنشطة الاستثمارية',
    'accounting.reports.cf.financing': 'الأنشطة التمويلية',
    'accounting.reports.cf.netIncome': 'صافي الربح',
    'accounting.reports.cf.movement.increase': 'زيادة',
    'accounting.reports.cf.movement.decrease': 'نقص',
    'accounting.reports.cf.total_operating': 'صافي النقد من الأنشطة التشغيلية',
    'accounting.reports.cf.total_investing': 'صافي النقد من الأنشطة الاستثمارية',
    'accounting.reports.cf.total_financing': 'صافي النقد من الأنشطة التمويلية',
    'accounting.reports.cf.netChange': 'صافي التغير في النقدية',
    'accounting.reports.cf.openingCash': 'النقدية في بداية الفترة',
    'accounting.reports.cf.closingCash': 'النقدية في نهاية الفترة',
    'accounting.reports.cf.methodHint': 'الطريقة غير المباشرة: صافي الربح معدّلاً بالتغير في كل حسابات الميزانية غير النقدية.',
    'accounting.reports.cf.notReconciled': 'النقدية الافتتاحية مضافاً إليها صافي التغير لا تساوي النقدية الختامية. شغّل فحص سلامة الدفتر.',
    'accounting.reports.cf.cashAccounts': 'حسابات النقدية والبنوك',
    'accounting.reports.cf.opening': 'افتتاحي',
    'accounting.reports.cf.closing': 'ختامي',
    'accounting.reports.opsDashboardNotice': 'هذه لوحة تشغيلية. للدفاتر الرسمية راجع قائمة الأرباح والخسائر في التقارير المالية.',
    'accounting.reports.openProfitAndLoss': 'فتح الأرباح والخسائر',
    'accounting.periods.subtitle': 'أقفل الفترات المنتهية حتى لا تتغير الأرقام المعلنة.',
    'accounting.periods.lockedThrough': 'الدفاتر مقفلة حتى',
    'accounting.periods.notClosed': 'لم يتم الإقفال بعد',
    'accounting.periods.firstOpenDate': 'أول تاريخ مفتوح',
    'accounting.periods.anyDate': 'أي تاريخ',
    'accounting.periods.fiscalYearStart': 'بداية السنة المالية',
    'accounting.periods.fiscalYearHint': 'يُستخدم للفصل بين الأرباح المحتجزة وأرباح السنة الحالية.',
    'accounting.periods.closeTitle': 'إقفال الدفاتر',
    'accounting.periods.closeHint': 'الإقفال يقفل كل الأيام حتى التاريخ المختار. تُرفض القيود اليدوية فيه، والعمليات المؤرخة فيه (طلبات، مدفوعات، مصروفات…) تُرحّل في أول يوم مفتوح بدلاً منه.',
    'accounting.periods.closeThrough': 'إقفال حتى',
    'accounting.periods.pickDate': 'اختر آخر يوم للإقفال.',
    'accounting.periods.range': 'الفترة',
    'accounting.periods.entries': 'القيود',
    'accounting.periods.netIncome': 'صافي الربح',
    'accounting.periods.totalPosted': 'إجمالي المرحّل',
    'accounting.periods.cannotClose': 'لا يمكن إقفال هذه الفترة بعد',
    'accounting.periods.unreconciledTitle': 'بعض بنود النقدية أو البنوك في هذه الفترة غير مسوّاة',
    'accounting.periods.unreconciledLine': '{name}: {count} بنود غير مسوّاة',
    'accounting.periods.goReconcile': 'الذهاب إلى التسوية البنكية',
    'accounting.periods.notes': 'ملاحظات',
    'accounting.periods.close': 'إقفال حتى {date}',
    'accounting.periods.closeConfirm': 'إقفال الدفاتر حتى {date}؟ سيتم قفل القيود حتى هذا التاريخ.',
    'accounting.periods.history': 'الفترات المقفلة',
    'accounting.periods.empty': 'لم يتم إقفال أي فترة بعد.',
    'accounting.periods.statusLabel': 'الحالة',
    'accounting.periods.status.closed': 'مقفلة',
    'accounting.periods.status.reopened': 'أعيد فتحها',
    'accounting.periods.closedBy': 'أقفلها',
    'accounting.periods.reopened': 'إعادة الفتح',
    'accounting.periods.reopen': 'إعادة فتح',
    'accounting.periods.reopenTitle': 'إعادة فتح الفترة',
    'accounting.periods.reopenWarning': 'إعادة فتح الفترة من {from} إلى {to} تسمح بتغيير القيود مرة أخرى، وقد لا تتطابق التقارير التي تمت مشاركتها.',
    'accounting.periods.reason': 'السبب',
    'accounting.reconciliation.subtitle': 'طابق كشوف البنك والنقدية مع الدفتر.',
    'accounting.reconciliation.start': 'بدء تسوية',
    'accounting.reconciliation.startOk': 'بدء',
    'accounting.reconciliation.reconcile': 'تسوية',
    'accounting.reconciliation.continue': 'متابعة',
    'accounting.reconciliation.open': 'فتح',
    'accounting.reconciliation.workspace': 'التسوية',
    'accounting.reconciliation.account': 'الحساب',
    'accounting.reconciliation.pickAccount': 'اختر حساب نقدية أو بنك',
    'accounting.reconciliation.allAccounts': 'كل الحسابات',
    'accounting.reconciliation.allStatuses': 'كل الحالات',
    'accounting.reconciliation.lastStatement': 'آخر كشف تمت تسويته: {date}. يجب أن يكون الكشف الجديد بعده.',
    'accounting.reconciliation.firstStatement': 'أول تسوية لهذا الحساب: الرصيد الافتتاحي صفر.',
    'accounting.reconciliation.statementDate': 'تاريخ الكشف',
    'accounting.reconciliation.statementOf': 'كشف {date}',
    'accounting.reconciliation.statementBalance': 'رصيد الكشف',
    'accounting.reconciliation.statementBalanceHint': 'الرصيد الختامي المطبوع على الكشف.',
    'accounting.reconciliation.reference': 'مرجع الكشف',
    'accounting.reconciliation.notes': 'ملاحظات',
    'accounting.reconciliation.editStatement': 'تعديل الكشف',
    'accounting.reconciliation.ledgerBalance': 'رصيد الدفتر',
    'accounting.reconciliation.reconciledThrough': 'تمت التسوية حتى {date} ({amount})',
    'accounting.reconciliation.neverReconciled': 'لم تتم تسويته من قبل',
    'accounting.reconciliation.unclearedCount': '{count} بنود غير مسوّاة',
    'accounting.reconciliation.noAccounts': 'أضف حساب نقدية أو بنك من صفحة النقدية والبنوك أولاً.',
    'accounting.reconciliation.history': 'الكشوف',
    'accounting.reconciliation.empty': 'لا توجد تسويات بعد.',
    'accounting.reconciliation.statusLabel': 'الحالة',
    'accounting.reconciliation.status.draft': 'قيد التنفيذ',
    'accounting.reconciliation.status.completed': 'مكتملة',
    'accounting.reconciliation.completedAt': 'الإكمال',
    'accounting.reconciliation.completedBy': 'أكملها {name} في {date}',
    'accounting.reconciliation.opening': 'الرصيد الافتتاحي',
    'accounting.reconciliation.clearedIn': 'وارد مسوّى',
    'accounting.reconciliation.clearedOut': 'صادر مسوّى',
    'accounting.reconciliation.clearedBalance': 'الرصيد المسوّى',
    'accounting.reconciliation.difference': 'الفرق',
    'accounting.reconciliation.clearedCount': '{count} بنود مسوّاة',
    'accounting.reconciliation.bookBalanceHint': 'رصيد الدفتر في {date}: {amount}',
    'accounting.reconciliation.howTo': 'حدّد كل بند يظهر في الكشف. عندما يصبح الفرق صفراً يمكنك إكمال التسوية.',
    'accounting.reconciliation.view.all': 'الكل',
    'accounting.reconciliation.view.uncleared': 'غير مسوّى',
    'accounting.reconciliation.view.cleared': 'مسوّى',
    'accounting.reconciliation.search': 'بحث في البنود',
    'accounting.reconciliation.noLines': 'لا توجد بنود في الدفتر حتى تاريخ الكشف.',
    'accounting.reconciliation.moneyIn': 'وارد',
    'accounting.reconciliation.moneyOut': 'صادر',
    'accounting.reconciliation.complete': 'إكمال',
    'accounting.reconciliation.completeConfirm': 'إكمال هذه التسوية؟ سيتم قفل البنود المسوّاة.',
    'accounting.reconciliation.reopen': 'إعادة فتح',
    'accounting.reconciliation.reopenConfirm': 'إعادة فتح هذه التسوية لتعديل بنودها؟',
    'accounting.reconciliation.deleteConfirm': 'حذف هذه التسوية؟ ستعود بنودها المحددة غير مسوّاة.',
    'expenses.form.paidFrom.label': 'مدفوع من',
    'expenses.form.paidFrom.hint': 'حساب النقدية أو البنك الذي خرجت منه الأموال. اتركه فارغاً لاستخدام الافتراضي.',
    'invoice.markPaid.depositTo': 'إيداع في',
    'clients.wallet.depositTo': 'إيداع في',
    'sidebar.finance': 'المالية',
    'sidebar.settings': 'الإعدادات',
    'sidebar.client_settings': 'الإعدادات',
    'sidebar.client_transactions': 'المعاملات',
    'sidebar.client_statement': 'كشف الحساب',
    'sidebar.client_wallet': 'المحفظة',
    'sidebar.setting': 'اعدادات المعمل',
    'sidebar.setting_lab_info': 'المعمل',
    'sidebar.setting_subscription': 'الاشتراك',
    'sidebar.setting_payment': 'إعدادات الدفع',
    'sidebar.setting_delivery': 'إعدادات التوصيل',
    'sidebar.setting_vacations': 'الأجازات',
    'sidebar.setting_discounts': 'إعدادات الخصومات',
    'discountSettings.subtitle': 'التحكم في طريقة ظهور الخصومات في الطلبات والفواتير وملفات PDF',
    'sidebar.orders': 'الطلبات',
    'sidebar.orders_calendar': 'التقويم',
    'sidebar.invoices': 'الفواتير',

    'collectionReport.title': 'تقرير التحصيلات',
    'collectionReport.subtitle': 'أساس نقدي: الدخل من الطلبات القابلة للفوترة المدفوعة في هذه الفترة (حسب تاريخ الدفع) بعد خصم الطلب. الطلبات المستحقة غير المدفوعة غير محتسبة. فائض النقد = المجموع الفرعي للطلبات المدفوعة − المصروفات العامة. تكاليف أنواع التركيبات تعرض هامش العمل المُحصَّل فقط ولا تُخصم من فائض النقد. لا تجمع هذا الفائض مع صافي تقرير الإيرادات.',
    'collectionReport.countLabel': 'أنواع تركيبات',
    'collectionReport.section.formulaTypesProfit': 'أرباح أنواع التركيبات',
    'collectionReport.period.month': 'شهر',
    'collectionReport.period.range': 'نطاق تاريخ',
    'collectionReport.includeCosts': 'احتساب التكاليف:',
    'collectionReport.includeCosts.material': 'الخامة',
    'collectionReport.includeCosts.technician': 'الفني',
    'collectionReport.includeCosts.additional': 'الإضافية',
    'collectionReport.column.name': 'نوع التركيبة',
    'collectionReport.column.units': 'عدد الوحدات',
    'collectionReport.column.sellingPrice': 'سعر البيع للوحدة',
    'collectionReport.column.totalIncome': 'إجمالي الدخل',
    'collectionReport.column.materialCost': 'تكلفة الخامة للوحدة',
    'collectionReport.column.totalMaterial': 'إجمالي تكلفة الخامة',
    'collectionReport.column.technicianCost': 'تكلفة الفني للوحدة',
    'collectionReport.column.totalTechnician': 'إجمالي تكلفة الفني',
    'collectionReport.column.additionalCost': 'التكلفة الإضافية للوحدة',
    'collectionReport.column.totalAdditional': 'إجمالي التكاليف الإضافية',
    'collectionReport.column.netProfit': 'صافي الأرباح',
    'collectionReport.totals': 'الإجمالي',
    'collectionReport.empty': 'لا توجد وحدات في هذه الفترة',
    'collectionReport.sellingPriceVaries': 'متوسط، لأن الوحدات بيعت بأسعار مختلفة. افتح الصف لعرض كل سعر.',
    'collectionReport.priceSource.default': 'السعر الافتراضي',
    'collectionReport.priceSource.client': 'سعر العميل',
    'collectionReport.priceSource.custom': 'سعر مخصص (في الطلب)',
    'collectionReport.priceSource.clientsCount': '{{count}} عميل',
    'collectionReport.priceSource.noClient': 'بدون عميل',
    'collectionReport.noAccess': 'ليس لديك صلاحية عرض تقرير التحصيلات',
    'collectionReport.loadError': 'تعذر تحميل تقرير التحصيلات',
    'collectionReport.section.paidOrders': 'الطلبات المدفوعة',
    'collectionReport.paidOrders.hint': 'إجماليات الطلبات القابلة للفوترة المدفوعة في هذه الفترة (حسب تاريخ الدفع): التركيبات، خصم الطلب، التكاليف الإضافية، المجموع الفرعي، الضريبة، التوصيل، والإجمالي. أرباح أنواع التركيبات تستخدم التركيبات بعد الخصم؛ تكاليفها هامش العمل المُحصَّل فقط.',
    'collectionReport.paidOrders.type': 'النوع',
    'collectionReport.paidOrders.amount': 'المبلغ',
    'collectionReport.paidOrders.formulas': 'التركيبات',
    'collectionReport.paidOrders.discount': 'الخصم',
    'collectionReport.paidOrders.additionalCosts': 'تكاليف إضافية',
    'collectionReport.paidOrders.subtotal': 'المجموع الفرعي',
    'collectionReport.paidOrders.vat': 'إجمالي الضريبة',
    'collectionReport.paidOrders.delivery': 'تكاليف التوصيل',
    'collectionReport.paidOrders.total': 'الإجمالي',
    'collectionReport.paidOrders.ordersCount': '{{count}} طلب مدفوع',
    'collectionReport.paidOrders.empty': 'لا توجد طلبات مدفوعة في هذه الفترة',
    'collectionReport.discountDetails.title': 'تفاصيل الخصم',
    'collectionReport.discountDetails.ordersCount': '{{count}} طلب عليه خصم',
    'collectionReport.discountDetails.hint': 'الطلبات التي عليها خصم على مستوى الطلب والتي يتكوّن منها سطر الخصم أعلاه. تخفيضات سعر الوحدة (سعر العميل أو السعر المخصص) محتسبة بالفعل ضمن التركيبات.',
    'collectionReport.discountDetails.order': 'الطلب',
    'collectionReport.discountDetails.client': 'العميل',
    'collectionReport.discountDetails.formulaTypes': 'أنواع التركيبات',
    'collectionReport.discountDetails.formulas': 'التركيبات',
    'collectionReport.discountDetails.discount': 'الخصم',
    'collectionReport.discountDetails.discountPercentage': 'نسبة الخصم %',
    'collectionReport.discountDetails.afterDiscount': 'بعد الخصم',
    'collectionReport.markupDetails.title': 'تفاصيل زيادة السعر',
    'collectionReport.markupDetails.ordersCount': '{{count}} طلب عليه زيادة سعر',
    'collectionReport.markupDetails.hint': 'الطلبات التي بها وحدات بسعر أعلى من سعر القائمة (قائمة أسعار العميل أو سعر الوحدة المخصص). زيادة السعر محتسبة بالفعل ضمن التركيبات.',
    'collectionReport.markupDetails.order': 'الطلب',
    'collectionReport.markupDetails.client': 'العميل',
    'collectionReport.markupDetails.formulaTypes': 'أنواع التركيبات',
    'collectionReport.markupDetails.catalog': 'سعر القائمة',
    'collectionReport.markupDetails.markup': 'زيادة السعر',
    'collectionReport.markupDetails.markupPercentage': 'نسبة الزيادة %',
    'collectionReport.markupDetails.charged': 'السعر المحصل',
    'collectionReport.settings.button': 'إعدادات التقرير',
    'collectionReport.settings.title': 'إعدادات التقرير',
    'collectionReport.settings.display': 'العرض في تقريري الإيرادات والتحصيل',
    'collectionReport.settings.showDiscounts': 'الخصومات',
    'collectionReport.settings.showDiscountsHint': 'عند الإيقاف يُدمج سطر الخصم ضمن التركيبات.',
    'collectionReport.settings.showDiscountDetails': 'تفاصيل الخصم',
    'collectionReport.settings.showMarkupDetails': 'تفاصيل زيادة السعر',
    'collectionReport.settings.showVat': 'ضريبة القيمة المضافة',
    'collectionReport.settings.showVatHint': 'عند الإيقاف يُخفى سطر الضريبة ويكون الإجمالي بدون ضريبة.',
    'collectionReport.settings.showCogs': 'تكلفة البضاعة المباعة (تكاليف أنواع التركيبات)',
    'collectionReport.settings.showCogsHint': 'تكاليف الخامات والفنيين والتكاليف الإضافية لكل وحدة في ربح أنواع التركيبات وصافي الربح.',
    'collectionReport.settings.noCostsEnabled': 'لا توجد تكاليف أنواع تركيبات مفعّلة لمعملك بعد.',
    'collectionReport.settings.saved': 'تم حفظ إعدادات التقرير',
    'collectionReport.settings.loadError': 'تعذر تحميل إعدادات التقرير',
    'collectionReport.settings.readOnly': 'تحتاج صلاحية تعديل الإعدادات لتغيير هذه الإعدادات.',
    'collectionReport.section.generalExpenses': 'المصروفات العامة',
    'collectionReport.generalExpenses.hint': 'مصروفات تشغيل نقدية مُدخلة يدويًا في هذه الفترة. لا تشمل المصروفات المُنشأة تلقائيًا من الطلبات (تلك تتبع تكاليف الإنتاج في تقرير الإيرادات).',
    'collectionReport.notBillableOrders': '{{count}} طلب في هذه الفترة غير محتسب بعد لأنه لم يصل إلى الحالة المحددة في سير عمل حالات الطلب.',
    'collectionReport.unpaidOrders': '{{count}} طلب مستحق غير مدفوع في هذه الفترة غير محتسب في التحصيلات (الأرصدة المستحقة لا تُحتسب حتى يتم الدفع).',
    'collectionReport.generalExpenses.expenseType': 'نوع المصروف',
    'collectionReport.generalExpenses.expenses': 'المصروفات',
    'collectionReport.generalExpenses.uncategorized': 'بدون بند',
    'collectionReport.generalExpenses.empty': 'لا توجد مصروفات عامة في هذه الفترة',
    'collectionReport.section.netProfitSummary': 'ملخص فائض النقد',
    'collectionReport.netProfitSummary.hint': 'أساس نقدي: إجمالي الدخل هو المجموع الفرعي للطلبات المدفوعة (بعد الخصومات ويشمل التكاليف الإضافية). فائض النقد = إجمالي الدخل − المصروفات العامة. تكاليف إنتاج أنواع التركيبات لا تُخصم هنا (انظر أرباح أنواع التركيبات لهامش العمل المُحصَّل). الضريبة والتوصيل يبقيان في الطلبات المدفوعة فقط.',
    'collectionReport.netProfitSummary.type': 'النوع',
    'collectionReport.netProfitSummary.amount': 'المبلغ',
    'collectionReport.netProfitSummary.totalIncome': 'إجمالي الدخل',
    'collectionReport.netProfitSummary.totalTechnicianCost': 'إجمالي تكلفة الفنيين',
    'collectionReport.netProfitSummary.totalMaterialCost': 'إجمالي تكلفة الخامات',
    'collectionReport.netProfitSummary.generalExpenses': 'المصروفات العامة',
    'collectionReport.netProfitSummary.others': 'أخرى',
    'collectionReport.netProfitSummary.netProfit': 'فائض النقد',
    'collectionReport.section.formulaTypesTracker': 'متعقب أنواع التركيبات',
    'collectionReport.section.latestFormulaTypes': 'أحدث أنواع التركيبات استخداما',
    'collectionReport.section.receivables': 'المستحقات غير المحصّلة',
    'collectionReport.receivables.hint': 'الطلبات القابلة للفوترة غير المدفوعة التي استحقت في هذه الفترة. المتبقي هو إجمالي الرصيد غير المدفوع؛ المتأخر وغير المستحق يصنّفانه حسب موعد استحقاق الفاتورة.',
    'collectionReport.receivables.outstanding': 'المتبقي',
    'collectionReport.receivables.overdue': 'متأخر',
    'collectionReport.receivables.current': 'غير مستحق',
    'collectionReport.receivables.empty': 'لا توجد مستحقات غير محصّلة في هذه الفترة',
    'collectionReport.section.byClient': 'حسب العميل',
    'collectionReport.byClient.hint': 'الطلبات المدفوعة في هذه الفترة مجمّعة حسب العميل (حسب تاريخ الدفع).',
    'collectionReport.byClient.client': 'العميل',
    'collectionReport.byClient.orders': 'الطلبات',
    'collectionReport.byClient.amount': 'المبلغ',
    'collectionReport.byClient.uncategorized': 'بدون عميل',
    'collectionReport.byClient.empty': 'لا توجد تحصيلات حسب العميل في هذه الفترة',
    'collectionReport.section.byPaymentMethod': 'حسب طريقة الدفع',
    'collectionReport.byPaymentMethod.hint': 'مدفوعات الفواتير المستلمة في هذه الفترة مجمّعة حسب طريقة الدفع.',
    'collectionReport.byPaymentMethod.method': 'طريقة الدفع',
    'collectionReport.byPaymentMethod.transactions': 'المدفوعات',
    'collectionReport.byPaymentMethod.amount': 'المبلغ',
    'collectionReport.byPaymentMethod.uncategorized': 'غير محدد',
    'collectionReport.byPaymentMethod.empty': 'لا توجد مدفوعات حسب الطريقة في هذه الفترة',
    'collectionReport.section.byInvoice': 'حسب الفاتورة',
    'collectionReport.byInvoice.hint': 'مدفوعات الفواتير المستلمة في هذه الفترة مجمّعة حسب الفاتورة.',
    'collectionReport.byInvoice.invoice': 'الفاتورة',
    'collectionReport.byInvoice.client': 'العميل',
    'collectionReport.byInvoice.transactions': 'المدفوعات',
    'collectionReport.byInvoice.amount': 'المبلغ',
    'collectionReport.byInvoice.empty': 'لا توجد مدفوعات فواتير في هذه الفترة',
    'collectionReport.section.refunds': 'المرتجعات',
    'collectionReport.refunds.hint': 'مرتجعات الفواتير المضافة إلى محافظ العملاء في هذه الفترة.',
    'collectionReport.refunds.invoice': 'الفاتورة',
    'collectionReport.refunds.client': 'العميل',
    'collectionReport.refunds.amount': 'المبلغ',
    'collectionReport.refunds.empty': 'لا توجد مرتجعات في هذه الفترة',
    'collectionReport.section.unallocated': 'مدفوعات غير مخصّصة',
    'collectionReport.unallocated.hint': 'شحنات المحفظة في هذه الفترة (دفعات مقدّمة لم تُطبَّق على فواتير بعد).',
    'collectionReport.unallocated.client': 'العميل',
    'collectionReport.unallocated.method': 'طريقة الدفع',
    'collectionReport.unallocated.amount': 'المبلغ',
    'collectionReport.unallocated.empty': 'لا توجد مدفوعات غير مخصّصة في هذه الفترة',

    'revenueReport.title': 'تقرير الإيرادات',
    'revenueReport.subtitle': 'أساس الاستحقاق: الدخل من الطلبات التي أصبحت مستحقة في هذه الفترة (عند وصولها إلى حالة الاستحقاق في سير عمل حالات الطلب) بعد خصم الطلب. تُحتسب الطلبات المدفوعة وغير المدفوعة. صافي الأرباح = المجموع الفرعي لطلبات الإيرادات − تكاليف الإنتاج (خامة، فني، إضافية). المصروفات النقدية العامة في تقرير التحصيلات. لا تجمع هذا الصافي مع فائض تقرير التحصيلات.',
    'revenueReport.countLabel': 'أنواع تركيبات',
    'revenueReport.section.formulaTypesProfit': 'أرباح أنواع التركيبات',
    'revenueReport.period.month': 'شهر',
    'revenueReport.period.range': 'نطاق تاريخ',
    'revenueReport.includeCosts': 'احتساب التكاليف:',
    'revenueReport.includeCosts.material': 'الخامة',
    'revenueReport.includeCosts.technician': 'الفني',
    'revenueReport.includeCosts.additional': 'الإضافية',
    'revenueReport.column.name': 'نوع التركيبة',
    'revenueReport.column.units': 'عدد الوحدات',
    'revenueReport.column.sellingPrice': 'سعر البيع للوحدة',
    'revenueReport.column.totalIncome': 'إجمالي الدخل',
    'revenueReport.column.materialCost': 'تكلفة الخامة للوحدة',
    'revenueReport.column.totalMaterial': 'إجمالي تكلفة الخامة',
    'revenueReport.column.technicianCost': 'تكلفة الفني للوحدة',
    'revenueReport.column.totalTechnician': 'إجمالي تكلفة الفني',
    'revenueReport.column.additionalCost': 'التكلفة الإضافية للوحدة',
    'revenueReport.column.totalAdditional': 'إجمالي التكاليف الإضافية',
    'revenueReport.column.netProfit': 'صافي الأرباح',
    'revenueReport.totals': 'الإجمالي',
    'revenueReport.empty': 'لا توجد وحدات في هذه الفترة',
    'revenueReport.sellingPriceVaries': 'متوسط، لأن الوحدات بيعت بأسعار مختلفة. افتح الصف لعرض كل سعر.',
    'revenueReport.priceSource.default': 'السعر الافتراضي',
    'revenueReport.priceSource.client': 'سعر العميل',
    'revenueReport.priceSource.custom': 'سعر مخصص (في الطلب)',
    'revenueReport.priceSource.clientsCount': '{{count}} عميل',
    'revenueReport.priceSource.noClient': 'بدون عميل',
    'revenueReport.noAccess': 'ليس لديك صلاحية عرض تقرير الإيرادات',
    'revenueReport.loadError': 'تعذر تحميل تقرير الإيرادات',
    'revenueReport.section.dueOrders': 'طلبات الإيرادات',
    'revenueReport.dueOrders.hint': 'إجماليات الطلبات المحتسبة كإيرادات في هذه الفترة، المدفوعة وغير المدفوعة (الطلبات التي أصبحت مستحقة حسب تاريخ الاستحقاق): التركيبات، خصم الطلب، التكاليف الإضافية، المجموع الفرعي، الضريبة، التوصيل، والإجمالي. أرباح أنواع التركيبات تستخدم التركيبات بعد الخصم.',
    'revenueReport.dueOrders.type': 'النوع',
    'revenueReport.dueOrders.amount': 'المبلغ',
    'revenueReport.dueOrders.formulas': 'التركيبات',
    'revenueReport.dueOrders.discount': 'الخصم',
    'revenueReport.dueOrders.additionalCosts': 'تكاليف إضافية',
    'revenueReport.dueOrders.subtotal': 'المجموع الفرعي',
    'revenueReport.dueOrders.vat': 'إجمالي الضريبة',
    'revenueReport.dueOrders.delivery': 'تكاليف التوصيل',
    'revenueReport.dueOrders.total': 'الإجمالي',
    'revenueReport.dueOrders.ordersCount': '{{count}} طلب',
    'revenueReport.dueOrders.empty': 'لا توجد طلبات إيرادات في هذه الفترة',
    'revenueReport.discountDetails.title': 'تفاصيل الخصم',
    'revenueReport.discountDetails.ordersCount': '{{count}} طلب عليه خصم',
    'revenueReport.discountDetails.hint': 'الطلبات التي عليها خصم على مستوى الطلب والتي يتكوّن منها سطر الخصم أعلاه. تخفيضات سعر الوحدة (سعر العميل أو السعر المخصص) محتسبة بالفعل ضمن التركيبات.',
    'revenueReport.discountDetails.order': 'الطلب',
    'revenueReport.discountDetails.client': 'العميل',
    'revenueReport.discountDetails.formulaTypes': 'أنواع التركيبات',
    'revenueReport.discountDetails.formulas': 'التركيبات',
    'revenueReport.discountDetails.discount': 'الخصم',
    'revenueReport.discountDetails.discountPercentage': 'نسبة الخصم %',
    'revenueReport.discountDetails.afterDiscount': 'بعد الخصم',
    'revenueReport.markupDetails.title': 'تفاصيل زيادة السعر',
    'revenueReport.markupDetails.ordersCount': '{{count}} طلب عليه زيادة سعر',
    'revenueReport.markupDetails.hint': 'الطلبات التي بها وحدات بسعر أعلى من سعر القائمة (قائمة أسعار العميل أو سعر الوحدة المخصص). زيادة السعر محتسبة بالفعل ضمن التركيبات.',
    'revenueReport.markupDetails.order': 'الطلب',
    'revenueReport.markupDetails.client': 'العميل',
    'revenueReport.markupDetails.formulaTypes': 'أنواع التركيبات',
    'revenueReport.markupDetails.catalog': 'سعر القائمة',
    'revenueReport.markupDetails.markup': 'زيادة السعر',
    'revenueReport.markupDetails.markupPercentage': 'نسبة الزيادة %',
    'revenueReport.markupDetails.charged': 'السعر المحصل',
    'revenueReport.settings.button': 'إعدادات التقرير',
    'revenueReport.settings.title': 'إعدادات التقرير',
    'revenueReport.settings.display': 'العرض في تقريري الإيرادات والتحصيل',
    'revenueReport.settings.showDiscounts': 'الخصومات',
    'revenueReport.settings.showDiscountsHint': 'عند الإيقاف يُدمج سطر الخصم ضمن التركيبات.',
    'revenueReport.settings.showDiscountDetails': 'تفاصيل الخصم',
    'revenueReport.settings.showMarkupDetails': 'تفاصيل زيادة السعر',
    'revenueReport.settings.showVat': 'ضريبة القيمة المضافة',
    'revenueReport.settings.showVatHint': 'عند الإيقاف يُخفى سطر الضريبة ويكون الإجمالي بدون ضريبة.',
    'revenueReport.settings.showCogs': 'تكلفة البضاعة المباعة (تكاليف أنواع التركيبات)',
    'revenueReport.settings.showCogsHint': 'تكاليف الخامات والفنيين والتكاليف الإضافية لكل وحدة في ربح أنواع التركيبات وصافي الربح.',
    'revenueReport.settings.noCostsEnabled': 'لا توجد تكاليف أنواع تركيبات مفعّلة لمعملك بعد.',
    'revenueReport.settings.saved': 'تم حفظ إعدادات التقرير',
    'revenueReport.settings.loadError': 'تعذر تحميل إعدادات التقرير',
    'revenueReport.settings.readOnly': 'تحتاج صلاحية تعديل الإعدادات لتغيير هذه الإعدادات.',
    'revenueReport.section.generalExpenses': 'المصروفات العامة',
    'revenueReport.generalExpenses.hint': 'مصروفات التشغيل النقدية تتبع تقرير التحصيلات ولا تُخصم من صافي أرباح الاستحقاق.',
    'revenueReport.notBillableOrders': '{{count}} طلب في هذه الفترة غير محتسب بعد لأنه لم يصل إلى الحالة المحددة في سير عمل حالات الطلب.',
    'revenueReport.unpaidDueOrders': '{{count}} طلب غير مدفوع في هذه الفترة محتسب في الإيرادات ولم يُحصَّل بعد.',
    'revenueReport.generalExpenses.expenseType': 'نوع المصروف',
    'revenueReport.generalExpenses.expenses': 'المصروفات',
    'revenueReport.generalExpenses.uncategorized': 'بدون بند',
    'revenueReport.generalExpenses.empty': 'لا توجد مصروفات عامة في هذه الفترة',
    'revenueReport.section.netProfitSummary': 'ملخص صافي الأرباح',
    'revenueReport.netProfitSummary.hint': 'أساس الاستحقاق: إجمالي الدخل هو المجموع الفرعي لطلبات الإيرادات (بعد الخصومات ويشمل التكاليف الإضافية). صافي الأرباح = إجمالي الدخل − تكلفة الفنيين − تكلفة الخامات − أخرى (التكاليف التشغيلية الإضافية). تُخصم تكاليف تركيبات الحالات هذه فقط عند تفعيل "احتساب تكاليف تركيبات الحالات كمصروفات" في المالية ← المصروفات؛ وإلا تُعرض كتقديرات فقط. التكاليف غير المحددة في الفلاتر لا تُخصم. المصروفات النقدية العامة في تقرير التحصيلات. الضريبة والتوصيل يبقيان في طلبات الإيرادات فقط.',
    'revenueReport.netProfitSummary.formulaCostsNotCounted': 'تُعرض تكاليف تركيبات الحالات كتقديرات فقط: لا تُخصم من صافي الأرباح ولا تُرحّل إلى القيود. لاحتسابها، فعّل "احتساب تكاليف تركيبات الحالات كمصروفات" في المالية ← المصروفات.',
    'revenueReport.netProfitSummary.formulaCostHint': 'تقدير من تكاليف تركيبات الحالات. لا يُخصم من صافي الأرباح ولا يُرحّل إلى القيود.',
    'revenueReport.netProfitSummary.type': 'النوع',
    'revenueReport.netProfitSummary.amount': 'المبلغ',
    'revenueReport.netProfitSummary.totalIncome': 'إجمالي الدخل',
    'revenueReport.netProfitSummary.totalTechnicianCost': 'إجمالي تكلفة الفنيين',
    'revenueReport.netProfitSummary.totalMaterialCost': 'إجمالي تكلفة الخامات',
    'revenueReport.netProfitSummary.generalExpenses': 'المصروفات العامة',
    'revenueReport.netProfitSummary.others': 'أخرى',
    'revenueReport.netProfitSummary.netProfit': 'صافي الأرباح',
    'revenueReport.section.formulaTypesTracker': 'متعقب أنواع التركيبات',
    'revenueReport.section.latestFormulaTypes': 'أحدث أنواع التركيبات استخداما',
    'revenueReport.section.receivables': 'المستحقات غير المحصّلة',
    'revenueReport.receivables.hint': 'الطلبات القابلة للفوترة غير المدفوعة التي استحقت في هذه الفترة. المتبقي هو إجمالي الرصيد غير المدفوع؛ المتأخر وغير المستحق يصنّفانه حسب موعد استحقاق الفاتورة. الطلبات غير المفوترة غير المدفوعة تُحسب ضمن غير المستحق.',
    'revenueReport.receivables.outstanding': 'المتبقي',
    'revenueReport.receivables.overdue': 'متأخر',
    'revenueReport.receivables.current': 'غير مستحق',
    'revenueReport.receivables.empty': 'لا توجد مستحقات غير محصّلة في هذه الفترة',
    'revenueReport.section.byClient': 'حسب العميل',
    'revenueReport.byClient.hint': 'طلبات الإيرادات في هذه الفترة مجمّعة حسب العميل (إيرادات الاستحقاق).',
    'revenueReport.byClient.client': 'العميل',
    'revenueReport.byClient.orders': 'الطلبات',
    'revenueReport.byClient.amount': 'المبلغ',
    'revenueReport.byClient.uncategorized': 'بدون عميل',
    'revenueReport.byClient.empty': 'لا توجد إيرادات حسب العميل في هذه الفترة',

    'monthSummary.title': 'تقرير التحصيلات',
    'monthSummary.subtitle': 'أساس نقدي: الدخل من الطلبات القابلة للفوترة المدفوعة في هذه الفترة (حسب تاريخ الدفع) بعد خصم الطلب. الطلبات المستحقة غير المدفوعة غير محتسبة. فائض النقد = المجموع الفرعي للطلبات المدفوعة − المصروفات العامة. تكاليف أنواع التركيبات تعرض هامش العمل المُحصَّل فقط ولا تُخصم من فائض النقد. لا تجمع هذا الفائض مع صافي تقرير الإيرادات.',
    'monthSummary.countLabel': 'أنواع تركيبات',
    'monthSummary.section.formulaTypesProfit': 'أرباح أنواع التركيبات',
    'monthSummary.period.month': 'شهر',
    'monthSummary.period.range': 'نطاق تاريخ',
    'monthSummary.includeCosts': 'احتساب التكاليف:',
    'monthSummary.includeCosts.material': 'الخامة',
    'monthSummary.includeCosts.technician': 'الفني',
    'monthSummary.includeCosts.additional': 'الإضافية',
    'monthSummary.column.name': 'نوع التركيبة',
    'monthSummary.column.units': 'عدد الوحدات',
    'monthSummary.column.sellingPrice': 'سعر البيع للوحدة',
    'monthSummary.column.totalIncome': 'إجمالي الدخل',
    'monthSummary.column.materialCost': 'تكلفة الخامة للوحدة',
    'monthSummary.column.totalMaterial': 'إجمالي تكلفة الخامة',
    'monthSummary.column.technicianCost': 'تكلفة الفني للوحدة',
    'monthSummary.column.totalTechnician': 'إجمالي تكلفة الفني',
    'monthSummary.column.additionalCost': 'التكلفة الإضافية للوحدة',
    'monthSummary.column.totalAdditional': 'إجمالي التكاليف الإضافية',
    'monthSummary.column.netProfit': 'صافي الأرباح',
    'monthSummary.totals': 'الإجمالي',
    'monthSummary.empty': 'لا توجد وحدات في هذه الفترة',
    'monthSummary.sellingPriceVaries': 'متوسط، لأن الوحدات بيعت بأسعار مختلفة. افتح الصف لعرض كل سعر.',
    'monthSummary.priceSource.default': 'السعر الافتراضي',
    'monthSummary.priceSource.client': 'سعر العميل',
    'monthSummary.priceSource.custom': 'سعر مخصص (في الطلب)',
    'monthSummary.priceSource.clientsCount': '{{count}} عميل',
    'monthSummary.priceSource.noClient': 'بدون عميل',
    'monthSummary.noAccess': 'ليس لديك صلاحية عرض تقرير التحصيلات',
    'monthSummary.loadError': 'تعذر تحميل تقرير التحصيلات',
    'monthSummary.section.paidOrders': 'الطلبات المدفوعة',
    'monthSummary.paidOrders.hint': 'إجماليات الطلبات القابلة للفوترة المدفوعة في هذه الفترة (حسب تاريخ الدفع): التركيبات، خصم الطلب، التكاليف الإضافية، المجموع الفرعي، الضريبة، التوصيل، والإجمالي. أرباح أنواع التركيبات تستخدم التركيبات بعد الخصم؛ تكاليفها هامش العمل المُحصَّل فقط.',
    'monthSummary.paidOrders.type': 'النوع',
    'monthSummary.paidOrders.amount': 'المبلغ',
    'monthSummary.paidOrders.formulas': 'التركيبات',
    'monthSummary.paidOrders.discount': 'الخصم',
    'monthSummary.paidOrders.additionalCosts': 'تكاليف إضافية',
    'monthSummary.paidOrders.subtotal': 'المجموع الفرعي',
    'monthSummary.paidOrders.vat': 'إجمالي الضريبة',
    'monthSummary.paidOrders.delivery': 'تكاليف التوصيل',
    'monthSummary.paidOrders.total': 'الإجمالي',
    'monthSummary.paidOrders.ordersCount': '{{count}} طلب مدفوع',
    'monthSummary.paidOrders.empty': 'لا توجد طلبات مدفوعة في هذه الفترة',
    'monthSummary.section.generalExpenses': 'المصروفات العامة',
    'monthSummary.generalExpenses.hint': 'مصروفات تشغيل نقدية مُدخلة يدويًا في هذه الفترة. لا تشمل المصروفات المُنشأة تلقائيًا من الطلبات (تلك تتبع تكاليف الإنتاج في تقرير الإيرادات).',
    'monthSummary.notBillableOrders': '{{count}} طلب في هذه الفترة غير محتسب بعد لأنه لم يصل إلى الحالة المحددة في سير عمل حالات الطلب.',
    'monthSummary.unpaidOrders': '{{count}} طلب مستحق غير مدفوع في هذه الفترة غير محتسب في التحصيلات (الأرصدة المستحقة لا تُحتسب حتى يتم الدفع).',
    'monthSummary.generalExpenses.expenseType': 'نوع المصروف',
    'monthSummary.generalExpenses.expenses': 'المصروفات',
    'monthSummary.generalExpenses.uncategorized': 'بدون بند',
    'monthSummary.generalExpenses.empty': 'لا توجد مصروفات عامة في هذه الفترة',
    'monthSummary.section.netProfitSummary': 'ملخص فائض النقد',
    'monthSummary.netProfitSummary.hint': 'أساس نقدي: إجمالي الدخل هو المجموع الفرعي للطلبات المدفوعة (بعد الخصومات ويشمل التكاليف الإضافية). فائض النقد = إجمالي الدخل − المصروفات العامة. تكاليف إنتاج أنواع التركيبات لا تُخصم هنا (انظر أرباح أنواع التركيبات لهامش العمل المُحصَّل). الضريبة والتوصيل يبقيان في الطلبات المدفوعة فقط.',
    'monthSummary.netProfitSummary.type': 'النوع',
    'monthSummary.netProfitSummary.amount': 'المبلغ',
    'monthSummary.netProfitSummary.totalIncome': 'إجمالي الدخل',
    'monthSummary.netProfitSummary.totalTechnicianCost': 'إجمالي تكلفة الفنيين',
    'monthSummary.netProfitSummary.totalMaterialCost': 'إجمالي تكلفة الخامات',
    'monthSummary.netProfitSummary.generalExpenses': 'المصروفات العامة',
    'monthSummary.netProfitSummary.others': 'أخرى',
    'monthSummary.netProfitSummary.netProfit': 'فائض النقد',
    'monthSummary.section.formulaTypesTracker': 'متعقب أنواع التركيبات',
    'monthSummary.section.latestFormulaTypes': 'أحدث أنواع التركيبات استخداما',
    // Invoices
    'invoices.header.title': 'الفواتير',
    'invoices.header.subtitle': 'إدارة فواتير المعمل ومتابعة التحصيلاتات وحالات الدفع والسجلات المالية',
    'invoices.stats.total': 'إجمالي الفواتير',
    'invoices.stats.amount': 'إجمالي المبلغ',
    'invoices.stats.paid': 'إجمالي المدفوع',
    'invoices.stats.unpaid': 'إجمالي غير المدفوع',
    'invoices.filter.title': 'تصفية الفواتير',
    'invoices.filter.active': 'مفعل',
    'invoices.filter.clear': 'إعادة تعيين عوامل التصفية',
    'invoices.table.refresh': 'تحديث',
    'invoices.table.ordersCount': 'الطلبات',
    'invoices.table.number': 'رقم الفاتورة',
    'invoices.table.status': 'الحالة',
    'invoices.table.issueDate': 'تاريخ الإصدار',
    'invoices.table.client': 'العميل',
    'invoices.table.dentist': 'طبيب الأسنان',
    'invoices.table.dueDate': 'تاريخ الاستحقاق',
    'invoices.table.total': 'الإجمالي',
    'invoices.table.remaining': 'متبقي',
    'invoices.table.actions': 'الاجراءات',
    'invoices.table.draft': 'مؤرشفة',
    'invoices.table.draftLabel': 'مؤرشفة',
    'invoices.search.placeholder': 'بحث برقم الفاتورة، المرجع، العميل، الطبيب أو الملاحظات',
    'invoices.confirm.delete': 'هل أنت متأكد أنك تريد حذف هذه الفاتورة؟',
    'invoices.alert.noAccess': 'ليس لديك صلاحية لعرض الفواتير.',
    'sidebar.formula_types': 'التركيبات والخدمات',
    'sidebar.colors': 'الألوان',
    'sidebar.platform_settings': 'إعدادات المنصة',
    'sidebar.notifications_settings': 'إعدادات الإشعارات',
    'sidebar.support_chat': 'محادثة الدعم',
    'sidebar.assets': 'الأصول الثابتة',
    'sidebar.branchs': 'الفروع',
    'sidebar.delivery_centers': 'مراكز التوصيل',
    'sidebar.expenses': 'المصروفات',
    'sidebar.expense_types': 'بنود المصروفات',
    'sidebar.dentists': 'أطباء الأسنان',
    'sidebar.users': 'المستخدمون',
    'sidebar.roles': 'الأدوار والصلاحيات',
    'sidebar.transactions': 'المعاملات',
    'sidebar.activities': 'سجل العمليات',
    'sidebar.units': 'الوحدات',
    'sidebar.unit_types': 'أنواع الوحدات',

    // Activities
    'activities.table.entity_affected': 'السجل المتأثر',
    'activities.table.user': 'اسم المستخدم',
    'activities.table.operation': 'العملية',
    'activities.table.ip': 'عنوان الجهاز',
    'activities.table.date': 'التاريخ',
    'activities.table.properties': 'الخصائص',
    'activities.filters.name': 'الاسم',
    'activities.filters.entity': 'الكيان',
    'activities.filters.operation': 'العملية',
    'activities.operations.create': 'إنشاء',
    'activities.operations.created': 'إنشاء',
    'activities.operations.update': 'تحديث',
    'activities.operations.updated': 'تحديث',
    'activities.operations.delete': 'حذف',
    'activities.operations.deleted': 'حذف',
    'activities.operations.paid_invoice': 'دفع فاتورة',
    'activities.operations.undo_mark_paid': 'التراجع عن تعليم كمدفوعة',
    'activities.operations.refund_invoice': 'استرداد فاتورة',
    'activities.operations.partial_payment': 'دفع جزئي لفاتورة',
    'activities.operations.mark_order_paid': 'تعليم الطلب كمدفوع',
    'activities.operations.mark_order_unpaid': 'تعليم الطلب كغير مدفوع',
    'activities.operations.restore_order_status_after_invoice_unpaid': 'استعادة حالة الطلب بعد تحويل الفاتورة إلى غير مدفوعة',
    'activities.operations.restore_order_status_after_invoice_detach': 'استعادة حالة الطلب بعد فصله عن الفاتورة',
    'activities.operations.mark_order_partially_paid': 'تعليم الطلب كمدفوع جزئياً',
    'activities.operations.cancel': 'إلغاء',
    'activities.operations.send_email': 'إرسال بريد إلكتروني',
    'activities.operations.send_whatsapp': 'إرسال واتساب',
    'activities.operations.download_invoice_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_invoice_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    'activities.operations.download_invoice_spreadsheet': 'تحميل الفاتورة Excel / CSV',
    'activities.operations.upload_attachment': 'رفع مرفق',
    'activities.operations.delete_attachment': 'حذف مرفق',
    'activities.operations.export_account_statement': 'تنزيل كشف الحساب',
    // Legacy activity event aliases
    'activities.operations.download_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    'activities.operations.login': 'تسجيل الدخول',
    'activities.operations.logout': 'تسجيل الخروج',
    'activities.operations.password_reset': 'إعادة تعيين كلمة المرور',
    'activities.operations.password_reset_request': 'طلب إعادة تعيين كلمة المرور',
    'activities.operations.impersonate': 'انتحال هوية',
    'activities.operations.wallet_recharge': 'شحن محفظة',
    'activities.operations.update_wallet_log_date': 'تغيير تاريخ سجل المحفظة',
    'activities.operations.wallet_recharge_revert': 'تراجع عن شحن محفظة',
    'activities.properties.field': 'الحقل',
    'activities.properties.old': 'القيمة السابقة',
    'activities.properties.new': 'القيمة الجديدة',
    'activities.properties.no_changes': 'لا توجد بيانات مقارنة قديم/جديد لهذا النشاط.',
    'activities.modal.properties_title': 'الخصائص المتغيرة',
    'activities.fields.id': 'المعرف',
    'activities.fields.name': 'الاسم',
    'activities.fields.email': 'البريد الإلكتروني',
    'activities.fields.phone': 'رقم الهاتف',
    'activities.fields.notes': 'ملاحظات',
    'activities.fields.address': 'العنوان',
    'activities.fields.whatsapp': 'واتساب',
    'activities.fields.client': 'العميل',
    'activities.fields.client_id': 'العميل',
    'activities.fields.client_name': 'العميل',
    'activities.fields.client_address': 'عنوان العميل',
    'activities.fields.dentist': 'الطبيب',
    'activities.fields.dentist_id': 'الطبيب',
    'activities.fields.dentist_name': 'الطبيب',
    'activities.fields.dentist_email': 'البريد الإلكتروني للطبيب',
    'activities.fields.dentist_phone': 'هاتف الطبيب',
    'activities.fields.technician': 'الفني',
    'activities.fields.technician_id': 'الفني',
    'activities.fields.technician_name': 'اسم الفني',
    'activities.fields.technician_email': 'البريد الإلكتروني للفني',
    'activities.fields.courier': 'مندوب التوصيل',
    'activities.fields.courier_id': 'مندوب التوصيل',
    'activities.fields.orders': 'الطلبات',
    'activities.fields.units': 'الوحدات',
    'activities.fields.units_count': 'عدد الوحدات',
    'activities.fields.attachments': 'المرفقات',
    'activities.fields.requested_at': 'تاريخ الطلب',
    'activities.fields.delivered_at': 'تم التسليم',
    'activities.fields.code': 'الكود',
    'activities.fields.color': 'اللون',
    'activities.fields.formula_type': 'نوع التركيبة',
    'activities.fields.delivery_type': 'نوع التوصيل',
    'activities.fields.delivery_type_name': 'نوع التوصيل',
    'activities.fields.user_type': 'نوع المستخدم',
    'activities.fields.payment_method': 'طريقة الدفع',
    'activities.fields.payment_method_id': 'طريقة الدفع',
    'activities.fields.payment_status': 'حالة الدفع',
    'activities.fields.payment_status_id': 'حالة الدفع',
    'activities.fields.order_status': 'حالة الطلب',
    'activities.fields.delivery_center': 'مركز التوصيل',
    'activities.fields.delivery_center_id': 'مركز التوصيل',
    'activities.fields.cost_center_id': 'مركز التكلفة',
    'activities.fields.delivery_center_name': 'اسم مركز التوصيل',
    'activities.fields.delivery_center_address': 'عنوان مركز التوصيل',
    'activities.fields.delivery_center_created_at': 'تاريخ إنشاء مركز التوصيل',
    'activities.fields.delivery_center_updated_at': 'تاريخ تحديث مركز التوصيل',
    'activities.fields.delivery_cost': 'تكلفة التوصيل',
    'activities.fields.discount_amount': 'قيمة الخصم',
    'activities.fields.vat_percentage': 'نسبة الضريبة',
    'activities.fields.unit_price_override': 'تجاوز سعر الوحدة',
    'activities.fields.unit_price_source': 'مصدر سعر الوحدة',
    'activities.fields.reference': 'المرجع',
    'activities.fields.is_draft': 'مسودة',
    'activities.fields.due_date': 'تاريخ الاستحقاق',
    'activities.fields.issue_date': 'تاريخ الإصدار',
    'activities.fields.paid_at': 'تاريخ الدفع',
    'activities.fields.paid_amount': 'المبلغ المدفوع',
    'activities.fields.total_amount': 'الإجمالي',
    'activities.fields.subtotal_amount': 'الإجمالي الفرعي',
    'activities.fields.remaining_amount': 'المبلغ المتبقي',
    'activities.fields.created_at': 'تاريخ الإنشاء',
    'activities.fields.balance': 'الرصيد',
    'activities.fields.updated_at': 'تاريخ التحديث',

    'auth.login.title': 'مرحبًا بعودتك',
    'auth.login.vendorTitle': 'صفحة دخول المعمل',
    'auth.login.vendorSubtitle': 'سجّل الدخول لإدارة معملك',
    'auth.login.brandLede': 'الطلبات والفواتير والتوصيل — كل شيء لمعملك في مكان واحد.',
    'auth.login.formSubtitle': 'سجّل الدخول بالبريد الإلكتروني أو اسم المستخدم وكلمة المرور',
    'auth.login.secureNotice': 'وصول محمي لموظفي المعمل المصرّح لهم فقط.',
    'auth.login.newAccount.title': 'حسابك جاهز',
    'auth.login.newAccount.message': 'قمنا بتعبئة بريدك الإلكتروني وكلمة مرور مؤقتة. سجّل الدخول الآن، ثم انتقل إلى الملف الشخصي ← تغيير كلمة المرور واستبدلها بكلمة مرور قوية (8 أحرف على الأقل تجمع بين الحروف والأرقام والرموز).',
    'auth.login.email.label': 'البريد الإلكتروني',
    'auth.login.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'auth.login.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'auth.login.email.placeholder': 'ادخل البريد الإلكتروني',
    'auth.login.identifier.label': 'البريد الإلكتروني أو اسم المستخدم',
    'auth.login.identifier.required': 'من فضلك ادخل البريد الإلكتروني أو اسم المستخدم',
    'auth.login.identifier.placeholder': 'ادخل البريد الإلكتروني أو اسم المستخدم',
    'auth.login.password.label': 'كلمة المرور',
    'auth.login.password.required': 'من فضلك ادخل كلمة المرور',
    'auth.login.password.placeholder': 'ادخل كلمة المرور',
    'auth.login.submit': 'تسجيل الدخول',
    'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
    'auth.forgotPassword.title': 'إعادة تعيين كلمة المرور',
    'auth.forgotPassword.description': 'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.',
    'auth.forgotPassword.brandHeadline': 'استعد الوصول خلال خطوات بسيطة',
    'auth.forgotPassword.brandLede': 'استخدم بريدك لإرسال رابط إعادة التعيين، أو اعرض بيانات مدير المعمل إذا كنت تسجّل الدخول باسم مستخدم فقط.',
    'auth.forgotPassword.submit': 'إرسال رابط إعادة التعيين',
    'auth.forgotPassword.success': 'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    'auth.forgotPassword.failed': 'تعذر إرسال رابط إعادة التعيين. يرجى المحاولة مرة أخرى.',
    'auth.forgotPassword.backToLogin': 'العودة إلى تسجيل الدخول',
    'auth.forgotPassword.noEmailDivider': 'بدون بريد إلكتروني؟',
    'auth.forgotPassword.noEmailDescription': 'إذا كنت تسجّل الدخول باسم مستخدم وليس لديك بريد إلكتروني، أدخل اسم المستخدم لعرض بيانات التواصل مع مدير المعمل. يمكنه إعادة تعيين كلمة المرور إلى الكلمة المؤقتة.',
    'auth.forgotPassword.contactAdmin': 'عرض بيانات المدير',
    'auth.forgotPassword.usernameRequired': 'من فضلك ادخل اسم المستخدم',
    'auth.forgotPassword.contactFailed': 'تعذر جلب بيانات التواصل. يرجى المحاولة مرة أخرى.',
    'auth.forgotPassword.hasEmail': 'هذا الحساب مرتبط ببريد إلكتروني. استخدم النموذج أعلاه لإرسال رابط إعادة التعيين.',
    'auth.forgotPassword.contactFound': 'تواصل مع مدير المعمل واطلب منه إعادة تعيين كلمة المرور.',
    'auth.forgotPassword.contactAdminGeneric': 'تواصل مع مدير المعمل واطلب منه إعادة تعيين كلمة المرور إلى الكلمة المؤقتة.',
    'auth.resetPassword.title': 'تعيين كلمة مرور جديدة',
    'auth.resetPassword.description': 'اختر كلمة مرور جديدة لحسابك.',
    'auth.resetPassword.brandHeadline': 'اختر كلمة مرور قوية وجديدة',
    'auth.resetPassword.brandLede': 'بعد إعادة التعيين يمكنك تسجيل الدخول مجددًا ببياناتك المحدّثة.',
    'auth.resetPassword.password.label': 'كلمة المرور الجديدة',
    'auth.resetPassword.password.required': 'من فضلك أدخل كلمة مرور جديدة',
    'auth.resetPassword.password.minLength': 'يجب ألا تقل كلمة المرور عن 8 أحرف',
    'auth.resetPassword.password.placeholder': 'أدخل كلمة المرور الجديدة',
    'auth.resetPassword.password.confirm': 'تأكيد كلمة المرور',
    'auth.resetPassword.password.confirmRequired': 'من فضلك أكد كلمة المرور',
    'auth.resetPassword.password.confirmPlaceholder': 'أكد كلمة المرور الجديدة',
    'auth.resetPassword.password.mismatch': 'كلمتا المرور غير متطابقتين',
    'auth.resetPassword.submit': 'إعادة تعيين كلمة المرور',
    'auth.resetPassword.success': 'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'auth.resetPassword.failed': 'تعذر إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    'auth.resetPassword.error': 'رابط غير صالح',
    'auth.resetPassword.invalidLink': 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',

    'assets.table.name': 'الاسم',
    'assets.table.cost': 'القيمة',
    'assets.table.notes': 'ملاحظات',
    'assets.table.actions': 'العمليات',
    'assets.button.add': 'إضافة أصل',
    'assets.editTitle': 'تعديل أصل',
    'assets.modal.title': 'الأصول الثابتة',
    'assets.confirm.deleteTitle': 'حذف أصل',
    'assets.confirm.deleteMessage': 'هل تريد حذف هذا الأصل؟',
    'assets.form.name.label': 'اسم الأصل',
    'assets.form.name.placeholder': 'ادخل اسم الأصل',
    'assets.form.name.required': 'من فضلك أدخل اسم الأصل',
    'assets.form.cost.label': 'التكلفة',
    'assets.form.cost.placeholder': 'أدخل التكلفة',
    'assets.form.cost.required': 'من فضلك أدخل التكلفة',
    'assets.form.cost.min': 'يجب أن تكون التكلفة ١ على الأقل',
    'assets.form.notes.label': 'ملاحظات',
    'assets.form.notes.placeholder': 'ادخل الملاحظات',
    'assets.table.attachments': 'المرفقات',
    'assets.form.attachments.label': 'الصور والملفات',
    'assets.form.attachments.hint': 'أرفق صورًا أو فواتير أو ضمانات أو كتيبات (بحد أقصى ٢٠ ميجابايت لكل ملف).',
    'assets.form.attachments.choose': 'اختر الملفات',
    'assets.form.attachments.existing': 'المرفقات الحالية',
    'assets.form.attachments.deleteConfirm': 'هل تريد حذف هذا المرفق؟',
    'assets.form.attachments.deleted': 'تم حذف المرفق',
    'assets.form.attachments.deleteFailed': 'تعذر حذف المرفق',
    'assets.form.attachments.tooLarge': 'حجم الملف أكبر من ٢٠ ميجابايت',
    'assets.search.namePlaceholder': 'ابحث بالاسم',
    'assets.search.notesPlaceholder': 'ابحث بالملاحظات',
    'assets.alert.noAccess': 'ليس لديك صلاحية لعرض الأصول.',

    'branchs.table.name': 'اسم الفرع',
    'branchs.table.address': 'العنوان',
    'branchs.table.phone': 'رقم التليفون',
    'branchs.table.whatsapp': 'رقم الواتساب',
    'branchs.table.email': 'البريد الإلكتروني',
    'branchs.table.notes': 'ملاحظات',
    'branchs.table.actions': 'العمليات',
    'branchs.button.add': 'إضافة فرع',
    'branchs.editTitle': 'تعديل فرع',
    'branchs.modal.title': 'إعدادت الفروع',
    'branchs.confirm.deleteTitle': 'حذف فرع',
    'branchs.confirm.deleteMessage': 'هل تريد حذف هذا الفرع؟',
    'branchs.form.name.label': 'اسم الفرع',
    'branchs.form.name.placeholder': 'ادخل اسم الفرع',
    'branchs.form.name.required': 'من فضلك ادخل اسم الفرع',
    'branchs.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'branchs.form.address.label': 'العنوان',
    'branchs.form.address.placeholder': 'ادخل العنوان',
    'branchs.form.address.required': 'من فضلك ادخل العنوان',
    'branchs.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'branchs.form.phone.label': 'رقم التليفون',
    'branchs.form.phone.placeholder': 'ادخل رقم التليفون',
    'branchs.form.phone.required': 'من فضلك ادخل رقم التليفون',
    'branchs.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'branchs.form.whatsapp.label': 'رقم الواتساب',
    'branchs.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'branchs.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'branchs.form.email.label': 'البريد الإلكتروني',
    'branchs.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'branchs.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'branchs.form.notes.label': 'ملاحظات',
    'branchs.form.notes.placeholder': 'ادخل الملاحظات',
    'branchs.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'branchs.alert.noAccess': 'ليس لديك صلاحية لعرض الفروع.',

    'deliveryCenters.table.name': 'اسم المركز',
    'deliveryCenters.table.address': 'العنوان',
    'deliveryCenters.table.phone': 'رقم التليفون',
    'deliveryCenters.table.whatsapp': 'رقم الواتساب',
    'deliveryCenters.table.email': 'البريد الإلكتروني',
    'deliveryCenters.table.client': 'العميل المعين',
    'deliveryCenters.table.noClient': 'لا يوجد عميل معين',
    'deliveryCenters.table.actions': 'العمليات',
    'deliveryCenters.button.add': 'إضافة مركز توصيل',
    'deliveryCenters.modal.title': 'مراكز التوصيل',
    'deliveryCenters.confirm.deleteTitle': 'حذف مركز توصيل',
    'deliveryCenters.confirm.deleteMessage': 'هل تريد حذف هذا المركز؟',
    'deliveryCenters.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'deliveryCenters.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'deliveryCenters.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'deliveryCenters.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'deliveryCenters.form.client.label': 'العميل',
    'deliveryCenters.form.client.placeholder': 'اختر العميل',
    'deliveryCenters.form.client.required': 'من فضلك اختر العميل',
    'deliveryCenters.alert.noAccess': 'ليس لديك صلاحية لعرض مراكز التوصيل.',
    'deliveryCenters.filter.title': 'تصفية مراكز التوصيل',
    'deliveryCenters.filter.active': 'مفعل',
    'deliveryCenters.filter.clear': 'إعادة تعيين عوامل التصفية',
    'deliveryCenters.filter.searchPlaceholder': 'ابحث بالاسم أو العنوان أو الهاتف أو واتساب أو البريد الإلكتروني',
    'responses.delivery_center.updated': 'تم تحديث مركز التوصيل بنجاح',

    'clients.header.title': 'العملاء',
    'clients.header.subtitle': 'إدارة العيادات والمستشفيات والمعامل مع جهات الاتصال والأطباء ومراكز التسليم',
    'clients.filter.title': 'تصفية العملاء',
    'clients.filter.active': 'مفعل',
    'clients.filter.clear': 'إعادة تعيين عوامل التصفية',
    'clients.filter.type.placeholder': 'نوع العميل',
    'clients.wallet.historyEmpty': 'لا توجد معاملات محفظة بعد',
    'clients.alert.noAccess': 'ليس لديك صلاحية لعرض العملاء.',
    'clients.table.name': 'اسم العميل',
    'clients.table.type': 'نوع العميل',
    'clients.table.phone': 'رقم التليفون',
    'clients.table.whatsapp': 'رقم الواتساب',
    'clients.table.email': 'البريد الإلكتروني',
    'clients.table.dentists': 'الأطباء المسؤولون ',
    'clients.table.noDentists': 'لا يوجد أطباء معينون',
    'clients.table.noLabContacts': 'لا توجد جهات اتصال مختبر معينة',
    'clients.table.showMore': 'عرض المزيد',
    'clients.table.showLess': 'عرض أقل',
    'clients.table.deliveryCenters': 'مراكز التسليم',
    'clients.table.noDeliveryCenters': 'لا توجد مراكز تسليم معينة',
    'clients.table.actions': 'العمليات',
    'clients.formulaTypePrices.button': 'أسعار أنواع التركيبات',
    'clients.formulaTypePrices.title': 'أسعار أنواع التركيبات لـ',
    'clients.formulaTypePrices.help': 'حدد سعر الوحدة المخصص لكل نوع تركيبة لهذا العميل. اتركه فارغًا لاستخدام سعر البيع الافتراضي.',
    'clients.formulaTypePrices.formulaType': 'نوع التركيبة',
    'clients.formulaTypePrices.defaultPrice': 'السعر الافتراضي',
    'clients.formulaTypePrices.customPrice': 'سعر الوحدة المخصص',
    'clients.formulaTypePrices.noChanges': 'لا توجد تغييرات للحفظ',
    'clients.button.add': 'إضافة عميل',
    'clients.editTitle': 'تعديل عميل',
    'clients.title': 'العميل',
    'clients.modal.title': 'العملاء',
    'clients.confirm.deleteTitle': 'حذف عميل',
    'clients.confirm.deleteMessage': 'هل تريد حذف هذا العميل؟',
    'clients.form.name.label': 'اسم العميل',
    'clients.form.name.placeholder': 'اسم العميل',
    'clients.form.name.required': 'من فضلك ادخل اسم العميل',
    'clients.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'clients.form.type.label': 'نوع العميل',
    'clients.form.type.placeholder': 'اختر نوع العميل',
    'clients.form.type.required': 'من فضلك اختر نوع العميل',
    'clients.form.type.options.clinic': 'عيادة',
    'clients.form.type.options.hospital': 'مستشفى',
    'clients.form.type.options.lab': 'معمل',
    'clients.form.search.placeholder': 'ابحث بالاسم أو البريد أو الهاتف',
    'clients.form.phone.label': 'رقم الهاتف',
    'clients.form.phone.placeholder': 'ادخل رقم الهاتف',
    'clients.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'clients.form.whatsapp.label': 'رقم الواتساب',
    'clients.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'clients.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'clients.form.email.label': 'البريد الإلكتروني',
    'clients.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'clients.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'clients.form.dentists.label': 'الأطباء',
    'clients.form.dentists.placeholder': 'اختر الأطباء',
    'clients.form.dentists.empty': 'لا يوجد أطباء متاحون',
    'clients.form.dentists.labelLab': 'جهات اتصال المختبر',
    'clients.form.dentists.placeholderLab': 'اختر جهات اتصال المختبر',
    'clients.form.dentists.emptyLab': 'لا توجد جهات اتصال مختبر متاحة',
    'clients.form.deliveryCenters.label': 'مراكز التسليم',
    'clients.form.deliveryCenters.placeholder': 'اختر أو أضف مراكز التسليم',
    'clients.form.deliveryCenters.empty': 'لا توجد مراكز تسليم متاحة',
    'clients.form.submit.edit': 'تحديث',
    'clients.form.submit.createThenContacts': 'إنشاء العميل ثم إضافة جهات الاتصال',
    'clients.form.submit.createWithContacts': 'إنشاء العميل مع جهات الاتصال',
    'clients.form.contactMode.label': 'جهات الاتصال لهذا العميل',
    'clients.form.contactMode.required': 'من فضلك اختر طريقة إضافة جهات الاتصال',
    'clients.form.contactMode.mirror': 'إنشاء طبيب بنفس بيانات العميل',
    'clients.form.contactMode.mirrorLab': 'إنشاء جهة اتصال مختبر بنفس بيانات العميل',
    'clients.form.contactMode.mirrorHelp': 'مناسب عندما يكون للعيادة/المستشفى طبيب واحد — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.mirrorHelpLab': 'مناسب عندما يكون للمعمل جهة اتصال واحدة — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.list': 'إضافة عدة أطباء',
    'clients.form.contactMode.listLab': 'إضافة عدة جهات اتصال مختبر',
    'clients.form.contactMode.listHelp': 'سيتم توسيع هذا النموذج لإضافة طبيب أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.listHelpLab': 'سيتم توسيع هذا النموذج لإضافة جهة اتصال أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.dentistTypeMissing': 'نوع مستخدم الطبيب غير متاح. حدّث الصفحة وحاول مرة أخرى.',
    'clients.form.mirror.sectionTitle': 'بيانات دخول الطبيب',
    'clients.form.mirror.sectionTitleLab': 'بيانات دخول جهة اتصال المختبر',
    'clients.form.mirror.hint': 'يتم أخذ الاسم والهاتف والواتساب والبريد من العميل. البريد الإلكتروني واسم المستخدم اختياريان.',
    'clients.form.mirror.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء الطبيب. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.mirror.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء جهة اتصال المختبر. يمكنك الإضافة من صفحة العميل.',
    'clients.form.list.sectionTitle': 'الأطباء',
    'clients.form.list.sectionTitleLab': 'جهات اتصال المختبر',
    'clients.form.list.clientCreated': 'تم إنشاء العميل "{{name}}"',
    'clients.form.list.stepTitle': 'إضافة أطباء — {{name}}',
    'clients.form.list.stepTitleLab': 'إضافة جهات اتصال مختبر — {{name}}',
    'clients.form.list.stepHelp': 'أضف طبيبًا أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.stepHelpLab': 'أضف جهة اتصال أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.addAnother': 'إضافة طبيب آخر',
    'clients.form.list.addAnotherLab': 'إضافة جهة اتصال أخرى',
    'clients.form.list.saveContacts': 'حفظ الأطباء',
    'clients.form.list.saveContactsLab': 'حفظ جهات اتصال المختبر',
    'clients.form.list.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء بعض الأطباء. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء بعض جهات الاتصال. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.done': 'تم',
    'clients.type.clinic': 'عيادة',
    'clients.type.hospital': 'مستشفى',
    'clients.type.lab': 'معمل',
    'clients.wallet.title': 'محفظة العميل',
    'clients.tabs.overview': 'نظرة عامة',
    'clients.tabs.wallet': 'المحفظة',
    'clients.tabs.deliveryCenters': 'مراكز التوصيل',
    'clients.tabs.dentists': 'الأطباء',
    'clients.tabs.labContacts': 'جهات اتصال المختبر',
    'clients.tabs.customPrices': 'الأسعار المخصوصة',
    'clients.tabs.accountStatement': 'كشف الحساب',
    'clients.tabs.orders': 'الطلبات',
    'clients.tabs.invoices': 'الفواتير',
    'clients.accountStatement.serial': 'الرقم التسلسلي',
    'clients.accountStatement.amount': 'المبلغ',
    'clients.accountStatement.status': 'حالة الدفع',
    'clients.accountStatement.orderStatus': 'حالة الطلب',
    'clients.accountStatement.paymentStatus': 'حالة الدفع',
    'clients.accountStatement.paid': 'مدفوع',
    'clients.accountStatement.due': 'مستحق',
    'clients.accountStatement.total': 'الإجمالي',
    'clients.accountStatement.empty': 'لا توجد طلبات لهذا العميل بعد',
    'clients.accountStatement.patient': 'المريض',
    'clients.accountStatement.positions': 'المواضع',
    'clients.accountStatement.units': 'عدد الوحدات',
    'clients.accountStatement.formula': 'التركيبة',
    'clients.accountStatement.arch': 'فك',
    'clients.accountStatement.paymentMethod': 'طريقة الدفع',
    'clients.accountStatement.date': 'التاريخ',
    'clients.accountStatement.color': 'اللون',
    'clients.accountStatement.periodDue': 'المستحق للفترة المحددة',
    'clients.accountStatement.previousDue': 'المستحق السابق',
    'clients.accountStatement.clientTotalDue': 'إجمالي مستخفات علي العميل',
    'clients.totalOrdersAmount': 'إجمالي مبالغ الطلبات',
    'clients.totalOrdersPaidAmount': 'إجمالي مبالغ الطلبات المدفوعة',
    'clients.totalDueOrdersAmount': 'إجمالي المستحق',
    'clients.totalOrdersCount': 'إجمالي عدد الطلبات',
    'clients.paidOrdersCount': 'الطلبات المدفوعة',
    'clients.unpaidOrdersCount': 'الطلبات غير المدفوعة',
    'clients.notYetDueOrders': 'طلبات لم تستحق بعد',
    'clients.notYetDueOrdersCount': '{{count}} طلبات',
    'clients.walletBalance': 'رصيد المحفظة',
    'clients.wallet.balance': 'الرصيد',
    'clients.wallet.recharge': 'إعادة الشحن',
    'clients.wallet.amount': 'المبلغ',
    'clients.wallet.amountPlaceholder': 'أدخل المبلغ',
    'clients.wallet.notes': 'ملاحظات',
    'clients.wallet.notesPlaceholder': 'ملاحظات اختيارية لعملية الشحن',
    'clients.wallet.rechargeSuccess': 'تم شحن المحفظة بنجاح',
    'clients.wallet.rechargeError': 'فشل في شحن المحفظة',
    'clients.wallet.amountRequired': 'المبلغ مطلوب',
    'clients.wallet.amountMin': 'يجب أن يكون المبلغ 0.01 على الأقل',
    'clients.wallet.paymentMethod': 'طريقة الدفع',
    'clients.wallet.paymentMethodPlaceholder': 'اختر طريقة الدفع',
    'clients.wallet.attachments': 'المرفقات',
    'clients.wallet.uploadImage': 'رفع صورة',
    'clients.wallet.history': 'سجل المحفظة',
    'clients.wallet.historyDate': 'التاريخ',
    'clients.wallet.transactionType': 'النوع',
    'clients.wallet.changeDate': 'تغيير التاريخ',
    'clients.wallet.changeDateTitle': 'تغيير تاريخ سجل المحفظة',
    'clients.wallet.newDate': 'التاريخ الجديد',
    'clients.wallet.dateRequired': 'التاريخ مطلوب',
    'clients.wallet.changeDateSuccess': 'تم تحديث تاريخ سجل المحفظة',
    'clients.wallet.changeDateError': 'فشل تحديث تاريخ سجل المحفظة',
    'clients.wallet.actions': 'الإجراءات',
    'clients.wallet.revert': 'تراجع',
    'clients.wallet.reverted': 'تم التراجع',
    'clients.wallet.revertTitle': 'التراجع عن شحن المحفظة',
    'clients.wallet.revertConfirm': 'سيتم خصم {{amount}} من المحفظة وتحديد عملية الشحن كمُلغاة. لا يمكن التراجع عن هذا الإجراء.',
    'clients.wallet.revertNotesPlaceholder': 'سبب التراجع (اختياري)',
    'clients.wallet.revertSuccess': 'تم التراجع عن شحن المحفظة',
    'clients.wallet.revertError': 'فشل التراجع عن شحن المحفظة',
    'sidebar.clients': 'العملاء والأطباء',
    'sidebar.wallets': 'المحافظ',
    'wallets.title': 'المحافظ',
    'wallets.column.walletId': 'رقم المحفظة',
    'wallets.column.clientName': 'اسم العميل',
    'wallets.column.balance': 'الرصيد',
    'wallets.viewTitle': 'المحفظة #{{id}}',
    'wallets.backToList': 'العودة إلى المعاملات',
    'wallets.openClient': 'إعدادت العميل',
    'wallets.walletIdLabel': 'رقم المحفظة',
    'wallets.alert.noAccess': 'ليس لديك صلاحية لعرض المحافظ.',

    'colors.table.name': 'اللون',
    'colors.table.actions': 'العمليات',
    'colors.button.add': 'إضافة لون',
    'colors.modal.title': 'الألوان',
    'colors.confirm.deleteTitle': 'حذف لون',
    'colors.confirm.deleteMessage': 'هل تريد حذف هذا اللون؟',
    'colors.search.placeholder': 'بحث باسم اللون',
    'colors.form.code.placeholder': 'ادخل الكود',
    'colors.form.preview.label': 'معاينة لون السن',
    'colors.alert.noAccess': 'ليس لديك صلاحية لعرض الألوان.',

    'dentists.label.singular': 'طبيب أسنان',
    'dentists.label.singular.lab': 'جهة اتصال المختبر',
    'dentists.label.plural': 'الأطباء',
    'dentists.label.plural.lab': 'جهات اتصال المختبر',
    'dentists.table.name': 'اسم الطبيب',
    'dentists.table.username': 'اسم المستخدم',
    'dentists.table.email': 'البريد الإلكتروني',
    'dentists.table.address': 'العنوان',
    'dentists.table.phone': 'رقم التليفون',
    'dentists.table.whatsapp': 'رقم الواتساب',
    'dentists.table.client': 'العميل',
    'dentists.table.accountRole': 'الحساب',
    'dentists.table.accountRoleMain': 'رئيسي',
    'dentists.table.accountRoleSub': 'فرعي',
    'dentists.table.noClient': 'بدون عميل',
    'dentists.table.actions': 'العمليات',
    'dentists.filter.title': 'تصفية الأطباء',
    'dentists.filter.titleLab': 'تصفية جهات اتصال المختبر',
    'dentists.filter.active': 'مفعل',
    'dentists.button.add': 'إضافة طبيب أسنان',
    'dentists.button.addLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.modal.title': 'الأطباء',
    'dentists.modal.titleLabContact': 'جهات اتصال المختبر',
    'dentists.confirm.deleteTitle': 'حذف طبيب',
    'dentists.confirm.deleteMessage': 'هل تريد حذف هذا الطبيب؟',
    'dentists.confirm.removeTitle': 'إزالة الطبيب',
    'dentists.confirm.removeMessage': 'سيتم فصل هذا الطبيب عن هذا العميل وإلغاء تفعيله.',
    'dentists.confirm.deleteTitleLabContact': 'حذف جهة اتصال المختبر',
    'dentists.confirm.deleteMessageLabContact': 'هل تريد حذف جهة اتصال المختبر هذه؟',
    'dentists.confirm.removeTitleLabContact': 'إزالة جهة اتصال المختبر',
    'dentists.confirm.removeMessageLabContact': 'سيتم فصل جهة اتصال المختبر عن هذا العميل وإلغاء تفعيلها.',
    'dentists.form.accountRole.label': 'نوع الحساب',
    'dentists.form.accountRole.main': 'حساب رئيسي',
    'dentists.form.accountRole.sub': 'حساب فرعي',
    'dentists.form.accountRole.hint': 'الحساب الرئيسي يمكنه الوصول إلى كل موارد العميل. الحساب الفرعي يصل فقط إلى طلباته وملفه الشخصي.',
    'dentists.form.accountRole.labLocked': 'جهات اتصال المختبر تكون دائماً حسابات رئيسية.',
    'dentists.form.client.label': 'العميل',
    'dentists.form.client.placeholder': 'اختر أو أضف عميلًا',
    'dentists.alert.noAccess': 'ليس لديك صلاحية لعرض الأطباء.',
    'dentists.alert.noDentistType': 'نوع مستخدم الطبيب غير متوفر، يرجى مراجعة الإعدادات.',
    'dentists.changeHistory': 'سجل التغييرات',
    'dentists.versions.title': 'سجل تغييرات الطبيب',
    'dentists.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'dentists.versions.timelineTitle': 'الخط الزمني',
    'dentists.versions.by': 'تم التحديث بواسطة',
    'dentists.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'dentists.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'dentists.versions.selectVersion': 'اختر إصدارًا',
    'dentists.versions.noFields': 'لا توجد حقول تغيّرت',
    'dentists.versions.before': 'قبل',
    'dentists.versions.after': 'بعد (الحالية)',

    'expenses.table.serial': 'م',
    'expenses.table.expenseType': 'نوع المصروف',
    'expenses.table.cost': 'التكلفة',
    'expenses.table.date': 'التاريخ',
    'expenses.table.notes': 'ملاحظات',
    'expenses.table.order': 'الطلب',
    'expenses.table.paidTo': 'مدفوع إلى',
    'expenses.table.actions': 'العمليات',
    'expenses.button.add': 'إضافة مصروف',
    'expenses.editTitle': 'تعديل مصروف',
    'expenses.modal.title': 'إعدادت المصروفات',
    'expenses.confirm.deleteTitle': 'حذف مصروف',
    'expenses.confirm.deleteMessage': 'هل تريد حذف هذا المصروف؟',
    'expenses.form.type.label': 'بند المصروفات',
    'expenses.form.expense_type_id': 'نوع المصروف',
    'expenses.form.type.placeholder': 'اختر بند المصروفات',
    'expenses.form.type.required': 'من فضلك اختر بند المصروفات',
    'expenses.form.cost.label': 'التكلفة',
    'expenses.form.cost.placeholder': '٠',
    'expenses.form.cost.required': 'من فضلك ادخل التكلفة',
    'expenses.form.expensedAt.label': 'تاريخ المصروف',
    'expenses.form.expensedAt.placeholder': 'اختر التاريخ',
    'expenses.form.expensedAt.required': 'من فضلك اختر تاريخ المصروف',
    'expenses.form.notes.label': 'ملاحظات',
    'expenses.form.notes.placeholder': 'ادخل الملاحظات',
    'expenses.form.paidTo.label': 'مدفوع لصالح',
    'expenses.form.paidTo.placeholder': 'اختر أحد أعضاء الفريق',
    'expenses.form.paidTo.none': 'غير محدد',
    'expenses.form.attachments.label': 'المرفقات',
    'expenses.form.attachments.hint': 'أرفق إيصالات أو فواتير أو صورًا (بحد أقصى ٢٠ ميجابايت لكل ملف).',
    'expenses.form.attachments.choose': 'اختر الملفات',
    'expenses.form.attachments.existing': 'المرفقات الحالية',
    'expenses.form.attachments.deleteConfirm': 'هل تريد حذف هذا المرفق؟',
    'expenses.form.attachments.deleted': 'تم حذف المرفق',
    'expenses.form.attachments.deleteFailed': 'تعذر حذف المرفق',
    'expenses.form.attachments.tooLarge': 'حجم الملف أكبر من ٢٠ ميجابايت',
    'expenses.search.notesPlaceholder': 'ابحث بالملاحظات',
    'expenses.notCalculated': 'غير محتسب',
    'expenses.notCalculatedHint': 'هذه التكلفة معطلة لحسابك، لذلك تُسجل ولكن لا تدخل في الإجماليات والتقارير.',
    'expenses.reportingOnly': 'للتقارير فقط',
    'expenses.reportingOnlyHint': 'تكلفة تركيبات لحالة، تُستخدم في تقارير الأرباح فقط ولا تُضاف إلى إجمالي المصروفات أو القيود.',
    'expenses.settings.formulaCostsInExpenses': 'احتساب تكاليف تركيبات الحالات كمصروفات',
    'expenses.settings.formulaCostsInExpensesOffHint': 'مغلق: تُستخدم تكاليف تركيبات الحالات في التقارير فقط، حتى لا تُحتسب مصروفاتك الفعلية مرتين.',
    'expenses.settings.formulaCostsInExpensesOnHint': 'مفعّل: تُضاف تكاليف تركيبات الحالات إلى إجمالي المصروفات ولوحة التحكم والقيود.',
    'expenses.filter.type.placeholder': 'تصفية حسب النوع',
    'expenses.filter.paidTo.placeholder': 'تصفية حسب المدفوع لأجله',
    'expenses.filter.systemTypes.label': 'تضمين البنود الأساسية',
    'expenses.filter.systemTypes.hint': 'ألغِ تحديد البند لإخفاء مصروفاته من الجدول والإجمالي.',
    'expenses.summary.totalAmount': 'إجمالي المبلغ',
    'expenses.view.paidFor': 'مدفوع لأجل',
    'expenses.alert.noAccess': 'ليس لديك صلاحية لعرض المصروفات.',

    'expenseTypes.table.name': 'اسم البند',
    'expenseTypes.table.description': 'الوصف',
    'expenseTypes.table.actions': 'العمليات',
    'expenseTypes.button.add': 'إضافة بند مصروف',
    'expenseTypes.editTitle': 'تعديل بند مصروف',
    'expenseTypes.modal.title': 'إعدادت بنود المصروفات',
    'expenseTypes.confirm.deleteTitle': 'حذف بند',
    'expenseTypes.confirm.deleteMessage': 'هل تريد حذف هذا البند؟',
    'expenseTypes.form.name.label': 'اسم البند',
    'expenseTypes.form.name.placeholder': 'ادخل اسم البند',
    'expenseTypes.form.name.required': 'من فضلك ادخل اسم البند',
    'expenseTypes.form.description.label': 'وصف البند',
    'expenseTypes.form.description.placeholder': 'ادخل وصف البند',
    'expenseTypes.search.namePlaceholder': 'ابحث بالاسم',
    'expenseTypes.search.descriptionPlaceholder': 'ابحث بالوصف',
    'expenseTypes.alert.noAccess': 'ليس لديك صلاحية لعرض بنود المصروفات.',
    'expenseTypes.system.tag': 'أساسي',
    'expenseTypes.system.locked': 'هذا بند مصروف أساسي ولا يمكن تعديله أو حذفه.',
    'expenseTypes.system.materials.name': 'خامات الأسنان',
    'expenseTypes.system.materials.description': 'شراء الخامات الخاصة بمعمل الأسنان',
    'expenseTypes.system.technicians.name': 'فنيي الأسنان',
    'expenseTypes.system.technicians.description': 'مستحقات وأجور الفنيين',
    'expenseTypes.system.additional_operation_cost.name': 'تكاليف تشغيلية إضافية',
    'expenseTypes.system.additional_operation_cost.description': 'تكاليف تشغيل إضافية مثل التعامل مع معامل أخرى',

    'orders.header.title': 'الطلبات',
    'orders.header.subtitle': 'متابعة طلبات المعمل ومراحل الإنتاج وجداول التسليم',
    'orders.stats.totalOrders': 'إجمالي الطلبات',
    'orders.stats.notYetDue': 'غير مستحق بعد',
    'orders.stats.totalDue': 'إجمالي الإيرادات',
    'orders.stats.outstanding': 'إجمالي المتبقي',
    'orders.stats.paymentOverdue': 'متأخر',
    'orders.stats.totalPaid': 'إجمالي التحصيلات',
    'orders.stats.totalPaidHint': 'حسب تاريخ الدفع، نفس تقرير التحصيل',
    'invoice.markPaid.paidAt': 'تاريخ الدفع',
    'orders.search.placeholder': 'بحث باسم المريض أو رقم الطلب أو المرجع',
    'orders.filter.title': 'تصفية الطلبات',
    'orders.filter.clear': 'إعادة تعيين عوامل التصفية',
    'orders.filter.active': 'مفعل',
    'orders.filter.dentist': 'الطبيب',
    'orders.filter.technicians': 'الفنيين',
    'orders.filter.courier': 'المندوب',
    'orders.filter.allStatuses': 'الكل',
    'orders.filter.formulaType': 'نوع التركيبة',
    'orders.filter.requestedAtFrom': 'تاريخ الطلب من',
    'orders.filter.requestedAtTo': 'تاريخ الطلب إلى',
    'orders.filter.deliveredAtFrom': 'تاريخ التسليم من',
    'orders.filter.deliveredAtTo': 'تاريخ التسليم إلى',
    'orders.filter.paidAtFrom': 'تاريخ الدفع من',
    'orders.filter.paidAtTo': 'تاريخ الدفع إلى',
    'orders.table.refresh': 'تحديث',
    'orders.table.notInvoiced': 'غير مفوتر',
    'orders.table.invoiced': 'مفوتر',
    'orders.table.positions': 'المواضع',
    'orders.table.formulaTypes': 'أنواع التركيبات',
    'orders.table.id': 'رقم الطلب',
    'orders.table.patientName': 'اسم المريض',
    'orders.table.client': 'العميل',
    'orders.table.invoice': 'الفاتورة',
    'orders.table.dentistName': 'الطبيب',
    'orders.table.color': 'اللون',
    'orders.table.formulaType': 'نوع التركيبة',
    'orders.table.total': 'إجمالي التكلفة',
    'orders.table.paid': 'المدفوع',
    'orders.table.remaining': 'المتبقي',
    'orders.table.paymentStatus': 'حالة الدفع',
    'orders.table.status': 'حالة الطلب',
    'orders.table.delivery': 'التوصيل',
    'orders.table.createdAt': 'تاريخ التسجيل',
    'orders.table.requestedAt': 'تاريخ الطلب',
    'orders.table.deliveredAt': 'تم التسليم',
    'orders.table.paidAt': 'تاريخ الدفع',
    'orders.table.units': 'عدد الوحدات',
    'orders.table.actions': 'العمليات',
    'orders.table.technician': 'الفني',
    'orders.table.courier': 'المندوب',
    'orders.status.delivered': 'تم التوصيل',
    'orders.status.pendingDelivery': 'لم يتم التوصيل',
    'orders.status.paid': 'مدفوع',
    'orders.status.unpaid': 'غيرمدفوع',
    'orders.status.unknown': 'غير محدد',
    'orders.form.patientName.label': 'اسم المريض',
    'orders.form.patientName.placeholder': 'ادخل اسم المريض',
    'orders.form.patientName.required': 'من فضلك ادخال اسم المريض',
    'orders.form.dentist.label': 'اسم طبيب الأسنان',
    'orders.form.dentist.placeholder': 'اختر أو أضف طبيبًا',
    'orders.form.dentist.required': 'من فضلك اختر الطبيب',
    'orders.form.dentist.clientRequired': 'من فضلك اختر العميل أولاً لاختيار الطبيب.',
    'orders.form.dentist.labelLabContact': 'جهة اتصال المختبر',
    'orders.form.dentist.placeholderLabContact': 'اختر أو أضف جهة اتصال مختبر',
    'orders.form.dentist.requiredLabContact': 'من فضلك اختر جهة اتصال المختبر',
    'orders.form.dentist.clientRequiredLabContact': 'من فضلك اختر العميل أولاً لاختيار جهة اتصال المختبر.',
    'orders.form.client.label': 'اختر العميل',
    'orders.form.client.placeholder': 'اختر أو أضف عميلًا',
    'orders.form.client.required': 'من فضلك اختر العميل',
    'orders.form.clientStep.selectTab': 'اختيار عميل',
    'orders.form.clientStep.newTab': 'عميل جديد',
    'orders.form.clientStep.selectPlaceholder': '-- اختر العميل --',
    'orders.form.clientStep.hint': 'اختر عميلًا حاليًا أو أضف عميلًا جديدًا لبدء إدخال بيانات الطلب.',
    'orders.form.clientStep.autoCreateHint': 'سيتم إضافة العميل تلقائيًا عند إنشاء الطلب.',
    'orders.form.color.label': 'اختار اللون',
    'orders.form.color.defaultLabel': 'اللون الافتراضي (لل وحدات الجديدة)',
    'orders.form.color.defaultHelp': 'يُطبق عند إضافة وحدة جديدة',
    'orders.form.color.placeholder': 'اختر أو أضف لونًا',
    'orders.form.color.required': 'من فضلك اختر اللون',
    'orders.form.color.selectButton': 'اختر اللون',
    'orders.form.color.modalTitle': 'اختر اللون',
    'orders.form.color.searchPlaceholder': 'ابحث بالاسم أو الكود أو درجة VITA',
    'orders.form.color.clear': 'إزالة اللون',
    'orders.form.unitColors.label': 'لون لكل وحدة',
    'orders.form.formulaType.defaultLabel': 'نوع التركيبة الافتراضي (للوحدات الجديدة)',
    'orders.form.formulaType.defaultHelp': 'تطبق عند إضافة وحدة جديدة',
    'orders.form.unitFormulaTypes.label': 'نوع التركيبة لكل وحدة',
    'orders.form.unitPriceOverride.placeholder': 'تخصيص سعر الوحدة',
    'orders.form.discountAmount.label': 'خصم الطلب (مبلغ)',
    'orders.form.discountAmount.help': 'يُخصم هذا المبلغ من المجموع الفرعي للطلب.',
    'orders.form.discountAmount.placeholder': '٠',
    'orders.form.formulaType.label': 'نوع التركيبة',
    'orders.form.formulaType.placeholder': 'اختر نوع التركيبة',
    'orders.form.formulaType.required': 'من فضلك اختر نوع التركيبة',
    'orders.form.requestedAt.label': 'تاريخ الطلب',
    'orders.form.requestedAt.placeholder': 'اختر التاريخ',
    'orders.form.issueDate.label': 'تاريخ الإصدار',
    'orders.form.issueDate.placeholder': 'اختر التاريخ',
    'orders.form.deliveryDate.label': 'تاريخ التسليم',
    'orders.form.deliveryDate.placeholder': 'اختر التاريخ',
    'orders.form.additionalCostItems.title': 'بنود تكلفة إضافية',
    'orders.form.additionalCostItems.labelPlaceholder': 'وصف البند',
    'orders.form.additionalCostItems.amountPlaceholder': 'التكلفة',
    'orders.form.additionalCostItems.add': 'إضافة بند تكلفة',
    'orders.form.additionalCostItems.remove': 'حذف',
    'orders.form.additionalCostItems.labelRequired': 'وصف البند مطلوب.',
    'orders.form.additionalCostItems.amountRequired': 'التكلفة مطلوبة.',
    'orders.form.additionalCostItems.rowLabelRequired': 'بند التكلفة الإضافية {{n}}: وصف البند مطلوب.',
    'orders.form.additionalCostItems.rowAmountRequired': 'بند التكلفة الإضافية {{n}}: التكلفة مطلوبة.',
    'orders.summary.additionalCostsTitle': 'تكاليف إضافية',
    'orders.summary.additionalCostItemFallback': 'بند إضافي',
    'orders.summary.additionalCosts': 'إجمالي التكاليف الإضافية',
    'orders.form.notes.label': 'ملاحظات',
    'orders.form.notes.placeholder': 'ملاحظات',
    'orders.form.technician.label': 'الفنيين',
    'orders.form.technician.placeholder': 'اختر فنيين',
    'orders.form.technician.required': 'من فضلك اختر فنيًا واحدًا على الأقل',
    'orders.form.selectUnits.label': 'اختر الوحدات',
    'orders.form.selectUnits.required': 'من فضلك اختر وحدة واحدة على الأقل',
    'orders.form.orderFormulas.title': 'تركيبات الطلب',
    'orders.form.orderFormulas.help': 'يمكن أن يتضمن الطلب عدة تركيبات. في كل سطر، اختر أولًا نوع التركيبة ثم الوحدات (الأسنان لنطاق الوحدة، أو الفك العلوي و/أو السفلي لنطاق الفك). تُعرض فقط أنواع الوحدات المطابقة لنوع التركيبة.',
    'orders.form.orderFormulas.lineTitle': 'تركيبة {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'رقم التركيبة',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.colorLabel': 'اللون (لهذه التركيبة)',
    'orders.form.orderFormulas.stepUnits': 'الخطوة 2: الوحدات',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'اختر نوع التركيبة أولًا',
    'orders.form.orderFormulas.addLine': 'إضافة تركيبة أخرى',
    'orders.form.orderFormulas.removeLine': 'إزالة هذه التركيبة',
    'orders.form.orderFormulas.formulaType': 'نوع التركيبة',
    'orders.form.orderFormulas.selectUnits': 'الأسنان / الوحدات',
    'orders.form.orderFormulas.archChoice': 'الفك',
    'orders.form.orderFormulas.archUpper': 'الفك العلوي',
    'orders.form.orderFormulas.archLower': 'الفك السفلي',
    'orders.form.orderFormulas.zeroPriceHint': 'نوع التركيبة هذا ليس له سعر بيع (0). أضف سعرًا له حتى يتم تسعير الطلب بشكل صحيح.',
    'orders.form.orderFormulas.zeroPriceHintAction': 'تحديد السعر',
    'orders.form.orderFormulas.required': 'أضف سطر تركيبة واحد على الأقل مع النوع والوحدات المختارة.',
    'orders.form.orderFormulas.incompleteLine': 'يجب أن يتضمن كل سطر تركيبة مع نوع مختار وحدة واحدة على الأقل (سن أو فك).',
    'orders.form.orderFormulas.duplicateFormulaType': 'يمكنك إضافة سطر واحد فقط لكل نوع تركيبة في الطلب.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'يجب أن يكون لكل وحدة مختارة نوع تركيبة قبل الحفظ.',
    'orders.form.orderFormulas.summaryUnits': 'وحدات هذا الطلب',
    'orders.form.persistedFormulas.title': 'تركيبات هذا الطلب',
    'orders.form.persistedFormulas.help': 'كل سطر هو تركيبة محفوظة (النوع، الوحدة، واللون). عند التعديل يمكن ضبط نوع التركيبة والأسعار لكل وحدة من الملخص.',
    'orders.form.persistedFormulas.unit': 'الوحدة (FDI)',
    'orders.form.persistedFormulas.color': 'اللون',
    'orders.form.persistedFormulas.detach': 'إزالة من الطلب',
    'orders.form.persistedFormulas.detachConfirm': 'إزالة سطر التركيبة هذا من الطلب؟ ستفقد الأسنان المرتبطة هذه التركيبة حتى تضيف سطرًا جديدًا أو تضبط الأنواع من الملخص.',
    'orders.form.persistedFormulas.detachSuccess': 'تمت إزالة سطر التركيبة من الطلب.',
    'orders.form.persistedFormulas.detachError': 'تعذرت إزالة سطر التركيبة. حاول مرة أخرى.',
    'orders.form.toothPreview.title': 'معاينة الأسنان',
    'orders.form.toothPreview.help': 'نفس مخطط الأسنان كما في إنشاء الطلب. عند التعديل، انقر الأسنان لتغيير الاختيار ثم احفظ.',
    'toothPicker.selectUpper': 'اختيار الفك العلوي',
    'toothPicker.selectLower': 'اختيار الفك السفلي',
    'toothPicker.clear': 'مسح',
    'orders.form.deliveryCenter.label': 'مركز التسليم',
    'orders.form.costCenter.label': 'مركز التكلفة',
    'orders.form.deliveryCenter.placeholder': 'اختر أو أضف مركز تسليم',
    'orders.form.deliveryCenter.required': 'من فضلك اختر مركز تسليم',
    'orders.form.deliveryCenter.clientRequired': 'من فضلك اختر العميل أولاً لاختيار مركز التسليم.',
    'orders.form.deliveryType.label': 'نوع التوصيل',
    'orders.form.deliveryType.placeholder': 'اختر نوع التوصيل',
    'orders.form.attachment.label': 'مرفقات',
    'orders.form.attachments.label': 'المرفقات',
    'orders.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'orders.form.attachments.choose': 'اختر ملفات',
    'orders.form.attachments.existing': 'المرفقات الموجودة:',
    'orders.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'orders.form.attachments.empty': 'لا توجد مرفقات',
    'orders.form.attachments.download': 'تنزيل',
    'orders.form.attachments.commentPlaceholder': 'تعليق',
    'orders.form.attachments.col.id': 'المعرف',
    'orders.form.attachments.col.name': 'الاسم',
    'orders.form.attachments.col.url': 'الرابط',
    'orders.form.attachments.col.file': 'الملف',
    'orders.form.attachments.col.comment': 'تعليق',
    'orders.form.attachments.col.preview': 'معاينة',
    'orders.attachments.viewer3d.view': 'عرض ثلاثي الأبعاد',
    'orders.attachments.viewer3d.loading': 'جارٍ تحميل النموذج ثلاثي الأبعاد…',
    'orders.attachments.viewer3d.loadFailed': 'تعذر تحميل الملف ثلاثي الأبعاد.',
    'orders.attachments.viewer3d.parseFailed': 'تعذرت قراءة هذا الملف كنموذج ثلاثي الأبعاد.',
    'orders.attachments.viewer3d.noModelsInZip': 'لم يتم العثور على ملفات STL أو PLY أو OBJ داخل هذا الأرشيف.',
    'orders.attachments.viewer3d.wireframe': 'إطار شبكي',
    'orders.attachments.viewer3d.resetView': 'إعادة ضبط العرض',
    'orders.attachments.viewer3d.parts': 'النماذج',
    'orders.attachments.viewer3d.controlsHint': 'سحب بالزر الأيسر: تدوير · سحب بالزر الأيمن: تحريك · العجلة: تكبير/تصغير',
    'orders.form.attachments.col.download': 'تنزيل',
    'orders.form.attachments.col.delete': 'حذف',
    'orders.form.attachments.col.edit': 'تعديل',
    'orders.form.attachments.edit': 'تعديل',
    'orders.form.attachments.editTitle': 'تعديل المرفق',
    'orders.form.attachments.viewTitle': 'تفاصيل المرفق',
    'orders.form.attachments.namePlaceholder': 'اسم المرفق',
    'orders.form.attachments.replaceFile': 'استبدال الملف',
    'orders.form.attachments.replaceFileHint': 'اتركه فارغًا للاحتفاظ بالملف الحالي.',
    'orders.form.attachments.chooseReplacement': 'اختر ملفًا بديلًا',
    'orders.files.title': 'إدارة الملفات',
    'orders.files.expand': 'توسيع',
    'orders.files.collapse': 'طي',
    'orders.files.dropzone': 'انقر أو اسحب الملفات هنا لرفعها',
    'orders.files.hint': '* يمكنك رفع ملف مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل ملف).',
    'orders.files.queueTitle': 'قائمة الملفات',
    'orders.files.queueLength': 'عدد الملفات في الانتظار: {{count}}',
    'orders.files.searchPlaceholder': 'ابحث باسم الملف أو التعليق',
    'orders.files.col.name': 'اسم الملف',
    'orders.files.col.uploadDate': 'تاريخ الرفع',
    'orders.files.col.size': 'الحجم',
    'orders.files.col.progress': 'التقدم',
    'orders.files.col.actions': 'الإجراءات',
    'orders.files.downloadAll': 'تنزيل الكل',
    'orders.files.total': 'الإجمالي: {{count}}',
    'orders.files.empty': 'لم يتم رفع أي ملفات بعد',
    'orders.files.noComment': 'لا يوجد تعليق',
    'orders.files.status.queued': 'في الانتظار',
    'orders.files.status.failed': 'فشل',
    'orders.files.retry': 'إعادة المحاولة',
    'orders.files.cancel': 'إلغاء الرفع',
    'orders.files.remove': 'إزالة من القائمة',
    'orders.files.preview': 'معاينة',
    'orders.files.download': 'تنزيل',
    'orders.files.edit': 'تعديل',
    'orders.files.delete': 'حذف',
    'orders.files.deleteConfirm': 'حذف هذا الملف؟',
    'orders.files.invalidType': '{{name}}: نوع الملف غير مسموح',
    'orders.files.tooLarge': '{{name}}: حجم الملف أكبر من 20 ميجابايت',
    'orders.files.downloadFailed': 'تعذر تنزيل الملف/الملفات',
    'orders.form.submit.create': 'تأكيد الطلب',
    'orders.form.submit.save': 'حفظ التغييرات',
    'orders.create.header.title': 'طلب جديد',
    'orders.create.header.subtitle': 'اختر العميل والطبيب، وأضف تركيبات الطلب، ثم أكّد مواعيد التسليم.',
    'orders.create.header.backToOrders': 'العودة إلى الطلبات',
    'orders.create.header.nextCode': 'كود الطلب',
    'orders.create.header.nextCodeHint': 'يتم تثبيت الكود النهائي عند حفظ الطلب.',
    'orders.create.success.title': 'تم إنشاء الطلب بنجاح',
    'orders.create.success.description': 'تم حفظ الطلب. يمكنك فتحه الآن أو البدء في طلب جديد بالأسفل.',
    'orders.create.success.patient': 'المريض',
    'orders.create.success.viewOrder': 'عرض الطلب',
    'orders.create.success.dismiss': 'إغلاق',
    'orders.table.code': 'كود الطلب',
    'orders.form.section.parties': 'العميل والطبيب',
    'orders.form.section.schedule': 'المريض والمواعيد',
    'orders.form.section.notesAttachments': 'الملاحظات والمرفقات',
    'orders.create.section.primaryTitle': 'تفاصيل الطلب',
    'orders.create.section.secondaryTitle': 'التفاصيل المالية',
    'orders.create.section.secondaryPlaceholder': 'سيتم إضافة هذا القسم لاحقاً.',
    'orders.update.section.primaryTitle': 'تفاصيل الطلب',
    'orders.update.section.secondaryTitle': 'إجراءات الطلب',
    'orders.update.section.secondaryPlaceholder': 'سيتم عرض تفاصيل إضافية عن الطلب هنا قريبًا.',
    'orders.actions.technician.label': 'الفنيين',
    'orders.actions.technician.unassigned': 'غير معين',
    'orders.actions.technician.change': 'تعيين الفنيين',
    'orders.actions.viewInvoice': 'عرض الفاتورة',
    'orders.actions.technician.select': 'اختر فنيين',
    'orders.actions.technician.changeSuccess': 'تم تحديث الفنيين',
    'orders.actions.technician.changeError': 'فشل تحديث الفنيين',
    'orders.actions.courier.label': 'المندوب',
    'orders.actions.courier.unassigned': 'غير معين',
    'orders.actions.courier.change': 'تعيين المندوب',
    'orders.actions.courier.select': 'اختر المندوب',
    'orders.actions.courier.changeSuccess': 'تم تحديث المندوب',
    'orders.actions.courier.changeError': 'فشل تحديث المندوب',
    'orders.actions.courier.unassign': 'إلغاء التعيين',
    'orders.actions.disableClientEdit.label': 'تعطيل تعديل العميل',
    'orders.actions.disableClientEdit.enabled': 'العميل لا يمكنه تعديل هذا الطلب',
    'orders.actions.disableClientEdit.disabled': 'العميل يمكنه تعديل هذا الطلب',
    'orders.actions.disableClientEdit.lockedMessage': 'هذا الطلب مقفل. لا يمكنك تعديله. تواصل مع المختبر إذا احتجت تغييرات.',
    'orders.actions.sharePhasesWithClient.label': 'مشاركة المراحل مع العميل',
    'orders.actions.sharePhasesWithClient.short': 'مشاركة',
    'orders.actions.sharePhasesWithClient.enabled': 'يمكن للعميل متابعة مراحل الطلب',
    'orders.actions.sharePhasesWithClient.disabled': 'المراحل مرئية للمعمل فقط',
    'orders.actions.shareWorkflowWithClient.label': 'مشاركة سير العمل مع العميل',
    'orders.actions.shareWorkflowWithClient.enabled': 'يمكن للعميل رؤية سير العمل والعمليات',
    'orders.actions.shareWorkflowWithClient.disabled': 'سير العمل والعمليات مرئي للمعمل فقط',
    'responses.permission.denied': 'ليس لديك صلاحية لإجراء هذا الإجراء.',
    'responses.common.password_reset_link_sent': 'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    'responses.common.password_reset_success': 'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'orders.actions.status.label': 'حالة الطلب',
    'orders.actions.status.change': 'تغيير الحالة',
    'orders.actions.status.changeSuccess': 'تم تحديث الحالة',
    'orders.actions.status.changeError': 'فشل تحديث الحالة',
    'orders.actions.status.cannotCancelPaid': 'لا يمكن تغيير الحالة إلى "ملغى" لأن هناك فاتورة مدفوعة مرتبطة بهذا الطلب.',
    'orders.actions.status.cannotSetClosedManually': 'تُعيَّن حالة "مغلق" تلقائياً عند دفع الفاتورة. لا يمكن نقل الطلب إلى "مغلق" يدوياً.',
    'orders.actions.status.closedOnInvoice': 'لا يمكن تغيير حالة الطلب طالما هو مرتبط بفاتورة. افصله عن الفاتورة أولاً.',
    'orders.actions.status.advanceHint': 'اضغط للانتقال إلى الحالة التالية',
    'orders.actions.status.nextSteps': 'الخطوة التالية',
    'orders.actions.status.jumpTo': 'انتقل إلى حالة',
    'orders.actions.status.moveTo': 'نقل إلى {{status}}',
    'orders.actions.status.advanceConfirmTitle': 'نقل الطلب #{{id}}؟',
    'orders.actions.status.advanceConfirmMessage': '{{from}} ← {{to}}',
    'orders.actions.cancel.detachInvoiceFirst': 'هذا الطلب مرتبط بفاتورة. يرجى فصله عن الفاتورة أولاً ثم إلغاؤه.',
    'orders.actions.cancel.alreadyCancelled': 'هذا الطلب ملغى بالفعل.',
    'orders.bulk.status.skippedHasInvoice': 'تم تخطي {{count}} طلب مرتبط بفاتورة. افصلها عن الفاتورة قبل تغيير الحالة.',
    'orders.bulk.actions': 'إجراءات جماعية ({{count}})',
    'orders.bulk.status.change': 'تغيير الحالة',
    'orders.bulk.status.title': 'تغيير الحالة ({{count}})',
    'orders.bulk.status.selectPlaceholder': 'اختر الحالة',
    'orders.bulk.status.selectRequired': 'اختر حالة',
    'orders.bulk.status.changeSuccess': 'تم تحديث الحالة لـ {{count}} طلب',
    'orders.bulk.status.partialSuccess': 'تم تحديث {{success}} طلب؛ فشل {{failed}}',
    'orders.bulk.status.noneEligible': 'لا يمكن تغيير حالة أي من الطلبات المحددة.',
    'orders.bulk.status.skipped': 'تم تخطي {{count}} طلب',
    'orders.bulk.requestedAt.change': 'تغيير تاريخ الطلب',
    'orders.bulk.requestedAt.title': 'تغيير تاريخ الطلب ({{count}})',
    'orders.bulk.requestedAt.selectRequired': 'اختر تاريخ الطلب',
    'orders.bulk.requestedAt.changeSuccess': 'تم تحديث تاريخ الطلب لـ {{count}} طلب',
    'orders.bulk.requestedAt.partialSuccess': 'تم تحديث تاريخ الطلب لـ {{success}} طلب؛ فشل {{failed}}',
    'orders.bulk.requestedAt.noneEligible': 'لا يمكن تغيير تاريخ الطلب لأي من الطلبات المحددة.',
    'orders.bulk.requestedAt.skipped': 'تم تخطي {{count}} طلب (مغلق).',
    'orders.bulk.deliveryDate.change': 'تغيير تاريخ التسليم',
    'orders.bulk.deliveryDate.title': 'تغيير تاريخ التسليم ({{count}})',
    'orders.bulk.deliveryDate.selectRequired': 'اختر تاريخ التسليم',
    'orders.bulk.deliveryDate.changeSuccess': 'تم تحديث تاريخ التسليم لـ {{count}} طلب',
    'orders.bulk.deliveryDate.partialSuccess': 'تم تحديث تاريخ التسليم لـ {{success}} طلب؛ فشل {{failed}}',
    'orders.bulk.deliveryDate.noneEligible': 'لا يمكن تغيير تاريخ التسليم لأي من الطلبات المحددة.',
    'orders.bulk.deliveryDate.skipped': 'تم تخطي {{count}} طلب (مغلق).',
    'orders.bulk.attach.cta': 'ربط بفاتورة',
    'orders.bulk.attach.title': 'ربط بفاتورة ({{count}})',
    'orders.bulk.attach.success': 'تم ربط {{count}} طلب بالفاتورة',
    'orders.bulk.attach.sameClientRequired': 'اختر طلبات من نفس العميل للربط بفاتورة واحدة.',
    'orders.bulk.attach.missingClient': 'يجب أن تكون الطلبات المحددة تابعة لعميل.',
    'orders.bulk.attach.noneEligible': 'لا يمكن ربط أي من الطلبات المحددة بفاتورة.',
    'orders.bulk.attach.skipped': 'تم تخطي {{count}} طلب',
    'orders.bulk.attach.loadInvoicesError': 'فشل تحميل الفواتير',
    'orders.bulk.attach.noInvoices': 'لا توجد فواتير غير مدفوعة لهذا العميل لربط الطلبات بها. قم بإنشاء فاتورة جديدة بدلاً من ذلك.',
    'orders.bulk.createInvoice.cta': 'إنشاء فاتورة',
    'orders.bulk.createInvoice.confirmTitle': 'إنشاء فاتورة لـ {{count}} طلب؟',
    'orders.bulk.createInvoice.summary': 'سيتم إضافة {{count}} طلب للعميل {{client}} إلى الفاتورة الجديدة · الإجمالي {{total}}',
    'orders.bulk.createInvoice.success': 'تم إنشاء فاتورة تحتوي على {{count}} طلب',
    'orders.bulk.createInvoice.sameClientRequired': 'اختر طلبات من نفس العميل لإنشاء فاتورة واحدة.',
    'orders.bulk.createInvoice.noneEligible': 'لا يمكن إضافة أي من الطلبات المحددة إلى فاتورة جديدة.',
    'orders.bulk.createInvoice.skipped': 'سيتم تخطي {{count}} طلب (ملغي أو معلق أو متنازع عليه أو مدفوع).',
    'orders.bulk.delete.cta': 'حذف المحدد ({{count}})',
    'orders.bulk.delete.confirmTitle': 'حذف {{count}} طلب محدد؟',
    'orders.bulk.delete.confirmSummary': 'سيتم حذف {{eligible}} من أصل {{count}} طلب محدد.',
    'orders.bulk.delete.confirmHint': 'تُزال الطلبات المحذوفة من قائمة الطلبات والإحصائيات والتقارير.',
    'orders.bulk.delete.willSkip': 'لا يمكن حذف {{count}} طلب وستبقى دون تغيير:',
    'orders.bulk.delete.confirmCta': 'حذف {{count}} طلب',
    'orders.bulk.delete.success': 'تم حذف {{count}} طلب',
    'orders.bulk.delete.partialTitle': 'تم حذف {{deleted}} طلب، ولم يُحذف {{skipped}}',
    'orders.bulk.delete.partialMessage': 'بقيت هذه الطلبات ({{count}}) دون تغيير:',
    'orders.bulk.delete.noneEligibleTitle': 'لم يتم حذف أي طلب',
    'orders.bulk.delete.noneEligible': 'لا يمكن حذف أي من الطلبات المحددة:',
    'orders.bulk.delete.error': 'تعذّر حذف الطلبات',
    'orders.delete.reason.has_invoice': 'مرتبط بفاتورة. افصله عن الفاتورة أولاً.',
    'orders.delete.reason.completed': 'لا يمكن حذف الطلبات المسلّمة أو المغلقة.',
    'orders.delete.reason.revenue_recognized': 'وصل الطلب إلى الحالة التي يُحتسب عندها مبلغه كإيراد.',
    'orders.delete.reason.technician_settlement': 'مُدرج في تسوية فني معتمدة أو مدفوعة.',
    'orders.delete.reason.materials_issued': 'تم صرف مواد من المخزون لهذا الطلب.',
    'orders.delete.reason.client_edit_disabled': 'هذا الطلب مقفل. تم تعطيل تعديل العميل بواسطة مدير المختبر.',
    'orders.delete.reason.not_found': 'الطلب غير موجود أو محذوف مسبقاً.',
    'orders.actions.downloadWorkCard': 'تنزيل بطاقة العمل',
    'orders.changeHistory': 'سجل التغييرات',
    'orders.comments.title': 'المحادثة',
    'orders.comments.internal.tab': 'داخلي (الفريق)',
    'orders.comments.internal.hint': 'مرئية لفريق المعمل فقط. لا يمكن للعملاء رؤية هذه الرسائل.',
    'orders.comments.external.tab': 'محادثة العميل',
    'orders.comments.external.hint': 'مرئية لأطباء العميل / جهات اتصال المعمل، ومديري المعمل والفنيين المعيّنين ومن تتم الإشارة إليهم.',
    'orders.comments.external.hintClient': 'محادثتك مع المعمل حول هذا الطلب.',
    'orders.comments.empty': 'لا توجد رسائل بعد. ابدأ المحادثة.',
    'orders.comments.placeholder': 'اكتب رسالة… اكتب @ للإشارة إلى شخص (Ctrl+Enter للإرسال)',
    'orders.comments.mentions.empty': 'لا يوجد مستخدمون مطابقون',
    'orders.comments.send': 'إرسال',
    'orders.comments.edited': 'معدّلة',
    'orders.comments.edit': 'تعديل',
    'orders.comments.delete': 'حذف',
    'orders.comments.save': 'حفظ',
    'orders.comments.deleteConfirm': 'حذف هذه الرسالة؟',
    'orders.comments.sendError': 'فشل إرسال الرسالة',
    'orders.comments.updateError': 'فشل تعديل الرسالة',
    'orders.comments.deleteError': 'فشل حذف الرسالة',
    'orders.comments.loadError': 'فشل تحميل الرسائل',
    'orders.comments.you': 'أنت',
    'orders.comments.files.attach': 'إرفاق ملفات (تُضاف أيضاً إلى ملفات الطلب)',
    'orders.comments.files.dropHere': 'أفلت الملفات لإرفاقها برسالتك',
    'orders.comments.files.tooMany': 'يمكنك إرفاق {{count}} ملفات كحد أقصى لكل رسالة',
    'orders.comments.files.openInNewTab': 'فتح في علامة تبويب جديدة',
    'orders.comments.files.remove': 'إزالة',
    'orders.comments.files.sending': 'جارٍ الإرسال…',
    'orders.comments.files.processing': 'جارٍ الإنهاء…',
    'orders.comments.files.cancelUpload': 'إلغاء الرفع',
    'orders.comments.files.discard': 'تجاهل الرسالة',
    'orders.comments.files.uploadCanceled': 'تم إلغاء الرفع. لم يتم إرسال رسالتك.',
    'orders.files.fromChat': 'من المحادثة',
    'orders.files.fromChatHint': 'يتم الرفع من رسالة في المحادثة',
    'orders.comments.role.client': 'العميل',
    'orders.comments.role.admin': 'مدير',
    'orders.comments.role.technician': 'فني',
    'orders.comments.role.courier': 'مندوب توصيل',
    'orders.phases.title': 'المراحل',
    'orders.phases.add': 'إضافة مرحلة',
    'orders.phases.addTitle': 'إضافة مرحلة',
    'orders.phases.editTitle': 'تعديل المرحلة',
    'orders.phases.edit': 'تعديل',
    'orders.phases.delete': 'حذف',
    'orders.phases.save': 'حفظ',
    'orders.phases.empty': 'لا توجد مراحل لهذا الطلب بعد.',
    'orders.phases.noDates': 'لم يتم تحديد تواريخ',
    'orders.phases.deleteConfirm': 'حذف المرحلة "{{title}}"؟',
    'orders.phases.created': 'تمت إضافة المرحلة',
    'orders.phases.updated': 'تم تحديث المرحلة',
    'orders.phases.deleted': 'تم حذف المرحلة',
    'orders.phases.createError': 'فشل إضافة المرحلة',
    'orders.phases.updateError': 'فشل تحديث المرحلة',
    'orders.phases.deleteError': 'فشل حذف المرحلة',
    'orders.phases.loadError': 'فشل تحميل المراحل',
    'orders.phases.fields.template': 'البدء من مرحلة قياسية',
    'orders.phases.fields.templateHint': 'اختياري: يملأ العنوان والتفاصيل ويمكنك تعديلها.',
    'orders.phases.fields.templatePlaceholder': 'اختر مرحلة قياسية',
    'orders.phases.fields.title': 'العنوان',
    'orders.phases.fields.titleAr': 'العنوان',
    'orders.phases.fields.titleRequired': 'يرجى إدخال العنوان',
    'orders.phases.fields.description': 'التفاصيل',
    'orders.phases.fields.descriptionAr': 'التفاصيل',
    'orders.phases.fields.technician': 'الفني',
    'orders.phases.fields.swap': 'تغيير المرحلة',
    'orders.phases.fields.swapPlaceholder': 'استبدال بمرحلة مخفية',
    'orders.phases.fields.noHiddenPhases': 'لا توجد مراحل مخفية',
    'orders.phases.swapped': 'تم تغيير المرحلة',
    'orders.phases.swapError': 'تعذر تغيير المرحلة',
    'orders.phases.visibilityError': 'تعذر تحديث عرض المراحل',
    'orders.phases.fields.dates': 'تاريخ البداية والنهاية',
    'orders.phases.fields.startDate': 'تاريخ البداية',
    'orders.phases.fields.endDate': 'تاريخ النهاية',
    'orders.phases.setCurrent': 'تعيين كمرحلة حالية',
    'orders.phases.moveUp': 'نقل لأعلى',
    'orders.phases.moveDown': 'نقل لأسفل',
    'orders.phases.currentSet': 'تم تحديث المرحلة الحالية',
    'orders.phases.currentError': 'فشل تعيين المرحلة الحالية',
    'orders.phases.reorderError': 'فشل تحديث تسلسل المراحل',
    'orders.phases.showNext': 'عرض المرحلة التالية',
    'orders.phases.hidePhase': 'إخفاء هذه المرحلة',
    'orders.phases.collapseAll': 'إخفاء المراحل بعد المرحلة الحالية',
    'orders.phases.manage': 'إدارة',
    'orders.phases.doneManaging': 'تم',
    'orders.phases.assignTechnician': '-- تعيين فني --',
    'orders.phases.notReached': 'لم يتم الوصول إلى هذه المرحلة بعد',
    'orders.phases.inProgress': 'قيد التنفيذ',
    'orders.phases.completed': 'مكتملة',
    'orders.phases.hideSection': 'إخفاء المراحل',
    'orders.phases.showSection': 'عرض المراحل',
    'orders.phases.changeImage': 'تغيير الصورة',
    'orders.phases.removeImage': 'إزالة الصورة',
    'orders.phases.removeImageConfirm': 'هل تريد إزالة صورة هذه المرحلة واستخدام الصورة الافتراضية؟',
    'orders.phases.imageUpdated': 'تم تحديث صورة المرحلة',
    'orders.phases.imageRemoved': 'تمت إزالة صورة المرحلة',
    'orders.phases.imageError': 'تعذر تحديث صورة المرحلة',
    'orders.phases.imageInvalid': 'يرجى اختيار ملف صورة',
    'orders.phases.imageTooLarge': 'يجب ألا يتجاوز حجم الصورة 4 ميجابايت',
    'orders.versions.title': 'سجل تغييرات الطلب',
    'orders.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'orders.versions.timelineTitle': 'الخط الزمني',
    'orders.versions.by': 'تم التحديث بواسطة',
    'orders.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'orders.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'orders.versions.selectVersion': 'اختر إصدارًا',
    'orders.versions.noFields': 'لا توجد حقول تغيّرت',
    'orders.versions.before': 'قبل',
    'orders.versions.after': 'بعد (الحالية)',
    'orders.versions.unitLabel': 'الوحدة',
    'orders.versions.priceLabel': 'السعر',
    'orders.calendar.title': 'التقويم',
    'orders.calendar.subtitle': 'متابعة تواريخ الطلبات والفواتير عبر عرض الأسبوع والشهر والسنة',
    'orders.calendar.viewList': 'عرض قائمة الطلبات',
    'orders.calendar.more': 'المزيد',
    'orders.calendar.week': 'أسبوع',
    'orders.calendar.month': 'شهر',
    'orders.calendar.year': 'سنة',
    'orders.calendar.ordersCount': 'طلبات',
    'orders.calendar.itemsCount': 'عناصر',
    'orders.calendar.today': 'اليوم',
    'orders.calendar.noOrders': 'لا توجد طلبات',
    'orders.calendar.noItems': 'لا توجد عناصر',
    'orders.calendar.patient': 'المريض',
    'orders.calendar.client': 'العميل',
    'orders.calendar.ref': 'الرقم التسلسلي',
    'orders.calendar.entity.order': 'طلب',
    'orders.calendar.entity.invoice': 'فاتورة',
    'orders.calendar.filter.title': 'عرض في التقويم',
    'orders.calendar.filter.byClientDentist': 'العملاء والأطباء',
    'orders.calendar.filter.client.placeholder': 'اختر العميل',
    'orders.calendar.filter.dentist.placeholder': 'اختر الطبيب',
    'orders.calendar.filter.orders': 'الطلبات',
    'orders.calendar.filter.invoices': 'الفواتير',
    'orders.calendar.filter.orderDeliveryDate': 'تاريخ التسليم',
    'orders.calendar.filter.orderRequestedAt': 'تاريخ الطلب',
    'orders.calendar.filter.invoiceIssueDate': 'تاريخ الإصدار',
    'orders.calendar.filter.invoiceDueDate': 'تاريخ الاستحقاق',
    'orders.calendar.weekend': 'أجازة أسبوعية',
    'orders.calendar.vacation': 'إجازة',
    'orders.calendar.legend.closed': 'أيام الإغلاق',

    'vacations.weekend.title': 'أيام أجازة أسبوعية',
    'vacations.weekend.hint': 'اختر أيام الأسبوع التي تُعد نهاية أسبوع. ستظهر مميزة في تقويم الطلبات.',
    'vacations.weekend.save': 'حفظ أيام أجازة أسبوعية',
    'vacations.list.title': 'الأجازات',
    'vacations.list.hint': 'أضف فترات إغلاق المعمل. ستظهر هذه الأيام في التقويم.',
    'vacations.add': 'إضافة إجازة',
    'vacations.edit': 'تعديل إجازة',
    'vacations.table.name': 'الاسم',
    'vacations.table.startsOn': 'من',
    'vacations.table.endsOn': 'إلى',
    'vacations.table.notes': 'ملاحظات',
    'vacations.table.actions': 'إجراءات',
    'vacations.form.name': 'الاسم',
    'vacations.form.nameRequired': 'الاسم مطلوب',
    'vacations.form.namePlaceholder': 'مثال: إجازة العيد',
    'vacations.form.range': 'الفترة',
    'vacations.form.rangeRequired': 'الفترة مطلوبة',
    'vacations.form.notes': 'ملاحظات',
    'vacations.confirm.deleteTitle': 'حذف الإجازة؟',
    'vacations.confirm.deleteMessage': 'لا يمكن التراجع عن هذا الإجراء.',
    'vacations.weekday.sunday': 'الأحد',
    'vacations.weekday.monday': 'الإثنين',
    'vacations.weekday.tuesday': 'الثلاثاء',
    'vacations.weekday.wednesday': 'الأربعاء',
    'vacations.weekday.thursday': 'الخميس',
    'vacations.weekday.friday': 'الجمعة',
    'vacations.weekday.saturday': 'السبت',

    // UI labels for work card modal
    'ui.order.work_card': 'بطاقة العمل',
    'ui.order.order_id': 'رقم الطلب',
    'ui.order.client': 'العميل',
    'ui.order.dentist': 'الطبيب',
    'ui.order.patient': 'المريض',
    'ui.order.formula_type': 'نوع التركيبة',
    'ui.order.formulaType': 'نوع التركيبة',
    'ui.order.color': 'اللون',
    'ui.order.units': 'الوحدات',
    'ui.order.units_positions': 'مواضع الوحدات',
    'ui.order.units_count': 'عدد الوحدات',
    'ui.order.items': 'العناصر',
    'ui.order.unit': 'وحدة',
    'ui.order.no_qr_available': 'لا يوجد QR',
    'ui.order.order_barcode': 'باركود الطلب',
    'ui.order.view_public_note': 'هذه معاينة عامة للطلب. لا يلزم تسجيل دخول.',
    'ui.order.unit_types': 'الوحدات المختارة (حسب الموضع)',
    'ui.order.unit_level': 'المستوى',
    'ui.order.unit_direction': 'الاتجاه',
    'ui.order.unit_order': 'الموضع',
    'ui.order.unit_name': 'النوع',
    'ui.order.tooth_picker': 'محدد الأسنان',
    'ui.order.tooth_previewer': 'عارض الأسنان',
    'ui.order.unit_positions': 'مواضع الوحدات',
    'ui.order.tooth_picker_hint': 'الوحدات المحددة مظللة أدناه',
    'ui.order.note': 'ملاحظة',
    'ui.order.view_title': 'عرض الطلب',
    'ui.order.units_list': 'الوحدات',
    'ui.order.qr': 'QR',
    'ui.order.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.order.switch_to_ar': 'التبديل إلى العربية',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',
    'ui.order.tracking_barcode': 'الباركود والتتبع المعملي',
    'ui.order.scan_instructions': 'امسح الباركود بجهاز المسح أو رمز QR بكاميرا الهاتف لتتبع الطلب.',
    'ui.order.dental_chart': 'مخطط الأسنان (Odontogram)',
    'ui.order.clinical_specifications': 'المواصفات السريرية والتركيبات',
    'ui.order.clinical_notes': 'الملاحظات والتعليمات السريرية',
    'ui.order.no_notes': 'لا توجد ملاحظات سريرية أو تعليمات خاصة مسجلة لهذا الطلب.',
    'ui.order.attachments_title': 'المرفقات والمسوح ثلاثية الأبعاد',
    'ui.order.no_attachments': 'لا توجد ملفات أو مسوح سريرية مرفقة بهذا الطلب.',
    'ui.order.logistics_title': 'التوصيل واللوجستيات',
    'ui.order.linked_invoice': 'الفاتورة المرتبطة',
    'ui.order.view_invoice_action': 'عرض الفاتورة العامة',
    'ui.order.selected_teeth_legend': 'الأسنان المعالجة',
    'ui.order.natural_teeth_legend': 'الأسنان الطبيعية / غير المعالجة',
    'ui.order.qc_signoff': 'مراقبة الجودة واعتماد المعمل',
    'ui.order.qc_passed': 'اجتاز فحص الجودة',
    'ui.order.technician_signature': 'توقيع الفني المسؤول',
    'ui.order.qc_date': 'التاريخ',
    'ui.order.teeth_selected_count': '{{count}} أسنان محددة',
    'ui.order.expected_delivery': 'التسليم المتوقع',
    'ui.order.shade_color': 'درجة الظل / اللون',
    'ui.order.product_type': 'المنتج',
    'ui.order.quadrant_1': 'الربع 1 (علوي يمين)',
    'ui.order.quadrant_2': 'الربع 2 (علوي يسار)',
    'ui.order.quadrant_3': 'الربع 3 (سفلي يسار)',
    'ui.order.quadrant_4': 'الربع 4 (سفلي يمين)',
    'ui.order.scan_modal_title': 'باركود ورمز QR للطلب',
    'ui.order.fullscreen_scan': 'تكبير / مسح',
    'ui.order.download_attachment': 'تحميل',
    'ui.order.preview_attachment': 'معاينة',
    'ui.order.clinic': 'العيادة',
    'ui.order.order_date': 'تاريخ الطلب',
    'ui.order.public_order_disclaimer': 'مواصفات أمر العمل المعملي الرسمية معتمدة للتحقق السريري والمعملي. لا يلزم تسجيل دخول.',
    'ui.order.loading_details': 'جاري تحميل تفاصيل الطلب...',

    // Generic language toggler
    'ui.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.switch_to_ar': 'التبديل إلى العربية',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.order.color_hex': 'رمز اللون',
    'ui.copy_link': 'نسخ الرابط',
    'ui.copy_link_copied': 'تم نسخ الرابط',
    'ui.theme.lightMode': 'الوضع الفاتح',
    'ui.theme.darkMode': 'الوضع الداكن',
    'ui.menu.open': 'فتح القائمة',
    'ui.menu.navigation': 'التنقل',
    'ui.menu.collapse': 'إخفاء القائمة الجانبية',
    'ui.menu.expand': 'إظهار القائمة الجانبية',
    'ui.prices.show': 'إظهار الأسعار',
    'ui.prices.hide': 'إخفاء الأسعار',
    'ui.date.startDate': 'تاريخ البداية',
    'ui.date.endDate': 'تاريخ النهاية',

    'cookies.title': 'نستخدم ملفات تعريف الارتباط',
    'cookies.message':
      'نستخدم ملفات تعريف الارتباط لإبقائك مسجّل الدخول، وتذكّر لغتك، وتحسين Dentrist. بالمتابعة فإنك توافق على استخدامنا لملفات تعريف الارتباط.',
    'cookies.accept': 'قبول ملفات تعريف الارتباط',

    'onboarding.menu.start': 'جولة النظام',
    'onboarding.welcome.title': 'مرحبًا بك في Dentrist',
    'onboarding.welcome.description':
      'هذه جولة النظام تمرّ بك على واجهة مساحة العمل وكل صفحة في الشريط الجانبي. يمكنك إعادة تشغيلها في أي وقت من قائمة الملف الشخصي.',
    'onboarding.navigation.title': 'القائمة الرئيسية',
    'onboarding.navigation.description':
      'استخدم الشريط الجانبي لفتح كل الصفحات المتاحة في نظامك. بعد ذلك سنزور كل صفحة منها.',
    'onboarding.controls.title': 'اللغة والمظهر',
    'onboarding.controls.description':
      'بدّل بين العربية والإنجليزية، واختر الوضع الفاتح أو الداكن لمساحة العمل.',
    'onboarding.account.title': 'الحساب والتنبيهات',
    'onboarding.account.description':
      'راجع الإشعارات، أظهر أو أخفِ الأسعار، افتح ملفك الشخصي، أو أعد تشغيل هذه الجولة من قائمة المستخدم.',
    'onboarding.workspace.title': 'مساحة العمل',
    'onboarding.workspace.description':
      'هنا تظهر لوحات المعلومات والقوائم والنماذج. ابدأ من الصفحة الرئيسية لمتابعة نشاط معملك بسرعة.',
    'onboarding.pages.title': 'صفحات النظام',
    'onboarding.pages.description':
      'سنفتح الآن كل صفحة مدرجة في نظامك حتى تعرف أين توجد كل أداة.',
    'onboarding.page.description':
      'هذه صفحة {{page}}. يمكنك فتحها في أي وقت من الشريط الجانبي لمتابعة عملك هنا.',
    'onboarding.finish.title': 'أنت جاهز',
    'onboarding.finish.description':
      'بهذا تكون قد مررت على كل صفحات نظامك. أعد تشغيل هذه الجولة في أي وقت من قائمة الملف الشخصي.',

    'userTypes.dentist': 'طبيب أسنان',
    'userTypes.lab_contact': 'جهة اتصال المختبر',
    'userTypes.technician': 'فني',
    'userTypes.courier': 'مندوب',
    'userTypes.admin': 'مدير',
    'userTypes.support': 'الدعم الفني',
    'userTypes.accountant': 'محاسب',
    'userTypes.designer': 'مصمم',
    'userTypes.scanner': 'فني مسح ضوئي',
    'userTypes.custom': 'دور مخصص',
    'orders.comments.role.designer': 'مصمم',
    'orders.comments.role.scanner': 'فني مسح ضوئي',
    'orders.comments.role.accountant': 'محاسب',
    'customRoles.button.manage': 'الأدوار',
    'customRoles.button.add': 'إضافة دور',
    'customRoles.header.title': 'الأدوار',
    'customRoles.header.subtitle': 'الأدوار الافتراضية مدمجة في النظام ولا يمكن تعديلها. أنشئ أدوارًا مخصصة بالصلاحيات التي تحتاجها بالضبط، ثم عيّنها للمستخدمين.',
    'customRoles.tag.default': 'افتراضي',
    'customRoles.readOnly': 'غير قابل للتعديل',
    'customRoles.alert.disabled': 'الأدوار المخصصة غير مفعّلة لمعملك. تواصل مع الدعم لتفعيلها. تبقى الأدوار الحالية معيّنة لمستخدميها.',
    'customRoles.empty': 'لا توجد أدوار مخصصة بعد',
    'customRoles.table.name': 'الدور',
    'customRoles.table.permissions': 'الصلاحيات',
    'customRoles.table.users': 'المستخدمون',
    'customRoles.modal.createTitle': 'إضافة دور مخصص',
    'customRoles.modal.editTitle': 'تعديل الدور المخصص',
    'customRoles.form.name.label': 'اسم الدور',
    'customRoles.form.name.placeholder': 'مثال: فني أول',
    'customRoles.form.name.required': 'أدخل اسم الدور',
    'customRoles.form.name.length': 'يجب أن يكون اسم الدور من 2 إلى 60 حرفًا',
    'customRoles.form.nameAr.label': 'الاسم بالعربية',
    'customRoles.form.nameAr.placeholder': 'مثال: فني أول',
    'customRoles.form.nameAr.hint': 'يظهر عند استخدام التطبيق باللغة العربية. اتركه فارغًا لاستخدام اسم الدور.',
    'customRoles.form.permissions.label': 'الصلاحيات',
    'customRoles.form.permissions.search': 'ابحث في الصلاحيات',
    'customRoles.form.permissions.selectAll': 'تحديد الكل',
    'customRoles.form.permissions.selectedCount': '{count} محددة',
    'customRoles.form.permissions.required': 'اختر صلاحية واحدة على الأقل',
    'customRoles.form.permissions.propagateHint': 'سيحصل مستخدمو هذا الدور على الصلاحيات المضافة ويفقدون المحذوفة، وسيحتاجون إلى تسجيل الدخول مجددًا.',
    'customRoles.delete.title': 'حذف هذا الدور؟',
    'customRoles.delete.description': 'لا يمكن التراجع عن هذا الإجراء.',
    'customRoles.delete.blocked': 'انقل مستخدميه إلى دور آخر قبل حذفه.',
    'customRoles.toast.created': 'تم إنشاء الدور',
    'customRoles.toast.updated': 'تم تحديث الدور',
    'customRoles.toast.deleted': 'تم حذف الدور',
    'customRoles.error.load': 'تعذر تحميل الأدوار',
    'customRoles.error.save': 'تعذر حفظ الدور',
    'customRoles.error.delete': 'تعذر حذف الدور',

    'deliveryTypes.standard_delivery': 'التوصيل العادي',
    'deliveryTypes.free_delivery': 'التوصيل المجاني',

    'orders.summary.title': 'ملخص الطلب',

    // General UI
    'common.print': 'طباعة',
    'common.openNew': 'فتح في صفحة جديدة',
    'common.copy': 'نسخ',
    'common.copied': 'تم النسخ',
    'common.save': 'حفظ',
    'common.updated': 'تم التحديث',
    'common.active': 'نشط',
    'common.status': 'الحالة',
    'common.inactive': 'غير نشط',
    'common.export': 'تنزيل',
    'common.export.csv': 'تنزيل CSV',
    'common.export.excel': 'تنزيل Excel',
    'common.export.pdf': 'تنزيل PDF',
    'common.export.selectedCount': '{{count}} محدد',
    'common.export.error': 'فشل التنزيل',
    'common.export.dateRange.label': 'الفترة',
    'common.export.dateRange.hint': 'اتركها فارغة لتنزيل كل التواريخ.',
    'common.export.dateRange.thisMonth': 'هذا الشهر',
    'common.export.dateRange.lastMonth': 'الشهر الماضي',
    'common.export.dateRange.last30Days': 'آخر 30 يومًا',
    'common.export.dateRange.thisYear': 'هذا العام',
    'common.export.entity.orders': 'الطلبات',
    'common.export.entity.invoices': 'الفواتير',
    'common.export.entity.clients': 'العملاء',
    'common.export.entity.users': 'المستخدمون',
    'common.export.entity.expenses': 'المصروفات',
    'orders.summary.itemsLabel': 'العناصر',
    'orders.summary.subtotal': 'المجموع الفرعي',
    'orders.summary.discountDentistFormulaType': 'خصم الطبيب حسب نوع التركيبة',
    'orders.summary.discountClientFormulaType': 'خصم العميل حسب نوع التركيبة',
    'orders.summary.discountUnitOverride': 'خصم تعديل سعر الوحدة',
    'orders.summary.discountOrderAmount': 'خصم الطلب',
    'orders.summary.totalDiscount': 'إجمالي الخصم',
    'orders.summary.markup': 'زيادة السعر',
    'orders.summary.markupClientFormulaType': 'زيادة سعر العميل حسب نوع التركيبة',
    'orders.summary.markupUnitOverride': 'زيادة تعديل سعر الوحدة',
    'orders.summary.totalMarkup': 'إجمالي زيادة السعر',
    'orders.actions.createWorkCard': 'بطاقة العمل',
    'orders.actions.workCardCreated': 'تم إنشاء بطاقة العمل',
    'orders.summary.vat': 'الضريبة ({{percent}}%)',
    'orders.summary.delivery': 'تكلفة التوصيل',
    'orders.summary.deliveryCenter': 'مركز التسليم',
    'orders.summary.noDeliveryCenter': 'لا يوجد مركز تسليم',
    'orders.summary.total': 'الإجمالي',
    'orders.summary.noFormulaType': 'لا يوجد نوع تركيبة محدد',
    'orders.summary.formulaType': 'نوع التركيبة',
    'orders.summary.unitUnknown': 'وحدة',
    'orders.summary.noUnits': 'لا توجد وحدات',
    'orders.summary.color': 'اللون',
    'orders.summary.noColor': '—',
    'orders.summary.unitLabel': 'الوحدة',
    'orders.summary.price': 'السعر',
    'orders.summary.formulaLineTitle': 'التركيبة {{n}}',
    'orders.summary.pricePerUnit': 'السعر لكل وحدة',
    'orders.summary.unitsCount': 'عدد الوحدات',
    'orders.summary.formulaLineTotal': 'سعر التركيبة',
    'orders.summary.vatLabel': 'الضريبة',
    'orders.summary.deliveryLabel': 'تكلفة التوصيل',
    'orders.summary.deliveryLabelWithType': 'تكلفة التوصيل ({type})',
    'orders.summary.free': 'مجاني',
    'orders.orderStatus.requested': 'تم الطلب',
    'orders.orderStatus.review': 'قيد المراجعة',
    'orders.orderStatus.tx-review': 'مراجعة الخطة العلاجية',
    'orders.orderStatus.tx-approved': 'تم اعتماد الخطة',
    'orders.orderStatus.tx-replan': 'إعادة التخطيط',
    'orders.orderStatus.in-progress': 'قيد التنفيذ',
    'orders.orderStatus.in-delivery': 'قيد التسليم',
    'orders.orderStatus.delivered': 'تم التسليم',
    'orders.orderStatus.finished': 'مكتمل',
    'orders.orderStatus.cancelled': 'ملغي',
    'orders.orderStatus.dispute': 'نزاع',
    'orders.orderStatus.draft': 'مسودة',
    'orders.orderStatus.pending_review': 'بانتظار المراجعة',
    'orders.orderStatus.under_review': 'قيد المراجعة',
    'orders.orderStatus.more_info_required': 'مطلوب معلومات إضافية',
    'orders.orderStatus.resubmitted': 'أعيد الإرسال',
    'orders.orderStatus.accepted': 'مقبول',
    'orders.orderStatus.rejected': 'مرفوض',
    'orders.orderStatus.queued': 'في قائمة الانتظار',
    'orders.orderStatus.ready_for_design': 'جاهز للتصميم',
    'orders.orderStatus.design_in_progress': 'التصميم قيد التنفيذ',
    'orders.orderStatus.pending_internal_design_review': 'بانتظار المراجعة الداخلية للتصميم',
    'orders.orderStatus.pending_design_approval': 'بانتظار اعتماد التصميم',
    'orders.orderStatus.design_revision_requested': 'مطلوب تعديل التصميم',
    'orders.orderStatus.design_revision_in_progress': 'تعديل التصميم قيد التنفيذ',
    'orders.orderStatus.design_approved': 'تم اعتماد التصميم',
    'orders.orderStatus.design_rejected': 'تم رفض التصميم',
    'orders.orderStatus.ready_for_try_in_production': 'جاهز لتصنيع البروفة',
    'orders.orderStatus.try_in_production_in_progress': 'تصنيع البروفة قيد التنفيذ',
    'orders.orderStatus.try_in_quality_check': 'فحص جودة البروفة',
    'orders.orderStatus.ready_for_try_in': 'جاهز للبروفة',
    'orders.orderStatus.out_for_try_in': 'خرج للبروفة',
    'orders.orderStatus.pending_try_in_feedback': 'بانتظار ملاحظات البروفة',
    'orders.orderStatus.try_in_approved': 'تم اعتماد البروفة',
    'orders.orderStatus.try_in_revision_requested': 'مطلوب تعديل البروفة',
    'orders.orderStatus.try_in_revision_in_progress': 'تعديل البروفة قيد التنفيذ',
    'orders.orderStatus.ready_for_repeat_try_in': 'جاهز لإعادة البروفة',
    'orders.orderStatus.try_in_not_required': 'البروفة غير مطلوبة',
    'orders.orderStatus.in_progress': 'قيد التنفيذ',
    'orders.orderStatus.manufacturing_try_in': 'بروفة التصنيع',
    'orders.orderStatus.ready_for_final_production': 'جاهز للإنتاج النهائي',
    'orders.orderStatus.final_production': 'الإنتاج النهائي',
    'orders.orderStatus.ready_for_final_manufacturing': 'جاهز للتصنيع النهائي',
    'orders.orderStatus.final_manufacturing_in_progress': 'التصنيع النهائي قيد التنفيذ',
    'orders.orderStatus.manufacturing_paused': 'التصنيع متوقف مؤقتًا',
    'orders.orderStatus.pending_external_work': 'بانتظار عمل خارجي',
    'orders.orderStatus.finishing_in_progress': 'التشطيب قيد التنفيذ',
    'orders.orderStatus.quality_control': 'فحص الجودة',
    'orders.orderStatus.quality_control_failed': 'فشل فحص الجودة',
    'orders.orderStatus.rework_in_progress': 'إعادة العمل قيد التنفيذ',
    'orders.orderStatus.quality_control_passed': 'اجتاز فحص الجودة',
    'orders.orderStatus.ready_for_dispatch': 'جاهز للشحن',
    'orders.orderStatus.awaiting_pickup': 'بانتظار الاستلام',
    'orders.orderStatus.out_for_delivery': 'خرج للتوصيل',
    'orders.orderStatus.delivery_attempt_failed': 'فشلت محاولة التوصيل',
    'orders.orderStatus.delivery_disputed': 'نزاع على التسليم',
    'orders.orderStatus.return_requested': 'مطلوب الإرجاع',
    'orders.orderStatus.returned_to_lab': 'أعيد إلى المعمل',
    'orders.orderStatus.pending_closure': 'بانتظار الإغلاق',
    'orders.orderStatus.closed': 'مغلق',
    'orders.orderStatus.on_hold': 'معلق',
    'orders.orderStatus.awaiting_client_action': 'بانتظار إجراء العميل',
    'orders.orderStatus.awaiting_payment': 'بانتظار الدفع',
    'orders.orderStatus.cancel_requested': 'مطلوب الإلغاء',
    'orders.orderStatus.remake_requested': 'مطلوب إعادة التصنيع',
    'orders.orderStatus.remake_approved': 'تمت الموافقة على إعادة التصنيع',
    'orders.orderStatus.remake_in_progress': 'إعادة التصنيع قيد التنفيذ',
    'orders.orderStatus.disputed': 'نزاع',
    'orders.invoice.notBillableYet': 'يمكن إضافة هذا الطلب إلى فاتورة بعد وصوله إلى الحالة المحددة في سير عمل حالات الطلب.',
    'orders.amount.notCountedYet': 'غير محتسب بعد: لم يصل هذا الطلب إلى الحالة المحددة في سير عمل حالات الطلب، لذلك لا يُحتسب مبلغه في لوحة التحكم ولا في أرصدة العملاء وكشوف حساباتهم ولا في تقريري التحصيلات والإيرادات.',
    'orders.actions.status.noAllowedTransitions': 'لا توجد تغييرات حالة مسموحة من الحالة الحالية',
    'orders.orderStatus.on-hold': 'معلق',
    'orders.paymentStatus.draft': 'مسودة',
    'orders.paymentStatus.due': 'مستحق',
    'orders.paymentStatus.not_due': 'غير مستحق',
    'orders.paymentStatus.unpaid': 'غيرمدفوع',
    'orders.paymentStatus.paid': 'مدفوع',
    'orders.paymentStatus.partially_paid': 'دفع جزئي',
    'orders.paymentStatus.void': 'ملغى',
    'orders.button.add': 'إضافة طلب',
    'orders.button.create': 'إنشاء طلب',
    'orders.empty.noOrdersYet': 'لا توجد حالات بعد',
    'orders.empty.noneMatchFilters': 'لا توجد حالات تطابق المرشحات الحالية. جرّب تغيير حالة الدفع أو المرشحات الأخرى.',
    'orders.button.cancel': 'إلغاء',
    'orders.confirm.cancelTitle': 'إلغاء الطلب',
    'orders.confirm.cancelMessage': 'هل تريد بالتأكيد إلغاء هذا الطلب؟ سيتم تحويله إلى مسودة.',
    'orders.confirm.cancelSuccess': 'تم إلغاء الطلب',
    'orders.confirm.cancelError': 'فشل إلغاء الطلب',
    'orders.button.viewEdit': 'عرض | تعديل',
    'orders.button.view': 'عرض',
    'orders.confirm.deleteTitle': 'حذف حالة',
    'orders.confirm.deleteMessage': 'هل تريد حذف هذه الحالة؟',
    'orders.update.collectPayment': 'تحصيل الحساب',
    'orders.update.refundPayment': 'إرجاع الحساب',
    'orders.update.markDelivered': 'توصيل',
    'orders.update.invoiceButton': 'الفاتورة',
    'orders.alert.noAccess': 'ليس لديك صلاحية لعرض الحالات.',
    'orders.alert.noCreate': 'ليس لديك صلاحية لإضافة حالات.',
    'orders.alert.dentistNoClient': 'حسابك غير مرتبط بعميل. يرجى التواصل مع مسؤول المختبر قبل إنشاء الحالات.',
    'orders.alert.noView': 'ليس لديك صلاحية لعرض هذه الحالة.',
    'orders.alert.editBlocked': 'لا يمكن تعديل تفاصيل الطلب لأنه مكتمل أو مسلّم أو مرتبط بفاتورة. لا يزال بإمكانك تحديث الفني والمندوب والحالة عند السماح بذلك.',
    'orders.alert.editBlockedBillable': 'لا يمكن تعديل تفاصيل الطلب لأنه وصل إلى الحالة التي يُحتسب عندها مبلغه. لا يزال بإمكانك تحديث الفني والمندوب والحالة عند السماح بذلك.',
    'colors.form.name.label': 'اسم اللون',
    'colors.form.name.placeholder': 'ادخل اسم اللون',
    'colors.form.name.required': 'من فضلك ادخل اسم اللون',
    'colors.form.name.max': 'يجب ألا يزيد اسم اللون عن 255 حرفًا',
    'colors.form.code.label': 'رمز اللون',
    'colors.form.code.required': 'اللون مطلوب.',
    'colors.quickCreate.title': 'إضافة لون',
    'colors.quickCreate.button': 'إضافة لون جديد',
    'colors.quickCreate.errorFallback': 'تعذر إضافة اللون، حاول مرة أخرى.',
    'dentists.quickCreate.title': 'إضافة طبيب',
    'dentists.quickCreate.button': 'إضافة طبيب جديد',
    'dentists.quickCreate.errorFallback': 'تعذر إضافة الطبيب، حاول مرة أخرى.',
    'dentists.quickCreate.useClientName': 'استخدام اسم العميل',
    'dentists.quickCreate.missingType': 'تعذر تحديد نوع مستخدم الطبيب، يرجى إعادة التحميل والمحاولة.',
    'dentists.quickCreate.titleLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.quickCreate.buttonLabContact': 'إضافة جهة اتصال مختبر جديدة',
    'dentists.quickCreate.errorFallbackLabContact': 'تعذر إضافة جهة اتصال المختبر، حاول مرة أخرى.',
    'dentists.form.name.label': 'اسم الطبيب',
    'dentists.form.name.placeholder': 'ادخل اسم الطبيب',
    'dentists.form.name.required': 'من فضلك ادخل اسم الطبيب',
    'dentists.form.name.labelLabContact': 'اسم جهة اتصال المختبر',
    'dentists.form.name.placeholderLabContact': 'ادخل اسم جهة اتصال المختبر',
    'dentists.form.name.requiredLabContact': 'من فضلك ادخل اسم جهة اتصال المختبر',
    'dentists.form.email.label': 'البريد الإلكتروني',
    'dentists.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'dentists.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'dentists.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'dentists.form.username.label': 'اسم المستخدم',
    'dentists.form.username.placeholder': 'ادخل اسم المستخدم',
    'dentists.form.username.hint': 'مطلوب إذا لم يكن للطبيب بريد إلكتروني',
    'dentists.form.username.optionalHint': 'اختياري. اترك البريد الإلكتروني واسم المستخدم فارغين ليتم إنشاء اسم مستخدم تلقائيًا.',
    'dentists.form.password.label': 'كلمة المرور',
    'dentists.form.password.placeholder': 'ادخل كلمة المرور',
    'dentists.form.password.required': 'من فضلك ادخل كلمة المرور',
    'dentists.form.password.min': 'يجب ألا تقل كلمة المرور عن 6 أحرف',
    'dentists.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'dentists.form.phone.label': 'رقم الهاتف',
    'dentists.form.phone.placeholder': 'ادخل رقم الهاتف',
    'dentists.form.whatsapp.label': 'رقم الواتساب',
    'dentists.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'dentists.form.address.label': 'العنوان',
    'dentists.form.address.placeholder': 'ادخل العنوان',

    // Transactions
    'transactions.table.type': 'النوع',
    'transactions.table.reference': 'المرجع',
    'transactions.table.amount': 'القيمة',
    'transactions.table.notes': 'ملاحظات',
    'transactions.table.createdAt': 'تاريخ الإنشاء',
    'transactions.types.invoice': 'فاتورة',
    'transactions.types.expense': 'مصروف',
    'transactions.types.wallet_recharge': 'شحن المحفظة',
    'transactions.types.wallet': 'المحفظة',
    'transactions.types.wallet_deduction': 'خصم من المحفظة',
    'transactions.types.invoice_refund': 'استرداد الفاتورة',
    'transactions.types.wallet_recharge_revert': 'تراجع عن شحن المحفظة',
    'transactions.alert.noAccess': 'ليست لديك صلاحية لعرض المعاملات.',

    'formulaTypes.table.image': 'الصورة',
    'formulaTypes.table.name': 'الاسم',
    'formulaTypes.search.placeholder': 'بحث بالاسم أو الوصف',
    'formulaTypes.filter.unit.placeholder': 'فرز حسب الوحدة أو الفك',
    'formulaTypes.table.cost': 'التكلفة لكل وحدة',
    'formulaTypes.table.description': 'الوصف',
    'formulaTypes.table.actions': 'العمليات',
    'formulaTypes.button.add': 'إضافة نوع تركيبة',
    'formulaTypes.modal.title': 'أنواع التركيبات',
    'formulaTypes.confirm.deleteTitle': 'حذف نوع تركيبة',
    'formulaTypes.alert.noAccess': 'ليس لديك صلاحية لعرض أنواع التركيبات.',
    'formulaTypes.confirm.deleteMessage': 'هل تريد حذف نوع التركيبة هذا؟',
    'formulaTypes.form.name.label': 'اسم التركيبة',
    'formulaTypes.form.name.placeholder': 'ادخل اسم التركيبة',
    'formulaTypes.form.name.required': 'من فضلك ادخل اسم التركيبة',
    'formulaTypes.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'formulaTypes.form.cost.label': 'التكلفة لكل وحدة',
    'formulaTypes.form.cost.placeholder': '٠',
    'formulaTypes.form.cost.required': 'من فضلك ادخل التكلفة',
    'formulaTypes.form.materialCostPerUnit.label': 'تكلفة الخامة لكل وحدة',
    'formulaTypes.form.materialCostPerUnit.placeholder': '٠',
    'formulaTypes.form.materialCostPerUnit.required': 'من فضلك ادخل تكلفة الخامة لكل وحدة',
    'formulaTypes.form.additionalOperationalCosts.label': 'تكاليف تشغيلية إضافية',
    'formulaTypes.form.additionalOperationalCosts.hint': 'أضف أي بنود تكلفة إضافية، مثال: lab_to_lab = 10',
    'formulaTypes.form.additionalOperationalCosts.add': 'إضافة بند تكلفة',
    'formulaTypes.form.additionalOperationalCosts.itemPlaceholder': 'بند التكلفة (مثال: lab_to_lab)',
    'formulaTypes.form.additionalOperationalCosts.itemRequired': 'من فضلك ادخل بند التكلفة',
    'formulaTypes.form.additionalOperationalCosts.itemDuplicate': 'هذا البند مضاف بالفعل',
    'formulaTypes.form.additionalOperationalCosts.valuePlaceholder': 'القيمة',
    'formulaTypes.form.additionalOperationalCosts.valueRequired': 'من فضلك ادخل القيمة',
    'formulaTypes.form.additionalOperationalCosts.valuePositive': 'يجب أن تكون القيمة أكبر من 0',
    'formulaTypes.form.sellingPrice.label': 'سعر البيع للوحدة',
    'formulaTypes.form.sellingPrice.placeholder': '٠',
    'formulaTypes.form.sellingPrice.required': 'من فضلك ادخل سعر البيع',
    'formulaTypes.form.technicianCostPerUnit.label': 'تكلفة الفني لكل وحدة',
    'formulaTypes.form.technicianCostPerUnit.placeholder': '٠',
    'formulaTypes.form.technicianCostPerUnit.required': 'من فضلك ادخل تكلفة الفني لكل وحدة',
    'formulaTypes.form.scope.label': 'النطاق',
    'formulaTypes.form.scope.placeholder': 'وحدة أو فك',
    'formulaTypes.form.scope.required': 'من فضلك اختر وحدة أو فك',
    'formulaTypes.scope.unit': 'وحدة',
    'formulaTypes.scope.arch': 'فك',
    'formulaTypes.table.materialCostPerUnit': 'تكلفة الخامة / وحدة',
    'formulaTypes.table.additionalOperationalCosts': 'تكاليف تشغيلية إضافية',
    'formulaTypes.table.sellingPrice': 'سعر البيع',
    'formulaTypes.table.technicianCostPerUnit': 'تكلفة الفني / وحدة',
    'formulaTypes.table.scope': 'وحدة / فك',
    'formulaTypes.form.description.label': 'وصف التركيبة',
    'formulaTypes.form.description.placeholder': 'ادخل وصف التركيبة',
    'formulaTypes.form.image.label': 'الصورة',
    'formulaTypes.form.image.hint': 'JPG أو PNG أو GIF أو WEBP (بحد أقصى 4 ميجابايت). تظهر صورة افتراضية عند عدم تحديد صورة.',
    'formulaTypes.form.image.choose': 'رفع صورة',
    'formulaTypes.form.image.change': 'تغيير الصورة',
    'formulaTypes.form.image.remove': 'إزالة الصورة',
    'formulaTypes.form.attachments.label': 'المرفقات',
    'formulaTypes.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'formulaTypes.form.attachments.choose': 'اختر ملفات',
    'formulaTypes.form.attachments.existing': 'المرفقات الموجودة:',
    'formulaTypes.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'formulaTypes.attachment.deleted': 'تم حذف المرفق',
    'formulaTypes.attachment.deleteError': 'فشل حذف المرفق',
    'formulaTypes.quickCreate.title': 'إضافة نوع تركيبة',
    'formulaTypes.quickCreate.button': 'إضافة نوع تركيبة جديد',
    'formulaTypes.setPrice.title': 'تحديد سعر البيع',
    'formulaTypes.setPrice.description': '«{name}» ليس له سعر بيع. أدخل سعرًا حتى يتم تسعير هذا الطلب بشكل صحيح.',
    'formulaTypes.setPrice.descriptionGeneric': 'نوع التركيبة هذا ليس له سعر بيع. أدخل سعرًا حتى يتم تسعير هذا الطلب بشكل صحيح.',
    'formulaTypes.setPrice.min': 'يجب أن يكون سعر البيع أكبر من صفر',
    'formulaTypes.setPrice.success': 'تم حفظ سعر البيع',
    'formulaTypes.setPrice.errorFallback': 'تعذر حفظ سعر البيع، حاول مرة أخرى.',
    'deliveryCenters.quickCreate.title': 'إضافة مركز تسليم',
    'deliveryCenters.quickCreate.button': 'إضافة مركز تسليم جديد',
    'deliveryCenters.quickCreate.errorFallback': 'تعذر إضافة مركز التسليم، حاول مرة أخرى.',
    'deliveryCenters.form.name.label': 'اسم مركز التسليم',
    'deliveryCenters.form.name.placeholder': 'ادخل اسم مركز التسليم',
    'deliveryCenters.form.name.required': 'من فضلك ادخل اسم مركز التسليم',
    'deliveryCenters.form.address.label': 'العنوان',
    'deliveryCenters.form.address.placeholder': 'ادخل العنوان',
    'deliveryCenters.form.phone.label': 'رقم الهاتف',
    'deliveryCenters.form.phone.placeholder': 'ادخل رقم الهاتف',
    'deliveryCenters.form.whatsapp.label': 'رقم الواتساب',
    'deliveryCenters.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'deliveryCenters.form.email.label': 'البريد الإلكتروني',
    'deliveryCenters.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'deliveryCenters.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'deliveryCenters.form.notes.label': 'ملاحظات',
    'deliveryCenters.form.notes.placeholder': 'أضف ملاحظات (اختياري)',

    'lab.title': 'معلومات المعمل',
    'lab.subtitle': 'عرض وتحديث بيانات المعمل ووسائل التواصل والشعار',
    'lab.delivery.subtitle': 'ضبط أنواع التوصيل والمبالغ والخيار الافتراضي للطلبات',
    'lab.delivery.showCost.label': 'إظهار التوصيل',
    'lab.delivery.showCost.help': 'عند الإيقاف، يُخفى التوصيل (نوع التوصيل وتكلفة التوصيل) في إنشاء/تعديل/عرض الطلب والطلب العام وسجل تغييرات الطلب والفواتير وملفات PDF والفاتورة العامة ورسائل المشاركة والتصدير. الإجمالي يبقى شاملاً التوصيل.',
    'lab.delivery.showCost.show': 'إظهار',
    'lab.delivery.showCost.hide': 'إخفاء',
    'lab.delivery.showCost.saved': 'تم تحديث إظهار تكلفة التوصيل.',
    'lab.payment.subtitle': 'إدارة الحسابات البنكية وقنوات التحويل لمدفوعات العملاء',
    'vacations.subtitle': 'إدارة أيام نهاية الأسبوع وفترات إغلاق المعمل في التقويم',
    'branchs.subtitle': 'إدارة فروع المعمل والعناوين وبيانات التواصل',
    'assets.subtitle': 'تتبع أصول المعمل وتكاليف الشراء والملاحظات',
    'assets.stats.totalAssets': 'إجمالي الأصول',
    'expenses.subtitle': 'تسجيل ومتابعة مصروفات المعمل حسب النوع والتاريخ والمبلغ',
    'expenses.stats.totalAmount': 'إجمالي مبلغ المصروفات',
    'expenseTypes.subtitle': 'تعريف بنود المصروفات المستخدمة عند تسجيل المصروفات',
    'colors.subtitle': 'إدارة ألوان الكتالوج المستخدمة في التركيبات والطلبات',
    'notificationSettings.subtitle': 'اختر رسائل البريد التي تصلك عن الطلبات',
    'notificationSettings.loadError': 'تعذر تحميل إعدادات الإشعارات',
    'notificationSettings.saved': 'تم الحفظ.',
    'notificationSettings.noAccess': 'ليس لديك صلاحية الوصول إلى إعدادات الإشعارات.',
    'notificationSettings.emailStatusChanges': 'أرسل لي بريداً عند تغيير حالة الطلب إلى',
    'notificationSettings.emailStatusChangesHelp': 'الحالات من سير عمل المعمل. أوقف التبديل لإيقاف تنبيهات البريد لهذه الحالة.',
    'notificationSettings.noStatuses': 'لا توجد حالات في سير العمل.',
    'notificationSettings.emailOrderModified': 'أرسل لي بريداً عند تعديل طلب',
    'notificationSettings.emailOrderChat': 'أرسل لي بريداً عند وجود محادثة جديدة في طلب',
    'notificationSettings.emailOrderAssigned': 'أرسل لي بريداً عند تعيين طلب لي',
    'notificationSettings.assignedOrdersOnly': 'استقبل فقط الإشعارات المتعلقة بالطلبات المسندة إليّ',
    'notificationSettings.assignedOrdersOnlyHelp': 'عند التفعيل، تقتصر إشعارات الطلبات على الطلبات التي تكون فيها طبيباً أو فنياً أو مندوب توصيل. مديرو المعمل يستمرون في استلام كل إشعارات الطلبات.',
    'formulaTypes.subtitle': 'ضبط أنواع التركيبات والأسعار والوحدات والمرفقات',
    'activities.subtitle': 'سجل تدقيق لعمليات المستخدمين عبر المنصة',
    'transactions.subtitle': 'مراجعة حركات الفواتير والمصروفات والمحفظة',
    'lab.table.field': 'البيان',
    'lab.table.value': 'القيمة',
    'lab.table.actions': 'إجراءات',
    'lab.table.branches': 'الفروع',
    'lab.delivery.title': 'التوصيل',
    'lab.delivery.col.name': 'الاسم',
    'lab.delivery.col.amount': 'المبلغ',
    'lab.delivery.default': 'افتراضي',
    'lab.delivery.setDefault': 'تعيين كافتراضي',
    'lab.delivery.setDefaultSuccess': 'تم التعيين كافتراضي.',
    'lab.delivery.editValue': 'تغيير القيمة',
    'lab.delivery.editStandardTitle': 'تغيير قيمة التوصيل العادي',
    'lab.delivery.amountForCurrency': 'المبلغ ({currency})',
    'lab.delivery.updateSuccess': 'تم التحديث.',
    'lab.changeHistory': 'سجل التغييرات',
    'lab.tax.changeHistory': 'سجل الضريبة',
    'lab.tax.versions.title': 'سجل تغييرات الضريبة',
    'lab.delivery.versions.title': 'سجل تغييرات إعدادات التوصيل',
    'lab.delivery.typeVersions.title': 'سجل تغييرات نوع التوصيل',
    'lab.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'lab.versions.by': 'تم التحديث بواسطة',
    'lab.versions.noFields': 'لا توجد حقول تغيّرت',
    'lab.versions.timelineTitle': 'الخط الزمني',
    'lab.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'lab.versions.selectVersion': 'اختر إصدارًا',
    'lab.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'lab.versions.before': 'قبل',
    'lab.versions.after': 'بعد (الحالي)',
    'lab.field.name': 'اسم المعمل',
    'lab.field.logo': 'الشعار',
    'lab.field.phone': 'تليفون المعمل',
    'lab.field.contactPhone': 'هاتف التواصل',
    'lab.field.vatPercentage': 'نسبة الضريبة',
    'lab.field.delivery': 'التوصيل',
    'lab.field.currency': 'العملة',
    'lab.field.showVat': 'إظهار الضريبة',
    'lab.field.showVat.show': 'ظاهرة',
    'lab.field.showVat.hide': 'مخفية',
    'lab.field.showPriceDiscounts': 'إظهار الخصومات',
    'lab.field.showPriceDiscounts.show': 'ظاهرة',
    'lab.field.showPriceDiscounts.hide': 'مخفية',
    'lab.field.shareContactsWithClients': 'مشاركة بيانات التواصل مع العملاء',
    'lab.field.shareContactsWithClients.show': 'مُشاركة',
    'lab.field.shareContactsWithClients.hide': 'مخفية',
    'lab.field.whatsapp': 'رقم واتساب المعمل',
    'lab.field.notes': 'وصف المعمل',
    'lab.button.edit': 'تعديل',
    'lab.modal.title': 'تعديل بيانات المعمل',
    'lab.form.name.label': 'اسم المعمل',
    'lab.form.name.placeholder': 'ادخل اسم المعمل',
    'lab.form.name.required': 'من فضلك ادخل اسم المعمل',
    'lab.form.phone.label': 'رقم التليفون',
    'lab.form.phone.placeholder': 'ادخل رقم التليفون',
    'lab.form.contactPhone.label': 'هاتف التواصل',
    'lab.form.contactPhone.placeholder': 'ادخل هاتف التواصل',
    'lab.form.vatPercentage.label': 'نسبة الضريبة',
    'lab.form.vatPercentage.placeholder': '٠',
    'lab.form.delivery.label': 'التوصيل',
    'lab.form.delivery.placeholder': '٠',
    'lab.form.showVat.label': 'إظهار الضريبة للعملاء',
    'lab.form.showVat.help': 'عند الإيقاف، تُخفى أسطر الضريبة في الطلبات والفواتير وملفات PDF والفاتورة العامة ورسائل المشاركة والتصدير. الإجمالي يبقى شاملاً الضريبة.',
    'lab.form.showVat.show': 'إظهار',
    'lab.form.showVat.hide': 'إخفاء',
    'lab.form.showPriceDiscounts.label': 'إظهار الخصومات في الطلبات والفواتير',
    'lab.form.showPriceDiscounts.help': 'عند الإيقاف، تُخفى تسميات ومبالغ الخصم في الطلبات والفواتير وملفات PDF والفاتورة العامة. المبالغ المحصلة تبقى حسب أسعار العميل.',
    'lab.form.showPriceDiscounts.show': 'إظهار',
    'lab.form.showPriceDiscounts.hide': 'إخفاء',
    'lab.form.shareContactsWithClients.label': 'مشاركة بيانات تواصل المعمل مع العملاء',
    'lab.form.shareContactsWithClients.help': 'عند الإيقاف، يُخفى هاتف المعمل وواتساب والعنوان من الفواتير والفواتير المجمعة وكشوف الحساب وملفات PDF والتصدير والفاتورة العامة.',
    'lab.form.shareContactsWithClients.show': 'مشاركة',
    'lab.form.shareContactsWithClients.hide': 'إخفاء',
    'lab.form.currency.label': 'العملة',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.readOnly': 'لا يمكن تغيير العملة بعد الإعداد.',
    'lab.form.whatsapp.label': 'رقم الواتساب',
    'lab.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'lab.form.notes.label': 'وصف المعمل',
    'lab.form.notes.placeholder': 'ادخل وصف المعمل',
    'lab.form.logo.label': 'الشعار (شريط التنقل)',
    'lab.form.logo.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'lab.form.logo.uploadButton': 'اختر إعدادت الشعار',
    'lab.form.removeLogo': 'إزالة الشعار الحالي',
    'lab.saveSuccess': 'تم حفظ الإعدادات',
    'lab.saveError': 'تعذر حفظ الإعدادات',
    'lab.button.save': 'حفظ',

    'home.currency.egp': 'EGP',
    'home.welcome': 'مرحبا {{labName}},',
    'home.lab_workspace_badge': 'مساحة عمل المعمل',
    'home.dentist_portal_badge': 'صفحة دخول الطبيب',
    'home.dentist_welcome': 'مرحباً د. {{name}}',
    'home.summary': 'ملخص نشاط وأداء المعمل.',
    'home.dentist_summary': 'نظرة عامة على حالات العيادة والتسليمات والفواتير.',
    'home.lab_contact_portal_badge': 'صفحة دخول جهة اتصال المختبر',
    'home.lab_contact_welcome': 'مرحباً {{name}}',
    'home.lab_contact_summary': 'نظرة عامة على حالات المختبر والتسليمات والفواتير.',
    'home.technician_workspace_badge': 'فني',
    'home.technician_welcome': 'مرحباً {{name}}',
    'home.technician_summary': 'الطلبات المسندة إليك والمصروفات المدفوعة لك.',
    'home.my_orders': 'حالات العيادة',
    'home.my_orders_count': 'حالات العيادة',
    'home.lab_orders': 'حالات المختبر',
    'home.lab_orders_count': 'حالات المختبر',
    'home.delivered_orders': 'تم التسليم',
    'home.finished_orders': 'الحالات المكتملة',
    'home.pending_orders': 'قيد الانتظار',
    'home.in_progress_orders': 'قيد التنفيذ',
    'home.upcoming_deliveries': 'التسليمات القادمة',
    'home.patients': 'المرضى',
    'home.filter_by_clients': 'تصفية حسب العملاء',
    'home.cases_this_month': 'حالات هذا الشهر',
    'home.clinic_invoices': 'فواتير العيادة',
    'home.lab_invoices': 'فواتير المختبر',
    'home.patient': 'المريض',
    'home.delivery_date': 'تاريخ التسليم',
    'home.invoices_amount': 'إجمالي الفواتير',
    'home.paid_invoices': 'الفواتير المدفوعة',
    'home.orders': 'الحالات',
    'home.dentists': 'الأطباء',
    'home.invoices': 'الفواتير',
    'home.unpaid_amount': 'المبالغ غير المدفوعة',
    'home.statistics': 'إحصائيات',
    'home.recent_clinics': 'المختبرات الأعلى',
    'home.activity_overview': 'نظرة عامة على النشاط',
    'home.activity_subtitle': 'نظرة عامة على الحالات والفواتير والإيرادات',
    'home.view_reports': 'عرض التقارير',
    'home.dental_clinic': 'العيادة',
    'home.active_invoices': 'الفواتير النشطة',
    'home.active_expenses': 'المصروفات النشطة',
    'home.invoices_label': 'الفواتير',
    'home.expenses_label': 'المصروفات',
    'home.amount': 'المبلغ',
    'home.count': 'العدد',
    'home.revenue': 'الإيرادات',
    'home.paid_invoices_amount': 'قيمة الفواتير المدفوعة',
    'home.unpaid_invoices_amount': 'قيمة الفواتير غير المدفوعة',
    'home.total_orders_amount': 'إجمالي قيمة الطلبات',
    'home.paid_orders_amount': 'إجمالي الطلبات المدفوعة',
    'home.unpaid_orders_amount': 'إجمالي الطلبات غير المدفوعة',
    'home.paid_invoices_count': 'عدد الفواتير المدفوعة',
    'home.unpaid_invoices_count': 'عدد الفواتير غير المدفوعة',
    'home.invoices_count': 'عدد الفواتير',
    'home.clients_count': 'عدد العملاء',
    'home.orders_count': 'عدد الحالات',
    'home.units_count': 'عدد الوحدات',
    'home.expenses_amount': 'إجمالي المصروفات',
    'home.orders_trend': 'اتجاه الحالات',
    'home.revenue_by_month': 'الإيرادات (6 أشهر)',
    'home.invoices_breakdown': 'توزيع الفواتير',
    'home.active_clients': 'العملاء النشطون',
    'home.active_orders': 'الطلبات النشطة',
    'home.active_dentists': 'الأطباء النشطون',
    'home.clients_label': 'العملاء',
    'home.orders_label': 'الطلبات',
    'home.full_period': 'الفترة الكاملة',

    // New home keys
    'home.new_orders': 'طلبات جديدة',
    'home.latest_orders': 'أحدث الطلبات',
    'home.latest_assigned_orders': 'أحدث الطلبات المسندة',
    'home.orders_tracker': 'متعقب الطلبات',
    'home.invoices_tracker': 'متعقب الفواتير',
    'home.formula_types_tracker': 'متعقب أنواع التركيبات',
    'home.latest_formula_types': 'أحدث أنواع التركيبات استخداما',
    'home.view_all_formula_types': 'عرض كل أنواع التركيبات',
    'home.formula_types_label': 'أنواع تركيبات',
    'home.most_used_formula_type': 'نوع التركيبة الأكثر استخدامًا',
    'home.total_units': 'إجمالي الوحدات',
    'home.units_label': 'وحدات',
    'home.last_order': 'آخر طلب',
    'home.last_used': 'آخر استخدام',
    'home.formula_type': 'نوع التركيبة',
    'home.formula_type_by_clients': 'حسب العملاء',
    'home.units_amount': 'مبلغ الوحدات',
    'home.total_units_amount': 'إجمالي مبلغ الوحدات',
    'home.total_net_profit': 'إجمالي صافي الأرباح',
    'home.this_week': 'هذا الأسبوع',
    'home.this_month': 'هذا الشهر',
    'home.last_month': 'الشهر الماضي',
    'home.last_3_months': 'آخر 3 أشهر',
    'home.last_6_months': 'آخر 6 أشهر',
    'home.last_year': ' اخر عام',
    'home.last_2_months': 'آخر شهرين',
    'home.last_12_months': 'آخر 12 شهرًا',
    'home.last_n_months': 'آخر {count} أشهر',
    'home.last_n_months_many': 'آخر {count} شهرًا',
    'home.this_year': 'هذا العام',
    'home.custom_range': 'نطاق مخصص',
    'home.revenue_tracker': 'متعقب الإيرادات',
    'home.collection_tracker': 'متعقب التحصيلات',
    'home.revenue_collection_tracker': 'الإيرادات والتحصيلات',
    'home.outstanding_balance': 'لم يتم تحصيله بعد',
    'home.tracker_total_orders': 'إجمالي الطلبات',
    'home.total_outstanding': 'إجمالي المتبقي',
    'home.total_overdue': 'متأخر',
    'home.total_paid_orders': 'إجمالي التحصيلات',
    'home.total_invoices': 'إجمالي الفواتير',
    'home.total_invoices_amount': 'إجمالي قيمة الفواتير',
    'home.total_expenses': 'إجمالي المصروفات',
    'home.net': 'الصافي',
    'home.total_revenue_net': 'صافي الإيرادات',
    'home.total_collection_net': 'صافي التحصيلات',
    'home.total_due_orders': 'إجمالي الإيرادات',
    'home.total_not_yet_due_orders': 'غير مستحق بعد',
    'home.total_collected_orders': 'إجمالي الطلبات المحصّلة',
    'home.due_orders_label': 'الإيرادات',
    'home.not_yet_due_orders_label': 'غير مستحق بعد',
    'home.collected_orders_label': 'التحصيلات',
    'home.invoices_vs_expenses': 'الفواتير مقابل المصروفات',
    'home.order': 'طلب',
    'home.client': 'عميل',
    'home.status': 'الحالة',
    'home.date': 'التاريخ',
    'home.total': 'الإجمالي',
    'home.total_orders': 'إجمالي الطلبات',
    'home.total_assigned_orders': 'إجمالي الطلبات المسندة',
    'home.total_orders_delivered': 'إجمالي الطلبات التي تم توصيلها',
    'home.total_expenses_paid': 'إجمالي المصروفات المدفوعة',
    'home.requested': 'مطلوب',
    'home.in_progress': 'قيد التنفيذ',
    'home.closed': 'مغلق',
    'home.completed_percentage': 'النسبة المكتملة',
    'home.closed_orders': 'الطلبات المغلقة',
    'home.no_data': 'لا توجد بيانات',
    'home.view_all_orders': 'عرض جميع الطلبات',

    // Profile
    'profile.title': 'الملف الشخصي',
    'profile.error.title': 'تعذر تحميل الملف الشخصي',
    'profile.avatar.upload': 'رفع صورة',
    'profile.avatar.remove': 'إزالة الصورة',
    'profile.avatar.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'profile.avatar.tooLarge': 'الصورة المرفوعة كبيرة جدًا. يرجى استخدام صورة بحجم 4 ميجابايت كحد أقصى.',
    'profile.field.avatar': 'الصورة',
    'profile.field.name': 'الاسم',
    'profile.field.username': 'اسم المستخدم',
    'profile.field.email': 'البريد الإلكتروني',
    'profile.field.userType': 'نوع المستخدم',
    'profile.field.vendorName': 'اسم المعمل',
    'profile.field.assignedClient': 'العميل المعين',
    'profile.section.assignedClient': 'العميل المعين',
    'profile.menu.profile': 'الملف الشخصي',
    'profile.menu.settings': 'الإعدادات',
    'profile.field.password': 'كلمة المرور',
    'profile.field.passwordConfirm': 'تأكيد كلمة المرور',
    'profile.field.phone': 'الهاتف',
    'profile.field.whatsapp': 'واتساب',
    'profile.passwordSet': '••••••••',
    'profile.passwordPending': 'في انتظار الدعوة',
    'profile.field.currentPassword': 'كلمة المرور الحالية',
    'profile.changePassword': 'تغيير كلمة المرور',
    'profile.menu.logout': 'تسجيل خروج',

    'notifications.title': 'الإشعارات',
    'notifications.empty': 'لا توجد إشعارات بعد',
    'notifications.markAllRead': 'تعليم الكل كمقروء',
    'notifications.close': 'إغلاق',
    'notifications.unread': 'غير مقروء',
    'notifications.showMore': 'عرض المزيد',
    'notifications.page.subtitle': 'عرض وإدارة جميع إشعاراتك',
    'notifications.countLabel': 'إجمالي',
    'support.chat.title': 'دعم Dentrist',
    'support.chat.subtitle': 'راسل فريقنا مباشرة — نرد عادةً خلال ساعات قليلة.',
    'support.chat.open': 'راسل فريق Dentrist',
    'support.chat.close': 'إغلاق المحادثة',
    'support.chat.greeting': 'مرحباً! كيف يمكننا مساعدتك اليوم؟',
    'support.chat.greetingNamed': 'مرحباً {name}! كيف يمكننا مساعدتك اليوم؟',
    'support.chat.placeholder': 'اكتب رسالة…',
    'support.chat.send': 'إرسال',
    'support.chat.seen': 'تمت المشاهدة',
    'support.chat.sendError': 'تعذر إرسال رسالتك. حاول مرة أخرى.',
    'support.chat.files.attach': 'إرفاق صور أو ملفات',
    'support.chat.files.dropHere': 'أفلت الملفات لإرفاقها برسالتك',
    'support.chat.files.remove': 'إزالة',
    'support.chat.files.processing': 'جارٍ الإنهاء…',
    'support.chat.files.invalidType': '{{name}}: نوع الملف غير مسموح',
    'support.chat.files.tooLarge': '{{name}}: حجم الملف أكبر من 20 ميجابايت',
    'support.chat.files.tooMany': 'يمكنك إرفاق {{count}} ملفات كحد أقصى لكل رسالة',

    'users.page.title': 'المستخدمون',
    'users.header.title': 'المستخدمون',
    'users.header.subtitle': 'إدارة حسابات طاقم المعمل والدعوات والصلاحيات والوصول',
    'users.filter.title': 'تصفية المستخدمين',
    'users.filter.active': 'مفعل',
    'users.filter.clear': 'إعادة تعيين عوامل التصفية',
    'users.filter.search.placeholder': 'ابحث بالاسم أو البريد أو الهاتف أو العنوان أو واتساب',
    'users.button.addUser': 'إضافة مستخدم',
    'users.modal.title': 'المستخدمون',
    'users.table.name': 'الاسم',
    'users.table.username': 'اسم المستخدم',
    'users.table.email': 'البريد الإلكتروني',
    'users.table.userType': 'نوع المستخدم',
    'users.table.status': 'الحالة',
    'users.table.contact': 'التواصل',
    'users.table.phone': 'رقم التليفون',
    'users.table.whatsapp': 'رقم الواتساب',
    'users.table.address': 'العنوان',
    'users.table.actions': 'العمليات',
    'users.status.verified': 'مفعّل',
    'users.status.pending': 'بانتظار التفعيل',
    'users.status.activated': 'تم تفعيل المستخدم',
    'users.status.deactivated': 'تم إلغاء تفعيل المستخدم',
    'users.status.toggleFailed': 'تعذر تحديث حالة المستخدم',
    'users.status.manualVerified': 'تم التحقق من المستخدم',
    'users.status.manualUnverified': 'تم إلغاء تحقق المستخدم',
    'users.status.verifyToggleFailed': 'تعذر تحديث حالة التحقق',
    'users.actions.activate': 'تفعيل',
    'users.actions.deactivate': 'إلغاء التفعيل',
    'users.actions.verify': 'تحقق',
    'users.actions.unverify': 'إلغاء التحقق',
    'users.table.accountStatus': 'التفعيل',
    'users.table.invitationStatus': 'التحقق',
    'users.details.profileSection': 'بيانات الملف',
    'users.details.invitationSection': 'الدعوة',
    'users.details.clientNotAssigned': 'غير مُعيَّن',
    'users.details.assignedOrdersSection': 'الطلبات المسندة',
    'users.details.noAssignedOrders': 'لا توجد طلبات مسندة',
    'users.details.totalExpensesPaid': 'إجمالي المصروفات المدفوعة',
    'users.confirm.activateTitle': 'تفعيل مستخدم',
    'users.confirm.activateMessage': 'سيتمكن هذا المستخدم من تسجيل الدخول مرة أخرى.',
    'users.confirm.deactivateTitle': 'إلغاء تفعيل مستخدم',
    'users.confirm.deactivateMessage': 'سيتم تسجيل خروج هذا المستخدم ومنعه من الدخول حتى يتم تفعيله مرة أخرى.',
    'users.confirm.verifyTitle': 'تحقق من مستخدم',
    'users.confirm.verifyMessage': 'سيتم تعليم هذا المستخدم كمتحقق دون إكمال تدفق الدعوة.',
    'users.confirm.unverifyTitle': 'إلغاء تحقق مستخدم',
    'users.confirm.unverifyMessage': 'سيتم تعليم هذا المستخدم كبانتظار التحقق مرة أخرى.',
    'users.confirm.deleteTitle': 'حذف مستخدم',
    'users.confirm.deleteMessage': 'هل تريد حذف هذا المستخدم؟',
    'users.modal.createTitle': 'إضافة مستخدم',
    'users.modal.editTitle': 'تعديل مستخدم',
    'users.changeHistory': 'سجل التغييرات',
    'users.versions.title': 'سجل تغييرات المستخدم',
    'users.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'users.versions.by': 'تم التحديث بواسطة',
    'users.versions.noFields': 'لا توجد حقول تغيّرت',
    'users.versions.timelineTitle': 'الخط الزمني',
    'users.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'users.versions.selectVersion': 'اختر إصدارًا',
    'users.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'users.versions.field': 'الحقل',
    'users.versions.versionValue': 'قيمة الإصدار',
    'users.versions.currentValue': 'القيمة الحالية',
    'users.versions.current': 'الحالي',
    'users.versions.before': 'قبل',
    'users.versions.after': 'بعد (الحالية)',
    'users.versions.status': 'الحالة',
    'users.versions.changed': 'تم التغيير',
    'users.versions.same': 'بدون تغيير',
    'users.form.name.label': 'الاسم',
    'users.form.name.placeholder': 'ادخل الاسم',
    'users.form.name.required': 'من فضلك ادخل الاسم',
    'users.form.email.label': 'البريد الإلكتروني',
    'users.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'users.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'users.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'users.form.username.label': 'اسم المستخدم',
    'users.form.username.placeholder': 'ادخل اسم المستخدم',
    'users.form.username.hint': 'مطلوب إذا لم يكن للمستخدم بريد إلكتروني',
    'users.form.password.label': 'كلمة المرور',
    'users.form.password.placeholder': 'ادخل كلمة المرور',
    'users.form.password.required': 'من فضلك ادخل كلمة المرور',
    'users.form.password.invitationHint': 'اتركه فارغًا لإرسال رابط الدعوة',
    'users.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'users.form.password.confirm': 'تأكيد كلمة المرور',
    'users.form.password.confirmRequired': 'من فضلك أكد كلمة المرور',
    'users.form.password.mismatch': 'كلمتا المرور غير متطابقتين',
    'users.form.password.confirmPlaceholder': 'أعد إدخال كلمة المرور',
    'users.invitation.copyLink': 'نسخ رابط الدعوة',
    'users.invitation.linkCopied': 'تم نسخ رابط الدعوة',
    'users.invitation.copyFailed': 'تعذر نسخ رابط الدعوة',
    'users.invitation.sendEmail': 'إرسال دعوة بالبريد',
    'users.invitation.emailSent': 'تم إرسال بريد الدعوة',
    'users.invitation.sendFailed': 'تعذر إرسال بريد الدعوة',
    'users.invitation.regenerate': 'إعادة إنشاء رابط الدعوة',
    'users.invitation.regenerated': 'تمت إعادة إنشاء رابط الدعوة',
    'users.invitation.regeneratedAndCopied': 'تمت إعادة إنشاء الرابط ونسخه',
    'users.invitation.regenerateFailed': 'تعذر إعادة إنشاء رابط الدعوة',
    'users.invitation.title': 'الدعوة',
    'users.invitation.invalidToken': 'رابط الدعوة غير صالح أو منتهي الصلاحية',
    'users.invitation.completed': 'تم تفعيل الحساب بنجاح! يمكنك تسجيل الدخول الآن.',
    'users.invitation.completeFailed': 'تعذر إكمال الدعوة',
    'users.invitation.error': 'خطأ',
    'users.invitation.backToLogin': 'العودة إلى تسجيل الدخول',
    'users.invitation.setPassword': 'تعيين كلمة المرور',
    'users.invitation.welcome': 'مرحبًا!',
    'users.invitation.welcomeMessage': 'يرجى تعيين كلمة مرور للحساب {{name}} ({{email}})',
    'users.invitation.complete': 'إكمال التفعيل',
    'users.form.phone.label': 'رقم التليفون',
    'users.form.phone.placeholder': 'ادخل رقم التليفون',
    'users.form.whatsapp.label': 'رقم الواتساب',
    'users.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'users.form.address.label': 'العنوان',
    'users.form.address.placeholder': 'ادخل العنوان',
    'users.form.userType.label': 'نوع المستخدم',
    'users.form.userType.placeholder': 'اختر نوع المستخدم',
    'users.form.userType.required': 'من فضلك اختر نوع المستخدم',
    'users.resetPassword.button': 'إعادة تعيين كلمة المرور',
    'users.resetPassword.confirmTitle': 'إعادة التعيين إلى الكلمة المؤقتة؟',
    'users.resetPassword.confirmMessage': 'سيتم تعيين كلمة المرور إلى temp123. شاركها مع المستخدم ليسجّل الدخول ثم يغيّرها.',
    'users.resetPassword.successTitle': 'كلمة المرور المؤقتة جاهزة',
    'users.resetPassword.successHint': 'أعطِ كلمة المرور هذه للمستخدم. عليه تسجيل الدخول ثم تغييرها من الملف الشخصي.',
    'users.resetPassword.failed': 'تعذر إعادة تعيين كلمة المرور',
    'users.form.client.label': 'العميل',
    'users.form.client.required': 'من فضلك اختر عميلاً لحساب الطبيب',
    'users.form.permissions.label': 'الصلاحيات',
    'users.form.permissions.placeholder': 'اختر الصلاحيات',
    'users.form.permissions.selectAll': 'تحديد الكل',
    'users.permissions.groups.asset': 'الأصول',
    'users.permissions.groups.branch': 'الفروع',
    'users.permissions.groups.delivery_center': 'مراكز التوصيل',
    'users.permissions.groups.color': 'الألوان',
    'users.permissions.groups.dentist': 'الأطباء',
    'users.permissions.groups.expense': 'المصروفات',
    'users.permissions.groups.expense_type': 'بنود المصروفات',
    'users.permissions.groups.invoice': 'الفواتير',
    'users.permissions.groups.formula_type': 'أنواع التركيبات',
    'users.permissions.groups.order': 'الطلبات',
    'users.permissions.groups.order_phase': 'مراحل الطلب',
    'users.permissions.groups.client': 'العملاء',
    'users.permissions.groups.transaction': 'المعاملات',
    'users.permissions.groups.unit': 'الوحدات',
    'users.permissions.groups.unit_type': 'أنواع الوحدات',
    'users.permissions.groups.user': 'المستخدمون',
    'users.permissions.groups.dashboard': 'لوحة التحكم',
    'users.permissions.groups.vendor': 'المعامل',
    'users.permissions.groups.vendor_bank_accounts': 'الحسابات البنكية',
    'users.permissions.groups.vendor_money_transfer_channels': 'طرق التحويل',
    'users.permissions.groups.setting': 'الإعدادات',
    'users.permissions.groups.client_settings': 'إعدادات العميل',
    'users.permissions.groups.client_transactions': 'معاملات العميل',
    'users.permissions.groups.client_statement': 'كشف حساب العميل',
    'users.permissions.groups.client_wallet': 'محفظة العميل',
    'users.permissions.items.view_dashboard_kpi_orders': 'عرض مقياس الطلبات',
    'users.permissions.items.view_dashboard_kpi_invoices': 'عرض مقياس الفواتير',
    'users.permissions.items.view_dashboard_kpi_clients': 'عرض مقياس العملاء',
    'users.permissions.items.view_dashboard_kpi_units': 'عرض مقياس الوحدات',
    'users.permissions.items.view_dashboard_kpi_expenses': 'عرض مقياس المصروفات',
    'users.permissions.items.view_dashboard_collection_tracker': 'عرض متتبع التحصيلات',
    'users.permissions.items.view_dashboard_revenue_tracker': 'عرض متتبع الإيرادات',
    'users.permissions.items.view_dashboard_latest_orders': 'عرض أحدث الطلبات',
    'users.permissions.items.view_dashboard_orders_tracker': 'عرض متتبع الطلبات',
    'users.permissions.items.view_dashboard_latest_invoices': 'عرض أحدث الفواتير',
    'users.permissions.items.view_dashboard_invoices_tracker': 'عرض متتبع الفواتير',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'عرض متتبع أنواع التركيبات',
    'users.permissions.items.view_dashboard_active_clients': 'عرض العملاء النشطين',
    'users.permissions.items.view_dashboard_active_orders': 'عرض الطلبات النشطة',
    'users.permissions.items.view_dashboard_active_invoices': 'عرض الفواتير النشطة',
    'users.permissions.items.view_dashboard_active_expenses': 'عرض المصروفات النشطة',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'تحميل الفاتورة (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'إرسال الفاتورة عبر واتساب',
    'users.permissions.items.send_invoice_email': 'إرسال الفاتورة عبر البريد الإلكتروني',
    'users.permissions.items.detach_order_from_invoice': 'فصل الطلب عن الفاتورة',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'عرض المعامل',
    'users.permissions.items.add_vendor': 'إضافة موردين',
    'users.permissions.items.edit_vendor': 'تعديل المعامل',
    'users.permissions.items.delete_vendor': 'حذف المعامل',

    'users.permissions.items.view_vendor_bank_accounts': 'عرض الحسابات البنكية',
    'users.permissions.items.add_vendor_bank_accounts': 'إضافة حسابات بنكية',
    'users.permissions.items.edit_vendor_bank_accounts': 'تعديل الحسابات البنكية',
    'users.permissions.items.delete_vendor_bank_accounts': 'حذف الحسابات البنكية',

    'users.permissions.items.view_vendor_money_transfer_channels': 'عرض طرق التحويل',
    'users.permissions.items.add_vendor_money_transfer_channels': 'إضافة طرق التحويل',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'تعديل طرق التحويل',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'حذف طرق التحويل',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'عرض الإعدادات',
    'users.permissions.items.edit_settings': 'تعديل الإعدادات',

    // Dentist portal settings
    'users.permissions.items.view_client_settings_client_info': 'عرض بيانات العميل (الإعدادات)',
    'users.permissions.items.view_client_settings_wallet_balance': 'عرض رصيد المحفظة (الإعدادات)',
    'users.permissions.items.view_client_settings_wallet_history': 'عرض سجل المحفظة (الإعدادات)',
    'users.permissions.items.view_client_settings_transactions': 'عرض المعاملات (الإعدادات)',
    'users.permissions.items.view_client_transactions': 'عرض معاملات العميل',
    'users.permissions.items.view_client_statement': 'عرض كشف حساب العميل',
    'users.permissions.items.view_client_wallet': 'عرض محفظة العميل',
    'users.permissions.items.export_clients': 'تصدير العملاء',
    'users.permissions.items.export_invoices': 'تصدير الفواتير',
    'users.permissions.items.export_orders': 'تصدير الطلبات',
    'users.permissions.items.export_users': 'تصدير المستخدمين',

    'clientTransactions.title': 'المعاملات',
    'clientTransactions.alert.noAccess': 'ليس لديك صلاحية الوصول إلى المعاملات.',
    'clientStatement.title': 'كشف الحساب',
    'clientStatement.alert.noAccess': 'ليس لديك صلاحية الوصول إلى كشف الحساب.',
    'clientWallet.title': 'المحفظة',
    'clientWallet.alert.noAccess': 'ليس لديك صلاحية الوصول إلى المحفظة.',
    'users.permissions.items.view_client_settings_wallet': 'عرض محفظة العميل (الإعدادات)',

    'clientSettings.title': 'الإعدادات',
    'clientSettings.alert.noAccess': 'ليس لديك صلاحية الوصول إلى الإعدادات.',
    'clientSettings.alert.noClientAssigned': 'لا يوجد عميل مرتبط بحسابك. تواصل مع مسؤول المعمل.',
    'clientSettings.clientInfo.title': 'بيانات العميل',
    'clientSettings.clientInfo.clientName': 'اسم العميل',
    'clientSettings.clientInfo.clientType': 'نوع العميل',
    'clientSettings.clientInfo.phone': 'رقم الهاتف',
    'clientSettings.clientInfo.whatsapp': 'رقم واتساب',
    'clientSettings.clientInfo.email': 'البريد الإلكتروني',
    'clientSettings.clientInfo.assignedDentists': 'الأطباء المسؤولون ',
    'clientSettings.clientInfo.assignedLabContacts': 'جهات اتصال المختبر',
    'clientSettings.clientInfo.deliveryCenters': 'مراكز التسليم',
    'clientSettings.accounts.title': 'الحسابات',
    'clientSettings.accounts.titleDentists': 'حسابات العميل',
    'clientSettings.accounts.titleLabContacts': 'حسابات جهات اتصال المختبر',
    'clientSettings.accounts.description': 'الحسابات الأخرى المرتبطة بهذا العميل. يمكن للحساب الرئيسي فقط عرض هذه القائمة.',
    'clientSettings.accounts.you': 'أنت',
    'clientSettings.accounts.status': 'الحالة',
    'clientSettings.accounts.statusActive': 'نشط',
    'clientSettings.accounts.statusInactive': 'غير نشط',
    'clientSettings.wallet.title': 'المحفظة',
    'clientSettings.transactions.title': 'المعاملات',

    'users.permissions.items.view_asset': 'عرض الأصول',
    'users.permissions.items.add_asset': 'إضافة الأصول',
    'users.permissions.items.edit_asset': 'تعديل الأصول',
    'users.permissions.items.delete_asset': 'حذف الأصول',
    'users.permissions.items.view_branch': 'عرض الفروع',
    'users.permissions.items.add_branch': 'إضافة الفروع',
    'users.permissions.items.edit_branch': 'تعديل الفروع',
    'users.permissions.items.delete_branch': 'حذف الفروع',
    'users.permissions.items.view_delivery_center': 'عرض مراكز التوصيل',
    'users.permissions.items.add_delivery_center': 'إضافة مراكز التوصيل',
    'users.permissions.items.edit_delivery_center': 'تعديل مراكز التوصيل',
    'users.permissions.items.delete_delivery_center': 'حذف مراكز التوصيل',
    'users.permissions.items.view_color': 'عرض الألوان',
    'users.permissions.items.add_color': 'إضافة الألوان',
    'users.permissions.items.edit_color': 'تعديل الألوان',
    'users.permissions.items.delete_color': 'حذف الألوان',
    'users.permissions.items.view_dentist': 'عرض الأطباء',
    'users.permissions.items.add_dentist': 'إضافة الأطباء',
    'users.permissions.items.edit_dentist': 'تعديل الأطباء',
    'users.permissions.items.delete_dentist': 'حذف الأطباء',
    'users.permissions.items.view_expense': 'عرض المصروفات',
    'users.permissions.items.add_expense': 'إضافة المصروفات',
    'users.permissions.items.edit_expense': 'تعديل المصروفات',
    'users.permissions.items.delete_expense': 'حذف المصروفات',
    'users.permissions.items.view_expense_type': 'عرض بنود المصروفات',
    'users.permissions.items.add_expense_type': 'إضافة بنود المصروفات',
    'users.permissions.items.edit_expense_type': 'تعديل بنود المصروفات',
    'users.permissions.items.delete_expense_type': 'حذف بنود المصروفات',
    'users.permissions.items.view_invoice': 'عرض الفواتير',
    'users.permissions.items.add_invoice': 'إضافة الفواتير',
    'users.permissions.items.edit_invoice': 'تعديل الفواتير',
    'users.permissions.items.delete_invoice': 'حذف الفواتير',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'إنشاء فاتورة من الطلب',
    'users.permissions.items.attach_order_to_invoice': 'ربط الطلب بفاتورة موجودة',
    'users.permissions.items.create_work_order': 'إنشاء أمر عمل',
    'users.permissions.items.view_assigned_orders': 'عرض الطلبات المسندة',
    'users.permissions.items.view_order_public_page': 'عرض صفحة الطلب العامة',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'إنشاء فاتورة',
    'orders.actions.createInvoice.description': 'إنشاء فاتورة باستخدام الطلب الحالي.',
    'orders.actions.createInvoice.cta': 'إنشاء فاتورة',
    'orders.actions.createInvoice.success': 'تم إنشاء الفاتورة بنجاح',
    'orders.actions.createInvoice.error': 'فشل في إنشاء الفاتورة',

    'orders.actions.attach.title': 'ربط بفاتورة موجودة',
    'orders.actions.attach.selectPlaceholder': 'اختر فاتورة',
    'orders.actions.attach.cta': 'ربط',
    'orders.actions.attach.success': 'تم ربط الطلب بالفاتورة',
    'orders.actions.attach.error': 'فشل في الربط',

    'orders.actions.createWorkOrder.title': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.assignedTo': 'تعيين إلى',
    'orders.actions.createWorkOrder.notes': 'ملاحظات',
    'orders.actions.createWorkOrder.cta': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.success': 'تم إنشاء أمر العمل',
    'orders.actions.createWorkOrder.error': 'فشل في إنشاء أمر العمل',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'بنود الطلب (حسب نوع التركيبة)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} وحدة',
    'orders.actions.createWorkOrder.unitLabel': 'الوحدة {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'لا توجد تركيبات في هذا الطلب.',
    'users.permissions.items.view_formula_type': 'عرض أنواع التركيبات',
    'users.permissions.items.add_formula_type': 'إضافة نوع تركيبة',
    'users.permissions.items.edit_formula_type': 'تعديل نوع تركيبة',
    'users.permissions.items.delete_formula_type': 'حذف نوع تركيبة',
    'users.permissions.items.view_all_formula_types': 'عرض كل أنواع التركيبات',
    'users.permissions.items.view_client': 'عرض العملاء',
    'users.permissions.items.add_client': 'إضافة العملاء',
    'users.permissions.items.edit_client': 'تعديل العملاء',
    'users.permissions.items.delete_client': 'حذف العملاء',
    'users.permissions.items.revert_wallet_recharge': 'التراجع عن شحن المحافظ',
    'users.permissions.items.view_order': 'عرض الطلبات',
    'users.permissions.items.add_order': 'إضافة الطلبات',
    'users.permissions.items.edit_order': 'تعديل الطلبات',
    'users.permissions.items.delete_order': 'حذف الطلبات',
    'users.permissions.items.view_order_phase': 'عرض مراحل الطلب',
    'users.permissions.items.add_order_phase': 'إضافة مراحل الطلب',
    'users.permissions.items.edit_order_phase': 'تعديل مراحل الطلب',
    'users.permissions.items.delete_order_phase': 'حذف مراحل الطلب',
    'users.permissions.items.view_transaction': 'عرض المعاملات',
    'users.permissions.items.add_transaction': 'إضافة المعاملات',
    'users.permissions.items.edit_transaction': 'تعديل المعاملات',
    'users.permissions.items.delete_transaction': 'حذف المعاملات',
    'users.permissions.items.view_unit': 'عرض الوحدات',
    'users.permissions.items.add_unit': 'إضافة الوحدات',
    'users.permissions.items.edit_unit': 'تعديل الوحدات',
    'users.permissions.items.delete_unit': 'حذف الوحدات',
    'users.permissions.items.view_unit_type': 'عرض أنواع الوحدات',
    'users.permissions.items.add_unit_type': 'إضافة أنواع الوحدات',
    'users.permissions.items.edit_unit_type': 'تعديل أنواع الوحدات',
    'users.permissions.items.delete_unit_type': 'حذف أنواع الوحدات',
    'users.permissions.items.view_user': 'عرض المستخدمين',
    'users.permissions.items.add_user': 'إضافة المستخدمين',
    'users.permissions.items.edit_user': 'تعديل المستخدمين',
    'users.permissions.items.delete_user': 'حذف المستخدمين',
    'users.permissions.groups.delivery_type': 'أنواع التوصيل',
    'users.permissions.groups.activity_logs': 'سجل النشاط',
    'users.permissions.groups.change_history': 'سجل التغييرات',
    'users.permissions.actions.view': 'عرض',
    'users.permissions.actions.add': 'إضافة',
    'users.permissions.actions.edit': 'تعديل',
    'users.permissions.actions.delete': 'حذف',
    'users.permissions.actions.change': 'تغيير',
    'users.permissions.actions.create': 'إنشاء',
    'users.permissions.actions.view_all': 'عرض الكل',
    'users.permissions.items.view_delivery_type': 'عرض أنواع التوصيل',
    'users.permissions.items.add_delivery_type': 'إضافة أنواع التوصيل',
    'users.permissions.items.edit_delivery_type': 'تعديل أنواع التوصيل',
    'users.permissions.items.delete_delivery_type': 'حذف أنواع التوصيل',
    'users.permissions.items.view_assigned_technician': 'عرض الفني المسند',
    'users.permissions.items.change_assigned_technician': 'تغيير الفني المسند',
    'users.permissions.items.view_assigned_courier': 'عرض المندوب المسند',
    'users.permissions.items.change_assigned_courier': 'تغيير المندوب المسند',
    'users.permissions.items.view_order_status': 'عرض حالة الطلب',
    'users.permissions.items.change_order_status': 'تغيير حالة الطلب',
    'users.permissions.items.view_activity_logs': 'عرض سجل النشاط',
    'users.permissions.items.view_notification_settings': 'عرض إعدادات الإشعارات',
    'users.permissions.items.edit_notification_settings': 'تعديل إعدادات الإشعارات',
    'users.permissions.items.view_change_history': 'عرض سجل التغييرات',
    'users.permissions.items.view_all_colors': 'عرض كل الألوان',
    'users.form.submit.add': 'إضافة',
    'users.form.submit.edit': 'تحديث',
    'users.alert.noAccess': 'ليس لديك صلاحية لعرض المستخدمين.',

    'invoice.title': 'فاتورة',
    'invoice.detailsTitle': 'تفاصيل الفاتورة',
    'invoice.button.print': 'طباعة',
    'invoice.button.addOrder': 'إضافة طلب',
    'invoice.field.dentistName': 'اسم الطبيب',
    'invoice.field.date': 'تاريخ الفاتورة',
    'invoice.table.orderRef': 'رقم الطلب',
    'invoice.table.invoiceRef': 'رقم الفاتورة',
    'invoice.field.shipmentDate': 'تاريخ الشحنة',
    'invoice.field.vat': 'قيمة الضريبة',
    'invoice.field.deliveryCost': 'تكلفة التوصيل',
    'invoice.field.orderId': 'رقم الطلب',
    'invoice.field.amount': 'المبلغ',
    'invoice.field.client': 'العميل',
    'invoice.field.status': 'حالة الفاتورة',
    'invoice.field.orders': 'الطلبات',
    'invoice.field.units': 'عدد الوحدات',
    'invoice.field.unitCost': 'التكلفة لكل وحدة',
    'invoice.field.issueDate': 'تاريخ الإصدار',
    'invoice.field.dueDate': 'تاريخ الاستحقاق',
    'invoice.field.paidAt': 'تاريخ الدفع',
    'invoice.field.paymentMethod': 'طريقة الدفع',
    'invoice.field.paymentStatus': 'حالة الدفع',
    'invoices.button.showDrafts': 'عرض المؤرشفة',
    'invoices.button.hideDrafts': 'إخفاء المؤرشفة',
    'invoices.filter.all': 'عرض الكل',
    'invoices.filter.drafts': 'عرض المؤرشفة',
    'invoices.filter.nonDrafts': 'إخفاء المؤرشفة',
    'invoices.filter.issueDateFrom': 'تاريخ الإصدار من',
    'invoices.filter.issueDateTo': 'تاريخ الإصدار إلى',
    'invoices.filter.dueDateFrom': 'تاريخ الاستحقاق من',
    'invoices.filter.dueDateTo': 'تاريخ الاستحقاق إلى',
    'invoice.field.deliveredAt': 'تم التسليم',
    'invoice.orders.viewFormulas': 'عرض التركيبات ومخطط الأسنان',
    'invoice.orders.hideFormulas': 'إخفاء التركيبات ومخطط الأسنان',
    'invoice.orders.expandAll': 'توسيع كل التركيبات',
    'invoice.orders.collapseAll': 'طَيّ كل التركيبات',
    'invoice.orders.formulasCount': '{{count}} تركيبات',
    'invoice.orders.unitsCount': '{{count}} وحدات',
    'invoice.orders.formulaList': 'التركيبات والألوان',
    'invoice.orders.financialSummary': 'التفاصيل المالية',
    'invoice.orders.teeth': 'الأسنان',
    'invoice.button.detach': 'فصل عن الفاتورة',
    'invoice.detach.confirmMessage': 'هل تريد بالتأكيد فصل هذا الطلب عن الفاتورة؟',
    'invoice.detach.success': 'تم فصل الطلب بنجاح',
    'invoice.detach.error': 'فشل فصل الطلب',
    'invoice.cancel.confirmMessage': 'فصل آخر طلب سيحول الفاتورة إلى مسودة. المتابعة؟',
    'invoice.cancel.success': 'تم تحويل الفاتورة إلى مسودة',
    'invoice.cancel.error': 'فشل إلغاء الفاتورة',
    'invoice.alert.draft': 'الفاتورة في حالة مسودة',
    'invoice.alert.paidReadOnly': 'تم دفع هذه الفاتورة. معظم التعديلات معطّلة؛ يمكنك مع ذلك تغيير تاريخ الدفع. استخدم التراجع عن الدفع في رأس الفاتورة إذا سُجّل الدفع بالخطأ، أو الاسترداد لإضافة المبلغ إلى محفظة العميل.',
    'invoice.paidAt.success': 'تم تحديث تاريخ الدفع',
    'invoice.paidAt.error': 'فشل تحديث تاريخ الدفع',
    'invoice.button.cancel': 'إلغاء الفاتورة',
    'invoice.button.downloadPdf': 'تنزيل PDF',
    'invoice.button.downloadSummaryPdf': 'تنزيل الفاتورة PDF',
    'invoice.taxInvoice.title': 'فاتورة ضريبية (إلكترونية)',
    'invoice.taxInvoice.badge': 'فاتورة ضريبية',
    'invoice.taxInvoice.downloadPdf': 'تنزيل الفاتورة الضريبية PDF',
    'invoice.taxInvoice.downloadError': 'تعذر تنزيل الفاتورة الضريبية',
    'invoice.taxInvoice.loadError': 'تعذر تحميل الفاتورة الضريبية',
    'invoice.taxInvoice.makeTax': 'تحويل إلى فاتورة ضريبية (إلكترونية)',
    'invoice.taxInvoice.makeRegular': 'تحويل إلى فاتورة عادية',
    'invoice.taxInvoice.toggleError': 'تعذر تغيير نوع الفاتورة',
    'invoice.taxInvoice.createLabel': 'فاتورة ضريبية (إلكترونية)',
    'invoice.taxInvoice.createHint': 'إصدار الفاتورة بصيغة الفاتورة الضريبية ثنائية اللغة: بيانات المعمل والعميل الضريبية، جدول الخدمات، الصافي قبل الضريبة، ضريبة القيمة المضافة والإجمالي المستحق.',
    'invoice.taxInvoice.createButton': 'إنشاء فاتورة إلكترونية',
    'invoice.taxInvoice.typeFilter': 'نوع الفاتورة',
    'invoice.taxInvoice.typeTax': 'الفواتير الضريبية (الإلكترونية)',
    'invoice.taxInvoice.typeRegular': 'الفواتير العادية',
    'invoice.button.downloadExcel': 'تنزيل Excel',
    'invoice.button.downloadCsv': 'تنزيل CSV',
    'invoice.button.sendWhatsapp': 'إرسال عبر واتساب',
    'invoice.button.sendEmail': 'إرسال عبر البريد',
    'invoice.button.markPaid': 'تسجيل كمدفوعة',
    'invoice.button.refund': 'استرداد',
    'invoice.markPaid.title': 'تسجيل الدفع',
    'invoice.markPaid.paymentMethod': 'طريقة الدفع',
    'invoice.markPaid.channel': 'قناة التحويل',
    'invoice.markPaid.channelOther': 'قناة أخرى',
    'invoice.markPaid.notes': 'ملاحظات',
    'invoice.markPaid.attachment': 'مرفق (صورة)',
    'invoice.markPaid.success': 'تم تسجيل الفاتورة كمدفوعة',
    'invoice.markPaid.error': 'فشل تسجيل الفاتورة كمدفوعة',
    'invoice.button.partialPayment': 'دفع جزئي',
    'invoice.partialPayment.title': 'تسجيل دفع جزئي',
    'invoice.partialPayment.type': 'نوع الدفع',
    'invoice.partialPayment.typeFull': 'دفع كامل للفاتورة (إجمالي الفاتورة)',
    'invoice.partialPayment.typeOrders': 'دفع جزئي لطلبات محددة',
    'invoice.partialPayment.typeAmount': 'دفع جزئي على الفاتورة (إدخال المبلغ؛ غير مرتبط بطلبات محددة)',
    'invoice.partialPayment.paymentDate': 'تاريخ الدفع',
    'invoice.partialPayment.amount': 'المبلغ المراد دفعه',
    'invoice.partialPayment.remaining': 'المتبقي',
    'invoice.partialPayment.selectOrders': 'اختر الطلبات المراد دفعها',
    'invoice.partialPayment.selectedTotal': 'إجمالي الطلبات المحددة',
    'invoice.partialPayment.noUnpaidOrders': 'جميع طلبات هذه الفاتورة مدفوعة بالفعل',
    'invoice.partialPayment.amountRequired': 'أدخل مبلغ دفع أكبر من صفر',
    'invoice.partialPayment.amountExceeds': 'لا يمكن أن يتجاوز المبلغ الرصيد المتبقي',
    'invoice.partialPayment.amountExceedsRemaining': 'المبلغ أكبر من الرصيد المتبقي ({{remaining}}). يرجى إدخال مبلغ صحيح.',
    'invoice.partialPayment.ordersRequired': 'اختر طلباً واحداً على الأقل',
    'invoice.partialPayment.ordersExceed': 'إجمالي الطلبات المحددة يتجاوز الرصيد المتبقي',
    'invoice.partialPayment.success': 'تم تسجيل الدفع الجزئي',
    'invoice.partialPayment.error': 'فشل تسجيل الدفع الجزئي',
    'invoice.payments.title': 'سجل المعاملات',
    'invoice.payments.date': 'التاريخ',
    'invoice.payments.amount': 'المبلغ',
    'invoice.payments.method': 'الطريقة',
    'invoice.payments.count': '{{count}} دفعة',
    'invoice.payments.empty': 'لا توجد دفعات مسجلة بعد',
    'invoice.payments.typePartial': 'دفعة جزئية',
    'invoice.payments.typeFull': 'دفعة كاملة',
    'invoice.payments.ordersPaid': 'الطلبات المدفوعة',
    'invoice.refund.confirmTitle': 'استرداد الفاتورة؟',
    'invoice.refund.confirmMessage': 'سيتم إضافة المبلغ المدفوع إلى محفظة العميل، وستُعاد الفاتورة إلى غير مدفوعة، وستُلغى الطلبات المدرجة.',
    'invoice.refund.success': 'تم استرداد الفاتورة بنجاح',
    'invoice.refund.error': 'فشل استرداد الفاتورة',
    'invoice.button.undoMarkPaid': 'التراجع عن الدفع',
    'invoice.undoMarkPaid.confirmTitle': 'التراجع عن الدفع؟',
    'invoice.undoMarkPaid.confirmMessage': 'سيتم إلغاء تسجيل الدفع كما لو لم يحدث. ستُحذف معاملات الدفع المرتبطة، وتُعاد الفاتورة إلى غير مدفوعة، وستُعاد الطلبات المدرجة إلى حالتها قبل "مغلق".',
    'invoice.undoMarkPaid.success': 'تم التراجع عن دفع الفاتورة',
    'invoice.undoMarkPaid.error': 'فشل التراجع عن دفع الفاتورة',
    'invoice.changeHistory': 'سجل التغييرات',
    'invoice.versions.title': 'سجل تغييرات الفاتورة',
    'invoice.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'invoice.versions.timelineTitle': 'الخط الزمني',
    'invoice.versions.by': 'تم التحديث بواسطة',
    'invoice.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'invoice.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'invoice.versions.selectVersion': 'اختر إصدارًا',
    'invoice.versions.noFields': 'لا توجد حقول تغيّرت',
    'invoice.versions.currentVersion': 'الإصدار الحالي',
    'invoice.versions.before': 'قبل',
    'invoice.versions.after': 'بعد (الحالية)',
    'invoice.field.phone': 'رقم الهاتف',
    'invoice.field.message': 'الرسالة',
    'invoice.paymentSummary.toggle': 'المبالغ',
    'invoice.paymentSummary.hide': 'إخفاء المبالغ',
    'invoice.paymentSummary.show': 'إظهار المبالغ',
    'invoice.dentist.title': 'الطبيب',
    'invoice.deliveryCenter.title': 'مراكز التسليم',
    'invoice.customer.title': 'العميل',
    'invoice.paymentSummary.title': 'ملخص الدفع',
    'invoice.clientBalance.title': 'إجمالي المبالغ المستحقة على العميل',
    'invoice.clientBalance.totalDue': 'إجمالي المستحق (كل الطلبات غير المدفوعة)',
    'invoice.clientBalance.unpaidOrders': 'الطلبات غير المدفوعة',
    'invoice.clientBalance.hint': 'يشمل كل الطلبات غير المدفوعة أو المدفوعة جزئياً لهذا العميل، سواء كانت مفوترة أم لا.',
    'invoice.notes.title': 'ملاحظات',
    'invoice.client.title': 'العميل',
    'invoice.notes.edit': 'تعديل',
    'invoice.notes.save': 'حفظ',
    'invoice.notes.cancel': 'إلغاء',
    'invoice.dates.title': 'تواريخ الفاتورة',
    'invoice.dates.dueIn': 'مستحقة خلال {{count}} يوم',
    'invoice.dates.dueToday': 'مستحقة اليوم',
    'invoice.dates.overdueBy': 'متأخرة {{count}} يوم',
    'invoice.dates.notSet': 'غير محدد',
    'invoice.dates.paymentTerms': 'شروط الدفع',
    'invoice.dates.paymentTermsNet': 'صافي {{count}} يوم',
    'invoice.summary.title': 'ملخص الفاتورة',
    'invoice.summary.statusOverdue': 'متأخرة',
    'invoice.summary.subtotal': 'الإجمالي قبل الضريبة',
    'invoice.summary.vat': 'ضريبة القيمة المضافة ({{percent}}%)',
    'invoice.summary.totalVat': 'إجمالي الضريبة',
    'invoice.summary.discount': 'الخصومات',
    'invoice.summary.delivery': 'التوصيل',
    'invoice.summary.total': 'الإجمالي',
    'invoice.summary.paid': 'المدفوع',
    'invoice.summary.remaining': 'المتبقي',
    'invoice.button.download': 'تنزيل',
    'invoice.button.share': 'مشاركة',
    'invoice.button.more': 'المزيد',
    'invoice.button.qrCode': 'رمز QR',
    'invoice.clientBalance.inline': 'إجمالي المستحقات على العميل',
    'invoice.clientBalance.unpaidOrdersCount': '{{count}} طلبات غير مدفوعة',
    'invoice.orders.expandAll': 'توسيع الكل',
    'invoice.orders.collapseAll': 'طي الكل',
    'invoice.attachments.title': 'المرفقات',
    'invoice.addOrder.selectRequired': 'الرجاء اختيار طلب واحد على الأقل',

    // UI invoice labels (عرض الفاتورة العام)
    'ui.invoice.number': 'رقم الفاتورة',
    'ui.invoice.status': 'الحالة',
    'ui.invoice.issue_date': 'تاريخ الإصدار',
    'ui.invoice.due_date': 'تاريخ الاستحقاق',
    'ui.invoice.section_vendor': 'المعمل',
    'ui.invoice.section_client': 'العميل',
    'ui.invoice.section_dentist': 'الطبيب',
    'ui.invoice.section_delivery_center': 'مركز التسليم',
    'ui.delivery_cost': 'تكلفة التوصيل',
    'ui.invoice.table.order_ref': 'مرجع الطلب',
    'ui.invoice.table.formula_type': 'نوع التركيبة',
    'ui.invoice.table.units': 'الوحدات',
    'ui.invoice.table.shipment_date': 'تاريخ الشحنة',
    'ui.invoice.table.patient': 'المريض',
    'ui.invoice.table.amount': 'المبلغ',
    'ui.invoice.table.discount': 'الخصم',
    'ui.invoice.table.vat': 'ضريبة',
    'ui.invoice.table.total': 'الإجمالي',
    'ui.invoice.status_paid': 'مدفوع',


    // Channel names

    // Payment / Bank accounts (Arabic)
    'ui.invoice.status_past_due': 'غير مدفوع',
    'ui.invoice.status_unpaid': 'غيرمدفوع',

    // Generic error messages
    'errors.fetchFailed': 'فشل في تحميل البيانات',
    'invoice.addOrder.added': 'تمت إضافة الطلبات للفاتورة',
    'invoice.addOrder.fetchError': 'تعذر استرجاع الطلبات',
    'invoice.addOrder.attachedHint': 'مرتبط بالفاتورة #{id} ({status}) — سيتم فصله إن تم التحديد',
    'invoice.addOrder.attachedWillDetach': 'سيتم فصله إن تم التحديد',
    'invoice.addOrder.noOrders': 'لا توجد طلبات غير مدفوعة لهذا العميل',
    'invoice.addOrder.detachConfirmTitle': 'هل تود فصل الطلبات عن الفواتير الأخرى؟',
    'invoice.addOrder.detachConfirmMessage': 'بعض الطلبات المحددة مرتبطة بفواتير أخرى. اختيارها سيؤدي إلى فصلها عن الفاتورة الحالية. هل تريد المتابعة؟',

    'invoices.detach.title': 'فصل الطلبات',
    'invoices.detach.noInvoice': 'الفاتورة غير موجودة',
    'invoice.addOrder.attachError': 'تعذر إضافة الطلبات',
    'invoice.addOrder.issueDateFrom': 'تاريخ الإصدار من',
    'invoice.addOrder.issueDateTo': 'تاريخ الإصدار إلى',
    'invoice.addOrder.loadByIssueDate': 'تحميل حسب تاريخ الإصدار',
    'invoice.addOrder.selectAllInRange': 'تحديد الكل',
    'invoice.addOrder.clearIssueDateFilter': 'مسح فلتر التاريخ',
    'invoice.addOrder.issueDateRangeRequired': 'يرجى اختيار نطاق تاريخ الإصدار',
    'invoice.addOrder.createNew': 'إنشاء فاتورة جديدة',
    'invoice.addOrder.chooseExisting': 'إرفاق بفاتورة موجودة',
    'invoice.addOrder.attach': 'إرفاق بفاتورة موجودة',
    'invoices.button.add': 'إنشاء فاتورة',
    'invoices.button.summary': 'فاتورة ملخصة',
    'invoice.summary.pageTitle': 'فاتورة ملخصة',
    'invoice.summary.dentistPlaceholder': 'اختر طبيباً (اختياري)',
    'invoice.summary.clientOrDentistRequired': 'اختر عميلاً و/أو طبيباً',
    'invoice.summary.dateRangeRequired': 'اختر فترة زمنية',
    'invoice.summary.preview': 'معاينة',
    'invoice.summary.downloadPdf': 'تحميل PDF',
    'invoice.summary.loadError': 'تعذر تحميل الفاتورة الملخصة',
    'invoice.summary.downloadError': 'تعذر تنزيل الفاتورة الملخصة',
    'invoice.summary.caseDescription': 'وصف الحالة',
    'invoice.summary.caseType': 'نوع الحالة',
    'invoice.summary.quantity': 'الكمية',
    'invoice.summary.date': 'التاريخ',
    'invoice.summary.patient': 'المريض',
    'invoice.summary.status': 'حالة الطلب',
    'invoice.summary.unitPrice': 'سعر الوحدة',
    'invoice.summary.numberOfUnits': 'عدد التركيبات',
    'invoice.summary.periodTotal': 'حساب الفترة المحددة',
    'invoice.summary.paidDuringPeriod': 'المدفوع خلال الفترة',
    'invoice.summary.previousBalance': 'حساب سابق',
    'invoice.summary.totalAmountDue': 'إجمالي المطلوب دفعه',
    'invoice.summary.noCases': 'لا توجد حالات في الفترة المحددة',
    'invoice.summary.filterTitle': 'معايير التصفية',
    'invoice.summary.resultsTitle': 'نتائج الملخص',
    'invoice.summary.totalCases': 'حالة',
    'invoice.button.downloading': 'جاري التحميل...',
    'invoice.create.title': 'إنشاء فاتورة',
    'invoice.create.nextCode': 'كود الفاتورة',
    'invoice.create.nextCodeHint': 'يتم تثبيت الكود النهائي عند حفظ الفاتورة.',
    'invoice.create.subtitle': 'اختر العميل، صفِّ الطلبات غير المدفوعة، ثم أنشئ الفاتورة',
    'invoice.create.backToInvoices': 'العودة إلى الفواتير',
    'invoice.create.backToOrders': 'العودة إلى الطلبات',
    'invoice.create.setupTitle': 'التصفية',
    'invoice.create.clientPlaceholder': 'العميل',
    'invoice.create.dentistPlaceholder': 'الطبيب (اختياري)',
    'invoice.create.formulaTypePlaceholder': 'نوع التركيبة',
    'invoice.create.ordersTitle': 'الطلبات غير المدفوعة',
    'invoice.create.ordersHint': 'حدد الطلبات المراد فوترتها. الطلبات المرتبطة بفاتورة غير مدفوعة أخرى سيتم فصلها إذا تم تحديدها.',
    'invoice.create.selectedCount': '{{count}} محدد',
    'invoice.create.selected': 'المحدد',
    'invoice.create.ordersCount': '{{count}} طلب',
    'invoice.create.totalDue': 'المبلغ المستحق',
    'invoice.create.emptyClient': 'اختر عميلاً لتحميل الطلبات غير المدفوعة',
    'invoice.create.search': 'بحث',
    'invoice.create.narrowByDate': 'نطاق تاريخ الإصدار',
    'invoice.create.deliveryDateRange': 'تاريخ التسليم',
    'invoice.create.clearSelection': 'إلغاء التحديد',
    'invoice.created': 'تم إنشاء الفاتورة',
    'invoice.form.clientPlaceholder': 'اختر عميلًا لتحميل الطلبات غير المدفوعة',
    'invoice.field.formula_type': 'نوع التركيبة',
    'invoice.field.color': 'اللون',
    'invoice.field.subtotal': 'إجمالي التكلفة',
    'invoice.field.discountType': 'نوع الخصم',
    'invoice.field.discountValue': 'قيمة الخصم',
    'invoice.field.total': 'المبلغ المستحق',
    'invoice.field.paid': 'المبلغ المدفوع',

    // Payment / Bank accounts
    'lab.payment.title': 'إعدادت الدفع',
    'lab.payment.bank_accounts_title': 'حسابات البنك',
    'lab.payment.addAccount': 'اضافة حساب بنكي',
    'lab.payment.editAccount': 'تعديل حساب بنكي',
    'lab.payment.accountHolder': 'صاحب الحساب',
    'lab.payment.accountHolder.required': 'اسم صاحب الحساب مطلوب',
    'lab.payment.accountHolder.max': 'اسم صاحب الحساب طويل جداً',
    'lab.payment.accountNumber': 'رقم الحساب',
    'lab.payment.accountNumber.required': 'رقم الحساب مطلوب',
    'lab.payment.accountNumber.invalid': 'رقم الحساب غير صالح',
    'lab.payment.accountNumber.min': 'رقم الحساب قصير جداً',
    'lab.payment.iban': 'آيبان',
    'lab.payment.iban.invalid': 'آيبان غير صالح',
    'lab.payment.swiftCode': 'رمز السويفت',
    'lab.payment.swiftCode.invalid': 'رمز سويفت/BIC غير صالح',
    'lab.payment.bankName': 'اسم البنك',
    'lab.payment.bankName.required': 'اسم البنك مطلوب',
    'lab.payment.bankName.max': 'اسم البنك طويل جداً',
    'lab.payment.branch': 'فرع البنك',
    'lab.payment.branch.max': 'تفاصيل الفرع طويلة جداً',
    'lab.payment.no_accounts': 'لا توجد حسابات بنكية',
    'lab.payment.no_transfer': 'لا توجد قنوات تحويل مفعلة',
    'lab.payment.addTransfer': 'إضافة قناة تحويل',
    'lab.payment.editTransfer': 'تعديل قناة التحويل',
    'lab.payment.channel': 'قناة التحويل',
    'lab.payment.deactivate': 'إلغاء التفعيل',
    'lab.payment.channel.required': 'يرجى اختيار قناة تحويل',
    'lab.payment.phone.invalid': 'رقم الهاتف غير صالح',
    'lab.payment.transfer_title': 'التحويل البنكي',
    'lab.payment.activate': 'تفعيل',
    'lab.payment.activated': 'تم التفعيل',
    'lab.payment.deactivated': 'تم إلغاء التفعيل',

    'ui.invoice.bank_account': 'الحساب البنكي',
    'ui.invoice.bank_account_numbered': 'الحساب البنكي {{n}}',
    'ui.invoice.account_holder': 'صاحب الحساب',
    'ui.invoice.account_number': 'رقم الحساب',
    'ui.invoice.bank_name': 'اسم البنك',
    'ui.invoice.bank_swift': 'رمز السويفت',
    'ui.invoice.bank_iban': 'آيبان',
    'ui.invoice.vendor_payment_data': 'بيانات دفع المعمل',
    'ui.invoice.payment_method': 'طريقة الدفع',
    'ui.invoice.payment_method_wallet': 'المحفظة',
    'ui.invoice.payment_method_money_transfer': 'التحويل البنكي',
    'ui.invoice.payment_method_cash_on_delivery': 'دفع نقدي',
    'ui.invoice.payment_method_credit_card': 'بطاقة ائتمان',
    'ui.invoice.money_transfer_channel': 'قناة التحويل',
    'ui.invoice.public_link': 'عرض الفاتورة',
    'ui.invoice.money_transfer_channels': 'قنوات التحويل',
    'ui.invoice.paid_at': 'تاريخ الدفع',

    // Channel names (support both slug formats: vodafone-cash and vodafone_cash)
    'ui.invoice.channel.instapay': 'إنستاباي',
    'ui.invoice.channel.vodafone_cash': 'فودافون كاش',
    'ui.invoice.channel.vodafone-cash': 'فودافون كاش',
    'ui.invoice.channel.etisalat_cash': 'اتصالات كاش',
    'ui.invoice.channel.etisalat-cash': 'اتصالات كاش',
    'ui.invoice.channel.we_pay': 'وي باي',
    'ui.invoice.channel.we-pay': 'وي باي',
    'ui.invoice.channel.fawry': 'فوري',
    'ui.invoice.channel.bank_transfer': 'تحويل بنكي',
    'ui.invoice.channel.bank-transfer': 'تحويل بنكي',
    'ui.invoice.channel.meeza': 'ميزة',
    'ui.invoice.channel.masary': 'مصاري',

    // Enhanced Public Invoice UI (Arabic)
    'ui.invoice.view_title': 'فاتورة',
    'ui.invoice.loading_details': 'جاري تحميل تفاصيل الفاتورة...',
    'ui.invoice.financial_summary': 'الملخص المالي',
    'ui.invoice.payment_details': 'تعليمات الدفع والتحويل البنكي',
    'ui.invoice.scan_qr_hint': 'امسح رمز QR لعرض والتحقق من الفاتورة عبر الإنترنت',
    'ui.invoice.copy_iban': 'نسخ الآيبان',
    'ui.invoice.copy_account': 'نسخ رقم الحساب',
    'ui.invoice.copy_number': 'نسخ الرقم',
    'ui.invoice.copied': 'تم النسخ إلى الحافظة',
    'ui.invoice.public_disclaimer': 'هذه الفاتورة رسمية صادرة من معمل الأسنان لأغراض المطابقة والتحقق المالي. لا تتطلب تسجيل الدخول.',
    'ui.invoice.included_orders': 'الطلبات المشمولة',
    'ui.invoice.orders_count': '{{count}} طلبات',
    'ui.invoice.total_restorations': '{{count}} تركيبة',
    'ui.invoice.paid_in_full': 'مدفوع بالكامل',
    'ui.invoice.remaining_balance': 'المبلغ المتبقي',
    'ui.invoice.billing_signoff': 'اعتماد الفاتورة وتوقيع المعمل',
    'ui.invoice.accountant_signature': 'التوقيع المعتمد / الختم',
    'ui.invoice.accountant_name': 'إعداد بواسطة',
    'ui.invoice.verification_date': 'تاريخ الاعتماد',
    'ui.invoice.channel_transfer_notice': 'يرجى إرفاق رقم الفاتورة كمرجع عند إتمام عملية التحويل.',
    'ui.invoice.bank_details': 'بيانات الحسابات البنكية',
    'ui.invoice.no_bank_accounts': 'لا توجد بيانات حسابات بنكية مضافة.',
    'ui.invoice.no_transfer_channels': 'لا توجد قنوات تحويل مالية مضافة.',
    'ui.invoice.balance_cleared': 'تم تسوية الرصيد بالكامل',
    'ui.invoice.unpaid_balance_alert': 'الدفع معلق. يرجى استخدام تفاصيل الدفع أدناه لإتمام السداد.',
    'ui.invoice.past_due_alert': 'تجاوزت هذه الفاتورة تاريخ الاستحقاق. يرجى تسوية المبلغ المستحق في أقرب وقت.',

    // Synced missing keys
    'assets.title': 'الأصول',
    'common.deleted': 'تم الحذف',
    'common.download_success': 'تم التنزيل بنجاح',
    'common.error': 'حدث خطأ ما',
    'common.no': 'لا',
    'common.noAccess': 'ليس لديك صلاحية الوصول',
    'common.noData': 'لا توجد بيانات',
    'common.popupBlocked': 'تم حظر النافذة المنبثقة. يرجى السماح بالنوافذ المنبثقة لهذا الموقع.',
    'common.unauthorized': 'يرجى تسجيل الدخول',
    'common.yes': 'نعم',
    'common.attachments': 'المرفقات',
    'errors.notFound': 'غير موجود',
    'errors.noViewPermission': 'ليس لديك صلاحية العرض',
    'entity.generic': 'السجل',
    'entity.notFound': '{entity} غير موجود',
    'entity.notFoundDescription': '{entity} رقم {id} غير موجود.',
    'entity.notFoundHint': 'السجل الذي تبحث عنه غير موجود أو تم حذفه.',
    'entity.backToList': 'العودة للقائمة',
    'entity.backToInvoices': 'العودة إلى الفواتير',
    'entity.backToOrders': 'العودة إلى الطلبات',
    'entity.backToClients': 'العودة إلى العملاء',
    'entity.backToDentists': 'العودة إلى الأطباء',
    'entity.backToUsers': 'العودة إلى المستخدمين',
    'entity.order': 'الطلب',
    'entity.invoice': 'الفاتورة',
    'entity.client': 'العميل',
    'entity.dentist': 'الطبيب',
    'entity.user': 'المستخدم',
    'entity.wallet': 'المحفظة',
    'home.latest_invoices': 'أحدث الفواتير',
    'home.tracker_description': 'تفاصيل تتبع الطلبات',
    'home.view_all_invoices': 'عرض كل الفواتير',
    'invoice.addOrder.attached': 'تم ربط الطلب بالفاتورة',
    'invoice.addOrder.attachedSuccess': 'تم ربط الطلب بنجاح',
    'invoice.addOrder.modalTitle': 'ربط طلب بفاتورة',
    'invoice.addOrder.noMatches': 'تعذر العثور على فواتير غير مدفوعة مطابقة لهذا العميل/الطبيب',
    'invoice.addOrder.selectPlaceholder': 'اختر فاتورة',
    'invoice.alert.noView': 'ليس لديك صلاحية عرض هذه الفاتورة.',
    'invoice.field.moneyTransferChannel': 'قناة التحويل',
    'invoice.field.transferReference': 'مرجع التحويل',
    'invoice.placeholder': 'عرض الفاتورة — بانتظار تحديد التخطيط.',
    'invoices.pdf.client': 'العميل',
    'invoices.pdf.dentist': 'الطبيب',
    'orders.actions.noInvoiceAttached': 'لا توجد فاتورة مرتبطة بهذا الطلب بعد',
    'orders.actions.operationalBlocked': 'تم قفل الإجراءات التشغيلية لهذا الطلب',
    'orders.actions.workCard': 'بطاقة العمل',
    'orders.actions.workOrder.assignedTo': 'تعيين إلى',
    'orders.actions.workOrder.cta': 'أمر شغل',
    'orders.actions.workOrder.error': 'فشل إنشاء أمر الشغل',
    'orders.actions.workOrder.notes': 'ملاحظات',
    'orders.actions.workOrder.success': 'تم إنشاء أمر الشغل',
    'orders.actions.workOrder.title': 'أمر شغل',
    'orders.assign.assign': 'تعيين',
    'orders.assign.attachExisting': 'الربط بفاتورة موجودة',
    'orders.assign.create': 'إنشاء فاتورة',
    'orders.assign.created': 'تم إنشاء الفاتورة وربط الطلب',
    'orders.assign.error': 'فشل تعيين الطلب للفاتورة',
    'orders.assign.selectExisting': 'اختر فاتورة موجودة لعميل هذا الطلب',
    'orders.assign.selectInvoice': 'يرجى اختيار فاتورة للتعيين',
    'orders.assign.selectPlaceholder': 'اختر فاتورة',
    'orders.assign.success': 'تم تعيين الطلب للفاتورة',
    'orders.assign.title': 'تعيين الطلب لفاتورة',
    'orders.button.assignInvoice': 'تعيين لفاتورة',
    'orders.form.unitsCount.label': 'عدد الوحدات',
    'orders.summary.discount': 'الخصم',
    'orders.table.deliveryCost': 'تكلفة التوصيل',
    'orders.table.reference': 'المرجع',
    'orders.update.section.invoicing': 'الفواتير والمدفوعات',
    'orders.update.section.quickActions': 'إجراءات سريعة',
    'orders.update.section.workflow': 'سير العمل والعمليات',
    'responses.common.locale_updated': 'تم تحديث اللغة',
    'ui.invoice.view_order': 'عرض الطلب',
    'ui.order.dates_and_timeline': 'الجدول الزمني والتواريخ',
    'ui.order.unit_positions_ar': 'مواضع الوحدات',
    'users.form.password.minLength': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',

    'subscription.title': 'الاشتراك',
    'subscription.loadError': 'تعذر تحميل تفاصيل الاشتراك',
    'subscription.adminOnly': 'يمكن لمسؤولي المعمل فقط إدارة خطة الاشتراك.',
    'subscription.currentPlan': 'الخطة الحالية',
    'subscription.noPlan': 'لا توجد خطة اشتراك معيّنة.',
    'subscription.choosePlan': 'اختر خطة',
    'subscription.choosePlanHint': 'اطلب خطة مدفوعة. سيراجع فريقنا طلبك ويفعّل الخطة الجديدة بعد الموافقة.',
    'subscription.popular': 'الأكثر شيوعاً',
    'subscription.month': 'شهر',
    'subscription.current': 'الخطة الحالية',
    'subscription.requestPlan': 'طلب الخطة',
    'subscription.requestConfirm': 'هل تريد إرسال طلب للتبديل إلى خطة {plan}؟',
    'subscription.requestSubmitted': 'تم إرسال طلب تغيير الخطة. سيتم تفعيلها بعد الموافقة.',
    'subscription.requestError': 'تعذر إرسال طلب تغيير الخطة',
    'subscription.awaitingApproval': 'بانتظار الموافقة',
    'subscription.requestPending': 'طلبك للتبديل إلى خطة {plan} بانتظار الموافقة.',
    'subscription.requestPendingHint': 'تظل خطتك الحالية مفعّلة حتى يوافق فريقنا على الطلب.',
    'subscription.cancelRequest': 'إلغاء الطلب',
    'subscription.cancelRequestConfirm': 'هل تريد إلغاء طلب تغيير الخطة؟',
    'subscription.requestCancelled': 'تم إلغاء طلب تغيير الخطة',
    'subscription.requestCancelError': 'تعذر إلغاء طلب تغيير الخطة',
    'subscription.requestRejected': 'تم رفض طلبك للتبديل إلى خطة {plan}.',
    'subscription.rejectionReason': 'السبب',
    'subscription.noPaidPlans': 'لا توجد خطط مدفوعة متاحة حالياً.',
    'subscription.trialEndsAt': 'تنتهي التجربة في',
    'subscription.trialActive': 'التجربة المجانية نشطة — متبقي {days} يوم.',
    'subscription.trialEndingSoon': 'تنتهي تجربتك المجانية خلال {days} يوم. اختر خطة للحفاظ على الوصول.',
    'subscription.trialExpired': 'انتهت تجربتك المجانية. اختر خطة لاستعادة الوصول.',
    'subscription.billing.trialing': 'تجريبي',
    'subscription.billing.active': 'نشط',
    'subscription.billing.past_due': 'متأخر',
    'subscription.billing.cancelled': 'ملغى',
    'subscription.billing.manual': 'يدوي',
    'subscription.status.pending': 'قيد الانتظار',
    'subscription.status.under_review': 'قيد المراجعة',
    'subscription.status.active': 'نشط',
    'subscription.status.suspended': 'معلق',
    'subscription.status.cancelled': 'ملغى',
    'subscription.status.rejected': 'مرفوض',

    'notFound.title': 'الصفحة غير موجودة',
  },
};

export default translations;
